export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Binary: any;
  CountryCode: any;
  DateTime: any;
  HexColorCode: any;
  JSON: any;
};

export type AcceptInviteInput = {
  inviteCode: Scalars['String'];
};

export type AcceptUserInviteResult = {
  __typename?: 'AcceptUserInviteResult';
  household?: Maybe<Household>;
  householdRole?: Maybe<UserHouseholdRole>;
  /** The updated current user. */
  user: User;
};

/** Recurly account note created by CX agents or support staff */
export type AccountNote = {
  __typename?: 'AccountNote';
  /** When the note was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The Recurly user who created the note */
  createdBy?: Maybe<AccountNoteUser>;
  /** Unique identifier for the note */
  id?: Maybe<Scalars['ID']>;
  /** The note message content */
  message?: Maybe<Scalars['String']>;
};

/** User information from Recurly who created the account note */
export type AccountNoteUser = {
  __typename?: 'AccountNoteUser';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
};

export type AcknowledgeSearchPartyResult = {
  __typename?: 'AcknowledgeSearchPartyResult';
  /** Error message if the operation failed, null otherwise. */
  error?: Maybe<Scalars['String']>;
  /** Whether the acknowledgment was successful. */
  success: Scalars['Boolean'];
};

export type ActivitiesForRangeResult = {
  __typename?: 'ActivitiesForRangeResult';
  activities: Array<Activity>;
};

export type Activity = {
  address?: Maybe<Scalars['String']>;
  areaName?: Maybe<Scalars['String']>;
  cityState?: Maybe<Scalars['String']>;
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int'];
  dbId: Scalars['Int'];
  debugMetadata: Scalars['JSON'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  /** @deprecated Use isLikable */
  isClappable: Scalars['Boolean'];
  isLikable: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  neighborhood?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  obfuscated: Scalars['Boolean'];
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']>;
  start: Scalars['DateTime'];
  totalSteps: Scalars['Int'];
};

export type ActivityFeed = {
  __typename?: 'ActivityFeed';
  activities: Array<Activity>;
  pageInfo: PageInfo;
};

export type ActivityGoal = {
  __typename?: 'ActivityGoal';
  targetScore: Scalars['Int'];
};

export type ActivityIntensity = {
  __typename?: 'ActivityIntensity';
  date: Scalars['DateTime'];
  intensity: Scalars['Int'];
  type: ActivityType;
};

/**
 * A single activity report from a device
 * !! IMPORTANT: This should never be exposed to or used by non-admin clients,
 * since it has a monotonically increasing ID (not a UUID).
 */
export type ActivityReport = {
  __typename?: 'ActivityReport';
  attributes?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  duration: Scalars['Float'];
  id: Scalars['ID'];
  ignoreReason?: Maybe<Scalars['String']>;
  steps: Scalars['Int'];
};

export type ActivityReportInput = {
  date: Scalars['DateTime'];
  duration: Scalars['Float'];
  params?: InputMaybe<Scalars['JSON']>;
  steps: Scalars['Int'];
};

/** Period of time over which Rest, Activity, and Strain feeds return data. */
export enum ActivityRestStrainPeriod {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

/** Indicates if data is available for given period, or reason why not. */
export enum ActivityRestStrainPeriodDataAvailability {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE_DATE_IS_IN_FUTURE = 'UNAVAILABLE_DATE_IS_IN_FUTURE',
  UNAVAILABLE_NO_DATA = 'UNAVAILABLE_NO_DATA'
}

export type ActivitySummary = {
  __typename?: 'ActivitySummary';
  dailySteps: Array<DailyStepSummary>;
  end: Scalars['DateTime'];
  hourlySteps: Array<TimeBoundStepCount>;
  period: ActivitySummaryPeriod;
  start: Scalars['DateTime'];
  stepGoal: Scalars['Int'];
  totalActiveTimeSeconds: Scalars['Float'];
  totalDistance: Scalars['Float'];
  totalSteps: Scalars['Int'];
};

export type ActivitySummaryFeed = {
  __typename?: 'ActivitySummaryFeed';
  activitySummaries: Array<ActivitySummary>;
  hasNext: Scalars['Boolean'];
  nextCursor: Scalars['String'];
};

export enum ActivitySummaryPeriod {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export enum ActivityType {
  MISSING_REPORTS = 'MISSING_REPORTS',
  PLAY = 'PLAY',
  REST = 'REST',
  TRAVEL = 'TRAVEL',
  WALK = 'WALK'
}

export type AddCouponToAccountInput = {
  /** The account code (user external ID) */
  accountCode: Scalars['ID'];
  /** The coupon code to add */
  couponCode: Scalars['String'];
  /**
   * Optional subscription ID (uuid) to apply the coupon to a specific subscription.
   * If not provided, the coupon is applied at the account level.
   */
  subscriptionId?: InputMaybe<Scalars['String']>;
};

export type AddMultipleSupplementSubscriptionsInput = {
  forceApplyDiscount?: InputMaybe<Scalars['Boolean']>;
  skusToAdd: Array<Scalars['String']>;
};

export type AddMultipleSupplementSubscriptionsResult = {
  __typename?: 'AddMultipleSupplementSubscriptionsResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AddOrderLineItemsInput = {
  cart: AdminCartInput;
  id: Scalars['ID'];
};

export type AddPetDocumentInput = {
  fileName: Scalars['String'];
  fileSizeBytes: Scalars['Int'];
  fileType: Scalars['String'];
  householdId: Scalars['ID'];
  recordKey: Scalars['String'];
};

export type AddPetPhotoInput = {
  petId: Scalars['ID'];
  photoId: Scalars['ID'];
  updates?: InputMaybe<PhotoUpdatesInput>;
};

export type AddPhotoCommentResult = {
  __typename?: 'AddPhotoCommentResult';
  photo: Photo;
};

export type AddResellerModulesInput = {
  moduleIds: Array<Scalars['String']>;
  orderSource: OrderSource;
  renewalMonths: Scalars['Int'];
  shipDate: Scalars['DateTime'];
  shipmentId?: InputMaybe<Scalars['String']>;
};

export type AddSupplementSubscriptionInput = {
  skuToAdd: Scalars['String'];
};

export type AddSupplementSubscriptionResult = {
  __typename?: 'AddSupplementSubscriptionResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AddTextPostCommentResult = {
  __typename?: 'AddTextPostCommentResult';
  post: TextPost;
};

export type AddThirdPartySubscriptionInput = {
  thirdParty: ThirdPartyId;
};

export type AddThirdPartySubscriptionResult = {
  __typename?: 'AddThirdPartySubscriptionResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AddUserEmailInput = {
  email: Scalars['String'];
  userId: Scalars['ID'];
};

export type AddUserToHouseholdInput = {
  householdId: Scalars['ID'];
  role: UserHouseholdRole;
  userId: Scalars['ID'];
};

export type AddUserToHouseholdResult = {
  __typename?: 'AddUserToHouseholdResult';
  household: Household;
};

export type AddVideoPostCommentResult = {
  __typename?: 'AddVideoPostCommentResult';
  post: VideoPost;
};

export type AddWifiCredentialInput = {
  credentials: WifiCredentialInput;
  householdId: Scalars['ID'];
  position: PositionInput;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type AddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type Admin = {
  __typename?: 'Admin';
  /** Fetch comments made by a specific pet across posts. For admin moderation. */
  adminCommentsByPet: AdminCommentsByPetResult;
  adminList: AdminList;
  /**
   * This is the same as the normal packMemberFeed but it doesn't filter pets
   * socially or require an acting pet.
   */
  adminPackMemberFeed: PackMemberFeed;
  allChargingBases: Array<ChargingBase>;
  /** Get all devices */
  allDevices: Array<Device>;
  allFeatureFlags: Array<FeatureFlag>;
  allPromotions: Array<Promotion>;
  allUserGroups: Array<UserGroup>;
  baseEventHistory: Array<AuditLogEvent>;
  batteryHistory: Array<BatteryHistoryAggregationBucket>;
  batteryHistoryConnectionStateChanges: ConnectionStateChangesResult;
  batteryHistoryDeviceActivity: Array<DeviceActivity>;
  batteryHistoryDeviceErrors: Array<DeviceError>;
  batteryHistoryOverviewDeviceEvents: Array<BatteryHistoryOverviewDeviceEvent>;
  batteryHistoryStatDeltaEvents: Array<StatDeltaDeviceEvent>;
  chargingBaseBatches: Array<DeviceBatchInfo>;
  chipEventHistory: Array<AuditLogEvent>;
  chipResellerEventHistory: Array<AuditLogEvent>;
  commentEventHistory: Array<AuditLogEvent>;
  consignmentAccountEventHistory: Array<AuditLogEvent>;
  couponById?: Maybe<Coupon>;
  couponRedirect: Scalars['String'];
  coupons: Array<Coupon>;
  /**
   * Query CX billing audit events for a specific entity.
   * Must provide at least one of: accountCode, invoiceNumber, or subscriptionId.
   */
  cxBillingAuditEvents: CxBillingAuditResult;
  deviceModelPlatformMappings: Array<DeviceModelPlatformMapping>;
  deviceStats: Array<DeviceStat>;
  /** Get multiple devices by module IDs */
  devices: Array<Device>;
  esIndices?: Maybe<Scalars['JSON']>;
  findUsersInGroup: Array<AdminBaseUserProfile>;
  firmwareStatistics: FirmwareStatistics;
  /** All the currently defined firmware tags. */
  firmwareTags: Array<FirmwareTag>;
  firmwareVersions: Array<FirmwareVersion>;
  /** Returns a signed URL that can be used to force a user into a GrowthBook experiment variant */
  growthBookExperimentForcedVariantUrl: Scalars['String'];
  householdEventHistory: Array<AuditLogEvent>;
  inPersonEvent: InPersonEvent;
  inPersonEvents: Array<InPersonEvent>;
  moduleBatches: Array<DeviceBatchInfo>;
  moduleEventHistory: Array<AuditLogEvent>;
  /** Get all AuditLogEvent by object type */
  petEventHistory: Array<AuditLogEvent>;
  placeEventHistory: Array<AuditLogEvent>;
  platforms: Array<Platform>;
  previewCreateCoupon: Array<Scalars['JSON']>;
  productInventoryLevels: ProductInventoryLevels;
  promotion: Promotion;
  /**
   * Fetch recent HealthGPT messages across all users for admin review.
   * Defaults to last 24 hours if no date range specified.
   */
  recentHealthGptMessages: AdminHealthGptMessagesConnection;
  recentlyPurchasedItems: RecentlyPurchasedItemsResponse;
  referralRewardHistory: Array<AuditLogEvent>;
  searchChipResellers: Array<ChipReseller>;
  searchChips: Array<ResellerChip>;
  searchDevices: Array<Device>;
  searchPets: Array<Pet>;
  searchUsers: Array<AdminBaseUserProfile>;
  signUrl: Scalars['String'];
  statistics: Statistics;
  subscriptionEventHistory: Array<AuditLogEvent>;
  /** This endpoint is a noop. It is used to test GraphQL DateTime validation. */
  testDateTimeParsing?: Maybe<Scalars['DateTime']>;
  userEventHistory: Array<AuditLogEvent>;
};


export type AdminadminCommentsByPetArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  petId: Scalars['ID'];
};


export type AdminadminListArgs = {
  name: Scalars['String'];
};


export type AdminadminPackMemberFeedArgs = {
  adjacentPetId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  packAgeFilter?: InputMaybe<PackAgeFilter>;
  packId: Scalars['ID'];
  pagingInstruction?: InputMaybe<PagingInstruction>;
  validityToken?: InputMaybe<Scalars['String']>;
};


export type AdminallChargingBasesArgs = {
  assignedOnly?: InputMaybe<Scalars['Boolean']>;
  input?: InputMaybe<AdminAllChargingBasesInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  updateChannel?: InputMaybe<Scalars['String']>;
};


export type AdminallDevicesArgs = {
  assignedOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type AdminallUserGroupsArgs = {
  excludePseudo?: InputMaybe<Scalars['Boolean']>;
};


export type AdminbaseEventHistoryArgs = {
  baseId: Scalars['ID'];
};


export type AdminbatteryHistoryArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  interval: Scalars['String'];
  moduleId: Scalars['String'];
};


export type AdminbatteryHistoryConnectionStateChangesArgs = {
  dateRange: DateRangeInput;
  moduleId: Scalars['String'];
};


export type AdminbatteryHistoryDeviceActivityArgs = {
  dateRange: DateRangeInput;
  moduleId: Scalars['String'];
};


export type AdminbatteryHistoryDeviceErrorsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  moduleId: Scalars['String'];
};


export type AdminbatteryHistoryOverviewDeviceEventsArgs = {
  moduleId: Scalars['String'];
};


export type AdminbatteryHistoryStatDeltaEventsArgs = {
  dateRange: DateRangeInput;
  moduleId: Scalars['String'];
  statNames: Array<Scalars['String']>;
};


export type AdminchipEventHistoryArgs = {
  chipId: Scalars['ID'];
};


export type AdminchipResellerEventHistoryArgs = {
  chipResellerId: Scalars['ID'];
};


export type AdmincommentEventHistoryArgs = {
  commentId: Scalars['ID'];
};


export type AdminconsignmentAccountEventHistoryArgs = {
  consignmentAccountId: Scalars['ID'];
};


export type AdmincouponByIdArgs = {
  id: Scalars['Int'];
};


export type AdmincouponRedirectArgs = {
  input: CouponRedirectInput;
};


export type AdmincxBillingAuditEventsArgs = {
  input: CxBillingAuditInput;
};


export type AdmindevicesArgs = {
  moduleIds: Array<Scalars['String']>;
};


export type AdminfindUsersInGroupArgs = {
  groupName: Scalars['String'];
};


export type AdminfirmwareStatisticsArgs = {
  platformId: Scalars['String'];
};


export type AdmingrowthBookExperimentForcedVariantUrlArgs = {
  experimentId: Scalars['String'];
  variantId: Scalars['String'];
};


export type AdminhouseholdEventHistoryArgs = {
  householdId: Scalars['ID'];
};


export type AdmininPersonEventArgs = {
  id: Scalars['ID'];
};


export type AdmininPersonEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<InPersonEventQuery>;
};


export type AdminmoduleEventHistoryArgs = {
  moduleId: Scalars['String'];
};


export type AdminpetEventHistoryArgs = {
  petId: Scalars['ID'];
};


export type AdminplaceEventHistoryArgs = {
  userId: Scalars['ID'];
};


export type AdminplatformsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};


export type AdminpreviewCreateCouponArgs = {
  input: CreateCouponInput;
};


export type AdminpromotionArgs = {
  id: Scalars['Int'];
};


export type AdminrecentHealthGptMessagesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type AdminrecentlyPurchasedItemsArgs = {
  householdId: Scalars['ID'];
};


export type AdminreferralRewardHistoryArgs = {
  userId: Scalars['ID'];
};


export type AdminsearchChipResellersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<ChipResellerQueryInput>;
};


export type AdminsearchChipsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<ChipQueryInput>;
};


export type AdminsearchDevicesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<DeviceQueryInput>;
};


export type AdminsearchPetsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  tenancy?: InputMaybe<Scalars['String']>;
};


export type AdminsearchUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  tenancy?: InputMaybe<Scalars['String']>;
};


export type AdminsignUrlArgs = {
  url: Scalars['String'];
};


export type AdminsubscriptionEventHistoryArgs = {
  subscriptionId: Scalars['String'];
};


export type AdmintestDateTimeParsingArgs = {
  dt?: InputMaybe<Scalars['DateTime']>;
};


export type AdminuserEventHistoryArgs = {
  userId: Scalars['ID'];
};

export type AdminAddDogParkFromOSMInput = {
  isDiscoverableOverride?: InputMaybe<Scalars['Boolean']>;
  osmWayId: Scalars['String'];
  preventUpdate?: InputMaybe<Scalars['Boolean']>;
};

export type AdminAddItemToListResult = {
  __typename?: 'AdminAddItemToListResult';
  /** The newly-created item that was added to the AdminList. */
  item: AdminListItem;
  list: AdminList;
};

export type AdminAllChargingBasesInput = {
  assignedOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlineSince?: InputMaybe<Scalars['DateTime']>;
  platformId?: InputMaybe<Scalars['String']>;
  updateChannel?: InputMaybe<Scalars['String']>;
};

export type AdminBaseUserProfile = {
  billingAccount?: Maybe<BillingAccount>;
  chipReseller?: Maybe<ChipReseller>;
  dbId: Scalars['Int'];
  deactivated: Scalars['Boolean'];
  ecommerceOrders: Array<Order>;
  email: Scalars['String'];
  emails: Array<UserEmail>;
  firstName: Scalars['String'];
  groups: Array<UserGroup>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  referrals: Referrals;
  /** Returns all feature flag values by default, but can optionally provide an array of feature flag names to return */
  targetedFeatureFlags: Array<TargetedFeatureFlag>;
  tenancy?: Maybe<Scalars['String']>;
  thirdPartyAccess?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  userHouseholds: Array<UserHousehold>;
};


export type AdminBaseUserProfilegroupsArgs = {
  excludePseudo?: InputMaybe<Scalars['Boolean']>;
};


export type AdminBaseUserProfiletargetedFeatureFlagsArgs = {
  names?: InputMaybe<Array<Scalars['String']>>;
};

export type AdminBulkAssignUsersToGroupInput = {
  groupName: Scalars['String'];
  uploadedFileKey: Scalars['String'];
};

export type AdminCartInput = {
  cartItems: Array<AdminCartItemInput>;
  couponCode?: InputMaybe<Scalars['String']>;
};

export type AdminCartItemInput = {
  cartItemId: Scalars['String'];
  lineItem: CartLineItemInput;
  quantity: Scalars['Int'];
  subscriptionLineItem?: InputMaybe<CartLineItemInput>;
};

export type AdminClaimNanoWebIdsInput = {
  number: Scalars['Int'];
};

export type AdminCommentsByPetResult = {
  __typename?: 'AdminCommentsByPetResult';
  comments: Array<Comment>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type AdminCreateBreedInput = {
  name: Scalars['String'];
  species: Species;
};

export type AdminCreateConsignmentOrderInput = {
  cart: AdminCartInput;
  /** The order channel. Defaults to CONSIGNMENT_RETAIL if not provided. */
  channel?: InputMaybe<OrderChannel>;
  consignmentLocationId: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
};

export type AdminCreateDogParkCheckinExclusionInput = {
  dogParkEncodedUuid: Scalars['ID'];
  /** Prefer to use petId instead of petDbId */
  petDbId: Scalars['Int'];
  petId?: InputMaybe<Scalars['ID']>;
};

export type AdminCreateEvalGuidelineInput = {
  appliesWhen?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  exampleBadResponse?: InputMaybe<Scalars['String']>;
  exampleGoodResponse?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  scope: EvalGuidelineScope;
  severity: EvalGuidelineSeverity;
  title: Scalars['String'];
};

export type AdminCreateInternalOrderInput = {
  cart: AdminCartInput;
  channel: OrderChannel;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  /** Optional notes about the order. */
  notes?: InputMaybe<Scalars['String']>;
  /** Partner name for the order. */
  partnerName: Scalars['String'];
  shippingAddress: AddressInput;
  shippingOption: ShippingOption;
  /** Number of subscription override months to apply to modules after shipment. */
  subscriptionOverrideMonths?: InputMaybe<Scalars['Int']>;
};

export type AdminCreateOrderInput = {
  billingAddress?: InputMaybe<AddressInput>;
  billingFirstName: Scalars['String'];
  billingLastName: Scalars['String'];
  billingToken: Scalars['String'];
  cart: AdminCartInput;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  shippingAddress: AddressInput;
  shippingOption?: InputMaybe<ShippingOption>;
};

export type AdminCreatePurchaseInput = {
  lineItems: Array<AdminLineItemInput>;
  userId: Scalars['ID'];
};

export type AdminCreateTargetedFeatureFlagInput = {
  description?: InputMaybe<Scalars['String']>;
  forcedValue?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  percentOfUsers?: InputMaybe<Scalars['Float']>;
  targetingRules?: InputMaybe<Scalars['JSON']>;
};

export type AdminCreateVipUserLookupCriteriaInput = {
  email?: InputMaybe<Scalars['String']>;
  emailDomain?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<AdminCreateVipUserLookupCriteriaNameInput>;
};

export type AdminCreateVipUserLookupCriteriaNameInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type AdminDeviceActuationsInput = {
  dateRange: DateRangeInput;
  moduleId: Scalars['String'];
};

export type AdminDeviceActuationsResult = {
  __typename?: 'AdminDeviceActuationsResult';
  actuations: Array<DeviceActuation>;
  totalCount: Scalars['Int'];
};

export type AdminDeviceHealthStatisticsInput = {
  customRange?: InputMaybe<DateRangeInput>;
  moduleId: Scalars['String'];
};

export type AdminDeviceHealthStatisticsResult = {
  __typename?: 'AdminDeviceHealthStatisticsResult';
  statistics: DeviceHealthStatistics;
};

export type AdminDogParkCheckinExclusion = {
  __typename?: 'AdminDogParkCheckinExclusion';
  createdAt: Scalars['DateTime'];
  dogPark: DogPark;
  id: Scalars['ID'];
  pet: StrangerPet;
};

export type AdminGPSTestConclusiveResult = {
  __typename?: 'AdminGPSTestConclusiveResult';
  result: GPSTestResult;
};

/** Indicates there was an internal error determining the result of the test */
export type AdminGPSTestErrorResult = {
  __typename?: 'AdminGPSTestErrorResult';
  errorDescription: Scalars['String'];
};

export type AdminGPSTestResult = AdminGPSTestConclusiveResult | AdminGPSTestErrorResult | AdminGPSTestTimeoutResult;

export type AdminGPSTestTimeoutResult = {
  __typename?: 'AdminGPSTestTimeoutResult';
  timedOut?: Maybe<Scalars['Boolean']>;
};

export type AdminGetZoomVideoSdkTokenInput = {
  userId: Scalars['ID'];
};

export type AdminHealthGptAddMessageInput = {
  llmOverride?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  petId: Scalars['ID'];
  promptTemplatesOverride?: InputMaybe<AdminHealthGptPromptTemplatesInput>;
  /**
   * Controls randomness of a model's output.
   * - 0.0: Fully deterministic — the model always chooses the highest-probability next token. (Same input → same output every time.)
   * - 0.7: Default for many OpenAI endpoints — balances randomness and coherence.
   * - 1.0: Higher randomness and creativity, more diverse outputs.
   * - >1.0 up to 2.0: Very exploratory — often leads to incoherent or nonsensical responses, but can be useful in rare creative tasks.
   */
  temperatureOverride?: InputMaybe<Scalars['Float']>;
};

export type AdminHealthGptConfig = {
  __typename?: 'AdminHealthGptConfig';
  availableLlms: Array<Scalars['String']>;
  currentLlm: Scalars['String'];
  /**
   * Controls randomness of a model's output.
   * - 0.0: Fully deterministic — the model always chooses the highest-probability next token. (Same input → same output every time.)
   * - 0.7: Default for many OpenAI endpoints — balances randomness and coherence.
   * - 1.0: Higher randomness and creativity, more diverse outputs.
   * - >1.0 up to 2.0: Very exploratory — often leads to incoherent or nonsensical responses, but can be useful in rare creative tasks.
   */
  currentTemperature?: Maybe<Scalars['Float']>;
  promptTemplates: AdminHealthGptPromptTemplates;
};

export type AdminHealthGptCreateDocumentInput = {
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  uploadedFileKey: Scalars['String'];
};

export type AdminHealthGptDocument = {
  __typename?: 'AdminHealthGptDocument';
  createdAt: Scalars['DateTime'];
  fetchFileUrl: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['ID'];
  status: HealthGptDocumentStatus;
  updateFileUrl: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type AdminHealthGptMessage = {
  __typename?: 'AdminHealthGptMessage';
  breedSummaryData?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  documents?: Maybe<Scalars['JSON']>;
  estimatedCostCents?: Maybe<Scalars['Float']>;
  expandedMessage?: Maybe<Scalars['String']>;
  graphqlData?: Maybe<Scalars['JSON']>;
  graphqlQuery?: Maybe<Scalars['String']>;
  graphqlQueryError?: Maybe<AdminHealthGptQueryError>;
  id: Scalars['ID'];
  inputTokens?: Maybe<Scalars['Int']>;
  outputTokens?: Maybe<Scalars['Int']>;
  petDetails?: Maybe<Scalars['JSON']>;
  petDocuments?: Maybe<Scalars['JSON']>;
  prompt?: Maybe<Scalars['String']>;
  queryExpansionReason?: Maybe<Scalars['String']>;
  queryWasExpanded?: Maybe<Scalars['Boolean']>;
  request: Scalars['String'];
  response: Scalars['String'];
  threadId: Scalars['ID'];
  timing?: Maybe<AdminHealthGptTiming>;
  userFeedback?: Maybe<HealthGptChatMessageUserFeedback>;
};

export type AdminHealthGptMessagesConnection = {
  __typename?: 'AdminHealthGptMessagesConnection';
  items: Array<AdminHealthGptMessage>;
  pageInfo: PageInfo;
};

export type AdminHealthGptPromptTemplates = {
  __typename?: 'AdminHealthGptPromptTemplates';
  brandTone: Scalars['String'];
  dataFetching: Scalars['String'];
  dataInclusion: Scalars['String'];
  responseFormat: Scalars['String'];
  userQuestion: Scalars['String'];
};

/** Can be specified to override default prompt template in the context of this request */
export type AdminHealthGptPromptTemplatesInput = {
  brandTone?: InputMaybe<Scalars['String']>;
  dataFetching?: InputMaybe<Scalars['String']>;
  dataInclusion?: InputMaybe<Scalars['String']>;
  responseFormat?: InputMaybe<Scalars['String']>;
  userQuestion?: InputMaybe<Scalars['String']>;
};

export type AdminHealthGptQueryError = {
  __typename?: 'AdminHealthGptQueryError';
  errors: Array<Scalars['String']>;
  query: Scalars['String'];
};

export type AdminHealthGptStepTiming = {
  __typename?: 'AdminHealthGptStepTiming';
  children?: Maybe<Array<AdminHealthGptStepTiming>>;
  durationMs: Scalars['Int'];
  mode?: Maybe<AdminHealthGptTimingMode>;
  step: Scalars['String'];
};

export type AdminHealthGptThread = {
  __typename?: 'AdminHealthGptThread';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastMessage?: Maybe<Scalars['DateTime']>;
  pet: Pet;
  totalMessages: Scalars['Int'];
};

export type AdminHealthGptTiming = {
  __typename?: 'AdminHealthGptTiming';
  breakdown: Array<AdminHealthGptStepTiming>;
  totalMs: Scalars['Int'];
};

export enum AdminHealthGptTimingMode {
  parallel = 'parallel',
  sequential = 'sequential'
}

export type AdminHealthGptUpdateDocumentInput = {
  fileName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export enum AdminLevel {
  CITY = 'CITY',
  STATE = 'STATE'
}

export type AdminLineItemInput = {
  id: Scalars['ID'];
  priceOverrideInCents?: InputMaybe<Scalars['Int']>;
  quantity: Scalars['Int'];
};

export type AdminList = {
  __typename?: 'AdminList';
  id: Scalars['ID'];
  /** The items in descending order of creation date. */
  items: Array<AdminListItem>;
  name: Scalars['String'];
};

export type AdminListItem = {
  __typename?: 'AdminListItem';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['JSON'];
};

export type AdminMobileAppBanner = MobileAppBannerInterface & {
  __typename?: 'AdminMobileAppBanner';
  backgroundColorHex: Scalars['HexColorCode'];
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  destinationUrl: Scalars['String'];
  foregroundColorHex: Scalars['HexColorCode'];
  id: Scalars['ID'];
  internalName: Scalars['String'];
  leadingImage?: Maybe<MobileAppBannerImage>;
  title: Scalars['String'];
};

export type AdminMobileAppBlockerScreen = MobileAppBlockerScreenInterface & {
  __typename?: 'AdminMobileAppBlockerScreen';
  bottomSheet: MobileAppBlockerScreenBottomSheet;
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  internalName: Scalars['String'];
  pages: Array<MobileAppBlockerScreenPage>;
};

export type AdminMobileAppBottomSheet = MobileAppBottomSheetInterface & {
  __typename?: 'AdminMobileAppBottomSheet';
  buttons: Array<MobileAppBottomSheetButton>;
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  formattedDescription: FormatString;
  formattedTitle: FormatString;
  id: Scalars['ID'];
  image?: Maybe<MobileAppBottomSheetImage>;
  internalName: Scalars['String'];
  title: Scalars['String'];
};

export type AdminMobileAppContent = AdminMobileAppBanner | AdminMobileAppBlockerScreen | AdminMobileAppBottomSheet | AdminMobileAppDiscoverItem | AdminMobileAppPermissionBlockerScreen | AdminMobileAppSplashScreen;

export type AdminMobileAppContentTargeting = {
  __typename?: 'AdminMobileAppContentTargeting';
  clientView?: Maybe<MobileAppContentSourceView>;
  dismissalDurationSeconds?: Maybe<Scalars['Int']>;
  endAt?: Maybe<Scalars['DateTime']>;
  isActive: Scalars['Boolean'];
  priority: Scalars['Int'];
  requiresTrigger: Scalars['Boolean'];
  startAt?: Maybe<Scalars['DateTime']>;
  targetSpecies: Array<Species>;
  /**
   * JSON converted `json-rules-engine` rules.
   * No targeting rules will result in content being visible to any user/pet
   * See https://github.com/CacheControl/json-rules-engine/blob/master/docs/rules.md#persisting
   */
  targetingRules?: Maybe<Scalars['JSON']>;
};

export type AdminMobileAppDiscoverItem = MobileAppDiscoverItemInterface & {
  __typename?: 'AdminMobileAppDiscoverItem';
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  destinationUrl: Scalars['String'];
  id: Scalars['ID'];
  image: Image;
  internalName: Scalars['String'];
  title: Scalars['String'];
};

export type AdminMobileAppPermissionBlockerScreen = MobileAppPermissionBlockerScreenInterface & {
  __typename?: 'AdminMobileAppPermissionBlockerScreen';
  bottomSheet: MobileAppBlockerScreenBottomSheet;
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime'];
  dismissable: Scalars['Boolean'];
  id: Scalars['ID'];
  internalName: Scalars['String'];
  pages: Array<MobileAppBlockerScreenPage>;
  permissionType: Scalars['String'];
};

export type AdminMobileAppSplashScreen = MobileAppSplashScreenInterface & {
  __typename?: 'AdminMobileAppSplashScreen';
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  internalName: Scalars['String'];
  pages: Array<MobileAppSplashScreenPage>;
};

export type AdminPetDocument = BasePetDocument & {
  __typename?: 'AdminPetDocument';
  date: Scalars['DateTime'];
  dbId: Scalars['Int'];
  fileName: Scalars['String'];
  fileSizeBytes: Scalars['Int'];
  fileType: Scalars['String'];
  fileUrl: Scalars['String'];
  id: Scalars['ID'];
  isUnseen: Scalars['Boolean'];
  labels?: Maybe<Array<Scalars['String']>>;
  markdownFileUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pets: Array<Pet>;
  status: PetDocumentStatus;
  summary?: Maybe<Scalars['String']>;
  totalCostCents?: Maybe<Scalars['Int']>;
  type: PetDocumentType;
};

export enum AdminPreSignedUploadPurpose {
  BULK_GROUP_ASSIGNMENT = 'BULK_GROUP_ASSIGNMENT',
  CONSIGNMENT_RESALE_CERTIFICATE = 'CONSIGNMENT_RESALE_CERTIFICATE',
  HEALTH_GPT = 'HEALTH_GPT',
  IAC_SHIPMENTS = 'IAC_SHIPMENTS'
}

export type AdminPreSignedUploadUrlInput = {
  contentType: Scalars['String'];
  filename?: InputMaybe<Scalars['String']>;
  purpose: AdminPreSignedUploadPurpose;
};

export type AdminPreviewOrderInput = {
  cart: AdminCartInput;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  shippingAddress: AddressInput;
  shippingOption?: InputMaybe<ShippingOption>;
};

export type AdminQueryNanoBatchInput = {
  batchId: Scalars['String'];
};

export type AdminRecentGPSTest = {
  __typename?: 'AdminRecentGPSTest';
  date: Scalars['DateTime'];
  duration: Scalars['Int'];
  /** A location report associated with the test result, if there is one. */
  locationReport?: Maybe<LocationReport>;
  result: AdminGPSTestResult;
  user: User;
};

export type AdminRecentGPSTests = {
  __typename?: 'AdminRecentGPSTests';
  tests: Array<AdminRecentGPSTest>;
};

export type AdminSearchDogParksInput = {
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<PositionInput>;
  radiusInMeters?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<POIType>;
};

export type AdminSendFreeNanoBoxesInput = {
  quantity: Scalars['Int'];
  userId: Scalars['ID'];
};

export type AdminSendScreenSharingNotificationInput = {
  push: Scalars['Boolean'];
  sms: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type AdminSendScreenSharingNotificationResult = {
  __typename?: 'AdminSendScreenSharingNotificationResult';
  pushSent: Scalars['Boolean'];
  smsSent: Scalars['Boolean'];
};

export type AdminSetThirdPartyAccessInput = {
  /** Calling this with an undefined thirdPartyAccess will remove any existing third party access */
  thirdPartyAccess?: InputMaybe<Scalars['String']>;
  /**
   * Finds matching user, and sets third party access for the user, for their household,
   * and for any pet they are an OWNER of.
   */
  userEmail?: InputMaybe<Scalars['String']>;
};

export type AdminTargetedFeatureFlag = {
  __typename?: 'AdminTargetedFeatureFlag';
  createdAt: Scalars['DateTime'];
  createdByUserEmail: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** A value here will override any value determined by the targetingRules. Can be helpful to disable a feature flag without needing to clear out the targetingRules. */
  forcedValue?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /**
   * If provided, this flag is only active for a percentage of users. This is in combination with the `targetingRules`.
   * If targetingRules are also specified, this percentage is applied to the users that match the `targetingRules`.
   */
  percentOfUsers?: Maybe<Scalars['Float']>;
  /**
   * JSON converted `json-rules-engine` rules.
   * See https://github.com/CacheControl/json-rules-engine/blob/master/docs/rules.md#persisting
   */
  targetingRules?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['DateTime'];
};

export type AdminTimeline = {
  __typename?: 'AdminTimeline';
  query: TimelineQueryResult;
};


export type AdminTimelinequeryArgs = {
  input: TimelineQueryInput;
};

export type AdminTriggerCustomerIoEventResult = {
  __typename?: 'AdminTriggerCustomerIoEventResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AdminUpdateChipPetInput = {
  chipId: Scalars['ID'];
  petId?: InputMaybe<Scalars['ID']>;
};

export type AdminUpdateChipResellerByBoxIdsInput = {
  boxIds: Array<Scalars['String']>;
  resellerId: Scalars['ID'];
};

export type AdminUpdateChipResellerByBoxInput = {
  boxId: Scalars['String'];
  resellerId: Scalars['ID'];
};

export type AdminUpdateChipResellerBySerialNumberInput = {
  resellerId: Scalars['ID'];
  serialNumbers: Array<Scalars['String']>;
};

export type AdminUpdateChipResellerInput = {
  chipId: Scalars['ID'];
  resellerId?: InputMaybe<Scalars['ID']>;
};

export type AdminUpdateEvalGuidelineInput = {
  appliesWhen?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  exampleBadResponse?: InputMaybe<Scalars['String']>;
  exampleGoodResponse?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  scope?: InputMaybe<EvalGuidelineScope>;
  severity?: InputMaybe<EvalGuidelineSeverity>;
  title?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateInventoryConfigurationInput = {
  allowAutoMarkOutOfStock?: InputMaybe<Scalars['Boolean']>;
  allowFulfillment?: InputMaybe<Scalars['Boolean']>;
  backInStockDateOverride?: InputMaybe<Scalars['DateTime']>;
  inStock?: InputMaybe<Scalars['Boolean']>;
  justInTimeKittingEnabled?: InputMaybe<Scalars['Boolean']>;
  manualInventoryAdjustment?: InputMaybe<Scalars['Int']>;
  outOfStockThreshold?: InputMaybe<Scalars['Int']>;
  sku: Scalars['String'];
  warehouseId?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateTargetedFeatureFlagInput = {
  description?: InputMaybe<Scalars['String']>;
  forcedValue?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  percentOfUsers?: InputMaybe<Scalars['Float']>;
  targetingRules?: InputMaybe<Scalars['JSON']>;
};

export type AdminUploadImageResult = {
  __typename?: 'AdminUploadImageResult';
  image: Image;
};

export type AdminUpsertFulfillmentWarehouseInput = {
  /** is the warehouse active and can be used for fulfillment */
  active?: InputMaybe<Scalars['Boolean']>;
  /** the code the 3PL uses to identify the warehouse */
  externalCode: Scalars['String'];
  /** code for the fulfillment provider (3PL) */
  fulfillmentProviderCode: FulfillmentProviderCode;
  /** metadata for the warehouse */
  metadata?: InputMaybe<FulfillmentWarehouseMetadataInput>;
  /** our internal name for this warehouse */
  name?: InputMaybe<Scalars['String']>;
};

export type AdministrativeArea = {
  __typename?: 'AdministrativeArea';
  id: Scalars['ID'];
  level: AdminLevel;
  name: Scalars['String'];
};

export type AdopterAdoptionTransfersFilter = {
  status?: InputMaybe<PetAdoptionTransferStatus>;
};

export enum AdoptionTransferResolution {
  ACCEPT = 'ACCEPT',
  RESCUE_RESOLVE = 'RESCUE_RESOLVE'
}

export enum AgeRange {
  ADULT = 'ADULT',
  PUPPY = 'PUPPY',
  SENIOR = 'SENIOR'
}

export type AggregateHealthMetric = {
  __typename?: 'AggregateHealthMetric';
  binnedValues?: Maybe<HealthMetricBinnedValues>;
  count?: Maybe<HealthRollupValues>;
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  max?: Maybe<HealthRollupValues>;
  mean?: Maybe<HealthRollupValues>;
  median?: Maybe<HealthRollupValues>;
  min?: Maybe<HealthRollupValues>;
  p95?: Maybe<HealthRollupValues>;
  p99?: Maybe<HealthRollupValues>;
  unit?: Maybe<Scalars['String']>;
};

export type AirvetDataItem = {
  __typename?: 'AirvetDataItem';
  cancellationWebviewUrl: Scalars['String'];
  deeplinkUrl: Scalars['String'];
  hasActiveSubscription: Scalars['Boolean'];
  hasValidBillingInfo: Scalars['Boolean'];
  nextBillDate?: Maybe<Scalars['DateTime']>;
  shouldShowMenuItem: Scalars['Boolean'];
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionWillExpire: Scalars['Boolean'];
  unitAmountInCents: Scalars['Int'];
  updatePaymentWebviewUrl: Scalars['String'];
};

export type AnimatedShareableUrls = {
  __typename?: 'AnimatedShareableUrls';
  squareUrl?: Maybe<Scalars['String']>;
  storyUrl?: Maybe<Scalars['String']>;
};

export enum AnimationFormat {
  GIF = 'GIF',
  H264 = 'H264',
  H265 = 'H265',
  MP4 = 'MP4',
  WEBM = 'WEBM'
}

export type AnnotatedPointInTimeEvent = PointInTimeEvent & {
  __typename?: 'AnnotatedPointInTimeEvent';
  annotation: Scalars['String'];
  time: Scalars['DateTime'];
};

export type AnnotatedTimeRangeEvent = TimeRangeEvent & {
  __typename?: 'AnnotatedTimeRangeEvent';
  annotation: Scalars['String'];
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type AppIntegration = {
  __typename?: 'AppIntegration';
  appId: Scalars['String'];
  description: Scalars['String'];
  exampleCaption?: Maybe<Scalars['String']>;
  exampleImage?: Maybe<Image>;
  icon?: Maybe<Image>;
  title: Scalars['String'];
  userConnected: Scalars['Boolean'];
};

export enum AppIntegrationId {
  alltrails = 'alltrails',
  amazon_alexa = 'amazon_alexa',
  bark = 'bark',
  bringfido = 'bringfido',
  citizen = 'citizen',
  dyrt = 'dyrt',
  fitbit = 'fitbit',
  gaia = 'gaia',
  google_home = 'google_home',
  hiking_project = 'hiking_project',
  irobot_home = 'irobot_home',
  life360 = 'life360',
  mapmyfitness = 'mapmyfitness',
  nextdoor = 'nextdoor',
  nike_run_club = 'nike_run_club',
  nike_training_club = 'nike_training_club',
  oura = 'oura',
  pawshake = 'pawshake',
  peakfinder = 'peakfinder',
  peloton = 'peloton',
  puppr = 'puppr',
  ramblr = 'ramblr',
  ring = 'ring',
  rover = 'rover',
  strava = 'strava',
  wag = 'wag',
  whoop = 'whoop'
}

export type AppUpdatePrompt = {
  __typename?: 'AppUpdatePrompt';
  forced: Scalars['Boolean'];
};

export enum ApplicationState {
  BACKGROUND = 'BACKGROUND',
  INACTIVE = 'INACTIVE'
}

export type ApplyMultidogDiscountResult = {
  __typename?: 'ApplyMultidogDiscountResult';
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Represents a distance that has been obfuscated so as not to reveal
 * too precise of a distance/location. The `miles` field is truncated,
 * and below a certain distance it is capped and the `isLessThanThisDistance`
 * boolean is flagged true.
 */
export type ApproximateDistance = {
  __typename?: 'ApproximateDistance';
  isLessThanThisDistance: Scalars['Boolean'];
  miles: Scalars['Float'];
};

export type ArchiveFirmwareInput = {
  versions: Array<Scalars['String']>;
};

export type Article = {
  __typename?: 'Article';
  excerpt?: Maybe<Scalars['String']>;
  featureImageUrl?: Maybe<Scalars['String']>;
  html: Scalars['String'];
  id: Scalars['ID'];
  likeCount: Scalars['Int'];
  /** Whether the current user has liked this article. */
  liked: Scalars['Boolean'];
  primaryAuthor: ArticleAuthor;
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type ArticleAuthor = {
  __typename?: 'ArticleAuthor';
  name: Scalars['String'];
};

export type AspectRatio = {
  __typename?: 'AspectRatio';
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type AspectRatioInput = {
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type AssignNewOwnerToChipInput = {
  chipId: Scalars['ID'];
  contactInfo: ChipContactInfoInput;
};

export type AssignNewPetToChipInput = {
  chipId: Scalars['ID'];
  petInfo: ChipNewPetInput;
};

/**
 * A chip that the current user owns. It could either be that a pet in their household is assigned to their chip
 * or their email is listed as primary email in the chip contact info.
 */
export type AssignedChip = BaseChip & {
  __typename?: 'AssignedChip';
  id: Scalars['ID'];
  isFiChip: Scalars['Boolean'];
  latestContactHistoryEntry?: Maybe<ChipContactHistoryEntry>;
  /** @deprecated Use `latestContactHistoryEntry.contactInfo` instead */
  latestContactInfo?: Maybe<ChipContactInfo>;
  pet?: Maybe<StrangerPet>;
  serialNumber: Scalars['String'];
  shortId: Scalars['String'];
  /** An outstanding transfer request that the current owner of the chip can resolve/reject */
  transfer?: Maybe<ChipTransfer>;
};

export type AuditLogEvent = {
  __typename?: 'AuditLogEvent';
  action: Scalars['String'];
  body: Scalars['JSON'];
  id: Scalars['ID'];
  initiatedBy?: Maybe<AuditLogEventUser>;
  initiatedByEmail?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
};

/** Narrower user interface for only what audit log events need */
export type AuditLogEventUser = {
  __typename?: 'AuditLogEventUser';
  dbId?: Maybe<Scalars['Int']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type AvailableS3DowngradeSubscriptionOptionsInput = {
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  currency?: InputMaybe<Currency>;
  moduleId: Scalars['ID'];
};

export type AvailableS3DowngradeSubscriptionOptionsResult = {
  __typename?: 'AvailableS3DowngradeSubscriptionOptionsResult';
  subscriptionOptions: Array<SubscriptionOption>;
};

/** Subscription plan available for a product transfer. */
export type AvailableTransferPlan = {
  __typename?: 'AvailableTransferPlan';
  /** True if this plan matches the source subscription's term */
  isRecommended: Scalars['Boolean'];
  name: Scalars['String'];
  priceInCents: Scalars['Int'];
  renewalMonths: Scalars['Int'];
  sku: Scalars['String'];
};

export type AvatarAbbreviation = {
  __typename?: 'AvatarAbbreviation';
  abbreviation: Scalars['String'];
};

export type AvatarImage = {
  __typename?: 'AvatarImage';
  image: Image;
};

export type BBoxInput = {
  northEasternPosition: PositionInput;
  southWesternPosition: PositionInput;
};

export type BaseChip = {
  id: Scalars['ID'];
  isFiChip: Scalars['Boolean'];
  serialNumber: Scalars['String'];
  shortId: Scalars['String'];
};

export type BasePack = {
  actingPetCanJoin: Scalars['Boolean'];
  actingPetCanLeave: Scalars['Boolean'];
  actingPetCannotJoinReason?: Maybe<Scalars['String']>;
  actingPetDidManuallyJoin: Scalars['Boolean'];
  actingPetIsMember: Scalars['Boolean'];
  actingPetMembershipReason: Scalars['String'];
  ageFiltersWithEnoughRankedPets: Array<PackAgeFilter>;
  avatar: PackAvatar;
  category: PackCategory;
  description?: Maybe<Scalars['String']>;
  /**
   * A 6-digit hex color code, including # sign, and letters lowercase (eg.
   * `#ff00b1`) used to highlight this pack in the app.
   */
  highlightColorHex?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  joinPackUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petRanking: PackRanking;
  totalRankedPets: Scalars['Int'];
  /**
   * A 64-bit integer representing the total steps for all pets in this pack for
   * the latest ranking period returned as a String.
   */
  totalRankedSteps: Scalars['String'];
};


export type BasePackpetRankingArgs = {
  packAgeFilter?: InputMaybe<PackAgeFilter>;
  petId: Scalars['ID'];
};

export type BasePet = {
  additionalInfo?: Maybe<Scalars['String']>;
  breed?: Maybe<Breed>;
  color?: Maybe<Scalars['String']>;
  dayOfBirth?: Maybe<Scalars['Int']>;
  discoverPostFeed: PetDiscoverFeed;
  fiHandle?: Maybe<Scalars['String']>;
  followers: StrangerPetFeed;
  following: StrangerPetFeed;
  gender: Gender;
  /** @deprecated Use homeLocation instead */
  homeCityState?: Maybe<Scalars['String']>;
  homeLocation?: Maybe<PetHomeLocation>;
  id: Scalars['ID'];
  instagramHandle?: Maybe<Scalars['String']>;
  isPurebred: Scalars['Boolean'];
  monthOfBirth?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  photos: PhotoFeed;
  species?: Maybe<Species>;
  /** Information about step streaks */
  stepActivityInfo: StepActivityInfo;
  /** Total number of likes for this pet, across walks, photos, etc. */
  totalLikes: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  weight: Scalars['Float'];
  yearOfBirth: Scalars['Int'];
};


export type BasePetdiscoverPostFeedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type BasePetfollowersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type BasePetfollowingArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type BasePetBehaviorDetail = {
  behaviorId: Scalars['String'];
  behaviorLabel: Scalars['String'];
  color: Scalars['HexColorCode'];
  comparison: PetBehaviorDetailComparison;
  cursor: Scalars['String'];
  durationLabel: Scalars['String'];
  durationText: Scalars['String'];
  durationTextColor?: Maybe<Scalars['HexColorCode']>;
  eventCountLabel: Scalars['String'];
  eventCountText: Scalars['String'];
  eventCountTextColor: Scalars['HexColorCode'];
  help: PetBehaviorDetailHelp;
  icon: Image;
  nextCursor?: Maybe<Scalars['String']>;
  period: PetBehaviorPeriod;
  previousCursor?: Maybe<Scalars['String']>;
  /** A human readable label for this period of time */
  rangeLabel: Scalars['String'];
};

export type BasePetDocument = {
  date: Scalars['DateTime'];
  fileName: Scalars['String'];
  fileSizeBytes: Scalars['Int'];
  fileType: Scalars['String'];
  fileUrl: Scalars['String'];
  id: Scalars['ID'];
  isUnseen: Scalars['Boolean'];
  labels?: Maybe<Array<Scalars['String']>>;
  markdownFileUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: PetDocumentStatus;
  summary?: Maybe<Scalars['String']>;
  totalCostCents?: Maybe<Scalars['Int']>;
  type: PetDocumentType;
};

export type BasicPointInTimeEvent = PointInTimeEvent & {
  __typename?: 'BasicPointInTimeEvent';
  time: Scalars['DateTime'];
};

export type BasicTimeRangeEvent = TimeRangeEvent & {
  __typename?: 'BasicTimeRangeEvent';
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type BatteryHistoryAggregationBucket = {
  __typename?: 'BatteryHistoryAggregationBucket';
  date: Scalars['DateTime'];
  minBattery?: Maybe<Scalars['Float']>;
  minBq27421Temperature?: Maybe<Scalars['Float']>;
  minBq27421Voltage?: Maybe<Scalars['Float']>;
  minMax77658BatteryTemperatureC?: Maybe<Scalars['Float']>;
  minMax77658VoltageUv?: Maybe<Scalars['Float']>;
  minUserFacingBatteryPercent?: Maybe<Scalars['Float']>;
};

export type BatteryHistoryOverviewDeviceEvent = ConnectionStateChangeDeviceEvent | FirmwareVersionChangeDeviceEvent | PowerStateChangeDeviceEvent | RebootDeviceEvent;

export type BillingAccount = {
  __typename?: 'BillingAccount';
  accountBalanceInCents: Scalars['Int'];
  accountURL?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  billingInfo?: Maybe<BillingInfo>;
  billingInfoEditUrl?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  /** Active coupon redemptions on this account (account-level coupons, not subscription-specific) */
  couponRedemptions: Array<CouponRedemption>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  recurlyHostedBillingInfoUrl?: Maybe<Scalars['String']>;
  subscriptions: Array<BillingSubscription>;
};


export type BillingAccountsubscriptionsArgs = {
  filter?: InputMaybe<BillingSubscriptionFilter>;
};

export type BillingAccountInput = {
  address?: InputMaybe<AddressInput>;
  billingInfo?: InputMaybe<BillingInfoInput>;
  company?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type BillingAccountMini = {
  __typename?: 'BillingAccountMini';
  code?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export enum BillingCadence {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type BillingInfo = {
  __typename?: 'BillingInfo';
  address: Address;
  /** @deprecated Multiple payment types are now availble so use paymentInfo instead */
  cardInfo: ObfuscatedCardInfo;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  paymentInfo: PaymentInfo;
};

export enum BillingTokenType {
  RECURLY_JS_TOKEN = 'RECURLY_JS_TOKEN',
  STRIPE_CONFIRMATION_TOKEN = 'STRIPE_CONFIRMATION_TOKEN',
}

export type BillingInfoInput = {
  threeDSecureActionResultToken?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  tokenType?: InputMaybe<BillingTokenType>;
};

export type BillingSubscription = {
  __typename?: 'BillingSubscription';
  /**
   * Account-level notes from Recurly (CX agent notes, support history, etc.)
   * Returns empty array if notes cannot be fetched.
   */
  accountNotes?: Maybe<Array<AccountNote>>;
  activatedAt?: Maybe<Scalars['DateTime']>;
  address?: Maybe<ShippingAddress>;
  billingEmail?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  currentTermEndsAt: Scalars['DateTime'];
  /** The device associated with this subscription (if any). */
  device?: Maybe<Device>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** Whether this subscription's plan code is a free trial plan */
  hasFreeTrialPlan?: Maybe<Scalars['Boolean']>;
  /** Maps to Recurly Subscription UUID */
  id: Scalars['ID'];
  isCanceled?: Maybe<Scalars['Boolean']>;
  /** Whether this subscription is currently within its trial period */
  isInTrialPeriod?: Maybe<Scalars['Boolean']>;
  isPaused?: Maybe<Scalars['Boolean']>;
  /** Whether or not the most recent payment attempt failed */
  lastPaymentFailed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nextRenewalPreview?: Maybe<SubscriptionRenewalPreview>;
  nextSupplementShipmentDetails?: Maybe<NextSupplementShipmentDetails>;
  pausedAt?: Maybe<Scalars['DateTime']>;
  pendingChanges?: Maybe<SubscriptionPendingChange>;
  /** The pet associated with this subscription (via the device). */
  pet?: Maybe<Pet>;
  quantity: Scalars['Int'];
  state: BillingSubscriptionState;
  /** Details about the plan itself. Null if the plan code is unknown/invalid. */
  subscriptionOption?: Maybe<SubscriptionOption>;
  supplementShipmentDates?: Maybe<SupplementShipmentDates>;
  thirdPartyId?: Maybe<ThirdPartyId>;
  /** When the trial period ends (null if subscription never had a trial) */
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  unitAmountInCents: Scalars['Int'];
  /** Warning message if there's an issue with this subscription (e.g., unknown plan code). */
  warning?: Maybe<Scalars['String']>;
};

export type BillingSubscriptionFilter = {
  category?: InputMaybe<BillingSubscriptionFilterCategory>;
  state?: InputMaybe<BillingSubscriptionFilterState>;
};

/** The filter categories include all ProductCategory values */
export enum BillingSubscriptionFilterCategory {
  BAND = 'BAND',
  CHARGING_BASE = 'CHARGING_BASE',
  COLLAR_KIT = 'COLLAR_KIT',
  ENDLINK = 'ENDLINK',
  GIFT_CARD = 'GIFT_CARD',
  MICROCHIP = 'MICROCHIP',
  MODULE = 'MODULE',
  S2_UPGRADE = 'S2_UPGRADE',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SUPPLEMENT = 'SUPPLEMENT',
  THIRD_PARTY_MEMBERSHIP = 'THIRD_PARTY_MEMBERSHIP'
}

/** The filter states include all the BillingSubscriptionState plus additional meta states */
export enum BillingSubscriptionFilterState {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FUTURE = 'FUTURE',
  IN_TRIAL = 'IN_TRIAL',
  LIVE = 'LIVE',
  PAST_DUE = 'PAST_DUE',
  PAUSED = 'PAUSED'
}

export enum BillingSubscriptionState {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FUTURE = 'FUTURE',
  PAUSED = 'PAUSED'
}

/** Content related to the display of a pet's birthday card */
export type BirthdayCard = {
  __typename?: 'BirthdayCard';
  petPicture?: Maybe<Image>;
  poem?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type BoardingFacility = {
  __typename?: 'BoardingFacility';
  createdAt: Scalars['DateTime'];
  dbId: Scalars['Int'];
  household: Household;
  /**
   * The configuration required to integrate with the boarding facility's management software.
   * Admin-only field.
   */
  managementPlatformConfig?: Maybe<BoardingFacilityPlatformConfig>;
  managementPlatformType: Scalars['String'];
  /**
   * The timezone for the boarding facility (e.g., "America/New_York").
   * Used to determine when to send daily email updates.
   */
  timezone: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BoardingFacilityCheckInPetInput = {
  externalPetId: Scalars['ID'];
  householdId: Scalars['ID'];
  moduleId: Scalars['String'];
  reportSubmission?: InputMaybe<ReportSubmissionInput>;
};

export type BoardingFacilityContact = {
  __typename?: 'BoardingFacilityContact';
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type BoardingFacilityOwnerInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  /** If null, the user will have to reset their password via email */
  password?: InputMaybe<Scalars['String']>;
  tenancy?: InputMaybe<Scalars['String']>;
};

export type BoardingFacilityPetFeed = {
  __typename?: 'BoardingFacilityPetFeed';
  pageInfo: PageInfo;
  pets: Array<BoardingPet>;
};

export type BoardingFacilityPlatformConfig = GingrConfig;

export type BoardingFacilityProspectivePetFeed = {
  __typename?: 'BoardingFacilityProspectivePetFeed';
  pageInfo: PageInfo;
  pets: Array<ProspectiveBoardingPet>;
};

export type BoardingFacilityProspectivePetsInput = {
  householdId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  query: Scalars['String'];
};

export type BoardingFacilityStaffUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  /** If null, the user will have to reset their password via email */
  password?: InputMaybe<Scalars['String']>;
};

/**
 * Pet that exists in the boarding facility's third-party platform and is tied to a Fi pet because they have previously
 * checked a the boarding facility on the Fi app.
 */
export type BoardingPet = {
  __typename?: 'BoardingPet';
  /** Populated if the pet is currently checked in at the facility. */
  currentSession?: Maybe<BoardingSession>;
  fiPet: Pet;
  owner: BoardingFacilityContact;
  /**
   * This breed comes from the third-party platform and may not map to our own Breed type that we store on Pet so we
   * make this available separately as a String.
   */
  thirdPartyBreedName: Scalars['String'];
  /** The ID of the pet in the boarding facility's third-party platform. */
  thirdPartyPetId: Scalars['ID'];
  /** The next upcoming reservation time for the pet. */
  upcomingReservationTime?: Maybe<Scalars['DateTime']>;
};

export type BoardingSession = {
  __typename?: 'BoardingSession';
  checkedInAt: Scalars['DateTime'];
  checkedInByUser: User;
  checkedOutAt?: Maybe<Scalars['DateTime']>;
  checkedOutByUser?: Maybe<User>;
  household: Household;
  id: Scalars['ID'];
  pet: Pet;
};

export type BooleanFeatureFlag = FeatureFlag & {
  __typename?: 'BooleanFeatureFlag';
  accessedAt?: Maybe<Scalars['DateTime']>;
  booleanValue: BooleanSetting;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  dynamicSettingName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BooleanSetting = {
  platformOverrides: Array<BooleanSettingPlatformOverride>;
};

export type BooleanSettingForceOffPlatformOverride = BooleanSettingPlatformOverride & {
  __typename?: 'BooleanSettingForceOffPlatformOverride';
  forceOff: Scalars['Boolean'];
  platform: HandsetPlatform;
};

export type BooleanSettingForceOnPlatformOverride = BooleanSettingPlatformOverride & {
  __typename?: 'BooleanSettingForceOnPlatformOverride';
  forceOn: Scalars['Boolean'];
  platform: HandsetPlatform;
};

export type BooleanSettingMinVersionPlatformOverride = BooleanSettingPlatformOverride & {
  __typename?: 'BooleanSettingMinVersionPlatformOverride';
  minVersion: Scalars['String'];
  platform: HandsetPlatform;
};

export type BooleanSettingPlatformOverride = {
  platform: HandsetPlatform;
};

export type BooleanSettingPlatformOverrideInput = {
  /** Note: only one of `forceOn`, `forceOff`, or `minVersion` should be set. */
  forceOff?: InputMaybe<Scalars['Boolean']>;
  /** Note: only one of `forceOn`, `forceOff`, or `minVersion` should be set. */
  forceOn?: InputMaybe<Scalars['Boolean']>;
  /** Note: only one of `forceOn`, `forceOff`, or `minVersion` should be set. */
  minVersion?: InputMaybe<Scalars['String']>;
  platform: HandsetPlatform;
};

export enum BooleanSettingType {
  FALSE = 'FALSE',
  GROUPS = 'GROUPS',
  PERCENTAGE_OF_USERS = 'PERCENTAGE_OF_USERS',
  RANDOM_PERCENTAGE = 'RANDOM_PERCENTAGE',
  TRUE = 'TRUE',
  USER_IDS = 'USER_IDS'
}

export type Breed = {
  __typename?: 'Breed';
  dbId: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** @deprecated Sorting should be done server side */
  popularityScore: Scalars['Int'];
  species: Species;
};

export type BrowsePacksResponse = {
  __typename?: 'BrowsePacksResponse';
  packFeed: PackFeed;
};

export type BulkPackInsertResponse = {
  __typename?: 'BulkPackInsertResponse';
  error?: Maybe<Scalars['String']>;
  petWarnings?: Maybe<Array<Maybe<BulkPackInsertWarning>>>;
  success: Scalars['Boolean'];
  successPetIds: Array<Scalars['ID']>;
};

export type BulkPackInsertWarning = {
  __typename?: 'BulkPackInsertWarning';
  petId: Scalars['ID'];
  reason: ReasonForPackInsertFailure;
};

/** Result of cancel and refund operation */
export type CancelAndRefundResult = {
  __typename?: 'CancelAndRefundResult';
  /** Refund invoice (if refund was processed) */
  refundInvoice?: Maybe<RecurlyInvoice>;
  /** Amount refunded in cents */
  refundedAmountInCents: Scalars['Int'];
  /** Updated subscription */
  subscription: BillingSubscription;
};

/** Options for canceling and refunding a subscription */
export type CancelAndRefundSubscriptionInput = {
  /** CX agent notes (optional) */
  notes?: InputMaybe<Scalars['String']>;
  /** Refund type */
  refundType: SubscriptionRefundType;
  /** Subscription UUID to cancel */
  subscriptionId: Scalars['String'];
};

export type CancelMembershipInput = {
  recurlySubscriptionId: Scalars['String'];
};

export type CancelMembershipResult = {
  __typename?: 'CancelMembershipResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CancelOrderLineItemsInput = {
  cancelYearlySubscriptions?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lineItemIds: Array<Scalars['ID']>;
  placeOrderOnHold?: InputMaybe<Scalars['Boolean']>;
};

export type CancelSupplementSubscriptionInput = {
  recurlySubscriptionId: Scalars['ID'];
};

export type CancelSupplementSubscriptionResult = {
  __typename?: 'CancelSupplementSubscriptionResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CancelThirdPartySubscriptionInput = {
  recurlySubscriptionId: Scalars['String'];
};

export type CancelThirdPartySubscriptionResult = {
  __typename?: 'CancelThirdPartySubscriptionResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Card = {
  date: Scalars['DateTime'];
  icon?: Maybe<Image>;
  id: Scalars['ID'];
  message: FormatString;
  title?: Maybe<Scalars['String']>;
};

export type CardFeed = {
  __typename?: 'CardFeed';
  cards: Array<Card>;
  pageInfo: PageInfo;
};

export type CartLineItemInput = {
  lineItemId: Scalars['ID'];
  sku: Scalars['String'];
};

export type CartPurchaseResult = {
  __typename?: 'CartPurchaseResult';
  chargeInvoice?: Maybe<PurchaseResultInvoice>;
  giftCardInvoices: Array<PurchaseResultInvoice>;
  isGWP: Scalars['Boolean'];
  isReturningCustomer: Scalars['Boolean'];
};

export type ChangeLog = {
  __typename?: 'ChangeLog';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  type: ChangeLogType;
  uuid: Scalars['String'];
  version: Scalars['String'];
};

export enum ChangeLogType {
  ANDROID_APP = 'ANDROID_APP',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  BASE = 'BASE',
  COLLAR = 'COLLAR',
  IOS_APP = 'IOS_APP'
}

export type ChangeLogs = {
  __typename?: 'ChangeLogs';
  changeLogs: Array<ChangeLog>;
  hasNext: Scalars['Boolean'];
};

export type ChangeMembershipPlanEndOfTermInput = {
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  currency?: InputMaybe<Currency>;
  moduleId: Scalars['String'];
  newSku: Scalars['String'];
};

export type ChangeMembershipPlanEndOfTermResult = {
  __typename?: 'ChangeMembershipPlanEndOfTermResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ChargeAccountBySkuInput = {
  accountId: Scalars['ID'];
  couponCode?: InputMaybe<Scalars['String']>;
  ecomConfigType?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  sku: Scalars['String'];
  /** Optional price override in cents. When provided, uses this price instead of catalog price. */
  unitAmountInCents?: InputMaybe<Scalars['Int']>;
};

export type ChargeConsignmentAccountInput = {
  amountInCents: Scalars['Int'];
  consignmentAccountId: Scalars['ID'];
  description: Scalars['String'];
  ecomConfigType?: InputMaybe<Scalars['String']>;
};

export type ChargeConsignmentAccountResult = {
  __typename?: 'ChargeConsignmentAccountResult';
  error?: Maybe<Scalars['String']>;
  invoice?: Maybe<RecurlyInvoice>;
  success: Scalars['Boolean'];
};

/** Preview of account charge pricing for any product type */
export type ChargePreview = {
  __typename?: 'ChargePreview';
  /** Currency code (e.g., USD) */
  currency: Scalars['String'];
  /** Line items from Recurly invoice preview */
  lineItems: Array<PreviewLineItem>;
  /** Product name/description */
  productName: Scalars['String'];
  /** Quantity being charged */
  quantity: Scalars['Int'];
  /** SKU being previewed */
  sku: Scalars['String'];
  /** Tax amount in cents */
  taxInCents: Scalars['Int'];
  /** Total amount to charge in cents (including tax) */
  totalInCents: Scalars['Int'];
  /** Base price per unit in cents (before tax) */
  unitPriceInCents: Scalars['Int'];
};

/** Product available for charging to accounts */
export type ChargeableProduct = {
  __typename?: 'ChargeableProduct';
  /** Product category (e.g., BAND, CHARGING_BASE, MODULE) */
  category: Scalars['String'];
  /** Product display name */
  name: Scalars['String'];
  /** Price in cents (USD) */
  priceInCents: Scalars['Int'];
  /** Product SKU code */
  sku: Scalars['String'];
};

export type ChargingBase = {
  __typename?: 'ChargingBase';
  baseId: Scalars['String'];
  batch?: Maybe<Scalars['String']>;
  /**
   * BLE transmit power level for Bluetooth communication between the base and modules.
   * Integer value maps to BtPowerLevel protobuf enum (0-15).
   * See: @barkinglabs/protos-common base_submission.proto
   * When null, defaults to 15 (ESP_PWR_LVL_P21, +21dBm).
   */
  bleTxPowerLevel?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  credentialUpdate?: Maybe<CredentialUpdate>;
  dbId: Scalars['Int'];
  fccId?: Maybe<Scalars['String']>;
  hardwareRevision?: Maybe<Scalars['String']>;
  /** May be false if the system has reason to believe the base's position is no longer accurate */
  hasAccuratePosition: Scalars['Boolean'];
  household?: Maybe<Household>;
  icId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  info: Scalars['JSON'];
  infoLastUpdated: Scalars['DateTime'];
  isInSafeZone: Scalars['Boolean'];
  lastReportedFirmwareVersion?: Maybe<Scalars['String']>;
  macAddress?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  modelImageUrl: Scalars['String'];
  name: Scalars['String'];
  networkName?: Maybe<Scalars['String']>;
  online: Scalars['Boolean'];
  /** Indicative of how often the base is online (doesn't relate to connection to modules etc) */
  onlineQuality: DiagnosticStatus;
  percentOnlineLastNDays: Scalars['Int'];
  places: Array<Place>;
  platform: Platform;
  position?: Maybe<Position>;
  /**
   * Admin only
   *
   * Human readable string like "Series 3 Base"
   */
  readableModelName?: Maybe<Scalars['String']>;
  returnEligibility?: Maybe<RMAPolicyResult>;
  tenancy?: Maybe<Scalars['String']>;
  updateChannel?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  warrantyStatus?: Maybe<RMAPolicyResult>;
  wifiNetwork?: Maybe<WifiNetwork>;
};


export type ChargingBasecredentialUpdateArgs = {
  currentHash?: InputMaybe<Scalars['String']>;
};


export type ChargingBasepercentOnlineLastNDaysArgs = {
  nDays: Scalars['Int'];
};


export type ChargingBasereturnEligibilityArgs = {
  drilldownCode: Scalars['String'];
  reasonCode: Scalars['String'];
};


export type ChargingBasewarrantyStatusArgs = {
  drilldownCode: Scalars['String'];
  reasonCode: Scalars['String'];
};

export type ChargingBaseAssignable = {
  __typename?: 'ChargingBaseAssignable';
  assignable: Scalars['Boolean'];
};

export enum CheckFiHandleValidAndAvailableResponse {
  INVALID = 'INVALID',
  IS_TAKEN = 'IS_TAKEN',
  SUCCESS = 'SUCCESS'
}

export type CheckInNewRMAItemInput = {
  condition: RMAItemCondition;
  itemInput: RMAItemInput;
};

export type CheckInRMAInput = {
  id: Scalars['ID'];
  itemUpdates: Array<CheckInRMAItemInput>;
  newItems: Array<CheckInNewRMAItemInput>;
  reasonUpdate?: InputMaybe<CheckInReasonUpdate>;
};

export type CheckInRMAItemInput = {
  condition: RMAItemCondition;
  hardwareDefectCodes?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  serialNumber?: InputMaybe<Scalars['String']>;
};

export type CheckInReasonUpdate = {
  drilldownCode: Scalars['String'];
  processType: RMAProcessType;
  reasonCode: Scalars['String'];
};

export type CheckInUnknownReturnInput = {
  customerEmail?: InputMaybe<Scalars['String']>;
  customerName?: InputMaybe<Scalars['String']>;
  drilldownCode: Scalars['String'];
  invoiceNumber?: InputMaybe<Scalars['String']>;
  invoiceSource?: InputMaybe<InvoiceSource>;
  items: Array<CheckInNewRMAItemInput>;
  purchaseProvenanceCode?: InputMaybe<Scalars['String']>;
  reasonCode: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export enum ChipCondition {
  DAMAGED = 'DAMAGED',
  DECEASED_PET = 'DECEASED_PET',
  MISSING = 'MISSING',
  WORKING = 'WORKING'
}

export type ChipContactHistoryEntry = ChipContactInfoResponse & {
  __typename?: 'ChipContactHistoryEntry';
  contactInfo: ChipContactInfo;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  dbId: Scalars['Int'];
  id: Scalars['ID'];
  latest: Scalars['Boolean'];
  rejected: Scalars['Boolean'];
  source: ChipContactHistoryEntrySource;
};

export enum ChipContactHistoryEntrySource {
  FI_NANO = 'FI_NANO',
  SHELTERLUV_BACKFILL = 'SHELTERLUV_BACKFILL',
  SHELTERLUV_INCREMENTAL = 'SHELTERLUV_INCREMENTAL'
}

export type ChipContactInfo = {
  __typename?: 'ChipContactInfo';
  city?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  primaryEmail: Scalars['String'];
  primaryPhone?: Maybe<Scalars['String']>;
  secondaryEmail?: Maybe<Scalars['String']>;
  secondaryFirstName?: Maybe<Scalars['String']>;
  secondaryLastName?: Maybe<Scalars['String']>;
  secondaryPhone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** A chip with information relevant to a ChipReseller. */
export type ChipContactInfoForVerifiedRescue = {
  __typename?: 'ChipContactInfoForVerifiedRescue';
  dbId: Scalars['Int'];
  id: Scalars['ID'];
  latestContactHistoryEntry?: Maybe<ChipContactHistoryEntry>;
  serialNumber: Scalars['String'];
};

export type ChipContactInfoInput = {
  city?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  estimatedAnnualAdoptions?: InputMaybe<Scalars['String']>;
  estimatedMonthlyChipRegistrations?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  primaryEmail: Scalars['String'];
  primaryPhone?: InputMaybe<Scalars['String']>;
  secondaryEmail?: InputMaybe<Scalars['String']>;
  secondaryFirstName?: InputMaybe<Scalars['String']>;
  secondaryLastName?: InputMaybe<Scalars['String']>;
  secondaryPhone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type ChipContactInfoResponse = {
  contactInfo: ChipContactInfo;
  dbId: Scalars['Int'];
  id: Scalars['ID'];
};

export type ChipImportInput = {
  chips: Array<ChipInput>;
  updateOnDuplicate?: InputMaybe<ChipImportUpdateOnDuplicate>;
};

export enum ChipImportUpdateOnDuplicate {
  SERIAL_NUMBER = 'SERIAL_NUMBER',
  SHORT_ID = 'SHORT_ID'
}

export type ChipInput = {
  boxId?: InputMaybe<Scalars['String']>;
  cartonId: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  manufacturedAt: Scalars['DateTime'];
  serialNumber: Scalars['String'];
  shippedAt: Scalars['DateTime'];
  shortId: Scalars['String'];
  sku?: InputMaybe<Scalars['String']>;
};

export type ChipNewPetInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  breedId?: InputMaybe<Scalars['ID']>;
  color?: InputMaybe<Scalars['String']>;
  dayOfBirth?: InputMaybe<Scalars['Int']>;
  gender: Gender;
  isPurebred?: InputMaybe<Scalars['Boolean']>;
  monthOfBirth?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  species?: InputMaybe<Species>;
  weight: Scalars['Float'];
  yearOfBirth: Scalars['Int'];
};

export type ChipQueryInput = {
  assignedToPet?: InputMaybe<Scalars['Boolean']>;
  assignedToReseller?: InputMaybe<Scalars['Boolean']>;
  boxId?: InputMaybe<Scalars['String']>;
  cartonId?: InputMaybe<Scalars['String']>;
  primaryEmail?: InputMaybe<Scalars['String']>;
  primaryPhone?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']>>;
  shortId?: InputMaybe<Scalars['String']>;
  statusType?: InputMaybe<ChipStatusType>;
};

/** This step currently does not allow using an email email different from the current logged in user's email address */
export type ChipRegistrationAddEmailInput = {
  chipId: Scalars['ID'];
};

export type ChipRegistrationAddExistingPetInput = {
  chipId: Scalars['ID'];
  petId: Scalars['ID'];
};

export type ChipRegistrationAddNewPetInput = {
  chipId: Scalars['ID'];
  petInfo: ChipNewPetInput;
};

export type ChipRegistrationUpdateContactInput = {
  chipId: Scalars['ID'];
  contactInfo: ChipContactInfoInput;
};

export type ChipReseller = {
  __typename?: 'ChipReseller';
  chips: ResellerChipFeed;
  contactInfo: ChipContactInfo;
  dbId: Scalars['Int'];
  household: Household;
  id: Scalars['ID'];
  name: Scalars['String'];
  petInterestTypes?: Maybe<Array<Maybe<ResellerPetInterest>>>;
  preferences: ChipResellerPreferences;
  programInterest?: Maybe<Array<ResellerProgramInterest>>;
  rawShippingAddress?: Maybe<Address>;
  searchChips: ResellerChipFeed;
  shippingAddress?: Maybe<Address>;
  stats: ChipResellerStats;
  status: ResellerStatus;
  taxExemptType?: Maybe<ResellerTaxExemptType>;
  types?: Maybe<Array<Maybe<ResellerType>>>;
  verified: Scalars['Boolean'];
};


export type ChipResellerchipsArgs = {
  chipCondition?: InputMaybe<ChipCondition>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  statusType?: InputMaybe<ChipStatusType>;
};


export type ChipResellersearchChipsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<ChipQueryInput>;
};

export type ChipResellerContactInfoInput = {
  city?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  primaryPhone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type ChipResellerPreferences = {
  __typename?: 'ChipResellerPreferences';
  shelterluv?: Maybe<ShelterluvConfiguration>;
};

export type ChipResellerQueryInput = {
  email?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ResellerStatus>;
  type?: InputMaybe<ResellerType>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type ChipResellerShippingAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ChipResellerStats = {
  __typename?: 'ChipResellerStats';
  chipsRegisteredOnShelterluv: Scalars['Int'];
  chipsRegisteredThisMonth: Scalars['Int'];
  chipsRegisteredThroughFi: Scalars['Int'];
  nonWorkingChips: Scalars['Int'];
  pendingTransfers: Scalars['Int'];
  totalChips: Scalars['Int'];
  totalRegistered: Scalars['Int'];
  totalStock: Scalars['Int'];
};

export enum ChipStatusType {
  /** Chip that is registered to the reseller. TODO: rename this? */
  ACTIVE = 'ACTIVE',
  /** Chip that is pending transfer to a new owner. */
  REVIEW = 'REVIEW',
  /** Chip that is not registered. */
  SHIPPED = 'SHIPPED'
}

export type ChipTransfer = ChipContactInfoResponse & {
  __typename?: 'ChipTransfer';
  /**
   * Whether the current user can resolve this transfer (i.e. it is to them,
   * or they are a reseller and the current owner of the chip.)
   */
  canResolve: Scalars['Boolean'];
  chip: StrangerChip;
  contactInfo: ChipContactInfo;
  createdAt: Scalars['DateTime'];
  dbId: Scalars['Int'];
  id: Scalars['ID'];
  origin: ChipTransferOrigin;
  pet?: Maybe<StrangerPet>;
  status: ChipTransferStatus;
};

export enum ChipTransferOrigin {
  CURRENT_OWNER = 'CURRENT_OWNER',
  NEW_OWNER = 'NEW_OWNER'
}

export type ChipTransferQueryInput = {
  hasPet?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ChipTransferStatus>;
};

export enum ChipTransferStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELED = 'CANCELED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type Circle = {
  __typename?: 'Circle';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  radius: Scalars['Float'];
};

export type ClaimClickToCancelDiscountInput = {
  moduleId: Scalars['String'];
  recurlySubscriptionId: Scalars['String'];
};

export type ClaimClickToCancelDiscountResult = {
  __typename?: 'ClaimClickToCancelDiscountResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ClaimFreeMonthInput = {
  moduleId?: InputMaybe<Scalars['String']>;
};

export type ClaimFreeMonthResult = {
  __typename?: 'ClaimFreeMonthResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type ClaimSupplementDiscountInput = {
  recurlySubscriptionId: Scalars['ID'];
};

export type ClaimSupplementDiscountResult = {
  __typename?: 'ClaimSupplementDiscountResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ClaimTwoMonthsHalfOffInput = {
  moduleId?: InputMaybe<Scalars['String']>;
  recurlySubscriptionId: Scalars['String'];
};

export type ClaimTwoMonthsHalfOffResult = {
  __typename?: 'ClaimTwoMonthsHalfOffResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum ClientLocationAccuracy {
  DEFAULT = 'DEFAULT',
  HIGH = 'HIGH'
}

export type ClientUrls = {
  __typename?: 'ClientUrls';
  helpCenterBaseConnectivityImprovement: Scalars['String'];
  helpCenterBaseTroubleshooting: Scalars['String'];
  helpCenterBatteryImprovement: Scalars['String'];
  helpCenterLteGpsConnectivityInfo: Scalars['String'];
};

export enum CollarLostDogModeState {
  /** LDM is not enabled on the backend. */
  LDM_DISABLED = 'LDM_DISABLED',
  /** LDM is on from the backend perspective, and the collar has sent a report in LDM. */
  LDM_ENABLED = 'LDM_ENABLED',
  /** Collar has been informed of LDM state change, but has not yet sent a report in LDM. */
  LDM_REPORT_PENDING = 'LDM_REPORT_PENDING',
  /** LDM has been toggled on in App or Admin. */
  LDM_REQUESTED = 'LDM_REQUESTED',
  /**
   * LDM has been toggled on in App or Admin, but the collar hasn't acknowledged
   * the request for some time.
   */
  LDM_REQUESTED_LONG_DELAY = 'LDM_REQUESTED_LONG_DELAY'
}

export type CollarStatus = OfflineCollarStatus | OnlineCollarStatus;

export type Comment = {
  __typename?: 'Comment';
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** Admin-only */
  dbId: Scalars['Int'];
  deleted: Scalars['Boolean'];
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  likeCount: Scalars['Int'];
  /** If the current user has liked this comment. */
  liked: Scalars['Boolean'];
  /** The parent post this comment belongs to. */
  parentPost?: Maybe<CommentParentPost>;
  strangerPet: StrangerPet;
};

export type CommentFeed = {
  __typename?: 'CommentFeed';
  items: Array<Comment>;
  totalCount: Scalars['Int'];
};


export type CommentFeeditemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type CommentModerationFeed = ModerationFeed & {
  __typename?: 'CommentModerationFeed';
  items: Array<ModerationCommentItem>;
  totalCount: Scalars['Int'];
};

export type CommentParentPost = Photo | TextPost | VideoPost;

export type ConcreteDailyRestSummary = DailyRestSummary & {
  __typename?: 'ConcreteDailyRestSummary';
  date: Scalars['DateTime'];
  sleepAmounts: Array<SleepAmount>;
};

/** A detailed breakdown of a pet's sleep period including interruptions. */
export type ConcreteOvernightRestSummary = OvernightRestSummary & {
  __typename?: 'ConcreteOvernightRestSummary';
  /**
   * The date on which sleep commenced (e.g. the pet slept on this night.)
   * This is a DateTime at midnight in the client's timezone that should be used for its date components only.
   */
  date: Scalars['DateTime'];
  interruptions: Array<SleepInterruptionSpan>;
  sleepEnd: Scalars['DateTime'];
  sleepSeconds: Scalars['Int'];
  sleepStart: Scalars['DateTime'];
};

export type ConcreteRestSummaryData = {
  __typename?: 'ConcreteRestSummaryData';
  hourlySleepBars: Array<HourlySleepBar>;
  /** E.g. duration pet was napping, duration pet was sleeping, for this day/week/month. */
  sleepAmounts: Array<SleepAmount>;
};

export type ConnectedToBase = ConnectionState & {
  __typename?: 'ConnectedToBase';
  chargingBase: ChargingBase;
  date: Scalars['DateTime'];
};

export type ConnectedToCellular = ConnectionState & {
  __typename?: 'ConnectedToCellular';
  date: Scalars['DateTime'];
  /**
   * DEPRECATED! This only represents cell strength at an instant in time
   * and is practically useless.
   */
  signalStrengthPercent?: Maybe<Scalars['Int']>;
};

export type ConnectedToUser = ConnectionState & {
  __typename?: 'ConnectedToUser';
  date: Scalars['DateTime'];
  user: User;
  userDevice: UserDevice;
};

export type ConnectedToWifi = ConnectionState & {
  __typename?: 'ConnectedToWifi';
  date: Scalars['DateTime'];
  ssid: Scalars['String'];
};

export type ConnectedWifiInput = {
  bssid?: InputMaybe<Scalars['String']>;
  ssid?: InputMaybe<Scalars['String']>;
};

export type ConnectionState = {
  date: Scalars['DateTime'];
};

export type ConnectionStateChangeDeviceEvent = DeviceEventBase & {
  __typename?: 'ConnectionStateChangeDeviceEvent';
  date: Scalars['DateTime'];
  firmwareVersion?: Maybe<Scalars['String']>;
  moduleId: Scalars['String'];
  newConnectionStateType: ConnectionStateType;
  oldConnectionStateType: ConnectionStateType;
  platform: Scalars['String'];
  prevDate: Scalars['DateTime'];
  prevDuration: Scalars['Float'];
};

export type ConnectionStateChangesResult = {
  __typename?: 'ConnectionStateChangesResult';
  maxResultsReached: Scalars['Boolean'];
  results: Array<ConnectionStateChangeDeviceEvent>;
};

export enum ConnectionStateType {
  BASE = 'BASE',
  CELLULAR = 'CELLULAR',
  MOBILE = 'MOBILE',
  UNKNOWN = 'UNKNOWN',
  WEARABLE = 'WEARABLE',
  WIFI = 'WIFI'
}

/**
 * A consignment account represents a business (e.g., boarding facility, small retail store, private dog park)
 * that sells Fi units on consignment. When a consignor sells a unit, they receive a portion of the sale price
 * when the unit is activated.
 */
export type ConsignmentAccount = {
  __typename?: 'ConsignmentAccount';
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhone?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dbId: Scalars['Int'];
  fiSalesRepEmail: Scalars['String'];
  /**
   * Whether the account has a payment method stored in Recurly.
   *
   * **Important:** This field queries the Recurly API directly and counts against Recurly's rate limits
   * (5,000 requests per 5 minutes). Each account queried makes one API call.
   *
   * **Usage Guidelines:**
   * - ✅ Safe for individual account queries
   * - ✅ Safe for small lists (< 20 accounts)
   * - ❌ Should NOT be used for list or bulk actions without caching
   * - ⚠️ Future: if needed for bulk operations, implement Redis caching similar to `hasValidBillingInfo`
   */
  hasPaymentMethod: Scalars['Boolean'];
  id: Scalars['ID'];
  locations: Array<ConsignmentLocation>;
  locationsCount: Scalars['Int'];
  name: Scalars['String'];
  recurlyAccountCode?: Maybe<Scalars['String']>;
  /**
   * Account code to use when creating a Recurly account manually (Customers → New account).
   * Use this exact value as the Recurly account code so we can link the account. After creating
   * the account in Recurly, use "Create Recurly account" in this UI to link it (or create via UI).
   */
  recurlyAccountCodeForLinking: Scalars['String'];
  /**
   * Recurly dashboard URL to open this account. Use this to go to Hosted Pages and copy the Edit Billing Information URL.
   * Null if no Recurly account.
   */
  recurlyAccountDashboardUrl?: Maybe<Scalars['String']>;
  /**
   * Recurly hosted page URL for the partner to add or edit their payment method.
   * Shown in Recurly dashboard as Hosted Pages → Edit Billing Information URL.
   * Null if no Recurly account or account has no hosted login token.
   */
  recurlyEditBillingInfoUrl?: Maybe<Scalars['String']>;
  /** S3 key for the resale certificate file (if registered). Used to generate presigned download URL. */
  resaleCertificateFileKey?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vatNumber?: Maybe<Scalars['String']>;
};

/**
 * A physical location belonging to a consignment account where Fi units are shipped and sold.
 * One account can have multiple locations (e.g., a chain of pet stores).
 */
export type ConsignmentLocation = {
  __typename?: 'ConsignmentLocation';
  account: ConsignmentAccount;
  accountId: Scalars['ID'];
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  dbId: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  recipientName: Scalars['String'];
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  zipcode: Scalars['String'];
};

export type ConsumerStoreCartInput = {
  cartItems: Array<StoreCartItemInput>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  couponCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currency>;
  giftShippingAddress?: InputMaybe<GiftShippingAddressInput>;
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']>;
  redeemedGiftCardCode?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
  referralSource?: InputMaybe<ReferralSource>;
  shippingCode?: InputMaybe<Scalars['String']>;
  stripeConfirmationToken?: InputMaybe<Scalars['String']>;
  threeDSecureActionResultToken?: InputMaybe<Scalars['String']>;
};

export type ContactInfo = {
  emails?: InputMaybe<Array<Scalars['String']>>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']>>;
};

export type ContactInfoWithMeta = {
  __typename?: 'ContactInfoWithMeta';
  associatedUser?: Maybe<StrangerUser>;
  contactInfo: UserContactInfo;
  /** Copy for sending an invitation to this user via SMS. */
  inviteText?: Maybe<Scalars['String']>;
  /** How many Fi users have this contact. */
  knownFiUsers?: Maybe<Scalars['Int']>;
};

export type ContactsForUserInput = {
  /** By default, we exclude contacts that have an account. Setting this option to true would return all contacts. */
  includeContactsWithAccount?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * By default, contacts with no phone number (just email) are included.
   * Setting this to true will only return contacts with phone numbers.
   * Default is true.
   */
  onlyContactsWithPhoneNumbers?: InputMaybe<Scalars['Boolean']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  /** Query for the contacts first/last name */
  searchQuery?: InputMaybe<Scalars['String']>;
  /**
   * If true, results are sorted first by number of Fi users that know the contact.
   * Defaults is false.
   */
  sortByKnownFiUsers?: InputMaybe<Scalars['Boolean']>;
};

/** Returned by the `contactsForUser` query. Used for referral/invitations. */
export type ContactsForUserResponse = {
  __typename?: 'ContactsForUserResponse';
  contacts: Array<ContactInfoWithMeta>;
  pageInfo: PageInfo;
};

export enum ContainmentFeedbackType {
  SOUND = 'SOUND',
  VIBRATION = 'VIBRATION'
}

/**
 * A ContainmentZone defines a "donut" shaped geographic boundary associated with a Place (Safe Zone)
 * that triggers feedback (sound/vibration) on the collar when a pet enters it.
 */
export type ContainmentZone = {
  __typename?: 'ContainmentZone';
  dbId: Scalars['Int'];
  enabled: Scalars['Boolean'];
  feedbackTypes: Array<ContainmentFeedbackType>;
  id: Scalars['ID'];
  place: Place;
  /** The shape defining the zone boundary (circle or polygon). */
  shape: ContainmentZoneShape;
};

/**
 * Circle-shaped containment zone boundary defined by center position and radii.
 * Creates a donut shape with inner and outer boundaries.
 */
export type ContainmentZoneCircle = {
  __typename?: 'ContainmentZoneCircle';
  /** Inner radius in meters. Defines the inner boundary of the donut. */
  innerRadius: Scalars['Float'];
  /** Outer radius in meters. Defines the outer boundary of the donut. */
  outerRadius: Scalars['Float'];
  /** Center position of the circle. */
  position: Position;
};

/**
 * Polygon-shaped containment zone boundary defined by GeoJSON.
 * The polygon contains an outer boundary ring and an inner hole ring to create the donut shape.
 */
export type ContainmentZonePolygon = {
  __typename?: 'ContainmentZonePolygon';
  /** GeoJSON Polygon with outer boundary and inner hole rings. */
  boundary: Scalars['JSON'];
};

/** The shape of a containment zone - either a circle or polygon. */
export type ContainmentZoneShape = ContainmentZoneCircle | ContainmentZonePolygon;

export type ConvertFreeTrialInput = {
  /** The Recurly subscription UUID to convert from trial to paid */
  subscriptionId: Scalars['String'];
};

export type ConvertFreeTrialResult = {
  __typename?: 'ConvertFreeTrialResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Coupon = {
  __typename?: 'Coupon';
  expiresAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CouponInput = {
  code: Scalars['ID'];
};

/** Represents a coupon that has been redeemed on an account */
export type CouponRedemption = {
  __typename?: 'CouponRedemption';
  /** The coupon code that was redeemed */
  couponCode: Scalars['String'];
  /** When the coupon was redeemed */
  createdAt: Scalars['DateTime'];
  /** Currency of the discount */
  currency?: Maybe<Scalars['String']>;
  /** For fixed discounts, the amount in the account currency */
  discountAmountInCents?: Maybe<Scalars['Int']>;
  /** For percent discounts, the percentage off */
  discountPercent?: Maybe<Scalars['Float']>;
  /** Discount type: percent, fixed, or free_trial */
  discountType?: Maybe<Scalars['String']>;
  /** Unique identifier for this redemption */
  id: Scalars['ID'];
  /** Current state of the redemption (active, inactive) */
  state: Scalars['String'];
  /** The subscription UUID this coupon is applied to (null if account-level) */
  subscriptionUuid?: Maybe<Scalars['String']>;
  /** When the coupon redemption was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CouponRedirectInput = {
  bannerText?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  isPartner?: InputMaybe<Scalars['Boolean']>;
  redirectUri: Scalars['String'];
};

export type CreateBillingAccountInput = {
  address?: InputMaybe<AddressInput>;
};

export type CreateCertGenJobResult = {
  __typename?: 'CreateCertGenJobResult';
  jobId?: Maybe<Scalars['String']>;
  jobName?: Maybe<Scalars['String']>;
};

export type CreateChangeLogInput = {
  description: Scalars['String'];
  type: ChangeLogType;
  version: Scalars['String'];
};

export type CreateConsignmentAccountInput = {
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhone?: InputMaybe<Scalars['String']>;
  fiSalesRepEmail: Scalars['String'];
  name: Scalars['String'];
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type CreateConsignmentLocationInput = {
  accountId: Scalars['ID'];
  city: Scalars['String'];
  country: Scalars['String'];
  name: Scalars['String'];
  recipientName: Scalars['String'];
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export type CreateConsignmentRecurlyAccountInput = {
  billingAccountInput: BillingAccountInput;
  consignmentAccountId: Scalars['ID'];
  ecomConfigType?: InputMaybe<Scalars['String']>;
};

/**
 * Input for creating a containment zone with donut shape.
 * Either circle fields (position + radii) or polygon field (boundary) must be provided, not both.
 */
export type CreateContainmentZoneInput = {
  /**
   * GeoJSON Polygon for POLYGON zones. Must contain outer boundary and inner hole rings.
   * Required for POLYGON, must be null for CIRCLE.
   */
  boundary?: InputMaybe<Scalars['JSON']>;
  /**
   * Inner radius (meters) for CIRCLE zones. Defines the inner boundary of the donut.
   * Required for CIRCLE, must be null for POLYGON.
   */
  innerRadius?: InputMaybe<Scalars['Float']>;
  /**
   * Outer radius (meters) for CIRCLE zones. Defines the outer boundary of the donut.
   * Required for CIRCLE, must be null for POLYGON.
   */
  outerRadius?: InputMaybe<Scalars['Float']>;
  /** Center position for CIRCLE zones. Required for CIRCLE, must be null for POLYGON. */
  position?: InputMaybe<PositionInput>;
  /** Circle or polygon containment zone. */
  type: PlaceType;
};

export type CreateCouponInput = {
  expiresAt: Scalars['DateTime'];
  name: Scalars['String'];
};

export type CreateDeviceActuationInput = {
  actuationId: Scalars['Int'];
  expiration: Scalars['DateTime'];
  moduleId: Scalars['String'];
  type: DeviceActuationType;
};

export type CreateDeviceInput = {
  carrier?: InputMaybe<Scalars['String']>;
  imei?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  moduleId: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  platform: Scalars['String'];
};

export type CreateDynamicEnumMemberInput = {
  code: Scalars['String'];
  kind: DynamicEnumKind;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
};

export type CreateFiNewsNotificationInput = {
  featureImageUrl: Scalars['String'];
  message: Scalars['String'];
  publishedAt: Scalars['DateTime'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type CreateFirmwareChannelInput = {
  channelName: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  platform: Scalars['String'];
  releaseClass: FirmwareReleaseClass;
};

export type CreateGingrBoardingFacilityInput = {
  apiKey: Scalars['String'];
  apiSubdomain: Scalars['String'];
  locationId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  owner: BoardingFacilityOwnerInput;
  /**
   * The timezone for the boarding facility (e.g., "America/New_York").
   * Defaults to "America/New_York" if not provided.
   */
  timezone?: InputMaybe<Scalars['String']>;
};

export type CreateHouseholdInput = {
  name?: InputMaybe<Scalars['String']>;
  socialOptedOut?: InputMaybe<Scalars['Boolean']>;
};

export type CreateImageFromUrlInput = {
  url: Scalars['String'];
};

export type CreateImageFromUrlResult = {
  __typename?: 'CreateImageFromUrlResult';
  image: Image;
  photoId: Scalars['ID'];
};

export type CreateInPersonEventInput = {
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['String'];
  location: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['String'];
  startingInventory: Scalars['JSON'];
};

/** Input for creating a manual subscription via CX admin */
export type CreateManualSubscriptionInput = {
  /** User account code (Recurly account ID) */
  accountCode: Scalars['String'];
  /** Optional coupon code to apply to the subscription purchase */
  couponCode?: InputMaybe<Scalars['String']>;
  /** Currency for the subscription (defaults to USD if not provided) */
  currency?: InputMaybe<Currency>;
  /** Device module ID to assign subscription to (required) */
  moduleId: Scalars['String'];
  /** CX agent notes (optional, added to customer record) */
  notes?: InputMaybe<Scalars['String']>;
  /** Override price in cents (optional, uses plan default if not provided) */
  overridePriceInCents?: InputMaybe<Scalars['Int']>;
  /** Subscription plan SKU */
  sku: Scalars['String'];
  /**
   * Optional future start date for the subscription. If set, the subscription will begin
   * on this date and the customer will be charged on this date. If omitted, the subscription
   * starts and charges immediately (default behavior).
   */
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** Waive the activation/setup fee (default: false) */
  waiveActivationFee?: InputMaybe<Scalars['Boolean']>;
  /** Waive the free trial period and charge immediately (default: false) */
  waiveTrial?: InputMaybe<Scalars['Boolean']>;
};

export type CreateMobileAppBannerInput = {
  backgroundColorHex: Scalars['HexColorCode'];
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  description: Scalars['String'];
  destinationUrl: Scalars['String'];
  foregroundColorHex?: InputMaybe<Scalars['HexColorCode']>;
  internalName: Scalars['String'];
  leadingImage?: InputMaybe<MobileAppBannerImageInput>;
  title: Scalars['String'];
};

export type CreateMobileAppBlockerScreenButtonInput = {
  destinationUrl?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type CreateMobileAppBlockerScreenInput = {
  bottomSheet: CreateMobileAppBottomSheetInput;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  internalName: Scalars['String'];
  pages: Array<CreateMobileAppBlockerScreenPageInput>;
};

export type CreateMobileAppBlockerScreenPageInput = {
  button: CreateMobileAppBlockerScreenButtonInput;
  description: Scalars['String'];
  imageUrl: Scalars['String'];
  title: Scalars['String'];
};

export type CreateMobileAppBottomSheetButtonInput = {
  backgroundColorHex?: InputMaybe<Scalars['HexColorCode']>;
  destinationUrl: Scalars['String'];
  text: Scalars['String'];
  type: MobileAppBottomSheetButtonType;
};

export type CreateMobileAppBottomSheetImageInput = {
  imageUrl: Scalars['String'];
  type: MobileAppBottomSheetImageType;
};

export type CreateMobileAppBottomSheetInput = {
  buttons: Array<CreateMobileAppBottomSheetButtonInput>;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  description: Scalars['String'];
  image?: InputMaybe<CreateMobileAppBottomSheetImageInput>;
  internalName: Scalars['String'];
  title: Scalars['String'];
};

export type CreateMobileAppDiscoverItemInput = {
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  description: Scalars['String'];
  destinationUrl: Scalars['String'];
  imageUrl: Scalars['String'];
  internalName: Scalars['String'];
  title: Scalars['String'];
};

export type CreateMobileAppPermissionBlockerScreenInput = {
  bottomSheet: CreateMobileAppBottomSheetInput;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  dismissable: Scalars['Boolean'];
  internalName: Scalars['String'];
  pages: Array<CreateMobileAppBlockerScreenPageInput>;
  permissionType: Scalars['String'];
};

export type CreateMobileAppSplashScreenButtonInput = {
  destinationUrl?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type CreateMobileAppSplashScreenInput = {
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  internalName: Scalars['String'];
  pages: Array<CreateMobileAppSplashScreenPageInput>;
};

export type CreateMobileAppSplashScreenPageInput = {
  button: CreateMobileAppSplashScreenButtonInput;
  description: Scalars['String'];
  imageUrl: Scalars['String'];
  title: Scalars['String'];
};

export type CreateNewHealthGptChatThreadInput = {
  petId: Scalars['ID'];
};

export type CreatePackInput = {
  fiHandle: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  petId?: InputMaybe<Scalars['ID']>;
};

export type CreatePetInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  breedId?: InputMaybe<Scalars['ID']>;
  color?: InputMaybe<Scalars['String']>;
  dayOfBirth?: InputMaybe<Scalars['Int']>;
  gender: Gender;
  householdId?: InputMaybe<Scalars['ID']>;
  isPurebred: Scalars['Boolean'];
  monthOfBirth?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  newHousehold?: InputMaybe<CreateHouseholdInput>;
  species?: InputMaybe<Species>;
  weight: Scalars['Float'];
  yearOfBirth: Scalars['Int'];
};

export type CreatePlaceInput = {
  address?: InputMaybe<Scalars['String']>;
  /** Should only be set for polygon safe zones. */
  boundary?: InputMaybe<Scalars['JSON']>;
  coordinates?: InputMaybe<Array<PositionInput>>;
  householdId?: InputMaybe<Scalars['ID']>;
  ignoreIfAlreadyExists?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  position?: InputMaybe<PositionInput>;
  /** Should only be set for circle safe zones. */
  radius?: InputMaybe<Scalars['Float']>;
  /** Optional containment zone for sound feedback to create with this place. */
  soundZone?: InputMaybe<CreateContainmentZoneInput>;
  /** Circle or polygon safe zone. */
  type?: InputMaybe<PlaceType>;
  /** Optional containment zone for vibration feedback to create with this place. */
  vibrationZone?: InputMaybe<CreateContainmentZoneInput>;
};

export type CreatePromotionInput = {
  internalName: Scalars['String'];
};

export type CreatePurchaseInput = {
  coupons: Array<CouponInput>;
  inPersonEventUuid?: InputMaybe<Scalars['String']>;
  isRescueOrganizationPurchase?: InputMaybe<Scalars['Boolean']>;
  lineItems: Array<LineItemInput>;
  redeemGiftCard?: InputMaybe<RedeemGiftCardInput>;
  referral?: InputMaybe<ReferralInput>;
  shippingOption?: InputMaybe<ShippingOptionInput>;
};

export type CreateRMAInput = {
  creationNotes?: InputMaybe<Scalars['String']>;
  customerEmail: Scalars['String'];
  customerName: Scalars['String'];
  drilldownCode: Scalars['String'];
  invoiceNumber?: InputMaybe<Scalars['String']>;
  invoiceSource?: InputMaybe<InvoiceSource>;
  items: Array<RMAItemInput>;
  /** Agent made a policy exception to create the RMA. We trust the frontend in this case. */
  madePolicyException?: InputMaybe<Scalars['Boolean']>;
  policyExceptionReason?: InputMaybe<Scalars['String']>;
  processType: RMAProcessType;
  purchaseProvenanceCode: Scalars['String'];
  reasonCode: Scalars['String'];
  replacementProductAudits: Array<ReplacementProductAudit>;
  replacementProducts: Array<ReplacementProductInput>;
  shippingAddress?: InputMaybe<AddressInput>;
  tags?: InputMaybe<Array<RMATag>>;
  zendeskNumber?: InputMaybe<Scalars['String']>;
};

export type CreateTestChargingBaseInput = {
  householdInputId?: InputMaybe<Scalars['String']>;
  inputId: Scalars['String'];
  platformId: Scalars['String'];
};

export type CreateTestDataDailyActivitySummaryInput = {
  date: Scalars['DateTime'];
  stepCount?: InputMaybe<Scalars['Int']>;
  stepGoal?: InputMaybe<Scalars['Int']>;
  strainScoreEndOfDay?: InputMaybe<Scalars['Float']>;
  strainStoreDailyAverage?: InputMaybe<Scalars['Float']>;
  totalDistanceMeters?: InputMaybe<Scalars['Float']>;
  tz?: InputMaybe<Scalars['String']>;
};

export type CreateTestDataInput = {
  bases?: InputMaybe<Array<CreateTestChargingBaseInput>>;
  devices?: InputMaybe<Array<CreateTestDeviceInput>>;
  households?: InputMaybe<Array<CreateTestHouseholdInput>>;
  pets?: InputMaybe<Array<CreateTestPetInput>>;
  userHouseholds?: InputMaybe<Array<CreateTestUserHouseholdInput>>;
  users?: InputMaybe<Array<CreateTestUserInput>>;
};

export type CreateTestDataResult = {
  __typename?: 'CreateTestDataResult';
  bases: Array<ChargingBase>;
  devices: Array<Device>;
  households: Array<Household>;
  pets: Array<Pet>;
  users: Array<User>;
};

export type CreateTestDeviceInput = {
  hasSubscriptionOverride?: InputMaybe<Scalars['Boolean']>;
  inputId: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  platformId: Scalars['String'];
  updateChannel: Scalars['String'];
};

export type CreateTestHouseholdInput = {
  inputId: Scalars['String'];
  socialOptedOut?: InputMaybe<Scalars['Boolean']>;
};

export type CreateTestPetInput = {
  breedId?: InputMaybe<Scalars['ID']>;
  dailyActivitySummaries?: InputMaybe<Array<CreateTestDataDailyActivitySummaryInput>>;
  dayOfBirth?: InputMaybe<Scalars['Int']>;
  deviceInputId?: InputMaybe<Scalars['String']>;
  gender: Gender;
  householdInputId: Scalars['String'];
  inputId: Scalars['String'];
  monthOfBirth?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  species?: InputMaybe<Species>;
  weight: Scalars['Float'];
  yearOfBirth: Scalars['Int'];
};

export type CreateTestUserBillingAccountInput = {
  address: AddressInput;
  purchase?: InputMaybe<ConsumerStoreCartInput>;
};

export type CreateTestUserEmailInput = {
  email: Scalars['String'];
  isVerified?: InputMaybe<Scalars['Boolean']>;
};

export type CreateTestUserHouseholdInput = {
  householdInputId: Scalars['String'];
  role: UserHouseholdRole;
  userInputId: Scalars['String'];
};

export type CreateTestUserInput = {
  billingAccount?: InputMaybe<CreateTestUserBillingAccountInput>;
  firstName: Scalars['String'];
  inputId: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  primaryEmail: CreateTestUserEmailInput;
};

export type CreateTextPostInput = {
  /** Users can only specific pre-defined styles (ie. text/background). */
  styleId: Scalars['ID'];
  text: Scalars['String'];
};

export type CreateUserForBoardingFacilityInput = {
  boardingFacilityId: Scalars['ID'];
  householdRole: UserHouseholdRole;
  user: BoardingFacilityStaffUserInput;
};

export type CreateUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  nanoChipRegistration?: InputMaybe<Scalars['Boolean']>;
  /** If null, the user will have to reset their password via email */
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  tenancy?: InputMaybe<Scalars['String']>;
};

export type CreateVideoPostInput = {
  aspectRatio: AspectRatioInput;
  caption?: InputMaybe<Scalars['String']>;
  includesAudio?: InputMaybe<Scalars['Boolean']>;
  /** The same key returned when pre-signed upload URL was fetched */
  key: Scalars['String'];
};

export type CreateZendeskCancellationTicketInput = {
  /** Optional additional text to include in the ticket description. */
  additionalText?: InputMaybe<Scalars['String']>;
  cancellationReason: zendeskCancellationReason;
  recurlySubscriptionId: Scalars['String'];
};

export type CreateZendeskReplacementTicketInput = {
  recurlySubscriptionId: Scalars['String'];
  /** Free form text explaining reason for requesting replacement. Included in the ticket description. */
  replacementReason: Scalars['String'];
};

export type CreateZendeskTicketResult = {
  __typename?: 'CreateZendeskTicketResult';
  ticketCreated?: Maybe<Scalars['Boolean']>;
  ticketUrl?: Maybe<Scalars['String']>;
};

export type CreateZendeskTroubleshootingTicketInput = {
  /** Optional free form text explaining reason for troubleshooting. Included in the ticket description. */
  additionalText?: InputMaybe<Scalars['String']>;
  recurlySubscriptionId: Scalars['String'];
  troubleshootingReason: zendeskCancellationReason;
};

export type CredentialUpdate = {
  __typename?: 'CredentialUpdate';
  encryptedCredentials: Scalars['Binary'];
  hash: Scalars['String'];
};

export enum Currency {
  CAD = 'CAD',
  GBP = 'GBP',
  USD = 'USD'
}

/**
 * Input for querying CX billing audit events.
 * At least one entity identifier (accountCode, invoiceNumber, or subscriptionId) is required.
 */
export type CxBillingAuditInput = {
  /** At least one entity identifier is required */
  accountCode?: InputMaybe<Scalars['String']>;
  actionTypes?: InputMaybe<Array<Scalars['String']>>;
  agentEmail?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  initiatedByEmail?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Optional filters */
  startDate?: InputMaybe<Scalars['DateTime']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
};

export type CxBillingAuditResult = {
  __typename?: 'CxBillingAuditResult';
  events: Array<AuditLogEvent>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type CxPendingAction = {
  __typename?: 'CxPendingAction';
  category: Scalars['String'];
  details?: Maybe<Scalars['String']>;
};

export type DailyRestSummary = {
  date: Scalars['DateTime'];
};

export type DailyStepSummary = {
  __typename?: 'DailyStepSummary';
  date: Scalars['DateTime'];
  stepGoal: Scalars['Int'];
  totalSteps: Scalars['Int'];
};

/** DEPRECATED: Use activity summaries instead. */
export type DailySummary = {
  __typename?: 'DailySummary';
  activityGoal: ActivityGoal;
  activityIntensities: Array<ActivityIntensity>;
  end: Scalars['DateTime'];
  nextCursor?: Maybe<Scalars['String']>;
  start: Scalars['DateTime'];
  totalSteps: Scalars['Int'];
};


/** DEPRECATED: Use activity summaries instead. */
export type DailySummaryactivityIntensitiesArgs = {
  stride?: InputMaybe<Scalars['Int']>;
};

/** DEPRECATED: Use activity summaries instead. */
export type DailySummaryFeed = {
  __typename?: 'DailySummaryFeed';
  dailySummaries: Array<DailySummary>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type DateRange = {
  __typename?: 'DateRange';
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type DateRangeInput = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type DecagonChatConfiguration = {
  __typename?: 'DecagonChatConfiguration';
  url: Scalars['String'];
};

export type DeleteFirmwareChannelInput = {
  channelName: Scalars['String'];
  platform: Scalars['String'];
};

/**
 * Represents an activity type that has been detected from a phone.
 * (Android and iOS both expose APIs to get this.)
 */
export enum DetectedActivityType {
  AUTOMOTIVE = 'AUTOMOTIVE',
  UNKNOWN = 'UNKNOWN',
  WALKING = 'WALKING'
}

export type Device = {
  __typename?: 'Device';
  actuationConfiguration: DeviceActuationConfiguration;
  adminRecentGPSTests: AdminRecentGPSTests;
  adminTimeline: AdminTimeline;
  /** Admin only */
  autoAddUserToHousehold?: Maybe<User>;
  availableLedColors: Array<LedColor>;
  batch?: Maybe<Scalars['String']>;
  bluetoothAddress: Scalars['String'];
  canCancel: Scalars['Boolean'];
  /** Date when a restricted subscription can be cancelled, otherwise null */
  canCancelDate?: Maybe<Scalars['DateTime']>;
  capabilities: Array<ModuleCapability>;
  carrier?: Maybe<Scalars['String']>;
  /** Admin only (Note: this query makes a request to a 3rd-party service and can be slow) */
  carrierDetails?: Maybe<Scalars['JSON']>;
  /** Admin only (Note: this query makes a request to a 3rd-party service and can be slow) */
  carrierSessionInfo?: Maybe<Scalars['JSON']>;
  /** Admin only (Note: this query makes a request to a 3rd-party service and can be slow) */
  carrierUsage?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  credentialUpdate?: Maybe<CredentialUpdate>;
  currentCollarModel?: Maybe<Scalars['String']>;
  currentCollarModelLongName?: Maybe<Scalars['String']>;
  /** Whether the device has a pending action with CX, e.g. a cancellation request */
  cxPendingAction?: Maybe<CxPendingAction>;
  dbId: Scalars['Int'];
  /** Admin only */
  deviceResponseOverride?: Maybe<DeviceResponseOverride>;
  diagnostics?: Maybe<DeviceDiagnostics>;
  fccId?: Maybe<Scalars['String']>;
  firmwareUpdate?: Maybe<FirmwareUpdate>;
  /** Whether the device can receive firmware updates */
  firmwareUpdateEligible: Scalars['Boolean'];
  hardwareRevision?: Maybe<Scalars['String']>;
  /** @deprecated Use subscriptionAccessType */
  hasActiveSubscription: Scalars['Boolean'];
  /** Month-to-Month upgrade promotion */
  hasClaimedFreeMonthsDuringMonthlyUpgrade?: Maybe<Scalars['Boolean']>;
  hasSubscriptionOverride: Scalars['Boolean'];
  icId?: Maybe<Scalars['String']>;
  iccid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imei?: Maybe<Scalars['String']>;
  info: Scalars['JSON'];
  infoLastUpdated: Scalars['DateTime'];
  /** Admin only (Note: queries Databricks for this data) */
  inventoryData?: Maybe<Scalars['JSON']>;
  /** Rescues: auto set to true when creating new adoption transfer */
  isAdoptionCollar?: Maybe<Scalars['Boolean']>;
  /** Admin only */
  isBlocked: Scalars['Boolean'];
  /** Admin only */
  isRefurbished: Scalars['Boolean'];
  /** Whether the device can use the Search Party feature for publicly sharing live location */
  isSearchPartyEligible: Scalars['Boolean'];
  /** The serial number for a charging base that was inside the same kit as the module */
  kitChargingBaseSerialNumber?: Maybe<Scalars['String']>;
  lastConnectionState: ConnectionState;
  lastLocation?: Maybe<Location>;
  lastLocationReport?: Maybe<LocationReport>;
  lastReportTimestampsBySource: Scalars['JSON'];
  lastReportedFirmwareVersion?: Maybe<Scalars['String']>;
  ledColor: LedColor;
  locationReportsByDate: Array<LocationReport>;
  macAddress?: Maybe<Scalars['String']>;
  modelIconUrl: Scalars['String'];
  modelId?: Maybe<Scalars['String']>;
  modelImageUrl: Scalars['String'];
  moduleId: Scalars['String'];
  /** Most recent actuation status triggered for this device */
  mostRecentActuationStatus?: Maybe<DeviceActuation>;
  /**
   * Date by which we expect a location report. If this date is in the future, it means
   * we have an accurate location for the module.
   */
  nextLocationUpdateExpectedBy?: Maybe<Scalars['DateTime']>;
  /** Description of when the subscription renews, e.g., "Renews 5/17/28" or "Renews indefinitely" */
  nextRenewalDateDescription?: Maybe<Scalars['String']>;
  /**
   * Date by which we next expect any report. If this date is in the future, it means
   * the module is online.
   */
  nextReportExpectedBy?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  operationParams: OperationParams;
  /** Admin-only. Return information about the original plan that the device was activated with. */
  originalPlan?: Maybe<SubscriptionOption>;
  originalPurchaser?: Maybe<User>;
  pet?: Maybe<Pet>;
  platform: Platform;
  prepaidSubscription?: Maybe<DevicePrepaidSubscription>;
  preselectedPlanCodeForNewSubscription?: Maybe<Scalars['String']>;
  /**
   * Return the set of SubscriptionOptions that a user is allowed to purchase for a device;
   * e.g. if they purchased with a $29/mo plan, only return $29/mo. For users who purchased
   * on a yearly plan this would return all yearly plans.
   */
  purchasableSubscriptionOptions: Array<SubscriptionOption>;
  /**
   * Admin only
   *
   * Human readable string like "Series 3+" or "Series 2"
   */
  readableModelName?: Maybe<Scalars['String']>;
  returnEligibility?: Maybe<RMAPolicyResult>;
  series2UpgradeEligible: Scalars['Boolean'];
  series3UpgradeV2Eligible: Scalars['Boolean'];
  /** Admin only */
  shipmentData?: Maybe<DeviceShipment>;
  shouldOfferDiscountDuringClickToCancel?: Maybe<Scalars['Boolean']>;
  shouldOfferDowngradeDuringCancellation?: Maybe<Scalars['Boolean']>;
  /** In-app cancellation flow offers. */
  shouldOfferFreeMonthDuringCancellation?: Maybe<Scalars['Boolean']>;
  shouldOfferPauseMonthDuringCancellation?: Maybe<Scalars['Boolean']>;
  /** Represents collar-specific state (i.e. online/offline) */
  status: CollarStatus;
  subscription?: Maybe<BillingSubscription>;
  subscriptionAccessType: SubscriptionAccessType;
  /** Returns the URL to the webview where a user can manage their device's subscription. */
  subscriptionDetailsWebviewUrl: Scalars['String'];
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionOverrideEndsAt?: Maybe<Scalars['DateTime']>;
  /** Used by clients in subscription management e.g., "Monthly membership", "6 month membership" */
  subscriptionPlanDescription?: Maybe<Scalars['String']>;
  /** Used by clients in subscription management e.g., "$19 / month", "$99 / 6 months" */
  subscriptionPricingDescription?: Maybe<Scalars['String']>;
  subscriptionRenewalStatus?: Maybe<SubscriptionRenewalStatus>;
  tenancy?: Maybe<Scalars['String']>;
  thirdPartyAccess?: Maybe<Scalars['String']>;
  /** Returns the URL to the webview where a user can troubleshoot issues with their device */
  troubleshootWebviewUrl: Scalars['String'];
  updateChannel?: Maybe<Scalars['String']>;
  updateFrequencyOptions: Array<UpdateFrequencyOption>;
  upgradeRedeemed?: Maybe<DeviceUpgrade>;
  warrantyStatus?: Maybe<RMAPolicyResult>;
  /** Admin only */
  wsConnectionDetails?: Maybe<Scalars['JSON']>;
};


export type DevicecredentialUpdateArgs = {
  currentHash?: InputMaybe<Scalars['String']>;
};


export type DevicediagnosticsArgs = {
  period: DeviceDiagnosticsPeriod;
};


export type DevicefirmwareUpdateArgs = {
  currentVersion: Scalars['String'];
};


export type DevicelastConnectionStateArgs = {
  ignoreOffline?: InputMaybe<Scalars['Boolean']>;
};


export type DevicelocationReportsByDateArgs = {
  after: Scalars['DateTime'];
  before: Scalars['DateTime'];
};


export type DevicepurchasableSubscriptionOptionsArgs = {
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  couponCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currency>;
  inAppFlow?: InputMaybe<Scalars['Boolean']>;
  monthlyUpgrade?: InputMaybe<Scalars['Boolean']>;
};


export type DevicereturnEligibilityArgs = {
  drilldownCode: Scalars['String'];
  reasonCode: Scalars['String'];
};


export type DevicewarrantyStatusArgs = {
  drilldownCode: Scalars['String'];
  reasonCode: Scalars['String'];
};

export type DeviceActivity = DeviceEventBase & {
  __typename?: 'DeviceActivity';
  date: Scalars['DateTime'];
  duration: Scalars['Float'];
  firmwareVersion?: Maybe<Scalars['String']>;
  moduleId: Scalars['String'];
  platform: Scalars['String'];
  steps: Scalars['Int'];
};

export type DeviceActuation = {
  __typename?: 'DeviceActuation';
  actuationId: Scalars['Int'];
  events?: Maybe<Array<DeviceActuationEvent>>;
  id: Scalars['ID'];
  state: DeviceActuationState;
  type: DeviceActuationType;
};

/** Configuration for actuation patterns on the device, user settable with a default fallback */
export type DeviceActuationConfiguration = {
  __typename?: 'DeviceActuationConfiguration';
  haptic: DeviceActuationType;
  piezo: DeviceActuationType;
};

export type DeviceActuationEvent = {
  __typename?: 'DeviceActuationEvent';
  eventType?: Maybe<DeviceActuationEventType>;
  timestamp: Scalars['DateTime'];
};

export enum DeviceActuationEventType {
  EXPIRED = 'EXPIRED',
  REPORTED_RESULT = 'REPORTED_RESULT',
  REPORT_RESPONSE_SENT = 'REPORT_RESPONSE_SENT',
  SERVER_PUSH_NOT_AVAILABLE = 'SERVER_PUSH_NOT_AVAILABLE',
  SERVER_PUSH_SENT = 'SERVER_PUSH_SENT'
}

export type DeviceActuationFailure = DeviceActuationStateInterface & {
  __typename?: 'DeviceActuationFailure';
  failureReason: DeviceActuationFailureReason;
  status: DeviceActuationStatus;
  updatedAt: Scalars['DateTime'];
};

export enum DeviceActuationFailureReason {
  BUSY = 'BUSY',
  EXPIRED = 'EXPIRED',
  INVALID_PARAMS = 'INVALID_PARAMS',
  UNKNOWN = 'UNKNOWN'
}

export type DeviceActuationSending = DeviceActuationStateInterface & {
  __typename?: 'DeviceActuationSending';
  status: DeviceActuationStatus;
  updatedAt: Scalars['DateTime'];
};

export type DeviceActuationState = DeviceActuationFailure | DeviceActuationSending | DeviceActuationSuccess;

export type DeviceActuationStateInterface = {
  status: DeviceActuationStatus;
  updatedAt: Scalars['DateTime'];
};

export enum DeviceActuationStatus {
  /** There are some cases where an actuation goes from `FAILURE` -> `SUCCESS`. For example, if device receives an actuation but informs the backend of success after the expiration time. */
  FAILURE = 'FAILURE',
  SENDING = 'SENDING',
  SUCCESS = 'SUCCESS'
}

export type DeviceActuationSuccess = DeviceActuationStateInterface & {
  __typename?: 'DeviceActuationSuccess';
  status: DeviceActuationStatus;
  updatedAt: Scalars['DateTime'];
};

export enum DeviceActuationType {
  COMBO_HIGH = 'COMBO_HIGH',
  COMBO_LOW = 'COMBO_LOW',
  COMBO_MEDIUM = 'COMBO_MEDIUM',
  COMBO_SIMPLE = 'COMBO_SIMPLE',
  HAPTIC_HIGH = 'HAPTIC_HIGH',
  HAPTIC_LOW = 'HAPTIC_LOW',
  HAPTIC_MEDIUM = 'HAPTIC_MEDIUM',
  HAPTIC_SIMPLE = 'HAPTIC_SIMPLE',
  LED_BLUE_SLOW = 'LED_BLUE_SLOW',
  LED_CYAN_SLOW = 'LED_CYAN_SLOW',
  LED_GREEN_SLOW = 'LED_GREEN_SLOW',
  LED_OFF = 'LED_OFF',
  LED_PURPLE_SLOW = 'LED_PURPLE_SLOW',
  LED_RED_SLOW = 'LED_RED_SLOW',
  LED_RED_SOS = 'LED_RED_SOS',
  LED_WHITE_SLOW = 'LED_WHITE_SLOW',
  LED_YELLOW_SLOW = 'LED_YELLOW_SLOW',
  PIEZO_HIGH = 'PIEZO_HIGH',
  PIEZO_LOW = 'PIEZO_LOW',
  PIEZO_MEDIUM = 'PIEZO_MEDIUM',
  PIEZO_SIMPLE = 'PIEZO_SIMPLE',
  SNOOZE_DISABLED = 'SNOOZE_DISABLED',
  SNOOZE_ENABLED = 'SNOOZE_ENABLED'
}

export type DeviceAssignable = {
  __typename?: 'DeviceAssignable';
  assignable: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type DeviceBatchInfo = {
  __typename?: 'DeviceBatchInfo';
  batch: Scalars['String'];
  numActivated: Scalars['Int'];
  numDevices: Scalars['Int'];
};

export enum DeviceConnectionMode {
  BASE = 'BASE',
  GPS = 'GPS',
  MOBILE = 'MOBILE',
  OFFLINE = 'OFFLINE',
  WIFI = 'WIFI'
}

export type DeviceConnectionRatio = {
  __typename?: 'DeviceConnectionRatio';
  mode: DeviceConnectionMode;
  percent: Scalars['Int'];
  seconds: Scalars['Int'];
};

/** Get the `errorRadius` from the `location` field. */
export type DeviceDiagnosticLocationReport = {
  __typename?: 'DeviceDiagnosticLocationReport';
  cellStrength: DiagnosticStatus;
  date: Scalars['DateTime'];
  /** If false, this is a celllookup report meaning the GPS wasn't able to aquire a fix. */
  fromGPS: Scalars['Boolean'];
  /** Not the actual location report ID (we don't expose that) */
  id: Scalars['ID'];
  location: Location;
};

export type DeviceDiagnostics = {
  __typename?: 'DeviceDiagnostics';
  connectionRatios: Array<DeviceConnectionRatio>;
  /** Clients should poll this to get the result of a GPS test. */
  gpsTestResultSince?: Maybe<GPSTestResult>;
  lastCellularReport?: Maybe<DeviceDiagnosticLocationReport>;
  /** Healthy if the collar is typically connected to BLE. */
  overallSystemHealth: DiagnosticStatus;
  periodDurationSeconds: Scalars['Int'];
};


export type DeviceDiagnosticsgpsTestResultSinceArgs = {
  date: Scalars['DateTime'];
};

export enum DeviceDiagnosticsPeriod {
  ONE_DAY = 'ONE_DAY',
  ONE_WEEK = 'ONE_WEEK',
  THREE_DAYS = 'THREE_DAYS'
}

export type DeviceError = {
  __typename?: 'DeviceError';
  crashSite?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  edata?: Maybe<Scalars['String']>;
  expr?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  func?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  line?: Maybe<Scalars['Int']>;
  pc?: Maybe<Scalars['Int']>;
  rev?: Maybe<Scalars['String']>;
  stack?: Maybe<Array<Scalars['String']>>;
  stackKey?: Maybe<Scalars['String']>;
  stackLines?: Maybe<Array<Scalars['String']>>;
};

export type DeviceEventBase = {
  date: Scalars['DateTime'];
  firmwareVersion?: Maybe<Scalars['String']>;
  moduleId: Scalars['String'];
  platform: Scalars['String'];
};

export type DeviceHealthActivityStats = {
  __typename?: 'DeviceHealthActivityStats';
  dailyStepCount?: Maybe<SimpleHealthMetric>;
  timeOffDog?: Maybe<SimpleHealthMetric>;
  totalAccelerationVariance?: Maybe<SimpleHealthMetric>;
  walkCount?: Maybe<SimpleHealthMetric>;
  walkDistance?: Maybe<AggregateHealthMetric>;
  walkDuration?: Maybe<AggregateHealthMetric>;
  walkSteps?: Maybe<AggregateHealthMetric>;
};

export type DeviceHealthBLEBaseStats = DeviceHealthBLEDeviceStats & {
  __typename?: 'DeviceHealthBLEBaseStats';
  base?: Maybe<ChargingBase>;
  deviceLabel: Scalars['String'];
  reportCount?: Maybe<SimpleHealthMetric>;
  rssi?: Maybe<AggregateHealthMetric>;
  sessionDuration?: Maybe<AggregateHealthMetric>;
  timeConnected?: Maybe<SimpleHealthMetric>;
  timeOffline?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthBLEDeviceStats = {
  deviceLabel: Scalars['String'];
  rssi?: Maybe<AggregateHealthMetric>;
  sessionDuration?: Maybe<AggregateHealthMetric>;
  timeConnected?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthBLEHandsetStats = DeviceHealthBLEDeviceStats & {
  __typename?: 'DeviceHealthBLEHandsetStats';
  deviceLabel: Scalars['String'];
  handset?: Maybe<Handset>;
  reportCount?: Maybe<SimpleHealthMetric>;
  rssi?: Maybe<AggregateHealthMetric>;
  sessionDuration?: Maybe<AggregateHealthMetric>;
  timeConnected?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthBLEStats = {
  __typename?: 'DeviceHealthBLEStats';
  bases?: Maybe<Array<DeviceHealthBLEBaseStats>>;
  handsets?: Maybe<Array<DeviceHealthBLEHandsetStats>>;
};

export type DeviceHealthBatteryStats = {
  __typename?: 'DeviceHealthBatteryStats';
  crashes?: Maybe<SimpleHealthMetric>;
  extrapolatedChargeTime?: Maybe<SimpleHealthMetric>;
  extrapolatedLifetime?: Maybe<SimpleHealthMetric>;
  percentChargedInPeriod?: Maybe<SimpleHealthMetric>;
  percentDrainedInPeriod?: Maybe<SimpleHealthMetric>;
  timesOnCharger?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthCellularStats = {
  __typename?: 'DeviceHealthCellularStats';
  connectionAttempts?: Maybe<SimpleHealthMetric>;
  connectionSuccessRate?: Maybe<SimpleHealthMetric>;
  connectionSuccesses?: Maybe<SimpleHealthMetric>;
  rsrp?: Maybe<AggregateHealthMetric>;
  rsrq?: Maybe<AggregateHealthMetric>;
};

export type DeviceHealthConnectivityStats = {
  __typename?: 'DeviceHealthConnectivityStats';
  baseToBaseChanges?: Maybe<SimpleHealthMetric>;
  baseToCellularChanges?: Maybe<SimpleHealthMetric>;
  baseToMobileChanges?: Maybe<SimpleHealthMetric>;
  baseToWifiChanges?: Maybe<SimpleHealthMetric>;
  /**
   * Deprecating use of "BLE" in favor of "Base" which is more specific.
   * @deprecated use baseToWifiChanges instead
   */
  bleToWifiChanges?: Maybe<SimpleHealthMetric>;
  cellularToBaseChanges?: Maybe<SimpleHealthMetric>;
  /** @deprecated use wifiToBaseChanges instead */
  cellularToBleChanges?: Maybe<SimpleHealthMetric>;
  cellularToMobileChanges?: Maybe<SimpleHealthMetric>;
  cellularToWifiChanges?: Maybe<SimpleHealthMetric>;
  mobileToBaseChanges?: Maybe<SimpleHealthMetric>;
  mobileToCellularChanges?: Maybe<SimpleHealthMetric>;
  mobileToMobileChanges?: Maybe<SimpleHealthMetric>;
  mobileToWifiChanges?: Maybe<SimpleHealthMetric>;
  reportCount?: Maybe<SimpleHealthMetric>;
  timeOffline?: Maybe<SimpleHealthMetric>;
  timeOnBLE?: Maybe<SimpleHealthMetric>;
  timeOnBase?: Maybe<SimpleHealthMetric>;
  timeOnCellular?: Maybe<SimpleHealthMetric>;
  timeOnMobile?: Maybe<SimpleHealthMetric>;
  timeOnWifi?: Maybe<SimpleHealthMetric>;
  totalConnectionChanges?: Maybe<SimpleHealthMetric>;
  wifiToBaseChanges?: Maybe<SimpleHealthMetric>;
  /** @deprecated use wifiToBaseChanges instead */
  wifiToBleChanges?: Maybe<SimpleHealthMetric>;
  wifiToCellularChanges?: Maybe<SimpleHealthMetric>;
  wifiToMobileChanges?: Maybe<SimpleHealthMetric>;
  wifiToWifiChanges?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthGNSSStats = {
  __typename?: 'DeviceHealthGNSSStats';
  accuracyRadius?: Maybe<AggregateHealthMetric>;
  allSatSnr?: Maybe<AggregateHealthMetric>;
  fixAttempts?: Maybe<SimpleHealthMetric>;
  fixSuccessRate?: Maybe<SimpleHealthMetric>;
  fixSuccesses?: Maybe<SimpleHealthMetric>;
  s3PlusCouldImprovePerf?: Maybe<SimpleHealthMetric>;
  satellitesTracked?: Maybe<AggregateHealthMetric>;
  timeToFirstFix?: Maybe<AggregateHealthMetric>;
  timeToFix?: Maybe<AggregateHealthMetric>;
  top4SatSnr?: Maybe<AggregateHealthMetric>;
};

export type DeviceHealthLDMStats = {
  __typename?: 'DeviceHealthLDMStats';
  activations?: Maybe<SimpleHealthMetric>;
  duration?: Maybe<AggregateHealthMetric>;
};

export type DeviceHealthMiscStats = {
  __typename?: 'DeviceHealthMiscStats';
  cxd5605?: Maybe<SimpleHealthMetric>;
  da16200?: Maybe<SimpleHealthMetric>;
  lis2dw12?: Maybe<SimpleHealthMetric>;
  lsm6dso?: Maybe<SimpleHealthMetric>;
  lte_modem?: Maybe<SimpleHealthMetric>;
  reboots?: Maybe<SimpleHealthMetric>;
  rv4162c7?: Maybe<SimpleHealthMetric>;
  /** @deprecated historically showed total self test failure count but was changed to total self test count, going to remove */
  selfTestFailures?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthNotificationStats = {
  __typename?: 'DeviceHealthNotificationStats';
  escapeNotificationLatency?: Maybe<AggregateHealthMetric>;
  escapeNotificationsInitiated?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthStatistics = {
  __typename?: 'DeviceHealthStatistics';
  activity?: Maybe<DeviceHealthActivityStats>;
  battery?: Maybe<DeviceHealthBatteryStats>;
  ble?: Maybe<DeviceHealthBLEStats>;
  cellular?: Maybe<DeviceHealthCellularStats>;
  connectivity?: Maybe<DeviceHealthConnectivityStats>;
  gnss?: Maybe<DeviceHealthGNSSStats>;
  ldm?: Maybe<DeviceHealthLDMStats>;
  misc?: Maybe<DeviceHealthMiscStats>;
  notifications?: Maybe<DeviceHealthNotificationStats>;
  wifi?: Maybe<DeviceHealthWiFiStats>;
};

export type DeviceHealthWiFiSSIDStats = {
  __typename?: 'DeviceHealthWiFiSSIDStats';
  bssid: Scalars['String'];
  reportCount?: Maybe<SimpleHealthMetric>;
  rssi?: Maybe<AggregateHealthMetric>;
  sessionDuration?: Maybe<AggregateHealthMetric>;
  ssid: Scalars['String'];
  timeConnected?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthWiFiStats = {
  __typename?: 'DeviceHealthWiFiStats';
  networks?: Maybe<Array<DeviceHealthWiFiSSIDStats>>;
};

export type DeviceModelPlatformEntry = {
  __typename?: 'DeviceModelPlatformEntry';
  description: Scalars['String'];
  platformId: Scalars['String'];
};

export type DeviceModelPlatformMapping = {
  __typename?: 'DeviceModelPlatformMapping';
  modelDescription: Scalars['String'];
  modelId: Scalars['String'];
  platforms: Array<DeviceModelPlatformEntry>;
};

export type DevicePowerState = {
  __typename?: 'DevicePowerState';
  hasPowerSupply?: Maybe<Scalars['Boolean']>;
  isCharging?: Maybe<Scalars['Boolean']>;
};

/**
 * If the user has purchased a subscription from a third party and has not activated it yet,
 * this will return the subscription details.
 */
export type DevicePrepaidSubscription = {
  __typename?: 'DevicePrepaidSubscription';
  freeMonths?: Maybe<Scalars['Int']>;
  orderSource: OrderSource;
  planCode: Scalars['String'];
  renewalPlanCode?: Maybe<Scalars['String']>;
  resellerPriceInCents?: Maybe<Scalars['Int']>;
};

export type DeviceQueryInput = {
  activated?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  moduleId?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
  updateChannel?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type DeviceResponseOverride = {
  __typename?: 'DeviceResponseOverride';
  expiresAt: Scalars['DateTime'];
  responseOverride: Scalars['JSON'];
};

export type DeviceShipment = {
  __typename?: 'DeviceShipment';
  createdAt: Scalars['DateTime'];
  externalOrderId?: Maybe<Scalars['String']>;
  externalOrderSource?: Maybe<Scalars['String']>;
  fulfillmentFlow?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  shippedAt: Scalars['DateTime'];
  sku: Scalars['String'];
};

export type DeviceStat = {
  __typename?: 'DeviceStat';
  friendlyName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DeviceTransferInput = {
  sourceModuleId: Scalars['String'];
  /** May be null for prorated upgrades if new device not yet assigned */
  targetModuleId?: InputMaybe<Scalars['String']>;
  /** e.g., 'sub-f3b-12m-001' */
  targetPlanCode: Scalars['String'];
  /** e.g., 'FC3B' for S3+, 'M1' for Mini */
  targetPlatformType: Scalars['String'];
};

export enum DeviceType {
  BASE = 'BASE',
  MODULE = 'MODULE'
}

export enum DeviceUpgrade {
  MINI = 'MINI',
  SERIES_2 = 'SERIES_2',
  SERIES_3 = 'SERIES_3',
  SERIES_3_PLUS = 'SERIES_3_PLUS'
}

export enum DiagnosticStatus {
  HEALTHY = 'HEALTHY',
  UNHEALTHY = 'UNHEALTHY',
  WARNING = 'WARNING'
}

export type DisconnectAppIntegrationResult = {
  __typename?: 'DisconnectAppIntegrationResult';
  /** Populated when success is false */
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DiscoverFeed = {
  __typename?: 'DiscoverFeed';
  feedItems: Array<DiscoverFeedItem>;
  pageInfo: PageInfo;
};

export type DiscoverFeedArticleItem = DiscoverFeedItem & {
  __typename?: 'DiscoverFeedArticleItem';
  article: Article;
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

/**
 * This is just an empty placeholder, it does not include data about suggested dogs.
 * On receiving this, clients need to query the `suggestedPetsToFollow` endpoint
 * to get data to populate the carousel.
 */
export type DiscoverFeedCarouselItem = DiscoverFeedItem & {
  __typename?: 'DiscoverFeedCarouselItem';
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export type DiscoverFeedItem = {
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export type DiscoverFeedPhotoItem = DiscoverFeedItem & {
  __typename?: 'DiscoverFeedPhotoItem';
  id: Scalars['ID'];
  photo: Photo;
  timestamp: Scalars['DateTime'];
};

export type DiscoverFeedTextPostItem = DiscoverFeedItem & {
  __typename?: 'DiscoverFeedTextPostItem';
  id: Scalars['ID'];
  post: TextPost;
  timestamp: Scalars['DateTime'];
};

export type DiscoverFeedVideoPostItem = DiscoverFeedItem & {
  __typename?: 'DiscoverFeedVideoPostItem';
  id: Scalars['ID'];
  post: VideoPost;
  timestamp: Scalars['DateTime'];
};

export type DismissPromotionBannerInput = {
  bannerType: Scalars['String'];
  dismissReason?: InputMaybe<Scalars['String']>;
};

/**
 * A piece of in-app content that has been dismissed by a user,
 * and a timestamp of when it was dismissed.
 */
export type DismissedMobileAppContent = {
  __typename?: 'DismissedMobileAppContent';
  /**
   * Pieces of Content can have a dismissal expiration time. This
   * field will be set if the user dismissed the content, but then
   * their dismissal expired, and the content should now be visible.
   */
  dismissalExpiredAt?: Maybe<Scalars['DateTime']>;
  dismissalId: Scalars['ID'];
  dismissedAt: Scalars['DateTime'];
  dismissedContent: AdminMobileAppContent;
};

export enum DistanceUnit {
  KM = 'KM',
  MILES = 'MILES'
}

export type DogPark = {
  __typename?: 'DogPark';
  address?: Maybe<ReverseGeocodeResult>;
  boundary?: Maybe<Scalars['JSON']>;
  /** Admin only */
  communityLeaderboardUrl?: Maybe<Scalars['String']>;
  dbId: Scalars['Int'];
  deleted: Scalars['Boolean'];
  id: Scalars['ID'];
  isDiscoverableOverride: Scalars['Boolean'];
  name: Scalars['String'];
  position: Position;
  preventUpdate: Scalars['Boolean'];
  sourceId?: Maybe<Scalars['String']>;
  type: POIType;
};

export type DogParkCheckin = {
  __typename?: 'DogParkCheckin';
  activity?: Maybe<Activity>;
  connectedUser?: Maybe<User>;
  dogPark: DogPark;
  timestamp: Scalars['DateTime'];
};

export type DogParkCheckinFeed = {
  __typename?: 'DogParkCheckinFeed';
  checkins: Array<DogParkCheckin>;
  pageInfo: PageInfo;
};

export type DogParkCheckinFilter = {
  types?: InputMaybe<Array<POIType>>;
};

export type DogParkCheckinsForPetInput = {
  filter?: InputMaybe<DogParkCheckinFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  petId: Scalars['ID'];
};

export type DogParkFeed = {
  __typename?: 'DogParkFeed';
  count: Scalars['Int'];
  dogParks: Array<DogPark>;
};

export type DogParkNotificationSettingOption = {
  __typename?: 'DogParkNotificationSettingOption';
  description: Scalars['String'];
  shareVisitsEnabled: Scalars['Boolean'];
  visitNotificationsEnabled: Scalars['Boolean'];
};

export type DogParkNotificationSettings = {
  __typename?: 'DogParkNotificationSettings';
  availableNotificationSettingOptions: Array<DogParkNotificationSettingOption>;
  currentNotificationSetting?: Maybe<DogParkNotificationSettingOption>;
  /** @deprecated Use dogParkShareableSubscriptionText instead */
  publicSmsLink?: Maybe<Scalars['String']>;
};

export type DogParkNotificationSettingsInput = {
  shareVisitsEnabled?: InputMaybe<Scalars['Boolean']>;
  visitNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type DogParkShareableSubscriptionText = {
  __typename?: 'DogParkShareableSubscriptionText';
  text: Scalars['String'];
};

export type DogParkVisitor = {
  __typename?: 'DogParkVisitor';
  /**
   * Optional text for the client to display.
   * For example "Last visited today" for recent visitors.
   */
  displayText?: Maybe<Scalars['String']>;
  /** True when the dog is at the dog park now. */
  isAtDogPark?: Maybe<Scalars['Boolean']>;
  /** Time at which this pet last visited the dog park. */
  lastVisitTimestamp?: Maybe<Scalars['DateTime']>;
  /** Visits this pet has made to the dog park, over a server-defined period. */
  numVisitsLastPeriod: Scalars['Int'];
  pet: StrangerPet;
  /**
   * Step count for this pet, over a server-defined period.
   * @deprecated No longer displayed in UI
   */
  rankingPeriodStepCount?: Maybe<Scalars['Int']>;
  /** Position of this pet in the dog park leaderboard. */
  visitorRankNumber: Scalars['Int'];
};

export type DogParkVisitorFeed = {
  __typename?: 'DogParkVisitorFeed';
  /**
   * Total number of visitors: may be greater than len(visitors) if
   * the backend is truncating feeds, or pagination is implemented.
   */
  count: Scalars['Int'];
  /**
   * The date of the beginning of the rolling window used to count
   * and rank visits to the dog park.
   */
  rankingPeriodStartDate: Scalars['DateTime'];
  visitors: Array<DogParkVisitor>;
};

export type DowngradeSeries2Input = {
  moduleId: Scalars['String'];
};

export type DowngradeSeries2Result = {
  __typename?: 'DowngradeSeries2Result';
  success?: Maybe<Scalars['Boolean']>;
};

export type DowngradeSeries3Input = {
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  currency?: InputMaybe<Currency>;
  moduleId: Scalars['String'];
  sku: Scalars['String'];
};

export type DowngradeSeries3Result = {
  __typename?: 'DowngradeSeries3Result';
  success?: Maybe<Scalars['Boolean']>;
};

export type DuplicatePromotionInput = {
  newInternalName: Scalars['String'];
  sourceId: Scalars['Int'];
};

export type DynamicEnum = {
  __typename?: 'DynamicEnum';
  id: Scalars['ID'];
  kind: DynamicEnumKind;
  members: Array<DynamicEnumMember>;
};

export enum DynamicEnumKind {
  /** List of hardware defects that can be noted in an RMA. */
  RMA_HARDWARE_DEFECT = 'RMA_HARDWARE_DEFECT',
  /** Where an RMA item was purchased from: Fi Ecomm, Chewy, etc. */
  RMA_PURCHASE_PROVENANCE = 'RMA_PURCHASE_PROVENANCE',
  /** Reason codes for an RMA return. */
  RMA_RETURN_REASON = 'RMA_RETURN_REASON',
  /** Reason codes for an RMA shipping error. */
  RMA_SHIPPING_ERROR_REASON = 'RMA_SHIPPING_ERROR_REASON',
  /** Reason codes for an unknown RMA check-in. */
  RMA_UNKNOWN_RETURN_REASON = 'RMA_UNKNOWN_RETURN_REASON',
  /** Reason codes for an RMA warranty exchange. */
  RMA_WARRANTY_EXCHANGE_REASON = 'RMA_WARRANTY_EXCHANGE_REASON'
}

export type DynamicEnumMember = {
  __typename?: 'DynamicEnumMember';
  canDelete: Scalars['Boolean'];
  code: Scalars['String'];
  id: Scalars['ID'];
  metadata: Scalars['JSON'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['ID']>;
};

export type EcommerceExperiment = {
  __typename?: 'EcommerceExperiment';
  id: Scalars['String'];
  name: Scalars['String'];
  variants: Array<EcommerceExperimentVariant>;
};

export type EcommerceExperimentEnrollment = {
  __typename?: 'EcommerceExperimentEnrollment';
  experiment: EcommerceExperiment;
  variant: EcommerceExperimentVariant;
};

export type EcommerceExperimentVariant = {
  __typename?: 'EcommerceExperimentVariant';
  description: Scalars['String'];
  name: Scalars['String'];
  /**
   * Returns a signed URL that can be used to direct users to the shop with this
   * variant enabled.
   */
  redirectUrl: Scalars['String'];
};

export type EnableOrExtendQuickReportModeResult = {
  __typename?: 'EnableOrExtendQuickReportModeResult';
  ttlSeconds: Scalars['Int'];
};

export type EndSharingSessionResult = {
  __typename?: 'EndSharingSessionResult';
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum EvalClassification {
  ACTIVITY = 'ACTIVITY',
  BEHAVIORS = 'BEHAVIORS',
  DAILY_CHECK_IN = 'DAILY_CHECK_IN',
  FUN = 'FUN',
  GOALS = 'GOALS',
  HEALTH = 'HEALTH',
  OTHER = 'OTHER',
  SLEEP = 'SLEEP'
}

export type EvalGuideline = {
  __typename?: 'EvalGuideline';
  appliesWhen?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  description: Scalars['String'];
  exampleBadResponse?: Maybe<Scalars['String']>;
  exampleGoodResponse?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  key: Scalars['String'];
  scope: EvalGuidelineScope;
  severity: EvalGuidelineSeverity;
  title: Scalars['String'];
  uuid: Scalars['String'];
  version: Scalars['Int'];
};

export enum EvalGuidelineScope {
  CONDITIONAL = 'CONDITIONAL',
  GLOBAL = 'GLOBAL'
}

export enum EvalGuidelineSeverity {
  BLOCKER = 'BLOCKER',
  MAJOR = 'MAJOR',
  MINOR = 'MINOR'
}

export type EventFeedbackResponse = {
  __typename?: 'EventFeedbackResponse';
  createdAt: Scalars['DateTime'];
  feedback: Scalars['String'];
  helpCenterLink: HelpCenterLink;
};

/** Input for executing a product transfer. */
export type ExecuteProductTransferInput = {
  /** Account code for the user */
  accountCode: Scalars['String'];
  /** Collar color for fulfillment (yellow, gray, blue, pink). Required for S3+ kit orders. */
  collarColor?: InputMaybe<Scalars['String']>;
  /** Collar size for fulfillment (xsmall, small, medium, large, xlarge). Required for S3+ kit orders. */
  collarSize?: InputMaybe<Scalars['String']>;
  /** Custom hardware fee amount in cents (overrides default) */
  hardwareFeeAmountInCents?: InputMaybe<Scalars['Int']>;
  /** SKU for hardware charge (e.g., 'F3B-M' for S3+ module) */
  hardwareSku?: InputMaybe<Scalars['String']>;
  /** Optional CX agent notes */
  notes?: InputMaybe<Scalars['String']>;
  /** List of device transfers to execute */
  transfers: Array<DeviceTransferInput>;
  /** Whether to waive the hardware fee */
  waiveHardwareFee?: InputMaybe<Scalars['Boolean']>;
};

export type ExtendSubscriptionInput = {
  days: Scalars['Int'];
  subscriptionId: Scalars['String'];
};

export type ExternalUser = {
  __typename?: 'ExternalUser';
  id: Scalars['ID'];
  name: Scalars['String'];
  profilePicture?: Maybe<Image>;
};

export type FalseBooleanSetting = BooleanSetting & {
  __typename?: 'FalseBooleanSetting';
  /**
   * DO NOT USE: This is required since GraphQL doesn't support empty types.
   * Use the __typename to determine the flag's boolean value.
   */
  emptyType?: Maybe<Scalars['Boolean']>;
  platformOverrides: Array<BooleanSettingPlatformOverride>;
};

export type FeatureFlag = {
  accessedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  dynamicSettingName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum FiCountry {
  CA = 'CA',
  GB = 'GB',
  US = 'US'
}

export type FiFeed = {
  __typename?: 'FiFeed';
  feedItems: Array<FiFeedItem>;
  pageInfo: PageInfo;
};

export type FiFeedActivityItem = FiFeedItem & {
  __typename?: 'FiFeedActivityItem';
  activity: Activity;
  existingFeedback?: Maybe<EventFeedbackResponse>;
  feedbackOptions?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  pet: Pet;
  timestamp: Scalars['DateTime'];
};

export type FiFeedBirthdayCardItem = FiFeedItem & {
  __typename?: 'FiFeedBirthdayCardItem';
  id: Scalars['ID'];
  message: Scalars['String'];
  petId: Scalars['ID'];
  timestamp: Scalars['DateTime'];
  title: Scalars['String'];
};

/** DEPRECATED: This type has been replaced by FiFeedLikableWalkItem */
export type FiFeedClappableWalkItem = FiFeedItem & {
  __typename?: 'FiFeedClappableWalkItem';
  followedPet: StrangerPet;
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
  walk: StrangerWalk;
};

export type FiFeedDogParkVisitItem = FiFeedItem & {
  __typename?: 'FiFeedDogParkVisitItem';
  dogPark: DogPark;
  id: Scalars['ID'];
  pet: Pet;
  timestamp: Scalars['DateTime'];
};

export enum FiFeedFilter {
  ALL = 'ALL',
  FOLLOWING = 'FOLLOWING',
  YOU = 'YOU'
}

export type FiFeedFollowedPetPhotoAddedItem = FiFeedItem & {
  __typename?: 'FiFeedFollowedPetPhotoAddedItem';
  followedPet: StrangerPet;
  id: Scalars['ID'];
  photo: Photo;
  timestamp: Scalars['DateTime'];
};

export type FiFeedGenericNotificationItem = FiFeedItem & {
  __typename?: 'FiFeedGenericNotificationItem';
  body: FormatString;
  existingFeedback?: Maybe<EventFeedbackResponse>;
  feedbackOptions?: Maybe<Array<Scalars['String']>>;
  hideTimestamp: Scalars['Boolean'];
  id: Scalars['ID'];
  optionalPet?: Maybe<Pet>;
  timestamp: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
};

export type FiFeedGoalStreakItem = FiFeedItem & {
  __typename?: 'FiFeedGoalStreakItem';
  /** The number of bonus points associated with the current streak bonus */
  currentBonusPoints: Scalars['Int'];
  daysToNextBonus: Scalars['Int'];
  id: Scalars['ID'];
  numDays: Scalars['Int'];
  pet: Pet;
  /** Indicates if this streak event resulted in a bonus being unlocked */
  streakBonusUnlocked: Scalars['Boolean'];
  subtitle: Scalars['String'];
  timestamp: Scalars['DateTime'];
  title: Scalars['String'];
};

export type FiFeedItem = {
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export type FiFeedLikableWalkItem = FiFeedItem & {
  __typename?: 'FiFeedLikableWalkItem';
  followedPet: StrangerPet;
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
  walk: StrangerWalk;
};

export type FiFeedPetFollowedItem = FiFeedItem & {
  __typename?: 'FiFeedPetFollowedItem';
  followedPet: Pet;
  followingPet: StrangerPet;
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export type FiFeedPhotoAddedItem = FiFeedItem & {
  __typename?: 'FiFeedPhotoAddedItem';
  id: Scalars['ID'];
  pet: Pet;
  photo: Photo;
  timestamp: Scalars['DateTime'];
  user: User;
};

export type FiFeedPhotoLikedItem = FiFeedItem & {
  __typename?: 'FiFeedPhotoLikedItem';
  id: Scalars['ID'];
  /** The pet who is liking the photo */
  likingPet: StrangerPet;
  numPhotosLiked: Scalars['Int'];
  /** The pet whose photo is being liked */
  pet: Pet;
  photo: Photo;
  timestamp: Scalars['DateTime'];
};

export type FiFeedRankingUpdateItem = FiFeedItem & {
  __typename?: 'FiFeedRankingUpdateItem';
  id: Scalars['ID'];
  newBreedRank: Scalars['Int'];
  newOverallRank: Scalars['Int'];
  newOverallRankPercentile?: Maybe<Scalars['Int']>;
  pet: Pet;
  timestamp: Scalars['DateTime'];
};

export enum FiLanguage {
  DE_DE = 'DE_DE',
  EN_CA = 'EN_CA',
  EN_GB = 'EN_GB',
  EN_US = 'EN_US',
  ES_ES = 'ES_ES',
  FR_CA = 'FR_CA',
  FR_FR = 'FR_FR',
  NL_NL = 'NL_NL'
}

export type FiNewsNotification = {
  __typename?: 'FiNewsNotification';
  /** Admin-only */
  dbId: Scalars['Int'];
  featureImageUrl: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
  publishedAt: Scalars['DateTime'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type FiNewsNotificationFeed = {
  __typename?: 'FiNewsNotificationFeed';
  items: Array<FiNewsNotification>;
};

/** A statistic about firmware versions in the field. */
export type FirmwareDeploymentStatistics = {
  __typename?: 'FirmwareDeploymentStatistics';
  versionDistribution: Array<FirmwareVersionStatistic>;
};

export enum FirmwareReleaseClass {
  PROD = 'PROD',
  TEST = 'TEST'
}

export type FirmwareStatistics = {
  __typename?: 'FirmwareStatistics';
  /** The distribution of updateChannel values across this platform. */
  configuredDistribution: Array<FirmwareUpdateChannelStatistic>;
  /** The distribution of versions reported by recent devices. */
  deploymentStatistics: FirmwareDeploymentStatistics;
};

export type FirmwareTag = {
  __typename?: 'FirmwareTag';
  buildAttribute: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type FirmwareUpdate = {
  __typename?: 'FirmwareUpdate';
  /**
   * Indicates that the client's firmware is out of date and they should download an update
   * from this URL.
   */
  downloadUrl?: Maybe<Scalars['String']>;
};

export type FirmwareUpdateChannel = {
  __typename?: 'FirmwareUpdateChannel';
  currentAppVersion?: Maybe<FirmwareVersion>;
  currentBootloaderVersion?: Maybe<FirmwareVersion>;
  name: Scalars['String'];
  platformId: Scalars['String'];
  releaseClass: FirmwareReleaseClass;
  remoteLogEnabled?: Maybe<Scalars['Boolean']>;
  /** Tags that are associated with this update channel. */
  tags: Array<FirmwareTag>;
};

/** A statistic about how many devices are on a particular firmware channel and version. */
export type FirmwareUpdateChannelStatistic = {
  __typename?: 'FirmwareUpdateChannelStatistic';
  count: Scalars['Int'];
  updateChannel: Scalars['String'];
  version: Scalars['String'];
};

export enum FirmwareUpdateType {
  APPLICATION = 'APPLICATION',
  BOOTLOADER = 'BOOTLOADER'
}

export type FirmwareVersion = {
  __typename?: 'FirmwareVersion';
  buildUrl?: Maybe<Scalars['String']>;
  commit?: Maybe<Scalars['String']>;
  compareUrl?: Maybe<Scalars['String']>;
  compatiblePlatformId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  releaseClass: FirmwareReleaseClass;
  s3Suffix: Scalars['String'];
  /** Tags that are associated with this firmware version. */
  tags: Array<FirmwareTag>;
  type: FirmwareUpdateType;
};

export type FirmwareVersionChangeDeviceEvent = DeviceEventBase & {
  __typename?: 'FirmwareVersionChangeDeviceEvent';
  date: Scalars['DateTime'];
  firmwareVersion?: Maybe<Scalars['String']>;
  moduleId: Scalars['String'];
  newVersion?: Maybe<Scalars['String']>;
  oldVersion?: Maybe<Scalars['String']>;
  platform: Scalars['String'];
};

/** A statistic about how many devices are reporting a particular firmware version. */
export type FirmwareVersionStatistic = {
  __typename?: 'FirmwareVersionStatistic';
  count: Scalars['Int'];
  version: Scalars['String'];
};

export enum FollowStatus {
  BLOCKED = 'BLOCKED',
  FOLLOWED = 'FOLLOWED',
  UNFOLLOWED = 'UNFOLLOWED'
}

export enum FontStyle {
  BOLD = 'BOLD',
  /**
   * This is currently used on client to indicate that text should be bold
   * @deprecated Use ITALIC or BOLD
   */
  EMPHASIZED = 'EMPHASIZED',
  ITALIC = 'ITALIC',
  REGULAR = 'REGULAR'
}

export type ForModuleBundleCartItemInput = {
  cartItemId: Scalars['String'];
  forModuleId: Scalars['String'];
  /** This will probably always be false but needed in schema because of the way the cart items are modeled on the frontend. */
  isGift?: InputMaybe<Scalars['Boolean']>;
  lineItem: CartLineItemInput;
  quantity: Scalars['Int'];
  subscriptionLineItem: CartLineItemInput;
};

export type ForModuleCartItemInput = {
  cartItemId: Scalars['String'];
  forModuleId: Scalars['String'];
  lineItem: CartLineItemInput;
  quantity: Scalars['Int'];
};

export type FormatString = {
  __typename?: 'FormatString';
  spans: Array<Span>;
  text: Scalars['String'];
};

export type ForwardGeocodeCityResult = {
  __typename?: 'ForwardGeocodeCityResult';
  city?: Maybe<Scalars['String']>;
  cityState: Scalars['String'];
  position: Position;
  state?: Maybe<Scalars['String']>;
};

export type ForwardGeocodeResult = {
  __typename?: 'ForwardGeocodeResult';
  address: Scalars['String'];
  cityState: Scalars['String'];
  position: Position;
};

export enum FulfillmentProviderCode {
  DCL = 'DCL',
  TAGG = 'TAGG'
}

export type FulfillmentWarehouse = {
  __typename?: 'FulfillmentWarehouse';
  active: Scalars['Boolean'];
  externalCode: Scalars['String'];
  fulfillmentProviderCode: FulfillmentProviderCode;
  id: Scalars['ID'];
  metadata?: Maybe<FulfillmentWarehouseMetadata>;
  name: Scalars['String'];
};

export type FulfillmentWarehouseMetadata = {
  __typename?: 'FulfillmentWarehouseMetadata';
  b2bAccountNumber?: Maybe<Scalars['String']>;
  d2cAccountNumber?: Maybe<Scalars['String']>;
  includeDangerousGoodsSticker?: Maybe<Scalars['Boolean']>;
  inventoryTypes: Array<Scalars['String']>;
  maxGoodsValuePerShipmentInDollars?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
};

export type FulfillmentWarehouseMetadataInput = {
  /** b2bAccountNumber is included with orders when submitted to the warehouse. B2B === Business to Business. */
  b2bAccountNumber?: InputMaybe<Scalars['String']>;
  /** d2cAccountNumber is included with orders when submitted to the warehouse. D2C === Direct to Consumer. */
  d2cAccountNumber?: InputMaybe<Scalars['String']>;
  /**
   * When true, for any orders that are shipped from this warehouse, the backend will explicitly include a dangerous
   * goods sticker as a line item in the shipment when the number of dangerous goods exceeds the appropriate threshold.
   */
  includeDangerousGoodsSticker?: InputMaybe<Scalars['Boolean']>;
  /**
   * The types of inventory that are stored at this warehouse. Used when fetching inventory from the 3PL
   * to match results with our fulfillment warehouse records.
   */
  inventoryTypes?: InputMaybe<Array<Scalars['String']>>;
  /**
   * If defined, we must split the order into multiple shipments when the order contains items that are valued
   * over the specified amount
   */
  maxGoodsValuePerShipmentInDollars?: InputMaybe<Scalars['Int']>;
  /**
   * The timezone of the warehouse. Warehouse data is usually reported in their local time without specifying
   * a timezone so we use this to convert times to UTC.
   */
  timezone?: InputMaybe<Scalars['String']>;
};

export type FullAdminUserProfile = AdminBaseUserProfile & {
  __typename?: 'FullAdminUserProfile';
  automaticallyActivateDevices: Scalars['Boolean'];
  billingAccount?: Maybe<BillingAccount>;
  chipReseller?: Maybe<ChipReseller>;
  dbId: Scalars['Int'];
  deactivated: Scalars['Boolean'];
  ecommerceOrders: Array<Order>;
  email: Scalars['String'];
  emails: Array<UserEmail>;
  fiNewsNotificationsEnabled: Scalars['Boolean'];
  firstName: Scalars['String'];
  groups: Array<UserGroup>;
  handsets: Array<Handset>;
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  latestLocation?: Maybe<Location>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  referrals: Referrals;
  settings: UserSettings;
  socialBanned: Scalars['Boolean'];
  /** Returns all feature flag values by default, but can optionally provide an array of feature flag names to return */
  targetedFeatureFlags: Array<TargetedFeatureFlag>;
  tenancy?: Maybe<Scalars['String']>;
  thirdPartyAccess?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  userHouseholds: Array<UserHousehold>;
};


export type FullAdminUserProfilegroupsArgs = {
  excludePseudo?: InputMaybe<Scalars['Boolean']>;
};


export type FullAdminUserProfilehandsetsArgs = {
  status?: InputMaybe<Array<HandsetStatus>>;
};


export type FullAdminUserProfiletargetedFeatureFlagsArgs = {
  names?: InputMaybe<Array<Scalars['String']>>;
};

export type GPSTestCompleteResult = {
  __typename?: 'GPSTestCompleteResult';
  report: DeviceDiagnosticLocationReport;
};

/** Connection was stolen by a charging base or another mobile user. */
export type GPSTestConnectionStolenResult = {
  __typename?: 'GPSTestConnectionStolenResult';
  /**
   * Connection state of the collar which can be used to determine if it was another user
   * or a base that stole the connection.
   */
  state: ConnectionState;
};

export type GPSTestResult = GPSTestCompleteResult | GPSTestConnectionStolenResult;

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

export type GetHealthGptChatThreadInput = {
  petId: Scalars['ID'];
};

export type GetMultipleSupplementSubscriptionsPricingInput = {
  forceApplyDiscount?: InputMaybe<Scalars['Boolean']>;
  skusToAdd: Array<Scalars['String']>;
};

export type GetMultipleSupplementSubscriptionsPricingResult = {
  __typename?: 'GetMultipleSupplementSubscriptionsPricingResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  subtotalInCents: Scalars['Int'];
  success: Scalars['Boolean'];
  taxInCents: Scalars['Int'];
  totalInCents: Scalars['Int'];
};

export type GetPermissionMobileAppContentInput = {
  clientTargetingFacts: MobileAppContentClientTargetingFactsInput;
  permissionTypes: Array<Scalars['String']>;
  petId?: InputMaybe<Scalars['ID']>;
};

export type GetPetBehaviorDetailInput = {
  /**
   * behaviorId is purposely not an enum to allow adding new behaviors without client updates.
   * Current supported values are 'activity', 'barking', 'cleaning_self', 'drinking', 'eating', 'scratching'
   */
  behaviorId: Scalars['String'];
  /** If null, treat as now */
  cursor?: InputMaybe<Scalars['String']>;
  period: PetBehaviorPeriod;
  petId: Scalars['ID'];
};

export type GetPetDocumentsInput = {
  householdId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type GiftCardDeliveryInput = {
  deliverAt?: InputMaybe<Scalars['DateTime']>;
  emailAddress: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  gifterName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  personalMessage?: InputMaybe<Scalars['String']>;
};

export type GiftShippingAddressInput = {
  city: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export type GingrConfig = {
  __typename?: 'GingrConfig';
  /** The API key that gives access to the Gingr API for the boarding facility. */
  apiKey: Scalars['String'];
  /**
   * On the Gingr platform, each boarding facility has their own subdomain
   * e.g. for prhg-testing.gingrapp.com this value would be prhg-testing
   */
  apiSubdomain: Scalars['String'];
  /**
   * Location ID in Gingr for this boarding facility. Optional because results using an API
   * key are already scoped to a location.
   */
  locationId?: Maybe<Scalars['String']>;
};

export type Give1MonthGet1DollarPerMonthDetails = {
  __typename?: 'Give1MonthGet1DollarPerMonthDetails';
  numActiveReferrals: Scalars['Int'];
  totalDollarsEarned: Scalars['Float'];
};

export type GnssFixFailure = {
  __typename?: 'GnssFixFailure';
  gnssTimeToFixInSeconds: Scalars['Int'];
  timestamp: Scalars['DateTime'];
};

export type GroupsBooleanSetting = BooleanSetting & {
  __typename?: 'GroupsBooleanSetting';
  groups: Array<Scalars['String']>;
  platformOverrides: Array<BooleanSettingPlatformOverride>;
};

export type Handset = {
  __typename?: 'Handset';
  /** Admin only */
  client?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  dbId: Scalars['Int'];
  /** Admin only */
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  /** Admin only */
  deviceToken: Scalars['String'];
  /** Admin only */
  endpointArn: Scalars['String'];
  fromImpersonation?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  platform: HandsetPlatform;
  updatedAt: Scalars['DateTime'];
};

export type HandsetLogClient = {
  __typename?: 'HandsetLogClient';
  deviceId?: Maybe<Scalars['String']>;
  deviceModel?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type HandsetLogDocument = {
  __typename?: 'HandsetLogDocument';
  assignable?: Maybe<Scalars['Boolean']>;
  authCode?: Maybe<Scalars['Int']>;
  baseId?: Maybe<Scalars['String']>;
  client?: Maybe<HandsetLogClient>;
  deviceTypeForSetup?: Maybe<Scalars['String']>;
  logLevel?: Maybe<Scalars['String']>;
  logType?: Maybe<HandsetLogType>;
  logdate: Scalars['DateTime'];
  moduleId?: Maybe<Scalars['String']>;
  msg: Scalars['String'];
  networkName?: Maybe<Scalars['String']>;
  peripheralInfo?: Maybe<HandsetLogPeripheralInfo>;
  results?: Maybe<Array<WifiScanResult>>;
  rssi?: Maybe<Scalars['Int']>;
  timestamp: Scalars['DateTime'];
};

export type HandsetLogPeripheralInfo = {
  __typename?: 'HandsetLogPeripheralInfo';
  peripheralType?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  uniqueId?: Maybe<Scalars['String']>;
};

export enum HandsetLogType {
  ADD_WIFI_CREDENTIALS_ERROR = 'ADD_WIFI_CREDENTIALS_ERROR',
  ADD_WIFI_CREDENTIALS_SUCCESS = 'ADD_WIFI_CREDENTIALS_SUCCESS',
  APP_EXIT = 'APP_EXIT',
  APP_LAUNCH = 'APP_LAUNCH',
  ASSIGNABILITY_RESULT = 'ASSIGNABILITY_RESULT',
  BASE_ASSIGNMENT_FAILURE = 'BASE_ASSIGNMENT_FAILURE',
  BASE_ASSIGNMENT_SUCCESS = 'BASE_ASSIGNMENT_SUCCESS',
  BASE_HANDOFF_FAILURE = 'BASE_HANDOFF_FAILURE',
  BASE_HANDOFF_REQUESTED = 'BASE_HANDOFF_REQUESTED',
  BASE_HANDOFF_SUCCESS = 'BASE_HANDOFF_SUCCESS',
  BASE_WIFI_AUTH_ERROR = 'BASE_WIFI_AUTH_ERROR',
  BASE_WIFI_CONNECT_SUCCESS = 'BASE_WIFI_CONNECT_SUCCESS',
  BASE_WIFI_SCAN_RESULTS = 'BASE_WIFI_SCAN_RESULTS',
  BLE_CONNECTED = 'BLE_CONNECTED',
  BLE_DISCONNECT = 'BLE_DISCONNECT',
  BLE_ERROR = 'BLE_ERROR',
  BLE_OPERATION = 'BLE_OPERATION',
  BLE_READ_INFO = 'BLE_READ_INFO',
  BLE_SCAN_RESULT = 'BLE_SCAN_RESULT',
  BLE_START_CONNECT = 'BLE_START_CONNECT',
  BLE_STATE_SNAPSHOT = 'BLE_STATE_SNAPSHOT',
  CREDENTIAL_PACK_QUERY_ERROR = 'CREDENTIAL_PACK_QUERY_ERROR',
  CREDENTIAL_PACK_QUERY_SUCCESS = 'CREDENTIAL_PACK_QUERY_SUCCESS',
  FEATURE_FLAG_READ = 'FEATURE_FLAG_READ',
  MODULE_ASSIGNMENT_FAILURE = 'MODULE_ASSIGNMENT_FAILURE',
  MODULE_ASSIGNMENT_SUCCESS = 'MODULE_ASSIGNMENT_SUCCESS',
  MODULE_CHARGE_STATE_READ = 'MODULE_CHARGE_STATE_READ',
  MODULE_FIRMWARE_UPDATE_FAILURE = 'MODULE_FIRMWARE_UPDATE_FAILURE',
  MODULE_FIRMWARE_UPDATE_STARTED = 'MODULE_FIRMWARE_UPDATE_STARTED',
  MODULE_FIRMWARE_UPDATE_SUCCESS = 'MODULE_FIRMWARE_UPDATE_SUCCESS',
  MODULE_PROXY_FAILURE = 'MODULE_PROXY_FAILURE',
  MODULE_PROXY_STARTED = 'MODULE_PROXY_STARTED',
  MODULE_PROXY_SUCCESS = 'MODULE_PROXY_SUCCESS',
  READ_BASE_DIAGNOSTIC = 'READ_BASE_DIAGNOSTIC',
  READ_CREDENTIAL_PACK_CHARACTERISTIC_SUCCESS = 'READ_CREDENTIAL_PACK_CHARACTERISTIC_SUCCESS',
  SELECTED_DEVICE_TYPE_FOR_SETUP = 'SELECTED_DEVICE_TYPE_FOR_SETUP',
  SELECTED_ENTER_MANUAL_WIFI_CREDENTIALS = 'SELECTED_ENTER_MANUAL_WIFI_CREDENTIALS',
  SELECTED_WIFI_NETWORK = 'SELECTED_WIFI_NETWORK',
  SELECT_DEVICE_TYPE_FOR_SETUP_PROMPT = 'SELECT_DEVICE_TYPE_FOR_SETUP_PROMPT',
  STARTING_BASE_ASSIGNMENT = 'STARTING_BASE_ASSIGNMENT',
  STARTING_BASE_CONFIGURATION = 'STARTING_BASE_CONFIGURATION',
  STARTING_BASE_WIFI_SCAN = 'STARTING_BASE_WIFI_SCAN',
  STARTING_FI_MINI_SETUP = 'STARTING_FI_MINI_SETUP',
  STARTING_MODULE_ASSIGNMENT = 'STARTING_MODULE_ASSIGNMENT',
  STARTING_MODULE_WIFI_CONFIGURATION = 'STARTING_MODULE_WIFI_CONFIGURATION',
  STARTING_WIFI_CONFIGURATION = 'STARTING_WIFI_CONFIGURATION',
  STARTING_WIFI_SCAN = 'STARTING_WIFI_SCAN',
  SYSTEM_METRIC = 'SYSTEM_METRIC',
  USER_NOTIFICATION = 'USER_NOTIFICATION',
  WEBSOCKET_CONNECTION_FAILURE = 'WEBSOCKET_CONNECTION_FAILURE',
  WEBSOCKET_CONNECTION_SUCCESS = 'WEBSOCKET_CONNECTION_SUCCESS',
  WIFI_AUTH_ERROR = 'WIFI_AUTH_ERROR',
  WIFI_CONNECT_SUCCESS = 'WIFI_CONNECT_SUCCESS',
  WIFI_SCAN_RESULTS = 'WIFI_SCAN_RESULTS',
  WRITE_CREDENTIAL_PACK_CHARACTERISTIC_SUCCESS = 'WRITE_CREDENTIAL_PACK_CHARACTERISTIC_SUCCESS'
}

export enum HandsetPlatform {
  ANDROID = 'ANDROID',
  IOS = 'IOS'
}

export enum HandsetStatus {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  FROM_IMPERSONATION = 'FROM_IMPERSONATION'
}

export type HardwareDefect = {
  __typename?: 'HardwareDefect';
  createdBy?: Maybe<Scalars['String']>;
  defect: DynamicEnumMember;
  id: Scalars['ID'];
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceSource?: Maybe<InvoiceSource>;
  serialNumber?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
};

/** Represents current state based on current/past collar reporting: */
export type HasReportsState = PetCollarState & {
  __typename?: 'HasReportsState';
  /** Represents collar-specific state (i.e. online/offline) */
  collarStatus: CollarStatus;
  /** Current Lost Dog Mode state. */
  ldmState: CollarLostDogModeState;
  /** Represents the latest activity at the time */
  ongoingActivity: OngoingActivity;
  timestamp: Scalars['DateTime'];
};

export type HealthGptChatMessage = {
  __typename?: 'HealthGptChatMessage';
  disclaimer?: Maybe<HealthGptChatMessageDisclaimer>;
  id: Scalars['ID'];
  request: HealthGptChatMessageRequest;
  response: HealthGptChatMessageResponse;
  userFeedback?: Maybe<HealthGptChatMessageUserFeedback>;
};

export type HealthGptChatMessageDisclaimer = {
  __typename?: 'HealthGptChatMessageDisclaimer';
  message: Scalars['String'];
};

export type HealthGptChatMessageRequest = {
  __typename?: 'HealthGptChatMessageRequest';
  message: Scalars['String'];
};

export type HealthGptChatMessageResponse = {
  __typename?: 'HealthGptChatMessageResponse';
  message: Scalars['String'];
};

export type HealthGptChatMessageUserFeedback = {
  __typename?: 'HealthGptChatMessageUserFeedback';
  feedback?: Maybe<Scalars['String']>;
  wasHelpful: Scalars['Boolean'];
};

export type HealthGptChatThread = {
  __typename?: 'HealthGptChatThread';
  messages: Array<HealthGptChatMessage>;
};

export enum HealthGptDocumentStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  READY = 'READY'
}

export type HealthGptSuggestedQuestion = {
  __typename?: 'HealthGptSuggestedQuestion';
  question: Scalars['String'];
};

export type HealthMetricBin = {
  __typename?: 'HealthMetricBin';
  count: Scalars['Int'];
  grade?: Maybe<HealthMetricGrade>;
  value: Scalars['Float'];
};

export type HealthMetricBinnedValues = {
  __typename?: 'HealthMetricBinnedValues';
  custom?: Maybe<HealthMetricRollupBinnedValues>;
  rollup7d?: Maybe<HealthMetricRollupBinnedValues>;
  rollup24h?: Maybe<HealthMetricRollupBinnedValues>;
  rollup28d?: Maybe<HealthMetricRollupBinnedValues>;
};

export enum HealthMetricGrade {
  GOOD = 'GOOD',
  PROBLEM = 'PROBLEM',
  WARNING = 'WARNING'
}

export type HealthMetricRollupBinnedValues = {
  __typename?: 'HealthMetricRollupBinnedValues';
  values: Array<HealthMetricBin>;
};

export type HealthMetricValue = {
  __typename?: 'HealthMetricValue';
  grade?: Maybe<HealthMetricGrade>;
  updated?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type HealthRollupValues = {
  __typename?: 'HealthRollupValues';
  custom?: Maybe<HealthMetricValue>;
  rollup7d?: Maybe<HealthMetricValue>;
  rollup24h?: Maybe<HealthMetricValue>;
  rollup28d?: Maybe<HealthMetricValue>;
};

export type HelpCenterLink = {
  __typename?: 'HelpCenterLink';
  displayText: Scalars['String'];
  url: Scalars['String'];
};

export type HourlySleepBar = {
  __typename?: 'HourlySleepBar';
  /** The number of minutes the pet was resting within this hour. */
  minutesResting: Scalars['Int'];
  /** Percent of time period pet was resting (0-1). */
  percentResting: Scalars['Float'];
  /** Start of the period of sleep (note end = this + 1 hour). */
  start: Scalars['DateTime'];
  type: SleepType;
};

export type Household = {
  __typename?: 'Household';
  bases: Array<ChargingBase>;
  /** Boarding facility pets that have previously checked into the facility on the Fi app. */
  boardingPets: BoardingFacilityPetFeed;
  credentialUpdateForDevice?: Maybe<CredentialUpdate>;
  dbId: Scalars['Int'];
  following: StrangerPetFeed;
  id: Scalars['ID'];
  invites: Array<UserInvite>;
  name?: Maybe<Scalars['String']>;
  pets: Array<Pet>;
  places: Array<Place>;
  socialOptedOut: Scalars['Boolean'];
  suggestedVets: Array<Veterinary>;
  tenancy?: Maybe<Scalars['String']>;
  thirdPartyAccess?: Maybe<Scalars['String']>;
  type: HouseholdType;
  users: Array<HouseholdUser>;
  vets: Array<Veterinary>;
  wifiNetworks: WifiNetworks;
};


export type HouseholdboardingPetsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  query?: InputMaybe<Scalars['String']>;
};


export type HouseholdcredentialUpdateForDeviceArgs = {
  currentHash?: InputMaybe<Scalars['String']>;
  deviceId: Scalars['ID'];
};


export type HouseholdfollowingArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type HouseholdinvitesArgs = {
  state?: InputMaybe<InviteState>;
};


export type HouseholdpetsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type HouseholdusersArgs = {
  role?: InputMaybe<UserHouseholdRole>;
};

export type HouseholdInvite = {
  __typename?: 'HouseholdInvite';
  role: UserHouseholdRole;
};

export type HouseholdInviteInput = {
  householdId: Scalars['ID'];
  role: UserHouseholdRole;
};

export enum HouseholdType {
  BOARDING = 'BOARDING',
  FOSTER = 'FOSTER',
  RESCUE = 'RESCUE',
  STANDARD = 'STANDARD'
}

export type HouseholdUser = {
  __typename?: 'HouseholdUser';
  adminUnderlyingUser: User;
  email: Scalars['String'];
  firstName: Scalars['String'];
  /** @deprecated Use id2 for a unique id or userId for the User.id */
  id: Scalars['ID'];
  /** id was returning the User.id before which was not unique across HouseholdUsers, this is a unique ID */
  id2: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role: UserHouseholdRole;
  userId: Scalars['ID'];
};

export type Image = {
  __typename?: 'Image';
  fullSize?: Maybe<Scalars['String']>;
  /** @deprecated This field is a duplicate of `fullSize` and only adds to confusion on client-side. */
  id: Scalars['ID'];
  /**
   * Returns a URL that is a best effort to resize the image to the specified dimensions.
   * The image may not be able to be resized, and the dimensions may be snapped to nearby
   * prespecified dimensions. Clients should still resize the image as they see fit when
   * they get it.
   */
  nearestResized: Scalars['String'];
};


export type ImagenearestResizedArgs = {
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type InAppPromotionBanner = {
  id: Scalars['ID'];
};

export type InPersonEvent = {
  __typename?: 'InPersonEvent';
  closed: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  id: Scalars['ID'];
  location: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['String'];
  startingInventory: Scalars['JSON'];
  status: InPersonEventStatus;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type InPersonEventQuery = {
  search?: InputMaybe<Scalars['String']>;
};

export enum InPersonEventStatus {
  PAST = 'PAST',
  PLANNED = 'PLANNED'
}

export enum IncentiveType {
  BASE = 'BASE',
  EVENING_WALK = 'EVENING_WALK',
  MORNING_WALK = 'MORNING_WALK'
}

export type Insight = PetInsight | PetInsightWithoutGraph;

export type InsightLeadingImage = {
  __typename?: 'InsightLeadingImage';
  displayHeight: Scalars['Int'];
  displayWidth: Scalars['Int'];
  image: Image;
};

export type InstagramMediaFeed = {
  __typename?: 'InstagramMediaFeed';
  items: Array<InstagramMediaItem>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type InstagramMediaItem = {
  __typename?: 'InstagramMediaItem';
  id: Scalars['ID'];
  mediaUrl: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type InstagramUser = {
  __typename?: 'InstagramUser';
  mediaFeed: InstagramMediaFeed;
};


export type InstagramUsermediaFeedArgs = {
  after?: InputMaybe<Scalars['String']>;
};

export type InvalidToken = {
  __typename?: 'InvalidToken';
  /** GraphQL doesn't allow empty types; this is a bogus field that will always be null. */
  invalid?: Maybe<Scalars['Boolean']>;
};

export type InventoryConfiguration = {
  __typename?: 'InventoryConfiguration';
  /** whether this warehouse should be allowed to fulfill this sku */
  allowFulfillment: Scalars['Boolean'];
  backInStockDateOverride?: Maybe<Scalars['DateTime']>;
  /** whether just-in-time kitting is eligible for this sku at this warehouse */
  eligibleForJustInTimeKitting: Scalars['Boolean'];
  estimatedBackInStockDate?: Maybe<Scalars['DateTime']>;
  fulfillmentWarehouse: FulfillmentWarehouse;
  id: Scalars['ID'];
  /** whether just-in-time kitting is enabled for this sku at this warehouse */
  justInTimeKittingEnabled: Scalars['Boolean'];
  nextOrMostRecentShipmentId?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
};

export enum InviteState {
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
  OUTSTANDING = 'OUTSTANDING',
  REVOKED = 'REVOKED'
}

export type InviteUserInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  /** Can consider making this nullable if we support other types of invites. */
  householdInvite: HouseholdInviteInput;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  suppressSms?: InputMaybe<Scalars['Boolean']>;
};

export type InviteUserToHouseholdResult = {
  __typename?: 'InviteUserToHouseholdResult';
  household: Household;
  inviteMessage: Scalars['String'];
  inviteUrl: Scalars['String'];
  /**
   * If a user account exists with that phone number, that user is immediately
   * added to the household and returned here.
   */
  user?: Maybe<HouseholdUser>;
};

export type Invoice = {
  __typename?: 'Invoice';
  id: Scalars['ID'];
  invoiceNumber: Scalars['String'];
  /**
   * This technically shouldn't be part of Invoice but we need to return it from createPurchase.
   * It'd be better if createPurchase returned its own specific CreatePurchaseResult, but
   * holding off on that migration for now.
   */
  isReturningCustomer: Scalars['Boolean'];
};

export type InvoiceMarkFailedInput = {
  ecomConfigType?: InputMaybe<Scalars['String']>;
  invoiceNumber: Scalars['String'];
};

export type InvoiceRefundInput = {
  ecomConfigType?: InputMaybe<Scalars['String']>;
  invoiceNumber: Scalars['String'];
  refundLineItems?: InputMaybe<Array<LineItemRefundInput>>;
};

export enum InvoiceSource {
  CHEWY = 'CHEWY',
  RECURLY = 'RECURLY'
}

export type Label = {
  __typename?: 'Label';
  subtext?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type LabeledCard = Card & {
  __typename?: 'LabeledCard';
  date: Scalars['DateTime'];
  icon?: Maybe<Image>;
  id: Scalars['ID'];
  labels: Array<Label>;
  message: FormatString;
  title?: Maybe<Scalars['String']>;
};

export type LedColor = {
  __typename?: 'LedColor';
  hexCode: Scalars['String'];
  ledColorCode: Scalars['Int'];
  name: Scalars['String'];
};

export type LimitedAdminUserProfile = AdminBaseUserProfile & {
  __typename?: 'LimitedAdminUserProfile';
  automaticallyActivateDevices: Scalars['Boolean'];
  billingAccount?: Maybe<BillingAccount>;
  chipReseller?: Maybe<ChipReseller>;
  dbId: Scalars['Int'];
  deactivated: Scalars['Boolean'];
  ecommerceOrders: Array<Order>;
  email: Scalars['String'];
  emails: Array<UserEmail>;
  fiNewsNotificationsEnabled: Scalars['Boolean'];
  firstName: Scalars['String'];
  groups: Array<UserGroup>;
  handsets: Array<Handset>;
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  referrals: Referrals;
  settings: UserSettings;
  socialBanned: Scalars['Boolean'];
  /** Returns all feature flag values by default, but can optionally provide an array of feature flag names to return */
  targetedFeatureFlags: Array<TargetedFeatureFlag>;
  tenancy?: Maybe<Scalars['String']>;
  thirdPartyAccess?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  userHouseholds: Array<UserHousehold>;
};


export type LimitedAdminUserProfilegroupsArgs = {
  excludePseudo?: InputMaybe<Scalars['Boolean']>;
};


export type LimitedAdminUserProfilehandsetsArgs = {
  status?: InputMaybe<Array<HandsetStatus>>;
};


export type LimitedAdminUserProfiletargetedFeatureFlagsArgs = {
  names?: InputMaybe<Array<Scalars['String']>>;
};

export type LineItem = {
  __typename?: 'LineItem';
  account: BillingAccountMini;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  invoiceNumber: Scalars['String'];
  isPhysicalProduct: Scalars['Boolean'];
  orderStatus?: Maybe<OrderLineItemStatus>;
  productCode: Scalars['String'];
  quantity: Scalars['Int'];
  returned: Scalars['Boolean'];
  /** Look up serial numbers associated with this line item using Tagg shipping information. */
  serialNumbers: Array<Scalars['String']>;
  /**
   * When invoice line item is for a physical product subscription (e.g. supplements), skuToShip will be the
   * sku of the physical product that needs to be shipped.
   */
  skuToShip: Scalars['String'];
  subItems: Array<LineSubItem>;
  subscriptionId?: Maybe<Scalars['String']>;
  subtotal: Scalars['Float'];
};

export type LineItemInput = {
  /**
   * If the item being purchased is a SubscriptionBundle, the `id` will be the SKU for the
   * bundle and this field should be set to the SKU of the bundled product being purchased
   * (e.g. collar variant).
   */
  bundledProductSku?: InputMaybe<Scalars['String']>;
  /** Extra data for a gift card line item, about to whom it is going to be delivered. */
  giftCardDelivery?: InputMaybe<GiftCardDeliveryInput>;
  id: Scalars['ID'];
  /**
   * A module ID associated with this line item in some way. Affects different types
   * of products differently. If the product is a subscription, the `moduleId` will cause
   * the plan to be immediately associated with the specified module.
   */
  moduleId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type LineItemRefundInput = {
  amountInCents?: InputMaybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<RefundType>;
};

export type LineSubItem = {
  __typename?: 'LineSubItem';
  code: Scalars['String'];
  description: Scalars['String'];
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']>;
  /** Altitude in meters */
  altitude?: Maybe<Scalars['Float']>;
  date: Scalars['DateTime'];
  /** Accuracy radius in meters */
  errorRadius?: Maybe<Scalars['Float']>;
  /** Value from 0-360 where 0 represents true north */
  heading?: Maybe<Scalars['Float']>;
  /** `Place` in which this `Location` is contained. */
  place?: Maybe<Place>;
  position: Position;
};

/**
 * A single location report from a device
 * !! IMPORTANT: This should never be exposed to or used by non-admin clients,
 * since it has a monotonically increasing ID (not a UUID).
 */
export type LocationReport = {
  __typename?: 'LocationReport';
  accuracyRadius: Scalars['Float'];
  altitude?: Maybe<Scalars['Float']>;
  attributes: Scalars['JSON'];
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  detectedActivityType?: Maybe<DetectedActivityType>;
  device: Device;
  id: Scalars['ID'];
  ignoreReason?: Maybe<Scalars['String']>;
  location: Location;
  /** Places (safe-zones) this location report overlaps with. */
  overlappingPlaces: Array<Place>;
  /** Points of interest (e.g. dog parks) this location report overlaps with. */
  pois?: Maybe<Array<DogPark>>;
  position: Position;
  reporter?: Maybe<User>;
  source: Scalars['String'];
};

export type LocationReportInput = {
  altitude?: InputMaybe<Scalars['Float']>;
  /** DEPRECATED: Use `connectedWifiInput` instead */
  connectedToSsid?: InputMaybe<Scalars['String']>;
  connectedWifiInput?: InputMaybe<ConnectedWifiInput>;
  date: Scalars['DateTime'];
  horizontalAccuracy: Scalars['Float'];
  params?: InputMaybe<Scalars['JSON']>;
  position: PositionInput;
  recentlySeenBases?: InputMaybe<Array<RecentlySeenBaseInput>>;
  verticalAccuracy?: InputMaybe<Scalars['Float']>;
};

export enum LogLevel {
  DEBUG = 'DEBUG',
  ERROR = 'ERROR',
  INFO = 'INFO',
  VERBOSE = 'VERBOSE',
  WARNING = 'WARNING'
}

export type LowLTESignalDeviceInfo = {
  __typename?: 'LowLTESignalDeviceInfo';
  rsrq: Scalars['Float'];
  timestamp: Scalars['DateTime'];
};

/** Result of manual subscription creation */
export type ManualSubscriptionResult = {
  __typename?: 'ManualSubscriptionResult';
  /** Applied discount in cents. Will be 0 for future-dated subscriptions. */
  discountInCents: Scalars['Int'];
  /**
   * Generated invoice. Will be null for future-dated subscriptions since the
   * customer is not charged until the subscription starts.
   */
  invoice?: Maybe<RecurlyInvoice>;
  /** Created subscription */
  subscription: BillingSubscription;
  /** Total amount charged in cents. Will be 0 for future-dated subscriptions. */
  totalChargedInCents: Scalars['Int'];
};

export type MapMatchedPath = {
  __typename?: 'MapMatchedPath';
  path: Array<Position>;
};

export type MapPath = MapMatchedPath | UnmatchedPath;

export enum MapStyle {
  ACTIVITY_CARD = 'ACTIVITY_CARD',
  LEGACY = 'LEGACY'
}

export type MigrateModulesToFirmwareChannelResult = {
  __typename?: 'MigrateModulesToFirmwareChannelResult';
  /** The number of records that were updated. */
  numUpdated: Scalars['Int'];
};

export type MissedLocationReport = {
  __typename?: 'MissedLocationReport';
  numberOfSecondsBehind: Scalars['Float'];
  timestamp: Scalars['DateTime'];
};

export type MissingReports = Activity & {
  __typename?: 'MissingReports';
  address?: Maybe<Scalars['String']>;
  areaName?: Maybe<Scalars['String']>;
  cityState?: Maybe<Scalars['String']>;
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int'];
  dbId: Scalars['Int'];
  debugMetadata: Scalars['JSON'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  /** @deprecated Use isLikable */
  isClappable: Scalars['Boolean'];
  isLikable: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  neighborhood?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  obfuscated: Scalars['Boolean'];
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']>;
  start: Scalars['DateTime'];
  totalSteps: Scalars['Int'];
};

export type MobileAppBanner = MobileAppBannerInterface & {
  __typename?: 'MobileAppBanner';
  backgroundColorHex: Scalars['HexColorCode'];
  /** @deprecated Use formattedDescription instead */
  description: Scalars['String'];
  destinationUrl: Scalars['String'];
  foregroundColorHex: Scalars['HexColorCode'];
  formattedDescription: FormatString;
  formattedTitle: FormatString;
  id: Scalars['ID'];
  leadingImage?: Maybe<MobileAppBannerImage>;
  /** @deprecated Use formattedDescription instead */
  title: Scalars['String'];
};

export type MobileAppBannerImage = {
  __typename?: 'MobileAppBannerImage';
  displayHeight: Scalars['Int'];
  displayWidth: Scalars['Int'];
  image: Image;
};

export type MobileAppBannerImageInput = {
  displayHeight: Scalars['Int'];
  displayWidth: Scalars['Int'];
  url: Scalars['String'];
};

export type MobileAppBannerInterface = {
  backgroundColorHex: Scalars['HexColorCode'];
  description: Scalars['String'];
  destinationUrl: Scalars['String'];
  id: Scalars['ID'];
  leadingImage?: Maybe<MobileAppBannerImage>;
  title: Scalars['String'];
};

export type MobileAppBlockerScreen = MobileAppBlockerScreenInterface & {
  __typename?: 'MobileAppBlockerScreen';
  bottomSheet: MobileAppBlockerScreenBottomSheet;
  id: Scalars['ID'];
  pages: Array<MobileAppBlockerScreenPage>;
};

export type MobileAppBlockerScreenBottomSheet = {
  __typename?: 'MobileAppBlockerScreenBottomSheet';
  buttons: Array<MobileAppBottomSheetButton>;
  description: Scalars['String'];
  formattedDescription: FormatString;
  formattedTitle: FormatString;
  image?: Maybe<MobileAppBottomSheetImage>;
  title: Scalars['String'];
};

export type MobileAppBlockerScreenButton = MobileAppBlockerScreenNextButton | MobileAppBlockerScreenUrlButton;

export type MobileAppBlockerScreenButtonInterface = {
  text: Scalars['String'];
};

/**
 * Similar to a splash screen but when 'x' is pressed it will show a bottom sheet instead
 * of dismissing.
 */
export type MobileAppBlockerScreenInterface = {
  bottomSheet: MobileAppBlockerScreenBottomSheet;
  id: Scalars['ID'];
  pages: Array<MobileAppBlockerScreenPage>;
};

export type MobileAppBlockerScreenNextButton = MobileAppBlockerScreenButtonInterface & {
  __typename?: 'MobileAppBlockerScreenNextButton';
  text: Scalars['String'];
};

export type MobileAppBlockerScreenPage = {
  __typename?: 'MobileAppBlockerScreenPage';
  button: MobileAppBlockerScreenButton;
  description: Scalars['String'];
  image: Image;
  title: Scalars['String'];
};

export type MobileAppBlockerScreenUrlButton = MobileAppBlockerScreenButtonInterface & {
  __typename?: 'MobileAppBlockerScreenUrlButton';
  destinationUrl: Scalars['String'];
  text: Scalars['String'];
};

export type MobileAppBottomSheet = MobileAppBottomSheetInterface & {
  __typename?: 'MobileAppBottomSheet';
  buttons: Array<MobileAppBottomSheetButton>;
  description: Scalars['String'];
  formattedDescription: FormatString;
  formattedTitle: FormatString;
  id: Scalars['ID'];
  image?: Maybe<MobileAppBottomSheetImage>;
  title: Scalars['String'];
};

export type MobileAppBottomSheetButton = MobileAppBottomSheetCTAButton | MobileAppBottomSheetTextLinkButton;

export type MobileAppBottomSheetButtonInterface = {
  destinationUrl: Scalars['String'];
  text: Scalars['String'];
};

export enum MobileAppBottomSheetButtonType {
  CTA = 'CTA',
  TEXT_LINK = 'TEXT_LINK'
}

export type MobileAppBottomSheetCTAButton = MobileAppBottomSheetButtonInterface & {
  __typename?: 'MobileAppBottomSheetCTAButton';
  backgroundColorHex: Scalars['HexColorCode'];
  destinationUrl: Scalars['String'];
  text: Scalars['String'];
};

export type MobileAppBottomSheetImage = {
  __typename?: 'MobileAppBottomSheetImage';
  image: Image;
  type: MobileAppBottomSheetImageType;
};

export enum MobileAppBottomSheetImageType {
  RECTANGULAR = 'RECTANGULAR',
  ROUND = 'ROUND',
  SQUARE = 'SQUARE'
}

export type MobileAppBottomSheetInterface = {
  buttons: Array<MobileAppBottomSheetButton>;
  description: Scalars['String'];
  formattedDescription: FormatString;
  formattedTitle: FormatString;
  id: Scalars['ID'];
  image?: Maybe<MobileAppBottomSheetImage>;
  title: Scalars['String'];
};

export type MobileAppBottomSheetTextLinkButton = MobileAppBottomSheetButtonInterface & {
  __typename?: 'MobileAppBottomSheetTextLinkButton';
  destinationUrl: Scalars['String'];
  text: Scalars['String'];
};

export type MobileAppContent = {
  __typename?: 'MobileAppContent';
  banners: Array<MobileAppBanner>;
  blockerScreen?: Maybe<MobileAppBlockerScreen>;
  bottomSheet?: Maybe<MobileAppBottomSheet>;
  discover: Array<MobileAppDiscoverItem>;
  splashScreen?: Maybe<MobileAppSplashScreen>;
};

export type MobileAppContentClientTargetingFactsInput = {
  sourceView?: InputMaybe<MobileAppContentSourceView>;
};

export enum MobileAppContentSourceView {
  HOME = 'HOME',
  ONBOARDING = 'ONBOARDING'
}

export type MobileAppContentTargetingFact = {
  __typename?: 'MobileAppContentTargetingFact';
  name: Scalars['String'];
  type: MobileAppContentTargetingFactType;
};

export enum MobileAppContentTargetingFactType {
  ARRAY_OF_STRINGS = 'ARRAY_OF_STRINGS',
  BOOLEAN = 'BOOLEAN',
  DATE_TIME = 'DATE_TIME',
  INTEGER = 'INTEGER',
  STRING = 'STRING'
}

export type MobileAppContentTargetingInput = {
  clientView?: InputMaybe<MobileAppContentSourceView>;
  dismissalDurationSeconds?: InputMaybe<Scalars['Int']>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  requiresTrigger?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  targetSpecies: Array<Species>;
  /**
   * JSON converted `json-rules-engine` rules.
   * No targeting rules will result in content being visible to any user/pet
   * See https://github.com/CacheControl/json-rules-engine/blob/master/docs/rules.md#persisting
   */
  targetingRules?: InputMaybe<Scalars['JSON']>;
};

export type MobileAppDiscoverItem = MobileAppDiscoverItemInterface & {
  __typename?: 'MobileAppDiscoverItem';
  description: Scalars['String'];
  destinationUrl: Scalars['String'];
  id: Scalars['ID'];
  image: Image;
  title: Scalars['String'];
};

export type MobileAppDiscoverItemInterface = {
  description: Scalars['String'];
  destinationUrl: Scalars['String'];
  id: Scalars['ID'];
  image: Image;
  title: Scalars['String'];
};

export type MobileAppPermissionBlockerScreen = MobileAppPermissionBlockerScreenInterface & {
  __typename?: 'MobileAppPermissionBlockerScreen';
  bottomSheet: MobileAppBlockerScreenBottomSheet;
  dismissable: Scalars['Boolean'];
  id: Scalars['ID'];
  pages: Array<MobileAppBlockerScreenPage>;
};

export type MobileAppPermissionBlockerScreenInterface = {
  bottomSheet: MobileAppBlockerScreenBottomSheet;
  dismissable: Scalars['Boolean'];
  id: Scalars['ID'];
  pages: Array<MobileAppBlockerScreenPage>;
};

export type MobileAppSplashScreen = MobileAppSplashScreenInterface & {
  __typename?: 'MobileAppSplashScreen';
  id: Scalars['ID'];
  pages: Array<MobileAppSplashScreenPage>;
};

export type MobileAppSplashScreenButton = MobileAppSplashScreenNextButton | MobileAppSplashScreenUrlButton;

export type MobileAppSplashScreenButtonInterface = {
  text: Scalars['String'];
};

export type MobileAppSplashScreenInterface = {
  id: Scalars['ID'];
  pages: Array<MobileAppSplashScreenPage>;
};

export type MobileAppSplashScreenNextButton = MobileAppSplashScreenButtonInterface & {
  __typename?: 'MobileAppSplashScreenNextButton';
  text: Scalars['String'];
};

export type MobileAppSplashScreenPage = {
  __typename?: 'MobileAppSplashScreenPage';
  button: MobileAppSplashScreenButton;
  description: Scalars['String'];
  image: Image;
  title: Scalars['String'];
};

export type MobileAppSplashScreenUrlButton = MobileAppSplashScreenButtonInterface & {
  __typename?: 'MobileAppSplashScreenUrlButton';
  destinationUrl: Scalars['String'];
  text: Scalars['String'];
};

export type MobilityReport = {
  __typename?: 'MobilityReport';
  attributes: Scalars['JSON'];
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  device: Device;
  id: Scalars['ID'];
  ignoreReason?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  type: MobilityType;
};

export type MobilityReportInput = {
  date: Scalars['DateTime'];
  recentlySeenBases?: InputMaybe<Array<RecentlySeenBaseInput>>;
  /** Optional, defaults to "mobile */
  source?: InputMaybe<Scalars['String']>;
  type: MobilityType;
};

export enum MobilityType {
  NO_SIGNIFICANT_CHANGE = 'NO_SIGNIFICANT_CHANGE',
  UNKNOWN = 'UNKNOWN'
}

export type ModerationCommentArticleSubject = {
  __typename?: 'ModerationCommentArticleSubject';
  article: Article;
};

export type ModerationCommentFeed = {
  __typename?: 'ModerationCommentFeed';
  items: Array<ModerationCommentItem>;
};

export type ModerationCommentItem = ModerationItem & {
  __typename?: 'ModerationCommentItem';
  comment: Comment;
  commentHistory: Array<AuditLogEvent>;
  complaintCount: Scalars['Int'];
  complaintCountSinceLastModerationAction: Scalars['Int'];
  lastModerationAction?: Maybe<AuditLogEvent>;
  pet?: Maybe<Pet>;
  subject: ModerationSubject;
  user?: Maybe<User>;
};

export type ModerationCommentPhotoSubject = {
  __typename?: 'ModerationCommentPhotoSubject';
  photo: Photo;
};

export type ModerationCommentTextPostSubject = {
  __typename?: 'ModerationCommentTextPostSubject';
  textPost: TextPost;
};

export type ModerationFeed = {
  items: Array<ModerationItem>;
  totalCount: Scalars['Int'];
};

export type ModerationFeedQueryInput = {
  caption?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  isShowingComplainedContentOnly?: InputMaybe<Scalars['Boolean']>;
  photoId?: InputMaybe<Scalars['ID']>;
  posterPetId?: InputMaybe<Scalars['ID']>;
  posterPetName?: InputMaybe<Scalars['String']>;
  posterUserId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  textPostContent?: InputMaybe<Scalars['String']>;
  textPostId?: InputMaybe<Scalars['ID']>;
};

export type ModerationItem = {
  complaintCount: Scalars['Int'];
  complaintCountSinceLastModerationAction: Scalars['Int'];
  lastModerationAction?: Maybe<AuditLogEvent>;
  pet?: Maybe<Pet>;
  subject: ModerationSubject;
  user?: Maybe<User>;
};

export type ModerationPhotoFromCommentItem = {
  __typename?: 'ModerationPhotoFromCommentItem';
  moderationCommentFeed: ModerationCommentFeed;
  photo: Photo;
  user?: Maybe<User>;
};

export type ModerationPhotoItem = ModerationItem & {
  __typename?: 'ModerationPhotoItem';
  commentHistory: Array<AuditLogEvent>;
  complaintCount: Scalars['Int'];
  complaintCountSinceLastModerationAction: Scalars['Int'];
  lastModerationAction?: Maybe<AuditLogEvent>;
  pet?: Maybe<Pet>;
  photo: Photo;
  subject: ModerationSubject;
  user?: Maybe<User>;
};

export type ModerationSubject = ModerationCommentArticleSubject | ModerationCommentPhotoSubject | ModerationCommentTextPostSubject;

export type ModerationTextPostFromCommentItem = {
  __typename?: 'ModerationTextPostFromCommentItem';
  moderationCommentFeed: ModerationCommentFeed;
  textPost: TextPost;
  user?: Maybe<User>;
};

export type ModerationTextPostItem = ModerationItem & {
  __typename?: 'ModerationTextPostItem';
  commentHistory: Array<AuditLogEvent>;
  complaintCount: Scalars['Int'];
  complaintCountSinceLastModerationAction: Scalars['Int'];
  lastModerationAction?: Maybe<AuditLogEvent>;
  pet?: Maybe<Pet>;
  subject: ModerationSubject;
  textPost: TextPost;
  user?: Maybe<User>;
};

export type ModifyWifiCredentialResult = {
  __typename?: 'ModifyWifiCredentialResult';
  hash: Scalars['String'];
  isInSafeZone?: Maybe<Scalars['Boolean']>;
};

export enum ModuleCapability {
  /** @deprecated Use Pet.productAvailability */
  APPLE_WATCH = 'APPLE_WATCH',
  /** @deprecated Use Pet.productAvailability */
  BEHAVIOR_DETECTION = 'BEHAVIOR_DETECTION',
  BQ27421_SUBMESSAGE = 'BQ27421_SUBMESSAGE',
  CAN_BE_SECONDARY = 'CAN_BE_SECONDARY',
  CAN_HAVE_SECONDARY = 'CAN_HAVE_SECONDARY',
  CXD5605 = 'CXD5605',
  CXD5610 = 'CXD5610',
  /** @deprecated Use Pet.productAvailability */
  HEALTH_AI = 'HEALTH_AI',
  LIVE_TRACKING = 'LIVE_TRACKING',
  LLE_UPDATE_IN_RESPONSE = 'LLE_UPDATE_IN_RESPONSE',
  LOST_MODE = 'LOST_MODE',
  LTE_BACKOFF_SUBMESSAGE = 'LTE_BACKOFF_SUBMESSAGE',
  PROTO_RESPONSE = 'PROTO_RESPONSE',
  REMOTE_LOG = 'REMOTE_LOG',
  REMOTE_REBOOT = 'REMOTE_REBOOT',
  SLEEP_TRACKING = 'SLEEP_TRACKING',
  SOUND = 'SOUND',
  USER_LED = 'USER_LED',
  VIBRATION = 'VIBRATION',
  WIFI = 'WIFI',
  ZONE_PACK = 'ZONE_PACK'
}

export type ModuleHSMTransitionDetails = {
  __typename?: 'ModuleHSMTransitionDetails';
  eventName: Scalars['String'];
  fromStateName: Scalars['String'];
  toStateName: Scalars['String'];
};

export type MultidogHouseholdPromotionBanner = InAppPromotionBanner & {
  __typename?: 'MultidogHouseholdPromotionBanner';
  ctaUrl: Scalars['String'];
  dismissFeedbackOptions?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  line1Text: FormatString;
  line2Text: FormatString;
};

export type MultipleModerationFeed = {
  __typename?: 'MultipleModerationFeed';
  commentFeed: CommentModerationFeed;
  photoFeed: PhotoModerationFeed;
  textPostFeed: TextPostModerationFeed;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptUserInvite: AcceptUserInviteResult;
  /**
   * Acknowledge a search party notification, indicating the user will "keep an eye out" for the lost pet.
   *
   * This mutation:
   * 1. Verifies an active search party session exists for the pet
   * 2. Creates or updates an acknowledgment record linking the user to the search party session
   * 3. Returns success status
   *
   * Users who acknowledge search parties will receive recovery notifications when the dog is found (future feature).
   * Each user can only acknowledge a search party once per session (enforced by unique constraint).
   */
  acknowledgeSearchParty: AcknowledgeSearchPartyResult;
  addCommentComplaint?: Maybe<Scalars['Boolean']>;
  /**
   * Add a coupon to an account
   * Requires: Admin or Customer Support role
   */
  addCouponToAccount: Scalars['Boolean'];
  addHouseholdVet: Array<Veterinary>;
  addMultipleSupplementSubscriptions?: Maybe<AddMultipleSupplementSubscriptionsResult>;
  addOrderLineItems: Order;
  addPetDocument: PetDocument;
  /** @deprecated Use addPhotoForPet instead */
  addPetPhoto: Pet;
  addPhotoComment?: Maybe<AddPhotoCommentResult>;
  addPhotoComplaint?: Maybe<Scalars['Boolean']>;
  addPhotoForPet: Photo;
  /** In-app supplements management mutations. */
  addSupplementSubscription?: Maybe<AddSupplementSubscriptionResult>;
  addTextPostComment?: Maybe<AddTextPostCommentResult>;
  addTextPostComplaint?: Maybe<Scalars['Boolean']>;
  /** 3rd party membership management mutations. */
  addThirdPartySubscription: AddThirdPartySubscriptionResult;
  addUserEmail: User;
  addVideoPostComment?: Maybe<AddVideoPostCommentResult>;
  addVideoPostComplaint?: Maybe<Scalars['Boolean']>;
  addWifiCredentials: ModifyWifiCredentialResult;
  adminActivateFulfillmentWarehouse: FulfillmentWarehouse;
  adminAddDogParkFromOSM: DogPark;
  adminAddFirmwareTag: FirmwareTag;
  adminAddItemToList: AdminAddItemToListResult;
  adminAddResellerModules?: Maybe<Array<ResellerModule>>;
  adminAddTagToFirmwareUpdateChannel: Scalars['Boolean'];
  adminAddTagToFirmwareVersion: Scalars['Boolean'];
  adminAddUserToGroup?: Maybe<AdminBaseUserProfile>;
  adminAddUserToHousehold: AddUserToHouseholdResult;
  adminAddVetSuggestion: Array<Veterinary>;
  adminArchiveFirmware?: Maybe<Scalars['Boolean']>;
  adminBulkAddPetsToUnmanagedPack: BulkPackInsertResponse;
  adminBulkAssignUsersToGroup: Scalars['ID'];
  /**
   * Create a one-time charge for a consignment account.
   * Admin-only access.
   */
  adminChargeConsignmentAccount: ChargeConsignmentAccountResult;
  adminClaimNanoWebIds: Array<NanoWebId>;
  adminClearChip?: Maybe<Scalars['Boolean']>;
  adminCloseInPersonEvent: InPersonEvent;
  adminCreateBatchRecords?: Maybe<Scalars['Boolean']>;
  adminCreateBreed: Breed;
  adminCreateChangeLog: ChangeLog;
  adminCreateConsignmentAccount: ConsignmentAccount;
  adminCreateConsignmentLocation: ConsignmentLocation;
  /** Creates an order for a consignment location */
  adminCreateConsignmentOrder: Order;
  adminCreateConsignmentRecurlyAccount: Scalars['String'];
  adminCreateCoupon: Coupon;
  adminCreateDogParkCheckinExclusion: AdminDogParkCheckinExclusion;
  adminCreateEvalGuideline: EvalGuideline;
  adminCreateFirmwareChannel?: Maybe<FirmwareUpdateChannel>;
  adminCreateGingrBoardingFacility: BoardingFacility;
  /** Creates a new household with the user specified taking an OWNER role. */
  adminCreateHouseholdWithUser: Household;
  adminCreateInPersonEvent: InPersonEvent;
  /** Allows an admin to create an internal order that is not tied to an invoice */
  adminCreateInternalOrder: Order;
  /** Allows an admin to create an order on behalf of a customer, billed to the customer's credit card */
  adminCreateOrder: CartPurchaseResult;
  adminCreatePlace?: Maybe<Place>;
  adminCreatePlatform?: Maybe<Platform>;
  adminCreatePromotion: Promotion;
  adminCreateTargetedFeatureFlag: AdminTargetedFeatureFlag;
  adminCreateTestData: CreateTestDataResult;
  adminCreateUserForBoardingFacility: User;
  adminCreateUserGroup?: Maybe<UserGroup>;
  adminCreateVipUserLookupCriteria: VipUserLookupCriteria;
  adminDeactivateEvalGuideline: EvalGuideline;
  adminDeactivateFulfillmentWarehouse: FulfillmentWarehouse;
  /**
   * Deactivates user, removes them from households, anonymizes their information.
   *
   * This is an irrevocable, destructive operation.
   */
  adminDeactivateUser?: Maybe<User>;
  adminDeleteChangeLog: Scalars['Boolean'];
  adminDeleteConsignmentAccount: ConsignmentAccount;
  adminDeleteConsignmentLocation: ConsignmentLocation;
  adminDeleteDogParkCheckinExclusion?: Maybe<Scalars['Boolean']>;
  /**
   * Deletes a firmware update channel.  This is a "safe" operation as only an unused
   * channel can be deleted.  If there are devices assigned to the channel, the operation
   * will fail.
   */
  adminDeleteFirmwareChannel?: Maybe<Scalars['Boolean']>;
  adminDeletePromotion?: Maybe<Scalars['Boolean']>;
  adminDeleteUserGroup?: Maybe<Scalars['Boolean']>;
  adminDeleteVipUserLookupCriteria?: Maybe<Scalars['Boolean']>;
  adminDisableShelterluv: ChipReseller;
  /** Create a copy of a target promotion */
  adminDuplicatePromotion: Promotion;
  adminEnableShelterluv: ChipReseller;
  adminExpireAndRecreateCoupon: Coupon;
  adminExpireCoupon: Coupon;
  adminHealthGptAddQuestion: AdminHealthGptMessage;
  adminHealthGptCreateDocument: AdminHealthGptDocument;
  adminHealthGptDeleteDocument: Scalars['Boolean'];
  adminHealthGptUpdateDocument: AdminHealthGptDocument;
  adminImportChips?: Maybe<Array<ResellerChip>>;
  adminImportPartnerOrders: Scalars['Int'];
  adminIncrementNumConfirmedReferrals?: Maybe<AdminBaseUserProfile>;
  adminMigrateModulesToFirmwareChannel?: Maybe<MigrateModulesToFirmwareChannelResult>;
  adminPublishTestPetUpdate?: Maybe<Scalars['Boolean']>;
  adminRegisterConsignmentResaleCertificate: ConsignmentAccount;
  adminReinstateStreak?: Maybe<Scalars['Boolean']>;
  adminRemoveConsignmentResaleCertificate: ConsignmentAccount;
  adminRemoveFeatureFlag?: Maybe<Scalars['Boolean']>;
  adminRemoveItemFromList: AdminList;
  adminRemoveTagFromFirmwareUpdateChannel: Scalars['Boolean'];
  adminRemoveTagFromFirmwareVersion: Scalars['Boolean'];
  adminRemoveUserFromGroup?: Maybe<AdminBaseUserProfile>;
  adminResetDeviceBatteryState?: Maybe<Scalars['Boolean']>;
  adminSendBackgroundNotification?: Maybe<Scalars['Boolean']>;
  adminSendFreeNanoBoxes: CartPurchaseResult;
  adminSendNotification?: Maybe<Scalars['Boolean']>;
  adminSendScreenSharingNotification: AdminSendScreenSharingNotificationResult;
  adminSendServerPushToDevice?: Maybe<Scalars['Boolean']>;
  adminSetAutomaticallyActivateDevicesOnUser?: Maybe<AdminBaseUserProfile>;
  adminSetChargingBaseOwner?: Maybe<ChargingBase>;
  adminSetChargingBaseUpdateChannel?: Maybe<ChargingBase>;
  adminSetChipResellerName: ChipReseller;
  adminSetChipResellerRescueVerified: ChipReseller;
  adminSetChipResellerStatus: ChipReseller;
  adminSetChipResellerTypes: ChipReseller;
  adminSetCommentHidden?: Maybe<Comment>;
  adminSetDeviceAutoAddUserToHousehold?: Maybe<Device>;
  /** Enable or disable a device from receiving firmware updates. */
  adminSetDeviceFirmwareUpdateEligibility: Device;
  adminSetDeviceIsBlocked?: Maybe<Device>;
  adminSetDeviceIsRefurbished?: Maybe<Device>;
  adminSetFeatureFlag?: Maybe<FeatureFlag>;
  adminSetFirmwareRolloutQuantity?: Maybe<SetFirmwareRolloutResult>;
  adminSetPetCityState: Pet;
  adminSetPhotoDeleted?: Maybe<Photo>;
  adminSetRemoteLoggingForFirmwareChannel?: Maybe<FirmwareUpdateChannel>;
  adminSetSubscriptionIdOnDevice?: Maybe<Device>;
  adminSetThirdPartyAccess: Scalars['Boolean'];
  adminSetUserGroups?: Maybe<AdminBaseUserProfile>;
  adminSubmitCertGenJob?: Maybe<CreateCertGenJobResult>;
  adminTriggerCustomerIoTrackEventForTestUser: AdminTriggerCustomerIoEventResult;
  /**
   * Undmismiss a previous mobile app content dismissal.
   * dbId is the id of the dismissal record.
   */
  adminUndismissMobileAppContent?: Maybe<Scalars['Boolean']>;
  adminUpdateChangeLog: ChangeLog;
  adminUpdateChipPet: ResellerChip;
  adminUpdateChipReseller: ResellerChip;
  adminUpdateChipResellerByBox: ResellerChipFeed;
  adminUpdateChipResellerByBoxIds: Array<ResellerChip>;
  adminUpdateChipResellerBySerialNumber: ResellerChipFeed;
  adminUpdateConsignmentAccount: ConsignmentAccount;
  adminUpdateConsignmentLocation: ConsignmentLocation;
  adminUpdateDeviceCellularStatus?: Maybe<Scalars['String']>;
  adminUpdateDeviceHasActiveSubscription?: Maybe<Device>;
  adminUpdateDeviceSubscriptionOverrideEndsAt?: Maybe<Device>;
  adminUpdateDeviceTenancy?: Maybe<Device>;
  adminUpdateEvalGuideline: EvalGuideline;
  adminUpdateFirmware?: Maybe<FirmwareVersion>;
  adminUpdateFirmwareChannel?: Maybe<FirmwareUpdateChannel>;
  adminUpdateGingrBoardingFacility: BoardingFacility;
  adminUpdateHouseholdName: Household;
  adminUpdateHouseholdTenancy: Household;
  adminUpdateHouseholdThirdPartyAccess: Household;
  adminUpdateInPersonEvent: InPersonEvent;
  adminUpdateInPersonEventInventory: InPersonEvent;
  adminUpdateInventoryConfiguration: ProductInventoryLevels;
  adminUpdateListItem: AdminList;
  adminUpdatePlatform?: Maybe<Platform>;
  adminUpdatePromotion: Promotion;
  adminUpdateShelterluvConfig: ChipReseller;
  adminUpdateTargetedFeatureFlag: AdminTargetedFeatureFlag;
  /**
   * Upload an image to the barkinglabs-media bucket with a public ACL.
   * One of `prefix` or `path` must be specified.
   */
  adminUploadImage: AdminUploadImageResult;
  adminUpsertFulfillmentWarehouse: FulfillmentWarehouse;
  /** Apply multidog discount to all dogs paid for by current user. */
  applyMultidogDiscount?: Maybe<ApplyMultidogDiscountResult>;
  /** Approves an internal order that is on hold and automatically ships it */
  approveInternalOrder: Order;
  /** Assign an unowned charging base to the current user. */
  assignChargingBase: ChargingBase;
  /** Assign an unowned device to a pet. */
  assignDevice: Pet;
  /** Chip resellers: transfer the a chip in their inventory to the new owner */
  assignNewOwnerToChip: ResellerChip;
  /** Chip resellers: add a pet to a chip in their inventory */
  assignNewPetToChip: ResellerChip;
  boardingFacilityCheckInPet: BoardingSession;
  boardingFacilityCheckOutPet: BoardingSession;
  /**
   * Cancel a subscription with optional refund
   * Requires: Admin or Customer Support role
   */
  cancelAndRefundSubscription: CancelAndRefundResult;
  /** Disable autorenew for a collar membership */
  cancelMembership?: Maybe<CancelMembershipResult>;
  cancelOrderLineItems: Order;
  cancelOrders: Array<Order>;
  cancelRMA?: Maybe<RMA>;
  cancelSupplementSubscription?: Maybe<CancelSupplementSubscriptionResult>;
  cancelThirdPartySubscription: CancelThirdPartySubscriptionResult;
  changeMembershipPlanEndOfTerm?: Maybe<ChangeMembershipPlanEndOfTermResult>;
  changePetHousehold?: Maybe<Pet>;
  changePlaceHousehold?: Maybe<Place>;
  chargeAccountBySku: RecurlyInvoice;
  checkInRMA?: Maybe<RMA>;
  checkInUnknownReturn?: Maybe<RMA>;
  /**
   * Pet owners: Step 1 of the chip registration process for pet owners who want to register a chip that is injected
   * into their pet. Only connect their email address to the chip.
   */
  chipRegistrationAddEmail: BaseChip;
  /**
   * Pet owners: Alternate step 2 of the chip registration process for pet owners. Choose an existing pet to register to
   * the chip.
   */
  chipRegistrationAddExistingPet: BaseChip;
  /** Pet owners: Step 2 of the chip registration process for pet owners. Add their pet information. */
  chipRegistrationAddNewPet: BaseChip;
  /** Pet owners: Step 3 of the chip registration process for pet owners. Add their contact information */
  chipRegistrationUpdateContact: BaseChip;
  claimClickToCancelDiscount?: Maybe<ClaimClickToCancelDiscountResult>;
  /** In-app cancellation flow retention offers. */
  claimFreeMonth?: Maybe<ClaimFreeMonthResult>;
  claimSupplementDiscount?: Maybe<ClaimSupplementDiscountResult>;
  claimTwoMonthsHalfOff?: Maybe<ClaimTwoMonthsHalfOffResult>;
  clearDeviceResponseOverride?: Maybe<Scalars['Boolean']>;
  /**
   * Convert a free trial subscription to paid early, applying a discount coupon.
   * This ends the trial period immediately and begins billing.
   */
  convertFreeTrial?: Maybe<ConvertFreeTrialResult>;
  createBillingAccount: BillingAccount;
  createDevice?: Maybe<Device>;
  createDeviceActuation: DeviceActuation;
  createDynamicEnumMember: DynamicEnum;
  createFiNewsNotification: FiNewsNotification;
  createImageFromUrl?: Maybe<CreateImageFromUrlResult>;
  /**
   * Create a manual subscription for a customer
   * Requires: Admin or Customer Support role
   */
  createManualSubscription: ManualSubscriptionResult;
  createMobileAppBanner: AdminMobileAppBanner;
  createMobileAppBlockerScreen: AdminMobileAppBlockerScreen;
  createMobileAppBottomSheet: AdminMobileAppBottomSheet;
  createMobileAppDiscoverItem: AdminMobileAppDiscoverItem;
  createMobileAppPermissionBlockerScreen: AdminMobileAppPermissionBlockerScreen;
  createMobileAppSplashScreen: AdminMobileAppSplashScreen;
  createNewHealthGptChatThread: HealthGptChatThread;
  createPack: Pack;
  createPet: Pet;
  createPlace: Place;
  createRMA?: Maybe<RMA>;
  /**
   * Creates a sharing session.
   * If sessionType is not specified, defaults to Search Party.
   */
  createSharingSession: SharingSession;
  createTestimonialReminder: User;
  createTextPost: TextPost;
  createUser?: Maybe<User>;
  createVideoPost: VideoPost;
  /**
   * Create a Zendesk ticket from in-app cancellation webview flow.
   * Return true if ticket was successfully created.
   */
  createZendeskCancellationTicket?: Maybe<CreateZendeskTicketResult>;
  createZendeskReplacementTicket?: Maybe<CreateZendeskTicketResult>;
  createZendeskTroubleshootingTicket?: Maybe<CreateZendeskTicketResult>;
  deleteComment?: Maybe<Scalars['Boolean']>;
  deletePetDocument: Scalars['Boolean'];
  deleteTextPost?: Maybe<Scalars['Boolean']>;
  deleteVideoPost?: Maybe<Scalars['Boolean']>;
  disconnectAppIntegration: DisconnectAppIntegrationResult;
  /** Dismisses a mobile app content item for the current user where id is associated with Splash Screen or Banner id */
  dismissMobileAppContent?: Maybe<Scalars['Boolean']>;
  dismissPetInsights?: Maybe<Scalars['Boolean']>;
  dismissPromotionBanner?: Maybe<Scalars['Boolean']>;
  downgradeSeries2?: Maybe<DowngradeSeries2Result>;
  downgradeSeries3?: Maybe<DowngradeSeries3Result>;
  enableOrExtendQuickReportMode?: Maybe<EnableOrExtendQuickReportModeResult>;
  /**
   * Ends a sharing session (Search Party or Location Sharing) for a pet.
   *
   * **Recovery Notifications for Lost Dog Mode:**
   * When a search party ends during Lost Dog Mode termination (when the user turns off Lost Dog Mode
   * via "Found my dog" in the app), recovery notifications are automatically sent to users who
   * acknowledged the search party. These notifications inform users that the pet has been found safe.
   *
   * Recovery notifications are ONLY sent when:
   * - The session type is SEARCH_PARTY
   * - The search party is ended via Lost Dog Mode termination (not via this GraphQL mutation)
   *
   * Recovery notifications are NOT sent when:
   * - The session type is LOCATION_SHARING
   * - The search party is ended via this GraphQL mutation directly
   * - No users acknowledged the search party
   *
   * To trigger recovery notifications, use the `updateDeviceOperationParams` mutation to change
   * the device mode from LOST_DOG to NORMAL, which will automatically end the search party and
   * send recovery notifications.
   */
  endSharingSession: EndSharingSessionResult;
  /**
   * Execute a prorated upgrade (S1/S2→S3+/Mini).
   * Issues prorated credit, terminates old subscription, creates new subscription.
   * The prorated credit is applied to the account balance before termination,
   * and auto-applies to reduce the charge for the new subscription.
   * Requires: Admin or Customer Support role
   */
  executeProratedUpgrade: ProductTransferResult;
  /**
   * Execute a SKU-only product transfer (S3→S3+, Mini↔S3+).
   * Changes the subscription plan code and charges a hardware fee.
   * The subscription is moved from the source device to the target device.
   * Requires: Admin or Customer Support role
   */
  executeSkuOnlyTransfer: ProductTransferResult;
  extendSubscription: BillingSubscription;
  ignoreVetSuggestion: Array<Veterinary>;
  inviteUserToHousehold: InviteUserToHouseholdResult;
  joinPack?: Maybe<Pack>;
  leavePack?: Maybe<Pack>;
  markInvoiceFailed: RecurlyInvoice;
  moderationApproveContent?: Maybe<Scalars['Boolean']>;
  moderationRejectContent?: Maybe<Scalars['Boolean']>;
  /**
   * Send push notifications to nearby users about an active search party.
   *
   * This mutation:
   * 1. Finds nearby users using proximity detection (Databricks or Redis GEO)
   * 2. Filters by mute preferences (excludes users with muteAllSearchParties: true)
   * 3. Queues a background job to send notifications asynchronously
   * 4. Returns immediately with estimated notification count
   *
   * The actual notification sending happens asynchronously in a background job.
   * The notificationsSent count is an estimate based on the number of user IDs that will be notified.
   */
  notifyNearbyUsersForSearchParty: NotifyNearbyUsersResult;
  notifyWroteReview: User;
  pauseMembership?: Maybe<PauseMembershipResult>;
  purchaseConsumerStoreCart: CartPurchaseResult;
  purchaseMembershipUpgrade: CartPurchaseResult;
  purchaseMonthlyUpgradePromotion: CartPurchaseResult;
  purchaseRenewAndSave: CartPurchaseResult;
  purchaseSeries3UpgradeCart: CartPurchaseResult;
  purchaseSubscription: CartPurchaseResult;
  purchaseUpgradeToSeriesThreePlusModule: CartPurchaseResult;
  reactivateSubscription: BillingSubscription;
  reassignChipToReseller: ResellerChip;
  /** Reassign a device from its current pet to a new pet. */
  reassignDevice: Pet;
  /** Chip resellers: recall the chip from the current owner and return it to the reseller's inventory with pet assigned. */
  recallChip: ResellerChip;
  recordAppInstallForUser: RecordAppInstallForUserResult;
  refundInvoice: RecurlyInvoice;
  /** @deprecated registerChipResellerV2 is the new version of this mutation. */
  registerChipReseller: ChipReseller;
  registerChipResellerV2: ChipReseller;
  registerHandset: Handset;
  registerHandsetLiveActivityToken: Scalars['Boolean'];
  registerThirdPartyChip: ResellerChip;
  /** Remove all containment zones for a safe zone (Place). */
  removeContainmentZonesForSafeZone: Place;
  /**
   * Remove a coupon from an account
   * Requires: Admin or Customer Support role
   */
  removeCouponFromAccount: Scalars['Boolean'];
  removeDynamicEnumMember: DynamicEnum;
  removeFiNewsNotification?: Maybe<Scalars['Boolean']>;
  removeHouseholdVets: Array<Veterinary>;
  removePet?: Maybe<Scalars['Boolean']>;
  removePetInstagramHandle: Pet;
  removePhoto?: Maybe<Scalars['Boolean']>;
  removePlace?: Maybe<Scalars['Boolean']>;
  removeUserEmail: User;
  removeUserFromHousehold: RemoveUserFromHouseholdResult;
  removeWifiCredentials: ModifyWifiCredentialResult;
  renewSubscription?: Maybe<RenewSubscriptionResult>;
  /** Assign the input member IDs monotonically increasing `order` values. */
  reorderDynamicEnumMembers: DynamicEnum;
  /** Report a charging base that was in BLE connection range of the provided position */
  reportChargingBaseAtPosition: Scalars['Boolean'];
  requestEmailVerification: Scalars['Boolean'];
  requestUserAccountDeletion: Scalars['Boolean'];
  requestVerificationCode: User;
  rerouteShipments: Array<OrderShipment>;
  rescueCancelPetAdoptionTransfer: RescueCancelPetAdoptionTransferResult;
  rescueCreatePetAdoptionTransfer: RescueCreatePetAdoptionTransferResult;
  rescueCreatePetFosterTransfer: RescueCreatePetFosterTransferResult;
  rescueRecallPet?: Maybe<RescueRecallPetResult>;
  rescueRecallPetFosterTransfer: RescueRecallPetFosterTransferResult;
  rescueTransferPetPermanently?: Maybe<RescueTransferPetPermanentlyResult>;
  rescueTransferPetTemporarily?: Maybe<RescueTransferPetTemporarilyResult>;
  resolveChipTransfer: ChipTransfer;
  resolvePetAdoptionTransfer: ResolvePetAdoptionTransferResult;
  resumeMembership?: Maybe<ResumeMembershipResult>;
  revokeUserInvite: RevokeUserInviteResult;
  sendHealthGptChatMessage: HealthGptChatMessage;
  setActivityNote?: Maybe<Activity>;
  setArticleLiked?: Maybe<Article>;
  setCommentLiked?: Maybe<Comment>;
  /**
   * Set or update containment zones for a safe zone (Place).
   * Each zone in the input will create or replace the corresponding zone type.
   * Omitted zones will be left unchanged.
   */
  setContainmentZonesForSafeZone: Place;
  setDeviceActuationPattern: DeviceActuationConfiguration;
  setDeviceLed: Device;
  setDeviceNote: Device;
  /** Force assign a device to a pet, for admins only. */
  setDevicePet?: Maybe<Pet>;
  setDeviceResponseOverride: DeviceResponseOverride;
  setDeviceUpdateChannel: Device;
  setFiNewsNotificationsEnabled: User;
  setMarketingEmailsOptedIn: User;
  setMuteAllSearchParties: User;
  /** Set nearby user detection for an active search party session. */
  setNearbyUserDetection: SharingSession;
  /** An acting pet is required to make this call. */
  setPetBlocked: StrangerPet;
  /**
   * An acting pet is required to make this call.
   * A dismissed pet will no longer appear in suggested pets to follow.
   */
  setPetDismissed: StrangerPet;
  /** An acting pet is required to make this call. */
  setPetFollowed: StrangerPet;
  setPetPrimaryPhoto: Pet;
  setPhotoLiked?: Maybe<Photo>;
  setPrimaryUserEmail: User;
  setSocialBanUser?: Maybe<Scalars['Boolean']>;
  setSocialOptedOut: Household;
  setStepGoalForPet?: Maybe<SetStepGoalForPetResult>;
  setSupplementNextShipDate?: Maybe<SetNextShipmentDateResult>;
  setSupplementShippingAddress?: Maybe<SetShippingAddressResult>;
  setTermsOfServiceAccepted: SetTermsOfServiceAcceptedResult;
  setTextPostLiked?: Maybe<TextPost>;
  setUserLocation: User;
  setUserRoleInHousehold: SetUserRoleInHouseholdResult;
  setVideoPostLiked?: Maybe<VideoPost>;
  setWalkLiked?: Maybe<StrangerWalk>;
  shipOrderLineItems: Order;
  shipOrders: Array<Order>;
  skipSupplementShipment?: Maybe<SkipSupplementShipmentResult>;
  /**
   * Temporarily snooze a pet, suppressing escape/walk/safe zone notifications for the given duration.
   * For Ultra devices, also sends a SNOOZE_ENABLED actuation to the collar.
   */
  snoozePet: PetSnoozeStatus;
  /** @deprecated Phase this out in favor of only using [submitReports].  Arbitrarily overwriting DeviceInfo fields is problematic. */
  submitDeviceInfo?: Maybe<Scalars['Boolean']>;
  submitHealthGptChatMessageFeedback: HealthGptChatMessageUserFeedback;
  /** @deprecated User `userFeedbackEscapeAlertFeedbackSubmit` */
  submitNotificationFeedback?: Maybe<Scalars['Boolean']>;
  submitObservedBehavior: SubmitObservedBehaviorResponse;
  submitRealtimeBehaviorFeedback: SubmitRealtimeBehaviorFeedbackResponse;
  submitReports?: Maybe<SubmitReportsResult>;
  syncAmazonReturnToRMA?: Maybe<RMA>;
  syncOrders: SyncOrdersResults;
  /** Unassign an owned charging base from the current user. */
  unassignChargingBase: Scalars['Boolean'];
  /** Unassign an owned device from a pet. */
  unassignDevice: Pet;
  undeletePet?: Maybe<Scalars['Boolean']>;
  unregisterHandset?: Maybe<Scalars['Boolean']>;
  unregisterHandsetLiveActivityToken: Scalars['Boolean'];
  /** Cancel an active snooze for a pet. For Ultra devices, sends a SNOOZE_DISABLED actuation. */
  unsnoozePet: PetSnoozeStatus;
  updateBillingAccount: BillingAccount;
  updateChargingBase: ChargingBase;
  updateChipCondition: ResellerChip;
  /** @deprecated Use `chipRegistration*` or `assignNew*ToChip` mutations instead. */
  updateChipContactInfo: UpdateChipContactInfoResult;
  updateChipResellerInfo: ChipReseller;
  /** Update operational parameters for a module */
  updateDeviceOperationParams: Device;
  /** @deprecated Dog park notifications were removed. */
  updateDogParkNotificationSettings?: Maybe<DogParkNotificationSettings>;
  updateDynamicEnumMember: DynamicEnum;
  updateFiNewsNotification: FiNewsNotification;
  updateMobileAppBanner: AdminMobileAppBanner;
  updateMobileAppBlockerScreen: AdminMobileAppBlockerScreen;
  updateMobileAppBottomSheet: AdminMobileAppBottomSheet;
  updateMobileAppDiscoverItem: AdminMobileAppDiscoverItem;
  updateMobileAppPermissionBlockerScreen: AdminMobileAppPermissionBlockerScreen;
  updateMobileAppSplashScreen: AdminMobileAppSplashScreen;
  updateOrderShippingAddress: Order;
  updateOrderShippingOption: Order;
  updatePet: Pet;
  updatePetAlertPreferences: Pet;
  updatePetCityState?: Maybe<Pet>;
  updatePetDocument: PetDocument;
  updatePhoneNumber: User;
  updatePhoneNumberAndAutoAcceptInvites: UpdatePhoneNumberAndAutoAcceptInvitesResult;
  updatePlace: Place;
  updateResellerContactInfo: ChipReseller;
  updateResellerRescueVerified: ChipReseller;
  updateSupplementSubscription?: Maybe<UpdateSupplementSubscriptionResult>;
  updateUser: User;
  updateUserCommunicationPreferences: User;
  updateUserLocalePreferences: User;
  updateWifiNetwork: WifiNetwork;
  /** Unassigns the current device and assigns the new unowned device */
  upgradeDevice: Pet;
  uploadContacts?: Maybe<Scalars['Boolean']>;
  userFeedbackActivityPlayFeedbackSubmit?: Maybe<EventFeedbackResponse>;
  userFeedbackActivityRestFeedbackSubmit?: Maybe<EventFeedbackResponse>;
  userFeedbackActivityTravelFeedbackSubmit?: Maybe<EventFeedbackResponse>;
  userFeedbackActivityWalkFeedbackSubmit?: Maybe<EventFeedbackResponse>;
  userFeedbackEscapeAlertFeedbackSubmit?: Maybe<EventFeedbackResponse>;
  userFeedbackLostDogFeedbackSubmit?: Maybe<EventFeedbackResponse>;
  userFeedbackLostDogModeDidHelp?: Maybe<Scalars['Boolean']>;
  /** Returns base-64 encoded zip file of walk segments in GeoJSON format */
  walkSegmentsGeoJSONZip?: Maybe<Scalars['String']>;
};


export type MutationacceptUserInviteArgs = {
  input: AcceptInviteInput;
};


export type MutationacknowledgeSearchPartyArgs = {
  petId: Scalars['ID'];
};


export type MutationaddCommentComplaintArgs = {
  commentId: Scalars['ID'];
};


export type MutationaddCouponToAccountArgs = {
  input: AddCouponToAccountInput;
};


export type MutationaddHouseholdVetArgs = {
  householdId: Scalars['ID'];
  vetId: Scalars['ID'];
};


export type MutationaddMultipleSupplementSubscriptionsArgs = {
  input: AddMultipleSupplementSubscriptionsInput;
};


export type MutationaddOrderLineItemsArgs = {
  input: AddOrderLineItemsInput;
};


export type MutationaddPetDocumentArgs = {
  input: AddPetDocumentInput;
};


export type MutationaddPetPhotoArgs = {
  input: AddPetPhotoInput;
};


export type MutationaddPhotoCommentArgs = {
  comment: Scalars['String'];
  photoId: Scalars['ID'];
};


export type MutationaddPhotoComplaintArgs = {
  photoId: Scalars['ID'];
};


export type MutationaddPhotoForPetArgs = {
  input: AddPetPhotoInput;
};


export type MutationaddSupplementSubscriptionArgs = {
  input: AddSupplementSubscriptionInput;
};


export type MutationaddTextPostCommentArgs = {
  comment: Scalars['String'];
  textPostId: Scalars['ID'];
};


export type MutationaddTextPostComplaintArgs = {
  textPostId: Scalars['ID'];
};


export type MutationaddThirdPartySubscriptionArgs = {
  input: AddThirdPartySubscriptionInput;
};


export type MutationaddUserEmailArgs = {
  input: AddUserEmailInput;
};


export type MutationaddVideoPostCommentArgs = {
  comment: Scalars['String'];
  videoPostId: Scalars['ID'];
};


export type MutationaddVideoPostComplaintArgs = {
  videoPostId: Scalars['ID'];
};


export type MutationaddWifiCredentialsArgs = {
  input: AddWifiCredentialInput;
};


export type MutationadminActivateFulfillmentWarehouseArgs = {
  warehouseId: Scalars['ID'];
};


export type MutationadminAddDogParkFromOSMArgs = {
  input: AdminAddDogParkFromOSMInput;
};


export type MutationadminAddFirmwareTagArgs = {
  buildAttribute: Scalars['Boolean'];
  tagName: Scalars['String'];
};


export type MutationadminAddItemToListArgs = {
  listName: Scalars['String'];
  value: Scalars['JSON'];
};


export type MutationadminAddResellerModulesArgs = {
  input: AddResellerModulesInput;
};


export type MutationadminAddTagToFirmwareUpdateChannelArgs = {
  channelName: Scalars['String'];
  platform: Scalars['String'];
  tagName: Scalars['String'];
};


export type MutationadminAddTagToFirmwareVersionArgs = {
  firmwareVersion: Scalars['String'];
  tagName: Scalars['String'];
};


export type MutationadminAddUserToGroupArgs = {
  groupName: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationadminAddUserToHouseholdArgs = {
  input: AddUserToHouseholdInput;
};


export type MutationadminAddVetSuggestionArgs = {
  householdId: Scalars['ID'];
  vetId: Scalars['ID'];
};


export type MutationadminArchiveFirmwareArgs = {
  input: ArchiveFirmwareInput;
};


export type MutationadminBulkAddPetsToUnmanagedPackArgs = {
  packId: Scalars['ID'];
  petIds: Array<Scalars['ID']>;
};


export type MutationadminBulkAssignUsersToGroupArgs = {
  input: AdminBulkAssignUsersToGroupInput;
};


export type MutationadminChargeConsignmentAccountArgs = {
  input: ChargeConsignmentAccountInput;
};


export type MutationadminClaimNanoWebIdsArgs = {
  input: AdminClaimNanoWebIdsInput;
};


export type MutationadminClearChipArgs = {
  chipId: Scalars['ID'];
};


export type MutationadminCloseInPersonEventArgs = {
  id: Scalars['ID'];
};


export type MutationadminCreateBatchRecordsArgs = {
  batch: Scalars['String'];
  count: Scalars['Int'];
  deviceType: DeviceType;
  hwRev: Scalars['String'];
  modelId?: InputMaybe<Scalars['String']>;
  numDigits?: InputMaybe<Scalars['Int']>;
  platform: Scalars['ID'];
  prefix: Scalars['String'];
  startOffset: Scalars['Int'];
};


export type MutationadminCreateBreedArgs = {
  input: AdminCreateBreedInput;
};


export type MutationadminCreateChangeLogArgs = {
  input: CreateChangeLogInput;
};


export type MutationadminCreateConsignmentAccountArgs = {
  input: CreateConsignmentAccountInput;
};


export type MutationadminCreateConsignmentLocationArgs = {
  input: CreateConsignmentLocationInput;
};


export type MutationadminCreateConsignmentOrderArgs = {
  input: AdminCreateConsignmentOrderInput;
};


export type MutationadminCreateConsignmentRecurlyAccountArgs = {
  input: CreateConsignmentRecurlyAccountInput;
};


export type MutationadminCreateCouponArgs = {
  input: CreateCouponInput;
};


export type MutationadminCreateDogParkCheckinExclusionArgs = {
  input: AdminCreateDogParkCheckinExclusionInput;
};


export type MutationadminCreateEvalGuidelineArgs = {
  input: AdminCreateEvalGuidelineInput;
};


export type MutationadminCreateFirmwareChannelArgs = {
  input: CreateFirmwareChannelInput;
};


export type MutationadminCreateGingrBoardingFacilityArgs = {
  input: CreateGingrBoardingFacilityInput;
};


export type MutationadminCreateHouseholdWithUserArgs = {
  userId: Scalars['ID'];
};


export type MutationadminCreateInPersonEventArgs = {
  input: CreateInPersonEventInput;
};


export type MutationadminCreateInternalOrderArgs = {
  input: AdminCreateInternalOrderInput;
};


export type MutationadminCreateOrderArgs = {
  input: AdminCreateOrderInput;
};


export type MutationadminCreatePlaceArgs = {
  input: CreatePlaceInput;
  userId: Scalars['ID'];
};


export type MutationadminCreatePlatformArgs = {
  description?: InputMaybe<Scalars['String']>;
  platformId: Scalars['ID'];
};


export type MutationadminCreatePromotionArgs = {
  input: CreatePromotionInput;
};


export type MutationadminCreateTargetedFeatureFlagArgs = {
  input: AdminCreateTargetedFeatureFlagInput;
};


export type MutationadminCreateTestDataArgs = {
  input: CreateTestDataInput;
};


export type MutationadminCreateUserForBoardingFacilityArgs = {
  input: CreateUserForBoardingFacilityInput;
};


export type MutationadminCreateUserGroupArgs = {
  name: Scalars['String'];
};


export type MutationadminCreateVipUserLookupCriteriaArgs = {
  input: AdminCreateVipUserLookupCriteriaInput;
};


export type MutationadminDeactivateEvalGuidelineArgs = {
  key: Scalars['String'];
};


export type MutationadminDeactivateFulfillmentWarehouseArgs = {
  warehouseId: Scalars['ID'];
};


export type MutationadminDeactivateUserArgs = {
  userId: Scalars['ID'];
};


export type MutationadminDeleteChangeLogArgs = {
  id: Scalars['ID'];
};


export type MutationadminDeleteConsignmentAccountArgs = {
  id: Scalars['ID'];
};


export type MutationadminDeleteConsignmentLocationArgs = {
  id: Scalars['ID'];
};


export type MutationadminDeleteDogParkCheckinExclusionArgs = {
  id: Scalars['ID'];
};


export type MutationadminDeleteFirmwareChannelArgs = {
  input: DeleteFirmwareChannelInput;
};


export type MutationadminDeletePromotionArgs = {
  id: Scalars['Int'];
};


export type MutationadminDeleteUserGroupArgs = {
  name: Scalars['String'];
};


export type MutationadminDeleteVipUserLookupCriteriaArgs = {
  id: Scalars['ID'];
};


export type MutationadminDisableShelterluvArgs = {
  chipResellerId: Scalars['ID'];
};


export type MutationadminDuplicatePromotionArgs = {
  input: DuplicatePromotionInput;
};


export type MutationadminEnableShelterluvArgs = {
  input: UpdateShelterluvConfigInput;
};


export type MutationadminExpireAndRecreateCouponArgs = {
  input: CreateCouponInput;
};


export type MutationadminExpireCouponArgs = {
  name: Scalars['String'];
};


export type MutationadminHealthGptAddQuestionArgs = {
  input: AdminHealthGptAddMessageInput;
};


export type MutationadminHealthGptCreateDocumentArgs = {
  input: AdminHealthGptCreateDocumentInput;
};


export type MutationadminHealthGptDeleteDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationadminHealthGptUpdateDocumentArgs = {
  input: AdminHealthGptUpdateDocumentInput;
};


export type MutationadminImportChipsArgs = {
  input: ChipImportInput;
};


export type MutationadminImportPartnerOrdersArgs = {
  csvData: Scalars['String'];
};


export type MutationadminIncrementNumConfirmedReferralsArgs = {
  amount: Scalars['Int'];
  userId: Scalars['ID'];
};


export type MutationadminMigrateModulesToFirmwareChannelArgs = {
  channel: Scalars['String'];
  deviceType: DeviceType;
  moduleIds: Array<Scalars['String']>;
  platform: Scalars['String'];
};


export type MutationadminPublishTestPetUpdateArgs = {
  changeType?: InputMaybe<PetChangeType>;
  petId: Scalars['ID'];
};


export type MutationadminRegisterConsignmentResaleCertificateArgs = {
  input: RegisterConsignmentResaleCertificateInput;
};


export type MutationadminReinstateStreakArgs = {
  petId: Scalars['ID'];
};


export type MutationadminRemoveConsignmentResaleCertificateArgs = {
  consignmentAccountId: Scalars['ID'];
};


export type MutationadminRemoveFeatureFlagArgs = {
  name: Scalars['String'];
};


export type MutationadminRemoveItemFromListArgs = {
  id: Scalars['ID'];
};


export type MutationadminRemoveTagFromFirmwareUpdateChannelArgs = {
  channelName: Scalars['String'];
  platform: Scalars['String'];
  tagName: Scalars['String'];
};


export type MutationadminRemoveTagFromFirmwareVersionArgs = {
  firmwareVersion: Scalars['String'];
  tagName: Scalars['String'];
};


export type MutationadminRemoveUserFromGroupArgs = {
  groupName: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationadminResetDeviceBatteryStateArgs = {
  moduleId: Scalars['String'];
};


export type MutationadminSendBackgroundNotificationArgs = {
  input: SendBackgroundNotificationInput;
};


export type MutationadminSendFreeNanoBoxesArgs = {
  input: AdminSendFreeNanoBoxesInput;
};


export type MutationadminSendNotificationArgs = {
  input: SendNotificationInput;
};


export type MutationadminSendScreenSharingNotificationArgs = {
  input: AdminSendScreenSharingNotificationInput;
};


export type MutationadminSendServerPushToDeviceArgs = {
  moduleId: Scalars['String'];
};


export type MutationadminSetAutomaticallyActivateDevicesOnUserArgs = {
  automaticallyActivateDevices: Scalars['Boolean'];
  userId: Scalars['ID'];
};


export type MutationadminSetChargingBaseOwnerArgs = {
  baseId: Scalars['String'];
  householdId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationadminSetChargingBaseUpdateChannelArgs = {
  baseId: Scalars['String'];
  channelName: Scalars['String'];
};


export type MutationadminSetChipResellerNameArgs = {
  name: Scalars['String'];
  subjectId: Scalars['ID'];
};


export type MutationadminSetChipResellerRescueVerifiedArgs = {
  subjectId: Scalars['ID'];
  verified: Scalars['Boolean'];
};


export type MutationadminSetChipResellerStatusArgs = {
  status: ResellerStatus;
  subjectId: Scalars['ID'];
};


export type MutationadminSetChipResellerTypesArgs = {
  subjectId: Scalars['ID'];
  types: Array<ResellerType>;
};


export type MutationadminSetCommentHiddenArgs = {
  commentId: Scalars['ID'];
  hidden: Scalars['Boolean'];
};


export type MutationadminSetDeviceAutoAddUserToHouseholdArgs = {
  moduleId: Scalars['String'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationadminSetDeviceFirmwareUpdateEligibilityArgs = {
  enable: Scalars['Boolean'];
  moduleId: Scalars['String'];
};


export type MutationadminSetDeviceIsBlockedArgs = {
  isBlocked: Scalars['Boolean'];
  moduleId: Scalars['String'];
};


export type MutationadminSetDeviceIsRefurbishedArgs = {
  isRefurbished: Scalars['Boolean'];
  moduleId: Scalars['String'];
};


export type MutationadminSetFeatureFlagArgs = {
  name: Scalars['String'];
  type: SetFeatureFlagType;
  value: SetFeatureFlagValue;
};


export type MutationadminSetFirmwareRolloutQuantityArgs = {
  deviceType: DeviceType;
  platform: Scalars['String'];
  quantity: Scalars['Int'];
  sourceChannel?: InputMaybe<Scalars['String']>;
  sourceVersion?: InputMaybe<Scalars['String']>;
  targetChannel?: InputMaybe<Scalars['String']>;
};


export type MutationadminSetPetCityStateArgs = {
  city: Scalars['String'];
  petId: Scalars['ID'];
  state: Scalars['String'];
};


export type MutationadminSetPhotoDeletedArgs = {
  deleted: Scalars['Boolean'];
  photoId: Scalars['ID'];
};


export type MutationadminSetRemoteLoggingForFirmwareChannelArgs = {
  input: SetRemoteLoggingForFirmwareChannelInput;
};


export type MutationadminSetSubscriptionIdOnDeviceArgs = {
  ecomConfigType?: InputMaybe<Scalars['String']>;
  moduleId: Scalars['String'];
  subscriptionId?: InputMaybe<Scalars['String']>;
};


export type MutationadminSetThirdPartyAccessArgs = {
  input: AdminSetThirdPartyAccessInput;
};


export type MutationadminSetUserGroupsArgs = {
  groups: Array<Scalars['String']>;
  userId: Scalars['ID'];
};


export type MutationadminSubmitCertGenJobArgs = {
  batch: Scalars['String'];
  deviceType: DeviceType;
};


export type MutationadminTriggerCustomerIoTrackEventForTestUserArgs = {
  emailAddress: Scalars['String'];
  eventData?: InputMaybe<Scalars['JSON']>;
  eventName: Scalars['String'];
};


export type MutationadminUndismissMobileAppContentArgs = {
  dbId: Scalars['Int'];
};


export type MutationadminUpdateChangeLogArgs = {
  input: UpdateChangeLogInput;
};


export type MutationadminUpdateChipPetArgs = {
  input: AdminUpdateChipPetInput;
};


export type MutationadminUpdateChipResellerArgs = {
  input: AdminUpdateChipResellerInput;
};


export type MutationadminUpdateChipResellerByBoxArgs = {
  input: AdminUpdateChipResellerByBoxInput;
};


export type MutationadminUpdateChipResellerByBoxIdsArgs = {
  input: AdminUpdateChipResellerByBoxIdsInput;
};


export type MutationadminUpdateChipResellerBySerialNumberArgs = {
  input: AdminUpdateChipResellerBySerialNumberInput;
};


export type MutationadminUpdateConsignmentAccountArgs = {
  id: Scalars['ID'];
  input: UpdateConsignmentAccountInput;
};


export type MutationadminUpdateConsignmentLocationArgs = {
  id: Scalars['ID'];
  input: UpdateConsignmentLocationInput;
};


export type MutationadminUpdateDeviceCellularStatusArgs = {
  moduleId: Scalars['String'];
};


export type MutationadminUpdateDeviceHasActiveSubscriptionArgs = {
  hasSubscriptionOverride: Scalars['Boolean'];
  moduleId: Scalars['String'];
};


export type MutationadminUpdateDeviceSubscriptionOverrideEndsAtArgs = {
  moduleId: Scalars['String'];
  subscriptionOverrideEndsAt?: InputMaybe<Scalars['String']>;
};


export type MutationadminUpdateDeviceTenancyArgs = {
  moduleId: Scalars['String'];
  tenancy: Scalars['String'];
};


export type MutationadminUpdateEvalGuidelineArgs = {
  input: AdminUpdateEvalGuidelineInput;
};


export type MutationadminUpdateFirmwareArgs = {
  input: UpdateFirmwareInput;
};


export type MutationadminUpdateFirmwareChannelArgs = {
  input: UpdateFirmwareChannelInput;
};


export type MutationadminUpdateGingrBoardingFacilityArgs = {
  input: UpdateGingrBoardingFacilityInput;
};


export type MutationadminUpdateHouseholdNameArgs = {
  householdId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationadminUpdateHouseholdTenancyArgs = {
  householdId: Scalars['ID'];
  tenancy: Scalars['String'];
};


export type MutationadminUpdateHouseholdThirdPartyAccessArgs = {
  householdId: Scalars['ID'];
  thirdPartyAccess?: InputMaybe<Scalars['String']>;
};


export type MutationadminUpdateInPersonEventArgs = {
  input: UpdateInPersonEventInput;
};


export type MutationadminUpdateInPersonEventInventoryArgs = {
  input: UpdateInPersonEventInventoryInput;
};


export type MutationadminUpdateInventoryConfigurationArgs = {
  input: AdminUpdateInventoryConfigurationInput;
};


export type MutationadminUpdateListItemArgs = {
  id: Scalars['ID'];
  value: Scalars['JSON'];
};


export type MutationadminUpdatePlatformArgs = {
  archive?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  platformId: Scalars['ID'];
};


export type MutationadminUpdatePromotionArgs = {
  input: UpdatePromotionInput;
};


export type MutationadminUpdateShelterluvConfigArgs = {
  input: UpdateShelterluvConfigInput;
};


export type MutationadminUpdateTargetedFeatureFlagArgs = {
  input: AdminUpdateTargetedFeatureFlagInput;
};


export type MutationadminUploadImageArgs = {
  data: Scalars['Binary'];
  path?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
};


export type MutationadminUpsertFulfillmentWarehouseArgs = {
  input: AdminUpsertFulfillmentWarehouseInput;
};


export type MutationapproveInternalOrderArgs = {
  orderId: Scalars['ID'];
};


export type MutationassignChargingBaseArgs = {
  baseId: Scalars['String'];
  householdId?: InputMaybe<Scalars['ID']>;
};


export type MutationassignDeviceArgs = {
  iccid?: InputMaybe<Scalars['String']>;
  moduleId: Scalars['String'];
  petId: Scalars['ID'];
};


export type MutationassignNewOwnerToChipArgs = {
  input: AssignNewOwnerToChipInput;
};


export type MutationassignNewPetToChipArgs = {
  input: AssignNewPetToChipInput;
};


export type MutationboardingFacilityCheckInPetArgs = {
  input: BoardingFacilityCheckInPetInput;
};


export type MutationboardingFacilityCheckOutPetArgs = {
  boardingSessionId: Scalars['ID'];
};


export type MutationcancelAndRefundSubscriptionArgs = {
  input: CancelAndRefundSubscriptionInput;
};


export type MutationcancelMembershipArgs = {
  input: CancelMembershipInput;
};


export type MutationcancelOrderLineItemsArgs = {
  input: CancelOrderLineItemsInput;
};


export type MutationcancelOrdersArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationcancelRMAArgs = {
  id: Scalars['ID'];
};


export type MutationcancelSupplementSubscriptionArgs = {
  input: CancelSupplementSubscriptionInput;
};


export type MutationcancelThirdPartySubscriptionArgs = {
  input: CancelThirdPartySubscriptionInput;
};


export type MutationchangeMembershipPlanEndOfTermArgs = {
  input: ChangeMembershipPlanEndOfTermInput;
};


export type MutationchangePetHouseholdArgs = {
  householdId: Scalars['ID'];
  subjectId: Scalars['ID'];
};


export type MutationchangePlaceHouseholdArgs = {
  householdId: Scalars['ID'];
  subjectId: Scalars['ID'];
};


export type MutationchargeAccountBySkuArgs = {
  input: ChargeAccountBySkuInput;
};


export type MutationcheckInRMAArgs = {
  input: CheckInRMAInput;
};


export type MutationcheckInUnknownReturnArgs = {
  input: CheckInUnknownReturnInput;
};


export type MutationchipRegistrationAddEmailArgs = {
  input: ChipRegistrationAddEmailInput;
};


export type MutationchipRegistrationAddExistingPetArgs = {
  input: ChipRegistrationAddExistingPetInput;
};


export type MutationchipRegistrationAddNewPetArgs = {
  input: ChipRegistrationAddNewPetInput;
};


export type MutationchipRegistrationUpdateContactArgs = {
  input: ChipRegistrationUpdateContactInput;
};


export type MutationclaimClickToCancelDiscountArgs = {
  input: ClaimClickToCancelDiscountInput;
};


export type MutationclaimFreeMonthArgs = {
  input: ClaimFreeMonthInput;
};


export type MutationclaimSupplementDiscountArgs = {
  input: ClaimSupplementDiscountInput;
};


export type MutationclaimTwoMonthsHalfOffArgs = {
  input: ClaimTwoMonthsHalfOffInput;
};


export type MutationclearDeviceResponseOverrideArgs = {
  moduleId: Scalars['String'];
};


export type MutationconvertFreeTrialArgs = {
  input: ConvertFreeTrialInput;
};


export type MutationcreateBillingAccountArgs = {
  input: CreateBillingAccountInput;
};


export type MutationcreateDeviceArgs = {
  input: CreateDeviceInput;
};


export type MutationcreateDeviceActuationArgs = {
  input: CreateDeviceActuationInput;
};


export type MutationcreateDynamicEnumMemberArgs = {
  input: CreateDynamicEnumMemberInput;
};


export type MutationcreateFiNewsNotificationArgs = {
  input: CreateFiNewsNotificationInput;
};


export type MutationcreateImageFromUrlArgs = {
  input: CreateImageFromUrlInput;
};


export type MutationcreateManualSubscriptionArgs = {
  input: CreateManualSubscriptionInput;
};


export type MutationcreateMobileAppBannerArgs = {
  input: CreateMobileAppBannerInput;
};


export type MutationcreateMobileAppBlockerScreenArgs = {
  input: CreateMobileAppBlockerScreenInput;
};


export type MutationcreateMobileAppBottomSheetArgs = {
  input: CreateMobileAppBottomSheetInput;
};


export type MutationcreateMobileAppDiscoverItemArgs = {
  input: CreateMobileAppDiscoverItemInput;
};


export type MutationcreateMobileAppPermissionBlockerScreenArgs = {
  input: CreateMobileAppPermissionBlockerScreenInput;
};


export type MutationcreateMobileAppSplashScreenArgs = {
  input: CreateMobileAppSplashScreenInput;
};


export type MutationcreateNewHealthGptChatThreadArgs = {
  input: CreateNewHealthGptChatThreadInput;
};


export type MutationcreatePackArgs = {
  input: CreatePackInput;
};


export type MutationcreatePetArgs = {
  input: CreatePetInput;
};


export type MutationcreatePlaceArgs = {
  input: CreatePlaceInput;
};


export type MutationcreateRMAArgs = {
  input: CreateRMAInput;
};


export type MutationcreateSharingSessionArgs = {
  petId: Scalars['ID'];
  sessionType?: InputMaybe<SharingSessionType>;
};


export type MutationcreateTestimonialReminderArgs = {
  petId: Scalars['ID'];
};


export type MutationcreateTextPostArgs = {
  input: CreateTextPostInput;
};


export type MutationcreateUserArgs = {
  input: CreateUserInput;
};


export type MutationcreateVideoPostArgs = {
  input: CreateVideoPostInput;
};


export type MutationcreateZendeskCancellationTicketArgs = {
  input: CreateZendeskCancellationTicketInput;
};


export type MutationcreateZendeskReplacementTicketArgs = {
  input: CreateZendeskReplacementTicketInput;
};


export type MutationcreateZendeskTroubleshootingTicketArgs = {
  input: CreateZendeskTroubleshootingTicketInput;
};


export type MutationdeleteCommentArgs = {
  commentId: Scalars['ID'];
};


export type MutationdeletePetDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationdeleteTextPostArgs = {
  textPostId: Scalars['ID'];
};


export type MutationdeleteVideoPostArgs = {
  videoPostId: Scalars['ID'];
};


export type MutationdisconnectAppIntegrationArgs = {
  app: AppIntegrationId;
};


export type MutationdismissMobileAppContentArgs = {
  id: Scalars['ID'];
};


export type MutationdismissPetInsightsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationdismissPromotionBannerArgs = {
  input: DismissPromotionBannerInput;
};


export type MutationdowngradeSeries2Args = {
  input: DowngradeSeries2Input;
};


export type MutationdowngradeSeries3Args = {
  input: DowngradeSeries3Input;
};


export type MutationenableOrExtendQuickReportModeArgs = {
  moduleId: Scalars['String'];
};


export type MutationendSharingSessionArgs = {
  petId: Scalars['ID'];
  sessionType: SharingSessionType;
};


export type MutationexecuteProratedUpgradeArgs = {
  input: ExecuteProductTransferInput;
};


export type MutationexecuteSkuOnlyTransferArgs = {
  input: ExecuteProductTransferInput;
};


export type MutationextendSubscriptionArgs = {
  input: ExtendSubscriptionInput;
};


export type MutationignoreVetSuggestionArgs = {
  householdId: Scalars['ID'];
  vetId: Scalars['ID'];
};


export type MutationinviteUserToHouseholdArgs = {
  input: InviteUserInput;
};


export type MutationjoinPackArgs = {
  packId: Scalars['ID'];
  petId: Scalars['ID'];
};


export type MutationleavePackArgs = {
  packId: Scalars['ID'];
  petId: Scalars['ID'];
};


export type MutationmarkInvoiceFailedArgs = {
  input: InvoiceMarkFailedInput;
};


export type MutationmoderationApproveContentArgs = {
  input: SocialContentInput;
};


export type MutationmoderationRejectContentArgs = {
  input: SocialContentInput;
};


export type MutationnotifyNearbyUsersForSearchPartyArgs = {
  petId: Scalars['ID'];
};


export type MutationpauseMembershipArgs = {
  input: PauseMembershipInput;
};


export type MutationpurchaseConsumerStoreCartArgs = {
  input: ConsumerStoreCartInput;
};


export type MutationpurchaseMembershipUpgradeArgs = {
  input: UpgradeMembershipInput;
};


export type MutationpurchaseMonthlyUpgradePromotionArgs = {
  input: UpgradeMembershipInput;
};


export type MutationpurchaseRenewAndSaveArgs = {
  input: RenewAndSaveInput;
};


export type MutationpurchaseSeries3UpgradeCartArgs = {
  input: Series3UpgradeCartInput;
};


export type MutationpurchaseSubscriptionArgs = {
  input: PurchaseSubscriptionInput;
};


export type MutationpurchaseUpgradeToSeriesThreePlusModuleArgs = {
  input: UpgradeToSeriesThreePlusModuleInput;
};


export type MutationreactivateSubscriptionArgs = {
  input: ReactivateSubscriptionInput;
};


export type MutationreassignChipToResellerArgs = {
  input: ReassignChipToResellerInput;
};


export type MutationreassignDeviceArgs = {
  moduleId: Scalars['String'];
  toPetId: Scalars['ID'];
};


export type MutationrecallChipArgs = {
  input: RecallChipInput;
};


export type MutationrecordAppInstallForUserArgs = {
  input: RecordAppInstallForUserInput;
};


export type MutationrefundInvoiceArgs = {
  input: InvoiceRefundInput;
};


export type MutationregisterChipResellerArgs = {
  input: RegisterChipResellerInput;
};


export type MutationregisterChipResellerV2Args = {
  input: RegisterChipResellerInputV2;
};


export type MutationregisterHandsetArgs = {
  input: RegisterHandsetInput;
};


export type MutationregisterHandsetLiveActivityTokenArgs = {
  input: RegisterHandsetLiveActivityTokenInput;
};


export type MutationregisterThirdPartyChipArgs = {
  input: ThirdPartyChipInput;
};


export type MutationremoveContainmentZonesForSafeZoneArgs = {
  placeId: Scalars['ID'];
};


export type MutationremoveCouponFromAccountArgs = {
  input: RemoveCouponFromAccountInput;
};


export type MutationremoveDynamicEnumMemberArgs = {
  id: Scalars['ID'];
};


export type MutationremoveFiNewsNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationremoveHouseholdVetsArgs = {
  householdId: Scalars['ID'];
  vetIds: Array<Scalars['ID']>;
};


export type MutationremovePetArgs = {
  subjectId: Scalars['ID'];
};


export type MutationremovePetInstagramHandleArgs = {
  subjectId: Scalars['ID'];
};


export type MutationremovePhotoArgs = {
  photoId: Scalars['ID'];
};


export type MutationremovePlaceArgs = {
  subjectId: Scalars['ID'];
};


export type MutationremoveUserEmailArgs = {
  input: RemoveUserEmailInput;
};


export type MutationremoveUserFromHouseholdArgs = {
  input: RemoveUserFromHouseholdInput;
};


export type MutationremoveWifiCredentialsArgs = {
  input: RemoveWifiCredentialInput;
};


export type MutationrenewSubscriptionArgs = {
  input: RenewSubscriptionInput;
};


export type MutationreorderDynamicEnumMembersArgs = {
  ids: Array<Scalars['ID']>;
  kind: DynamicEnumKind;
};


export type MutationreportChargingBaseAtPositionArgs = {
  baseId: Scalars['String'];
  horizontalAccuracy: Scalars['Float'];
  position: PositionInput;
};


export type MutationrequestEmailVerificationArgs = {
  input: RequestEmailVerificationInput;
};


export type MutationrequestUserAccountDeletionArgs = {
  input: UserAccountDeletionInput;
};


export type MutationrequestVerificationCodeArgs = {
  input: RequestVerificationCodeInput;
};


export type MutationrerouteShipmentsArgs = {
  input: RerouteShipmentsInput;
};


export type MutationrescueCancelPetAdoptionTransferArgs = {
  input: RescueCancelPetAdoptionTransferInput;
};


export type MutationrescueCreatePetAdoptionTransferArgs = {
  input: RescueCreatePetAdoptionTransferInput;
};


export type MutationrescueCreatePetFosterTransferArgs = {
  input: RescueCreatePetFosterTransferInput;
};


export type MutationrescueRecallPetArgs = {
  input: RescueRecallPetInput;
};


export type MutationrescueRecallPetFosterTransferArgs = {
  input: RescueRecallPetFosterTransferInput;
};


export type MutationrescueTransferPetPermanentlyArgs = {
  input: RescueTransferPetPermanentlyInput;
};


export type MutationrescueTransferPetTemporarilyArgs = {
  input: RescueTransferPetTemporarilyInput;
};


export type MutationresolveChipTransferArgs = {
  input: ResolveChipTransferInput;
};


export type MutationresolvePetAdoptionTransferArgs = {
  input: ResolvePetAdoptionTransferInput;
};


export type MutationresumeMembershipArgs = {
  input: ResumeMembershipInput;
};


export type MutationrevokeUserInviteArgs = {
  input: RevokeUserInviteInput;
};


export type MutationsendHealthGptChatMessageArgs = {
  input: SendHealthGptChatMessageInput;
};


export type MutationsetActivityNoteArgs = {
  activityId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationsetArticleLikedArgs = {
  articleId: Scalars['ID'];
  liked: Scalars['Boolean'];
};


export type MutationsetCommentLikedArgs = {
  commentId: Scalars['ID'];
  liked: Scalars['Boolean'];
};


export type MutationsetContainmentZonesForSafeZoneArgs = {
  input: SetPlaceContainmentInput;
  placeId: Scalars['ID'];
};


export type MutationsetDeviceActuationPatternArgs = {
  moduleId: Scalars['String'];
  pattern: DeviceActuationType;
};


export type MutationsetDeviceLedArgs = {
  ledColorCode: Scalars['Int'];
  moduleId: Scalars['String'];
};


export type MutationsetDeviceNoteArgs = {
  imei?: InputMaybe<Scalars['String']>;
  moduleId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
};


export type MutationsetDevicePetArgs = {
  imei?: InputMaybe<Scalars['String']>;
  moduleId?: InputMaybe<Scalars['String']>;
  petId?: InputMaybe<Scalars['ID']>;
};


export type MutationsetDeviceResponseOverrideArgs = {
  deviceResponseOverride: Scalars['JSON'];
  moduleId: Scalars['String'];
  overrideDurationInMinutes: Scalars['Int'];
};


export type MutationsetDeviceUpdateChannelArgs = {
  channelName: Scalars['String'];
  imei?: InputMaybe<Scalars['String']>;
  moduleId?: InputMaybe<Scalars['String']>;
};


export type MutationsetFiNewsNotificationsEnabledArgs = {
  fiNewsNotificationsEnabled: Scalars['Boolean'];
  userId: Scalars['ID'];
};


export type MutationsetMarketingEmailsOptedInArgs = {
  marketingEmailsOptedIn: Scalars['Boolean'];
};


export type MutationsetMuteAllSearchPartiesArgs = {
  muteAllSearchParties: Scalars['Boolean'];
  userId: Scalars['ID'];
};


export type MutationsetNearbyUserDetectionArgs = {
  enabled: Scalars['Boolean'];
  petId: Scalars['ID'];
};


export type MutationsetPetBlockedArgs = {
  blocked: Scalars['Boolean'];
  petId: Scalars['ID'];
};


export type MutationsetPetDismissedArgs = {
  dismissed: Scalars['Boolean'];
  petId: Scalars['ID'];
};


export type MutationsetPetFollowedArgs = {
  followed: Scalars['Boolean'];
  petId: Scalars['ID'];
};


export type MutationsetPetPrimaryPhotoArgs = {
  input: SetPetPrimaryPhotoInput;
};


export type MutationsetPhotoLikedArgs = {
  actingPetId?: InputMaybe<Scalars['ID']>;
  liked: Scalars['Boolean'];
  photoId: Scalars['ID'];
};


export type MutationsetPrimaryUserEmailArgs = {
  input: SetPrimaryUserEmailInput;
};


export type MutationsetSocialBanUserArgs = {
  banned: Scalars['Boolean'];
  userId: Scalars['ID'];
};


export type MutationsetSocialOptedOutArgs = {
  householdId: Scalars['ID'];
  socialOptedOut: Scalars['Boolean'];
};


export type MutationsetStepGoalForPetArgs = {
  input: SetStepGoalForPetInput;
};


export type MutationsetSupplementNextShipDateArgs = {
  input: SetNextShipmentDateInput;
};


export type MutationsetSupplementShippingAddressArgs = {
  input: SetShippingAddressInput;
};


export type MutationsetTermsOfServiceAcceptedArgs = {
  input: SetTermsOfServiceAcceptedInput;
};


export type MutationsetTextPostLikedArgs = {
  liked: Scalars['Boolean'];
  textPostId: Scalars['ID'];
};


export type MutationsetUserLocationArgs = {
  input: LocationReportInput;
};


export type MutationsetUserRoleInHouseholdArgs = {
  input: SetUserRoleInHouseholdInput;
};


export type MutationsetVideoPostLikedArgs = {
  liked: Scalars['Boolean'];
  videoPostId: Scalars['ID'];
};


export type MutationsetWalkLikedArgs = {
  liked: Scalars['Boolean'];
  walkId: Scalars['ID'];
};


export type MutationshipOrderLineItemsArgs = {
  input: ShipOrderLineItemsInput;
};


export type MutationshipOrdersArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationskipSupplementShipmentArgs = {
  input: SkipSupplementShipmentInput;
};


export type MutationsnoozePetArgs = {
  petId: Scalars['ID'];
  ttlSeconds: Scalars['Int'];
};


export type MutationsubmitDeviceInfoArgs = {
  deviceInfo: Scalars['JSON'];
  imei?: InputMaybe<Scalars['String']>;
  moduleId?: InputMaybe<Scalars['String']>;
};


export type MutationsubmitHealthGptChatMessageFeedbackArgs = {
  input: SubmitHealthGptChatMessageFeedbackInput;
};


export type MutationsubmitNotificationFeedbackArgs = {
  input: NotificationReportInput;
};


export type MutationsubmitObservedBehaviorArgs = {
  input: SubmitObservedBehaviorInput;
};


export type MutationsubmitRealtimeBehaviorFeedbackArgs = {
  input: SubmitRealtimeBehaviorFeedbackInput;
};


export type MutationsubmitReportsArgs = {
  activityInput?: InputMaybe<Array<ActivityReportInput>>;
  binaryResponse?: InputMaybe<Scalars['Boolean']>;
  locationInput?: InputMaybe<Array<LocationReportInput>>;
  mobilityInput?: InputMaybe<Array<MobilityReportInput>>;
  moduleId: Scalars['String'];
  moduleRequest?: InputMaybe<Scalars['String']>;
};


export type MutationsyncAmazonReturnToRMAArgs = {
  lpn: Scalars['String'];
};


export type MutationsyncOrdersArgs = {
  input: SyncOrdersInput;
};


export type MutationunassignChargingBaseArgs = {
  baseId: Scalars['String'];
};


export type MutationunassignDeviceArgs = {
  moduleId: Scalars['String'];
  petId: Scalars['ID'];
};


export type MutationundeletePetArgs = {
  subjectId: Scalars['ID'];
};


export type MutationunregisterHandsetArgs = {
  input: RegisterHandsetInput;
};


export type MutationunregisterHandsetLiveActivityTokenArgs = {
  input: UnregisterHandsetLiveActivityTokenInput;
};


export type MutationunsnoozePetArgs = {
  petId: Scalars['ID'];
};


export type MutationupdateBillingAccountArgs = {
  input: BillingAccountInput;
  recaptchaToken?: InputMaybe<Scalars['String']>;
  trackEvent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationupdateChargingBaseArgs = {
  baseId: Scalars['String'];
  input: UpdateChargingBaseInput;
};


export type MutationupdateChipConditionArgs = {
  input: UpdateChipConditionInput;
};


export type MutationupdateChipContactInfoArgs = {
  input: UpdateChipContactInfoInput;
};


export type MutationupdateChipResellerInfoArgs = {
  input: UpdateChipResellerInfoInput;
};


export type MutationupdateDeviceOperationParamsArgs = {
  input: UpdateDeviceOperationParamsInput;
  moduleId?: InputMaybe<Scalars['String']>;
};


export type MutationupdateDogParkNotificationSettingsArgs = {
  input: UpdateDogParkNotificationSettingsInput;
};


export type MutationupdateDynamicEnumMemberArgs = {
  input: UpdateDynamicEnumMemberInput;
};


export type MutationupdateFiNewsNotificationArgs = {
  input: UpdateFiNewsNotificationInput;
};


export type MutationupdateMobileAppBannerArgs = {
  input: UpdateMobileAppBannerInput;
};


export type MutationupdateMobileAppBlockerScreenArgs = {
  input: UpdateMobileAppBlockerScreenInput;
};


export type MutationupdateMobileAppBottomSheetArgs = {
  input: UpdateMobileAppBottomSheetInput;
};


export type MutationupdateMobileAppDiscoverItemArgs = {
  input: UpdateMobileAppDiscoverItemInput;
};


export type MutationupdateMobileAppPermissionBlockerScreenArgs = {
  input: UpdateMobileAppPermissionBlockerScreenInput;
};


export type MutationupdateMobileAppSplashScreenArgs = {
  input: UpdateMobileAppSplashScreenInput;
};


export type MutationupdateOrderShippingAddressArgs = {
  input: UpdateOrderShippingAddressInput;
};


export type MutationupdateOrderShippingOptionArgs = {
  input: UpdateOrderShippingOptionInput;
};


export type MutationupdatePetArgs = {
  input: UpdatePetInput;
};


export type MutationupdatePetAlertPreferencesArgs = {
  input: UpdatePetAlertPreferencesInput;
};


export type MutationupdatePetCityStateArgs = {
  input: UpdatePetCityStateInput;
};


export type MutationupdatePetDocumentArgs = {
  input: UpdatePetDocumentInput;
};


export type MutationupdatePhoneNumberArgs = {
  input: UpdatePhoneNumberInput;
};


export type MutationupdatePhoneNumberAndAutoAcceptInvitesArgs = {
  input: UpdatePhoneNumberInput;
};


export type MutationupdatePlaceArgs = {
  input: UpdatePlaceInput;
};


export type MutationupdateResellerContactInfoArgs = {
  input: UpdateResellerContactInfoInput;
};


export type MutationupdateResellerRescueVerifiedArgs = {
  input: UpdateResellerRescueVerified;
};


export type MutationupdateSupplementSubscriptionArgs = {
  input: UpdateSupplementSubscriptionInput;
};


export type MutationupdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationupdateUserCommunicationPreferencesArgs = {
  input: UpdateUserCommunicationPreferencesInput;
};


export type MutationupdateUserLocalePreferencesArgs = {
  input: UpdateUserLocalePreferencesInput;
};


export type MutationupdateWifiNetworkArgs = {
  input: UpdateWifiNetworkInput;
};


export type MutationupgradeDeviceArgs = {
  currentModuleId: Scalars['String'];
  petId: Scalars['ID'];
  upgradeModuleId: Scalars['String'];
};


export type MutationuploadContactsArgs = {
  uploadContactInputs: UploadContactInput;
};


export type MutationuserFeedbackActivityPlayFeedbackSubmitArgs = {
  input: UserFeedbackActivityPlayFeedbackSubmitInput;
};


export type MutationuserFeedbackActivityRestFeedbackSubmitArgs = {
  input: UserFeedbackActivityRestFeedbackSubmitInput;
};


export type MutationuserFeedbackActivityTravelFeedbackSubmitArgs = {
  input: UserFeedbackActivityTravelFeedbackSubmitInput;
};


export type MutationuserFeedbackActivityWalkFeedbackSubmitArgs = {
  input: UserFeedbackActivityWalkFeedbackSubmitInput;
};


export type MutationuserFeedbackEscapeAlertFeedbackSubmitArgs = {
  input: UserFeedbackEscapeAlertFeedbackSubmitInput;
};


export type MutationuserFeedbackLostDogFeedbackSubmitArgs = {
  input: UserFeedbackLostDogFeedbackSubmitInput;
};


export type MutationuserFeedbackLostDogModeDidHelpArgs = {
  input: UserFeedbackLostDogModeDidHelpInput;
};


export type MutationwalkSegmentsGeoJSONZipArgs = {
  input: WalkSegmentsGeoJSONZipInput;
};

export type NanoWebId = {
  __typename?: 'NanoWebId';
  batchId?: Maybe<Scalars['String']>;
  claimed: Scalars['Boolean'];
  claimedAt?: Maybe<Scalars['DateTime']>;
  claimedBy?: Maybe<Scalars['String']>;
  webId: Scalars['String'];
};

export type NanoWebIdBatchInfo = {
  __typename?: 'NanoWebIdBatchInfo';
  batchId: Scalars['String'];
  claimedAt: Scalars['DateTime'];
  claimedBy: Scalars['String'];
  idCount: Scalars['String'];
};

export type NearbyDogPark = {
  __typename?: 'NearbyDogPark';
  /**
   * Text describing distance to dog park.
   * e.g. "2.5 miles away"
   */
  distanceText: Scalars['String'];
  dogPark: DogPark;
};

export type NearbyDogParkFeed = {
  __typename?: 'NearbyDogParkFeed';
  count: Scalars['Int'];
  nearbyDogParks: Array<NearbyDogPark>;
};

export type NearbyPetItem = {
  __typename?: 'NearbyPetItem';
  approximateDistance: ApproximateDistance;
  pet: StrangerPet;
};

export type NearbyPetsFeed = {
  __typename?: 'NearbyPetsFeed';
  items: Array<NearbyPetItem>;
  totalCount: Scalars['Int'];
};

export type NearbyUsersResult = {
  __typename?: 'NearbyUsersResult';
  /** Convenience flag indicating if there are any nearby users (userCount > 0). */
  hasUsers: Scalars['Boolean'];
  /**
   * Number of nearby users who could be notified about the search party.
   * This count filters by mute preferences and excludes pet owners, but is BEFORE feature flag filtering.
   */
  userCount: Scalars['Int'];
  /** Number of nearby users after feature flag filtering. */
  userCountAfterFeatureFlag: Scalars['Int'];
  /** User IDs before feature flag filtering (after mute preferences and pet owner exclusion). */
  userIds: Array<Scalars['Int']>;
  /** User IDs after feature flag filtering. */
  userIdsAfterFeatureFlag: Array<Scalars['Int']>;
};

/**
 * Represents a state where the current state can't be fully determined due to a lack of reports
 * resulting from the pet either needing a collar or a lack of reports for that pet/collar
 */
export type NeedsReportsState = PetCollarState & {
  __typename?: 'NeedsReportsState';
  /** Whether the pet has a collar assigned */
  needsCollar: Scalars['Boolean'];
  /** Whether the pet has any reports associated with its collar */
  needsReports: Scalars['Boolean'];
  timestamp: Scalars['DateTime'];
};

export type NextSupplementShipmentDetails = {
  __typename?: 'NextSupplementShipmentDetails';
  deliveryExpected?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  trackingLink?: Maybe<Scalars['String']>;
};

export type NoLTEConnectivityDeviceInfo = {
  __typename?: 'NoLTEConnectivityDeviceInfo';
  modemNoRegistrationCount: Scalars['Int'];
  timestamp: Scalars['DateTime'];
  uptime: Scalars['Int'];
};

export enum NotificationChannel {
  PUSH = 'PUSH',
  SMS = 'SMS'
}

export type NotificationCountByType = {
  __typename?: 'NotificationCountByType';
  logDocumentCount: Scalars['Int'];
  notificationType: Scalars['String'];
};

export type NotificationFeed = {
  __typename?: 'NotificationFeed';
  feedItems: Array<NotificationFeedItem>;
  pageInfo: PageInfo;
  unreadCount: Scalars['Int'];
};


export type NotificationFeedunreadCountArgs = {
  since?: InputMaybe<Scalars['DateTime']>;
};

export type NotificationFeedArticleItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedArticleItem';
  article: Article;
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedDogParkVisitItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedDogParkVisitItem';
  /** Which dog park was visited */
  dogPark: DogPark;
  id: Scalars['ID'];
  /** The pet that visited the dog park */
  pet: StrangerPet;
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedFiNewsItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedFiNewsItem';
  fiNewsNotification: FiNewsNotification;
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedFollowedPetPhotoAddedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedFollowedPetPhotoAddedItem';
  followedPet: StrangerPet;
  id: Scalars['ID'];
  photo: Photo;
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedItem = {
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedNearbyPetJoinedFiItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedNearbyPetJoinedFiItem';
  id: Scalars['ID'];
  /** Where the new pet is located. */
  locationText: Scalars['String'];
  /** The pet that just joined Fi. */
  pet: StrangerPet;
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedPetFollowedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedPetFollowedItem';
  followedPet: Pet;
  followingPet: StrangerPet;
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedPhotoCommentItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedPhotoCommentItem';
  comment: Comment;
  /** The pet who commented */
  commentingPet: StrangerPet;
  id: Scalars['ID'];
  /** The pet whose photo was commented on */
  pet: Pet;
  photo: Photo;
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedPhotoCommentLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedPhotoCommentLikedItem';
  comment: Comment;
  id: Scalars['ID'];
  /** The pet who liked the comment */
  likingPet: StrangerPet;
  /** The pet whose post was commented on */
  pet: Pet;
  photo: Photo;
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedPhotoLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedPhotoLikedItem';
  id: Scalars['ID'];
  /** The pet who is liking the photo */
  likingPet: StrangerPet;
  numPhotosLiked: Scalars['Int'];
  /** The pet whose photo is being liked */
  pet: Pet;
  photo: Photo;
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedTextPostCommentItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedTextPostCommentItem';
  comment: Comment;
  /** The pet who commented */
  commentingPet: StrangerPet;
  id: Scalars['ID'];
  /** The pet whose photo was commented on */
  pet: StrangerPet;
  textPost: TextPost;
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedTextPostCommentLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedTextPostCommentLikedItem';
  comment: Comment;
  id: Scalars['ID'];
  /** The pet who liked the comment */
  likingPet: StrangerPet;
  /** The pet whose post was commented on */
  pet: Pet;
  textPost: TextPost;
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedTextPostLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedTextPostLikedItem';
  id: Scalars['ID'];
  /** The pet who is liking the post */
  likingPet: StrangerPet;
  numPostsLiked: Scalars['Int'];
  /** The pet whose post is being liked */
  pet: Pet;
  textPost: TextPost;
  timestamp: Scalars['DateTime'];
};

export type NotificationFeedVideoPostCommentItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedVideoPostCommentItem';
  comment: Comment;
  /** The pet who commented */
  commentingPet: StrangerPet;
  id: Scalars['ID'];
  /** The pet whose photo was commented on */
  pet: StrangerPet;
  timestamp: Scalars['DateTime'];
  videoPost: VideoPost;
};

export type NotificationFeedVideoPostCommentLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedVideoPostCommentLikedItem';
  comment: Comment;
  id: Scalars['ID'];
  /** The pet who liked the comment */
  likingPet: StrangerPet;
  /** The pet whose post was commented on */
  pet: Pet;
  timestamp: Scalars['DateTime'];
  videoPost: VideoPost;
};

export type NotificationFeedVideoPostLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedVideoPostLikedItem';
  id: Scalars['ID'];
  /** The pet who is liking the post */
  likingPet: StrangerPet;
  numPostsLiked: Scalars['Int'];
  /** The pet whose post is being liked */
  pet: Pet;
  timestamp: Scalars['DateTime'];
  videoPost: VideoPost;
};

/** DEPRECATED */
export type NotificationFeedWalkClappedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedWalkClappedItem';
  /** The pet who gave the clap */
  clappingPet: StrangerPet;
  id: Scalars['ID'];
  /** The pet whose walk got a clap */
  pet: Pet;
  timestamp: Scalars['DateTime'];
  walk: StrangerWalk;
};

export type NotificationFeedWalkLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedWalkLikedItem';
  id: Scalars['ID'];
  /** The pet who gave the like */
  likingPet: StrangerPet;
  /** The pet whose walk got a like */
  pet: Pet;
  timestamp: Scalars['DateTime'];
  walk: StrangerWalk;
};

export type NotificationLog = SentPushNotificationLog | SentSMSNotificationLog | SuppressedNotificationLog;

export type NotificationLogDocument = {
  __typename?: 'NotificationLogDocument';
  channel: Scalars['String'];
  msg: Scalars['String'];
  notificationCategory?: Maybe<Scalars['String']>;
  notificationMessage: Scalars['String'];
  notificationType: Scalars['String'];
  petId?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  shouldShowBadge?: Maybe<Scalars['Boolean']>;
  timestamp: Scalars['DateTime'];
  twilio?: Maybe<Scalars['Boolean']>;
  userId: Scalars['Int'];
};

export type NotificationLogsForUserInput = {
  dateRange: DateRangeInput;
  includeSuppressed?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  notificationTypes?: InputMaybe<Array<Scalars['String']>>;
  petIds?: InputMaybe<Array<Scalars['Int']>>;
  userId: Scalars['Int'];
};

export type NotificationLogsForUserResult = {
  __typename?: 'NotificationLogsForUserResult';
  logs: Array<NotificationLog>;
};

export type NotificationReportInput = {
  feedback: Scalars['String'];
  notificationId: Scalars['ID'];
  petId?: InputMaybe<Scalars['ID']>;
};

export type NotifyNearbyUsersResult = {
  __typename?: 'NotifyNearbyUsersResult';
  /** Error message if the operation failed, null otherwise. */
  error?: Maybe<Scalars['String']>;
  /**
   * Estimated number of notifications that will be sent.
   * This is an estimate based on user IDs before processing.
   * The actual count may differ due to notification failures or filtering.
   */
  notificationsSent: Scalars['Int'];
  /** Whether the operation was successful. */
  success: Scalars['Boolean'];
};

export type NumberFeatureFlag = FeatureFlag & {
  __typename?: 'NumberFeatureFlag';
  accessedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  dynamicSettingName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  numberValue: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type OAuthSetupDetails = {
  __typename?: 'OAuthSetupDetails';
  authorizeUrl: Scalars['String'];
  clientId: Scalars['Int'];
  redirectUrl: Scalars['String'];
  scope: Scalars['String'];
};

export type ObfuscatedCardInfo = {
  __typename?: 'ObfuscatedCardInfo';
  lastFour: Scalars['Int'];
  month: Scalars['Int'];
  type: Scalars['String'];
  year: Scalars['Int'];
};

export enum ObfuscatedReason {
  HAS_ACCESS = 'HAS_ACCESS',
  NO_ACCESS = 'NO_ACCESS',
  NO_SUBSCRIPTION = 'NO_SUBSCRIPTION'
}

export enum OfflineCollarDuration {
  /** Offline for > 30 minutes. */
  LONG = 'LONG',
  /** Offline for <= 30 minutes. */
  SHORT = 'SHORT'
}

/** Encapsulates any state associated with the collar being offline */
export type OfflineCollarStatus = {
  __typename?: 'OfflineCollarStatus';
  /** Indication of how long the collar has been offline. */
  offlineDuration: OfflineCollarDuration;
  /** Whether the system believes the collar is offline due to being out of power */
  outOfBattery: Scalars['Boolean'];
};

/**
 * An onboarding session is a period of time during which a user is using the app to activate a device. This is for
 * retrieving handset logs for a specific period of time during an onboarding session.
 */
export type OnboardingSession = {
  __typename?: 'OnboardingSession';
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type OngoingActivity = {
  address?: Maybe<Scalars['String']>;
  areaName?: Maybe<Scalars['String']>;
  atDogPark?: Maybe<DogPark>;
  cityState?: Maybe<Scalars['String']>;
  debugMetadata: Scalars['JSON'];
  lastReportTimestamp: Scalars['DateTime'];
  neighborhood?: Maybe<Scalars['String']>;
  obfuscated: Scalars['Boolean'];
  obfuscatedReason: ObfuscatedReason;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']>;
  shouldShowDuration?: Maybe<Scalars['Boolean']>;
  start: Scalars['DateTime'];
  totalSteps: Scalars['Int'];
  uncertaintyInfo?: Maybe<UncertaintyInfo>;
};

export type OngoingRest = OngoingActivity & {
  __typename?: 'OngoingRest';
  actualSegmentTypeForDebug: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  allPositionsForDebug?: Maybe<Array<Position>>;
  areaName?: Maybe<Scalars['String']>;
  atDogPark?: Maybe<DogPark>;
  cityState?: Maybe<Scalars['String']>;
  debugMetadata: Scalars['JSON'];
  lastReportTimestamp: Scalars['DateTime'];
  location: Location;
  neighborhood?: Maybe<Scalars['String']>;
  obfuscated: Scalars['Boolean'];
  obfuscatedReason: ObfuscatedReason;
  place?: Maybe<Place>;
  /** @deprecated Use location instead */
  position: Position;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']>;
  shouldShowDuration?: Maybe<Scalars['Boolean']>;
  start: Scalars['DateTime'];
  totalSteps: Scalars['Int'];
  uncertaintyInfo?: Maybe<UncertaintyInfo>;
};

export type OngoingWalk = OngoingActivity & {
  __typename?: 'OngoingWalk';
  address?: Maybe<Scalars['String']>;
  areaName?: Maybe<Scalars['String']>;
  atDogPark?: Maybe<DogPark>;
  cityState?: Maybe<Scalars['String']>;
  debugMetadata: Scalars['JSON'];
  distance: Scalars['Float'];
  lastReportTimestamp: Scalars['DateTime'];
  neighborhood?: Maybe<Scalars['String']>;
  obfuscated: Scalars['Boolean'];
  obfuscatedReason: ObfuscatedReason;
  path: Array<Position>;
  positions: Array<Location>;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']>;
  shouldShowDuration?: Maybe<Scalars['Boolean']>;
  start: Scalars['DateTime'];
  totalSteps: Scalars['Int'];
  uncertaintyInfo?: Maybe<UncertaintyInfo>;
};

/** Encapsulates any state associated with the collar being online */
export type OnlineCollarStatus = {
  __typename?: 'OnlineCollarStatus';
  state: OnlineConnectionState;
};

export type OnlineConnectionState = ConnectedToBase | ConnectedToCellular | ConnectedToUser | ConnectedToWifi;

export type OperationParams = {
  __typename?: 'OperationParams';
  /** @deprecated Not used */
  gnssLongTimeout?: Maybe<Scalars['Int']>;
  /** @deprecated Not used */
  gnssMaxAcceptableRadiusM?: Maybe<Scalars['Float']>;
  /** @deprecated Not used */
  gnssMinAcceptableSatellites?: Maybe<Scalars['Int']>;
  /**
   * Unused, delete once clients stop asking for them.
   * @deprecated Not used
   */
  gnssShortTimeout?: Maybe<Scalars['Int']>;
  ledEnabled?: Maybe<Scalars['Boolean']>;
  ledOffAt?: Maybe<Scalars['DateTime']>;
  mode?: Maybe<OperationParamsMode>;
  reboot?: Maybe<Scalars['Boolean']>;
  remoteLogLevel?: Maybe<RemoteLogLevel>;
  requestLppp?: Maybe<Scalars['Boolean']>;
  updateFrequency?: Maybe<Scalars['Int']>;
  updateFrequencyNoActivity?: Maybe<Scalars['Int']>;
  wifiDisabled?: Maybe<Scalars['Boolean']>;
};

export enum OperationParamsMode {
  DORMANT = 'DORMANT',
  EAGER = 'EAGER',
  LOST_DOG = 'LOST_DOG',
  NORMAL = 'NORMAL',
  POST_ESCAPE_NOTIFICATION = 'POST_ESCAPE_NOTIFICATION'
}

export type Order = {
  __typename?: 'Order';
  bigCommerceOrderId?: Maybe<Scalars['String']>;
  billingInfo?: Maybe<BillingInfo>;
  canBeCanceled: Scalars['Boolean'];
  channel?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customerOrderNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inPersonEvent?: Maybe<InPersonEvent>;
  internalOrderCreatorEmail?: Maybe<Scalars['String']>;
  internalOrderNotes?: Maybe<Scalars['String']>;
  internalOrderPartnerName?: Maybe<Scalars['String']>;
  internalOrderSubscriptionOverrideMonths?: Maybe<Scalars['Int']>;
  lineItems: Array<OrderLineItem>;
  orderDate: Scalars['DateTime'];
  orderSource: OrderSource;
  orderSourceId: Scalars['String'];
  poNumber?: Maybe<Scalars['String']>;
  shipments: Array<OrderShipment>;
  shippingAddress: ShippingAddress;
  shippingOption: ShippingOption;
  status: OrderStatus;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<StrangerUser>;
};

export enum OrderChannel {
  CONSIGNMENT_RETAIL = 'CONSIGNMENT_RETAIL',
  COSTCO_ROADSHOW = 'COSTCO_ROADSHOW',
  INVENTORY_TO_OFFICE = 'INVENTORY_TO_OFFICE',
  MARKETING_EVENT = 'MARKETING_EVENT',
  OTHER = 'OTHER',
  POLICE_DEPARTMENT = 'POLICE_DEPARTMENT',
  RESCUE = 'RESCUE',
  VERIZON = 'VERIZON',
  WHOLESALE = 'WHOLESALE'
}

export type OrderHistoryLineItem = {
  __typename?: 'OrderHistoryLineItem';
  description: Scalars['String'];
  quantity: Scalars['Int'];
  serialNumber?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
};

export type OrderHistoryPackage = {
  __typename?: 'OrderHistoryPackage';
  deliveredAt?: Maybe<Scalars['DateTime']>;
  deliveryStatus?: Maybe<Scalars['String']>;
  estimatedDeliveryDate?: Maybe<Scalars['DateTime']>;
  shippingCarrierCode: Scalars['String'];
  trackingNumber: Scalars['String'];
  trackingUrl?: Maybe<Scalars['String']>;
};

export type OrderHistoryResult = {
  __typename?: 'OrderHistoryResult';
  invoiceNumber: Scalars['String'];
  lineItems: Array<OrderHistoryLineItem>;
  orderDate: Scalars['DateTime'];
  packages: Array<OrderHistoryPackage>;
  shippingAddress: ShippingAddress;
  shippingOption: ShippingOption;
  status: OrderHistoryStatus;
};

export enum OrderHistoryStatus {
  AWAITING_SHIPMENT = 'AWAITING_SHIPMENT',
  BACKORDERED = 'BACKORDERED',
  CANCELED = 'CANCELED',
  DELIVERED = 'DELIVERED',
  SHIPPED = 'SHIPPED'
}

export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  orderSourceLineNumber?: Maybe<Scalars['String']>;
  productDescription?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  sku: Scalars['String'];
  status: OrderLineItemStatus;
  updatedAt: Scalars['DateTime'];
};

export enum OrderLineItemStatus {
  BACKORDERED = 'BACKORDERED',
  CANCELED = 'CANCELED',
  PENDING = 'PENDING',
  RELEASED = 'RELEASED'
}

export type OrderShipment = {
  __typename?: 'OrderShipment';
  createdAt: Scalars['DateTime'];
  fulfillmentProviderOrderNumber: Scalars['String'];
  fulfillmentWarehouse: FulfillmentWarehouse;
  id: Scalars['ID'];
  lineItems: Array<OrderShipmentLineItem>;
  packages: Array<OrderShipmentPackage>;
  shippedAt?: Maybe<Scalars['DateTime']>;
  shippingAddress: ShippingAddress;
  shippingOption: ShippingOption;
  status: OrderShipmentStatus;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type OrderShipmentLineItem = {
  __typename?: 'OrderShipmentLineItem';
  allSerialsReturned: Scalars['Boolean'];
  id: Scalars['ID'];
  orderLineItem?: Maybe<OrderLineItem>;
  productDescription?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  serialNumbers: Array<Scalars['String']>;
  sku: Scalars['String'];
  status: OrderShipmentLineItemStatus;
};

export enum OrderShipmentLineItemStatus {
  AWAITING_SHIPMENT = 'AWAITING_SHIPMENT',
  CANCELED = 'CANCELED',
  SHIPPED = 'SHIPPED'
}

export type OrderShipmentPackage = {
  __typename?: 'OrderShipmentPackage';
  deliveredAt?: Maybe<Scalars['String']>;
  deliveryStatus?: Maybe<Scalars['String']>;
  shippingCarrier?: Maybe<Scalars['String']>;
  shippingMethod?: Maybe<Scalars['String']>;
  trackingNumber: Scalars['String'];
};

export enum OrderShipmentStatus {
  AWAITING_RELEASE = 'AWAITING_RELEASE',
  AWAITING_SHIPMENT = 'AWAITING_SHIPMENT',
  CANCELED = 'CANCELED',
  DELIVERED = 'DELIVERED',
  PENDING = 'PENDING',
  RELEASED = 'RELEASED',
  SHIPPED = 'SHIPPED'
}

export type OrderShippingAddressInput = {
  city: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export enum OrderSource {
  AMAZON = 'AMAZON',
  CHEWY = 'CHEWY',
  COSTCO = 'COSTCO',
  COSTCO_ROADSHOW = 'COSTCO_ROADSHOW',
  FLIP = 'FLIP',
  HSN = 'HSN',
  INTERNAL = 'INTERNAL',
  MANUAL = 'MANUAL',
  PETSMART = 'PETSMART',
  PETWATCH = 'PETWATCH',
  PET_RESORTS = 'PET_RESORTS',
  RACHIO = 'RACHIO',
  RECURLY = 'RECURLY',
  RESCUE = 'RESCUE',
  RETAIL = 'RETAIL',
  STUNTPUPPY = 'STUNTPUPPY'
}

export enum OrderStatus {
  BACKORDERED = 'BACKORDERED',
  CANCELED = 'CANCELED',
  COMPLETE = 'COMPLETE',
  ON_HOLD = 'ON_HOLD',
  PARTIALLY_RELEASED = 'PARTIALLY_RELEASED',
  PENDING = 'PENDING',
  RELEASED = 'RELEASED'
}

export type OrdersQueryInput = {
  customerOrderNumber?: InputMaybe<Scalars['String']>;
  endOrderDate?: InputMaybe<Scalars['DateTime']>;
  inPersonEventUuid?: InputMaybe<Scalars['String']>;
  orderSources?: InputMaybe<Array<OrderSource>>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  search?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  shipmentStatuses?: InputMaybe<Array<OrderShipmentStatus>>;
  skus?: InputMaybe<Array<Scalars['String']>>;
  startOrderDate?: InputMaybe<Scalars['DateTime']>;
};

export type OvernightRestSummary = {
  date: Scalars['DateTime'];
};

export enum POIType {
  BAR = 'BAR',
  BEACH = 'BEACH',
  BOARDING = 'BOARDING',
  DOG_CLUB = 'DOG_CLUB',
  DOG_PARK = 'DOG_PARK',
  NATURE_RESERVE = 'NATURE_RESERVE',
  OTHER = 'OTHER',
  PARK = 'PARK'
}

export type Pack = BasePack & {
  __typename?: 'Pack';
  actingPetCanJoin: Scalars['Boolean'];
  actingPetCanLeave: Scalars['Boolean'];
  actingPetCannotJoinReason?: Maybe<Scalars['String']>;
  actingPetDidManuallyJoin: Scalars['Boolean'];
  actingPetIsMember: Scalars['Boolean'];
  actingPetMembershipReason: Scalars['String'];
  ageFiltersWithEnoughRankedPets: Array<PackAgeFilter>;
  avatar: PackAvatar;
  category: PackCategory;
  dbId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  /** @deprecated Packs Phase 1 made fiHandle nullable */
  fiHandle: Scalars['String'];
  /**
   * A 6-digit hex color code, including # sign, and letters lowercase (eg.
   * `#ff00b1`) used to highlight this pack in the app.
   */
  highlightColorHex?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Use category instead */
  isAllFiDogsPack: Scalars['Boolean'];
  /** @deprecated Use category instead */
  isLocationPack: Scalars['Boolean'];
  isManaged: Scalars['Boolean'];
  joinPackUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use packMemberFeed instead */
  members: StrangerPetFeed;
  name: Scalars['String'];
  /** @deprecated Use packMemberFeed instead */
  pendingMembers: StrangerPetFeed;
  petRanking: PackRanking;
  photo?: Maybe<Photo>;
  /** @deprecated Use totalRankedSteps instead */
  totalMonthlySteps: Scalars['Int'];
  totalRankedPets: Scalars['Int'];
  /**
   * A 64-bit integer representing the total steps for all pets in this pack for
   * the latest ranking period returned as a String.
   */
  totalRankedSteps: Scalars['String'];
};


export type PackpetRankingArgs = {
  packAgeFilter?: InputMaybe<PackAgeFilter>;
  petId: Scalars['ID'];
};

export enum PackAgeFilter {
  ADULT = 'ADULT',
  ALL = 'ALL',
  PUPPY = 'PUPPY',
  SENIOR = 'SENIOR'
}

export type PackAvatar = AvatarAbbreviation | AvatarImage;

export enum PackCategory {
  ALL_FI_DOGS = 'ALL_FI_DOGS',
  BREED = 'BREED',
  GEO = 'GEO',
  MY_PACK = 'MY_PACK',
  ORGANIZATION = 'ORGANIZATION',
  OTHER = 'OTHER'
}

export type PackFeed = {
  __typename?: 'PackFeed';
  packs: Array<Pack>;
  pageInfo: PageInfo;
};

export type PackMember = {
  __typename?: 'PackMember';
  /**
   * Only present for members of the "Your Pack" pack.
   * "Your Pack" pack without any members will be empty array.
   */
  ownersContactInfo?: Maybe<Array<PackMemberContactInfo>>;
  pet: StrangerPet;
  /** Empty when pet does not have a ranking */
  ranking?: Maybe<PackRanking>;
};

/** For the "Your Pack" pack, this is the contact info for the pet's owner. */
export type PackMemberContactInfo = {
  __typename?: 'PackMemberContactInfo';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type PackMemberFeed = {
  __typename?: 'PackMemberFeed';
  members: Array<PackMember>;
  pageInfo: PageInfo;
  tokenValidity: TokenValidity;
};

export type PackRanking = {
  __typename?: 'PackRanking';
  isPending: Scalars['Boolean'];
  points: PackRankingPoints;
  rankChange?: Maybe<RankChange>;
  rankNumber: Scalars['Int'];
  rankPercentile: Scalars['Int'];
  stepCount: Scalars['Int'];
};

export type PackRankingPoints = {
  __typename?: 'PackRankingPoints';
  /** Points before any bonuses are added */
  basePoints: Scalars['Int'];
  /** Total bonus points granted from any source (currently only streaks) */
  totalBonusPoints: Scalars['Int'];
  /** Combination of base points and bonus points */
  totalPoints: Scalars['Int'];
};

/** Padding is in pixels */
export type PaddingInput = {
  bottom: Scalars['Int'];
  left: Scalars['Int'];
  right: Scalars['Int'];
  top: Scalars['Int'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** Pass this as `before` to paginate backwards in time. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Pass this as `after` to paginate forwards in time. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginatedPhotoFeed = {
  __typename?: 'PaginatedPhotoFeed';
  feedItems: Array<Photo>;
  pageInfo: PageInfo;
};

/**
 * The semantics of PagingDirection are ambiguous depending on the context of its
 * use. In time-based paging scenarios, "forward" refers to moving forward in
 * time (more recent) whereas "backwards" is correspondingly backwards in time
 * (less recent). For most "feeds", the implementation has the user scrolling
 * down on the device from the most recent data towards older data ("backwards").
 * When implementing a time-based feed of data, these semantics make sense.
 *
 * However when implementing paging in non-time-based contexts (browsing
 * alphabetically, browsing by rank, etc) this temporal reasoning is abandoned
 * and instead we must think about "BACKWARDS" meaning scrolling down further
 * into the list of items, and "FORWARDS" meaning scrolling up. This is not
 * intuitive but keeps the client logic for scrolling in time-based feeds and
 * other forms of pagination consistent.
 */
export enum PagingDirection {
  /** endCursor on PageInfo + BACKWARD scrolls 'down' */
  BACKWARD = 'BACKWARD',
  /** startCursor on PageInfo + FORWARD scrolls 'up' */
  FORWARD = 'FORWARD'
}

export type PagingInstruction = {
  cursor: Scalars['String'];
  direction: PagingDirection;
};

export type PathProcessingDataForDebug = {
  __typename?: 'PathProcessingDataForDebug';
  errors: Array<Scalars['String']>;
  steps: Array<PathProcessingStepForDebug>;
};

export type PathProcessingStepForDebug = {
  __typename?: 'PathProcessingStepForDebug';
  details?: Maybe<Scalars['JSON']>;
  geoJson: Scalars['JSON'];
  name: Scalars['String'];
};

export type PauseMembershipInput = {
  moduleId: Scalars['String'];
  numTerms: Scalars['Int'];
  recurlySubscriptionId: Scalars['String'];
};

export type PauseMembershipResult = {
  __typename?: 'PauseMembershipResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type PayPalInfo = {
  __typename?: 'PayPalInfo';
  billingAgreementId?: Maybe<Scalars['String']>;
};

export type PaymentInfo = ObfuscatedCardInfo | PayPalInfo;

export type PercentageOfUsersBooleanSetting = BooleanSetting & {
  __typename?: 'PercentageOfUsersBooleanSetting';
  percentage: Scalars['Int'];
  platformOverrides: Array<BooleanSettingPlatformOverride>;
};

export type PermissionMobileAppContent = {
  __typename?: 'PermissionMobileAppContent';
  blockerScreen: MobileAppPermissionBlockerScreen;
  permissionType: Scalars['String'];
};

export type Pet = BasePet & {
  __typename?: 'Pet';
  activitiesForRange: ActivitiesForRangeResult;
  activity: Activity;
  activityFeed: ActivityFeed;
  /** `after` is exclusive. */
  activityIntensities: Array<ActivityIntensity>;
  /** @deprecated Use pet.stepFeed */
  activitySummaryFeed: ActivitySummaryFeed;
  additionalInfo?: Maybe<Scalars['String']>;
  ageRange: AgeRange;
  /** @deprecated Use notificationSettings */
  alertPreferences: PetAlertPreferences;
  alertsEnabled: Scalars['Boolean'];
  breed?: Maybe<Breed>;
  /**
   * Return a feed of this Pet's cards.
   * Pass `endCursor` to `before` to paginate backwards in time.
   * Pass `startCursor` to `after` to paginate forwards in time.
   * Results are always returned in descending chronological order (most recent first).
   */
  cardFeed: CardFeed;
  chip?: Maybe<AssignedChip>;
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currentActivityIntensity: ActivityIntensity;
  currentActivitySummary: ActivitySummary;
  dayOfBirth?: Maybe<Scalars['Int']>;
  dbId: Scalars['Int'];
  debugActivitiesLastNDays: Scalars['Int'];
  deleted: Scalars['Boolean'];
  device?: Maybe<Device>;
  discoverPostFeed: PetDiscoverFeed;
  fiHandle?: Maybe<Scalars['String']>;
  followers: StrangerPetFeed;
  following: StrangerPetFeed;
  gender: Gender;
  hasSleepData: Scalars['Boolean'];
  /** @deprecated Use homeLocation instead */
  homeCityState?: Maybe<Scalars['String']>;
  homeLocation?: Maybe<PetHomeLocation>;
  household: Household;
  id: Scalars['ID'];
  instagramHandle?: Maybe<Scalars['String']>;
  isEligibleForHealthReport: Scalars['Boolean'];
  isIncludedInRanking: Scalars['Boolean'];
  isPurebred: Scalars['Boolean'];
  lastLocation?: Maybe<Location>;
  lastOvernightRestSummary: OvernightRestSummary;
  latestStepActivity?: Maybe<StepActivity>;
  monthOfBirth?: Maybe<Scalars['Int']>;
  /** Pack containing this pet and the owners contacts */
  myPack?: Maybe<VirtualPack>;
  name: Scalars['String'];
  notificationSettings: Array<PetNotificationSetting>;
  ongoingActivity?: Maybe<OngoingActivity>;
  overnightRestSummary: OvernightRestSummary;
  packFeed: PackFeed;
  packs: Array<Pack>;
  /** Returns a chip for which there is an outstanding transfer associated with this Pet. */
  pendingChip?: Maybe<StrangerChip>;
  /** The step count distribution specific to this pet's age and breed */
  personalizedStepCountDistribution?: Maybe<StepCountDistribution>;
  petCollarState: PetCollarState;
  photos: PhotoFeed;
  places: Array<Place>;
  /** Product features that are available for this pet. These may be based on pet species, breed, or other factors. */
  productAvailability: Array<ProductAvailability>;
  publicProfile?: Maybe<PublicProfileSharing>;
  renderDebugActivitySegments: RenderedDebugActivitySegments;
  /** Rescue transfer record: only returned for rescue users, one of PetTemporaryTransfer OR PetAdoptionTransfer */
  rescueTransfer?: Maybe<RescueTransfer>;
  restFeed: RestFeed;
  restSegmentsForRange: Array<RestSegment>;
  /** @deprecated Use pet.restFeed */
  restSummaryFeed: RestSummaryFeed;
  secondaryDevice?: Maybe<Device>;
  /** Current snooze status for this pet. */
  snoozeStatus: PetSnoozeStatus;
  species?: Maybe<Species>;
  stepActivityInfo: StepActivityInfo;
  /**
   * Added to support Activity/Rest UI refresh in June 2024.
   * https://docs.google.com/document/d/1T2qpG0_E1QC-k0gq7A0Cp-sfqkKDAyQNuMrB9zTLv2U/edit#heading=h.2rmuizvwm3bv
   */
  stepFeed: StepFeed;
  /** The pet's current daily step goal. */
  stepGoal: Scalars['Int'];
  /** Returns the average strain score for all Fi dogs. */
  strainScoreAverageAllDogs?: Maybe<StrainScoreAverage>;
  /** Returns average strain score over last 60 days. */
  strainScoreAveragePast60Days?: Maybe<StrainScoreAverage>;
  /** Returns the average strain score over all "similar" dogs (same breed + age) */
  strainScoreAverageSimilarDogs?: Maybe<StrainScoreAverage>;
  /**
   * Returns 24 buckets, one per hour, of strain scores (if available) on specified day.
   *
   * The `day` argument should be null to retrieve today's score.
   * To page back into the past, set `day` to be the `nextCursor` string provided in the
   * StrainScoreResult.
   *
   * Returned strain scores are *not* rounded.
   * @deprecated Use pet.strainFeed
   */
  strainScoreHourly?: Maybe<StrainScoreResult>;
  streakHistoryFeed: StreakHistoryFeed;
  tenancy?: Maybe<Scalars['String']>;
  thirdPartyAccess?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  /** Total number of likes for this pet, across walks, photos, etc. */
  totalLikes: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  weight: Scalars['Float'];
  yearOfBirth: Scalars['Int'];
};


export type PetactivitiesForRangeArgs = {
  after: Scalars['DateTime'];
  before?: InputMaybe<Scalars['DateTime']>;
  includeAll?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type PetactivityArgs = {
  id: Scalars['ID'];
  walksVersion?: InputMaybe<Scalars['Int']>;
};


export type PetactivityFeedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  includeAll?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  typeFilter?: InputMaybe<Array<ActivityType>>;
  walksVersion?: InputMaybe<Scalars['Int']>;
};


export type PetactivityIntensitiesArgs = {
  after: Scalars['DateTime'];
  before?: InputMaybe<Scalars['DateTime']>;
  stride?: InputMaybe<Scalars['Int']>;
};


export type PetactivitySummaryFeedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  period: ActivitySummaryPeriod;
};


export type PetcardFeedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type PetcurrentActivityIntensityArgs = {
  stride?: InputMaybe<Scalars['Int']>;
};


export type PetcurrentActivitySummaryArgs = {
  period: ActivitySummaryPeriod;
};


export type PetdiscoverPostFeedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type PetfollowersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type PetfollowingArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type PetnotificationSettingsArgs = {
  category?: InputMaybe<PetNotificationSettingCategory>;
  forUserId?: InputMaybe<Scalars['ID']>;
};


export type PetongoingActivityArgs = {
  walksVersion?: InputMaybe<Scalars['Int']>;
};


export type PetovernightRestSummaryArgs = {
  date: Scalars['DateTime'];
};


export type PetrenderDebugActivitySegmentsArgs = {
  input: Scalars['JSON'];
};


export type PetrestFeedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  period: ActivityRestStrainPeriod;
};


export type PetrestSegmentsForRangeArgs = {
  after: Scalars['DateTime'];
  before?: InputMaybe<Scalars['DateTime']>;
};


export type PetrestSummaryFeedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  period: ActivitySummaryPeriod;
};


export type PetstepFeedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  period: ActivityRestStrainPeriod;
};


export type PetstrainScoreHourlyArgs = {
  day?: InputMaybe<Scalars['String']>;
};


export type PetstreakHistoryFeedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
};

export type PetAdoptionTransfer = {
  __typename?: 'PetAdoptionTransfer';
  completedAt?: Maybe<Scalars['DateTime']>;
  completedBy?: Maybe<User>;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  fromHousehold: Household;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  pet: Pet;
  status: PetAdoptionTransferStatus;
  toHousehold: Household;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['ID'];
};

export enum PetAdoptionTransferStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  RESCUE_RESOLVED = 'RESCUE_RESOLVED'
}

export type PetAlertPreferences = {
  __typename?: 'PetAlertPreferences';
  notificationMode: PetNotificationMode;
  /** A value of 0 means these notifications are turned off. */
  numMinutesForOfflineNotification: Scalars['Int'];
};

export enum PetBehaviorChangeDirection {
  DOWN = 'DOWN',
  NONE = 'NONE',
  UP = 'UP'
}

export type PetBehaviorDetail = PetBehaviorDetailDay | PetBehaviorDetailMonth | PetBehaviorDetailWeek | PetBehaviorDetailYear;

export type PetBehaviorDetailComparison = {
  __typename?: 'PetBehaviorDetailComparison';
  changeAmount: Scalars['String'];
  description: FormatString;
  direction: PetBehaviorChangeDirection;
  graph: PetBehaviorDetailComparisonGraph;
};

export type PetBehaviorDetailComparisonGraph = {
  __typename?: 'PetBehaviorDetailComparisonGraph';
  /**
   * Indicates the end of data.
   * There may be future time indicated by this value being less than `length`
   */
  currentPeriodDataEnd?: Maybe<Scalars['Float']>;
  currentPeriodDataEndText?: Maybe<Scalars['String']>;
  currentPeriodDescription: Scalars['String'];
  currentPeriodIntervals: Array<PetBehaviorDetailComparisonGraphInterval>;
  currentPeriodLabel: Scalars['String'];
  previousPeriodDescription: Scalars['String'];
  previousPeriodIntervals: Array<PetBehaviorDetailComparisonGraphInterval>;
  previousPeriodLabel: Scalars['String'];
  xAxisLabels: Array<Maybe<Scalars['String']>>;
};

/** Values are normalized between 0 and 1 */
export type PetBehaviorDetailComparisonGraphInterval = {
  __typename?: 'PetBehaviorDetailComparisonGraphInterval';
  offset: Scalars['Float'];
  value: Scalars['Float'];
};

export type PetBehaviorDetailDay = BasePetBehaviorDetail & {
  __typename?: 'PetBehaviorDetailDay';
  behaviorId: Scalars['String'];
  behaviorLabel: Scalars['String'];
  color: Scalars['HexColorCode'];
  comparison: PetBehaviorDetailComparison;
  cursor: Scalars['String'];
  durationLabel: Scalars['String'];
  durationText: Scalars['String'];
  durationTextColor?: Maybe<Scalars['HexColorCode']>;
  eventCountLabel: Scalars['String'];
  eventCountText: Scalars['String'];
  eventCountTextColor: Scalars['HexColorCode'];
  graph: PetBehaviorDetailGraph;
  help: PetBehaviorDetailHelp;
  icon: Image;
  nextCursor?: Maybe<Scalars['String']>;
  period: PetBehaviorPeriod;
  previousCursor?: Maybe<Scalars['String']>;
  /** A human readable label for this period of time */
  rangeLabel: Scalars['String'];
  segmentedTimeline: PetBehaviorDetailSegmentedTimeline;
};

export type PetBehaviorDetailGraph = {
  __typename?: 'PetBehaviorDetailGraph';
  average: Scalars['Float'];
  intervals: Array<PetBehaviorDetailGraphInterval>;
  maxValueText: Scalars['String'];
  xAxisLabels: Array<Scalars['String']>;
};

export type PetBehaviorDetailGraphInterval = {
  __typename?: 'PetBehaviorDetailGraphInterval';
  inFuture: Scalars['Boolean'];
  /** Will be true if the current interval is incomplete (current day) */
  isIncomplete: Scalars['Boolean'];
  /** Optional overlay value for dual-bar visualization (normalized between 0 and 1) */
  overlayValue?: Maybe<Scalars['Float']>;
  tooltip?: Maybe<PetBehaviorDetailGraphIntervalTooltip>;
  /** Values are normalized between 0 and 1 */
  value: Scalars['Float'];
};

export type PetBehaviorDetailGraphIntervalTooltip = {
  __typename?: 'PetBehaviorDetailGraphIntervalTooltip';
  /**
   * Duration text like "22m 3s" or "1hr 20m"
   * @deprecated Use eventLabelSecondary instead
   */
  duration: Scalars['String'];
  /** Event type label like "Sleep", "Nap", "Active time", "Walk" */
  eventLabel: Scalars['String'];
  /** Event details like "22m 3s", "Walk 1.2mi", "22m • 2.2k steps" */
  eventLabelSecondary: Scalars['String'];
  /** Timestamp like "8:01AM" */
  timestamp: Scalars['String'];
};

export type PetBehaviorDetailHelp = {
  __typename?: 'PetBehaviorDetailHelp';
  buttonText: Scalars['String'];
  description: Scalars['String'];
  title: Scalars['String'];
};

/** Indicates the type of interval in a segmented timeline */
export enum PetBehaviorDetailIntervalType {
  /** An interval where the device was off the pet */
  DEVICE_OFF = 'DEVICE_OFF',
  /** An interval representing detected behavior events (eg barking, sleeping, activity) */
  EVENT = 'EVENT',
  /** An interval with no detected behavior events */
  NOTHING = 'NOTHING'
}

export type PetBehaviorDetailMonth = BasePetBehaviorDetail & {
  __typename?: 'PetBehaviorDetailMonth';
  behaviorId: Scalars['String'];
  behaviorLabel: Scalars['String'];
  color: Scalars['HexColorCode'];
  comparison: PetBehaviorDetailComparison;
  cursor: Scalars['String'];
  durationLabel: Scalars['String'];
  durationText: Scalars['String'];
  durationTextColor?: Maybe<Scalars['HexColorCode']>;
  eventCountLabel: Scalars['String'];
  eventCountText: Scalars['String'];
  eventCountTextColor: Scalars['HexColorCode'];
  graph: PetBehaviorDetailGraph;
  help: PetBehaviorDetailHelp;
  icon: Image;
  nextCursor?: Maybe<Scalars['String']>;
  period: PetBehaviorPeriod;
  previousCursor?: Maybe<Scalars['String']>;
  /** A human readable label for this period of time */
  rangeLabel: Scalars['String'];
};

export type PetBehaviorDetailSegmentedTimeline = {
  __typename?: 'PetBehaviorDetailSegmentedTimeline';
  /**
   * Indicates the end of data.
   * There may be future time indicated by this value being less than `length`
   */
  dataEnd?: Maybe<Scalars['Float']>;
  dataEndText?: Maybe<Scalars['String']>;
  /** Optional data markers to overlay on the timeline (e.g., sun icon at wake-up time, moon icon at bedtime) */
  dataMarkers?: Maybe<Array<PetBehaviorDetailSegmentedTimelineDataMarker>>;
  intervals: Array<PetBehaviorDetailSegmentedTimelineInterval>;
  /** Will be null if there is only one timeline being returned */
  label?: Maybe<Scalars['String']>;
  /** Will be null if time period is complete and there is no future time */
  lastUpdatedText?: Maybe<Scalars['String']>;
  length: Scalars['Float'];
  xAxisLabels: Array<Maybe<Scalars['String']>>;
};

/**
 * A marker that can be overlaid on a segmented timeline to indicate specific events
 * such as wake-up time (sun icon) or bedtime (moon icon)
 */
export type PetBehaviorDetailSegmentedTimelineDataMarker = {
  __typename?: 'PetBehaviorDetailSegmentedTimelineDataMarker';
  /** Icon to display at the marker position */
  labelIcon: Image;
  /** Text label to display next to the marker (e.g., "8:47AM") */
  labelText: Scalars['String'];
  /** Offset in seconds from the start of the timeline where the marker should appear */
  offset: Scalars['Float'];
};

export type PetBehaviorDetailSegmentedTimelineInterval = {
  __typename?: 'PetBehaviorDetailSegmentedTimelineInterval';
  color: Scalars['HexColorCode'];
  /** The type of interval (e.g., activity, rest, device off). */
  intervalType: PetBehaviorDetailIntervalType;
  length: Scalars['Float'];
  offset: Scalars['Float'];
  tooltip?: Maybe<PetBehaviorDetailSegmentedTimelineIntervalTooltip>;
};

export type PetBehaviorDetailSegmentedTimelineIntervalTooltip = {
  __typename?: 'PetBehaviorDetailSegmentedTimelineIntervalTooltip';
  /**
   * Duration text like "22m 3s" or "1hr 20m"
   * @deprecated Use eventLabelSecondary instead
   */
  duration: Scalars['String'];
  /** Event type label like "Sleep", "Nap", "Active time", "Walk" */
  eventLabel: Scalars['String'];
  /** Event details like "22m 3s", "Walk 1.2mi", "22m • 2.2k steps" */
  eventLabelSecondary: Scalars['String'];
  /** Timestamp like "8:01AM" */
  timestamp: Scalars['String'];
};

export type PetBehaviorDetailWeek = BasePetBehaviorDetail & {
  __typename?: 'PetBehaviorDetailWeek';
  behaviorId: Scalars['String'];
  behaviorLabel: Scalars['String'];
  color: Scalars['HexColorCode'];
  comparison: PetBehaviorDetailComparison;
  cursor: Scalars['String'];
  durationLabel: Scalars['String'];
  durationText: Scalars['String'];
  durationTextColor?: Maybe<Scalars['HexColorCode']>;
  eventCountLabel: Scalars['String'];
  eventCountText: Scalars['String'];
  eventCountTextColor: Scalars['HexColorCode'];
  graph: PetBehaviorDetailGraph;
  help: PetBehaviorDetailHelp;
  icon: Image;
  nextCursor?: Maybe<Scalars['String']>;
  period: PetBehaviorPeriod;
  previousCursor?: Maybe<Scalars['String']>;
  /** A human readable label for this period of time */
  rangeLabel: Scalars['String'];
  segmentedTimelines: Array<PetBehaviorDetailSegmentedTimeline>;
};

export type PetBehaviorDetailYear = BasePetBehaviorDetail & {
  __typename?: 'PetBehaviorDetailYear';
  behaviorId: Scalars['String'];
  behaviorLabel: Scalars['String'];
  color: Scalars['HexColorCode'];
  comparison: PetBehaviorDetailComparison;
  cursor: Scalars['String'];
  durationLabel: Scalars['String'];
  durationText: Scalars['String'];
  durationTextColor?: Maybe<Scalars['HexColorCode']>;
  eventCountLabel: Scalars['String'];
  eventCountText: Scalars['String'];
  eventCountTextColor: Scalars['HexColorCode'];
  graph: PetBehaviorDetailGraph;
  help: PetBehaviorDetailHelp;
  icon: Image;
  nextCursor?: Maybe<Scalars['String']>;
  period: PetBehaviorPeriod;
  previousCursor?: Maybe<Scalars['String']>;
  /** A human readable label for this period of time */
  rangeLabel: Scalars['String'];
};

export enum PetBehaviorPeriod {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export enum PetChangeType {
  CARD = 'CARD',
  CURRENT_ACTIVITY = 'CURRENT_ACTIVITY',
  LOCATION = 'LOCATION',
  MODULE_INFO = 'MODULE_INFO',
  ONGOING_ACTIVITY = 'ONGOING_ACTIVITY',
  STATUS = 'STATUS',
  TEST = 'TEST'
}

/** Represents a pet/collar combo's synthesized state at a given moment in time */
export type PetCollarState = {
  /** The moment in time the state represents */
  timestamp: Scalars['DateTime'];
};

export type PetDailyGoalStreakBonus = {
  __typename?: 'PetDailyGoalStreakBonus';
  /** The number of bonus points earned for meeting this goal */
  bonusPoints: Scalars['Int'];
  /** The number of days in a row that pet must meat their step goal to qualify for this bonus */
  streakLengthRequirement: Scalars['Int'];
  /** Indicates whether the pet has or has not met this streak goal */
  streakMet: Scalars['Boolean'];
};

export type PetDiscoverFeed = {
  __typename?: 'PetDiscoverFeed';
  feedItems: Array<PetDiscoverFeedItem>;
  pageInfo: PageInfo;
};

export type PetDiscoverFeedItem = DiscoverFeedPhotoItem | DiscoverFeedTextPostItem | DiscoverFeedVideoPostItem;

export type PetDocument = BasePetDocument & {
  __typename?: 'PetDocument';
  date: Scalars['DateTime'];
  fileName: Scalars['String'];
  fileSizeBytes: Scalars['Int'];
  fileType: Scalars['String'];
  fileUrl: Scalars['String'];
  id: Scalars['ID'];
  isUnseen: Scalars['Boolean'];
  labels?: Maybe<Array<Scalars['String']>>;
  markdownFileUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: PetDocumentStatus;
  summary?: Maybe<Scalars['String']>;
  totalCostCents?: Maybe<Scalars['Int']>;
  type: PetDocumentType;
};

export type PetDocumentFeed = {
  __typename?: 'PetDocumentFeed';
  documents: Array<PetDocument>;
  pageInfo: PageInfo;
  unreadCount: Scalars['Int'];
};

export enum PetDocumentStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  READY = 'READY'
}

export enum PetDocumentType {
  DOCUMENT = 'DOCUMENT',
  PHOTO = 'PHOTO'
}

export type PetHealthInsight = {
  __typename?: 'PetHealthInsight';
  deepLink?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  isFullWidth: Scalars['Boolean'];
  title: Scalars['String'];
};

export type PetHealthTrend = {
  __typename?: 'PetHealthTrend';
  chart: PetHealthTrendChart;
  deepLinkUrl: Scalars['String'];
  /**
   * This is a trend that is not available for the pet's hardware version. This would be false for pets with a S3+ module.
   * A disabled trend will also contain mocked graph/timeline data.
   */
  disabled: Scalars['Boolean'];
  icon: Image;
  id: Scalars['ID'];
  /** Summary of the trend like "4,128 steps/day" or "9hr 55m /day" */
  summaryComponents: PetHealthTrendSummary;
  title: Scalars['String'];
};

export type PetHealthTrendChangeSummary = {
  __typename?: 'PetHealthTrendChangeSummary';
  direction: PetBehaviorChangeDirection;
  icon: Image;
  summary: Scalars['String'];
};

export type PetHealthTrendChart = PetHealthTrendGraph | PetHealthTrendSegmentedTimeline;

export type PetHealthTrendGraph = {
  __typename?: 'PetHealthTrendGraph';
  average: Scalars['Float'];
  color: Scalars['HexColorCode'];
  /** A null value indicates that the value is not available, probably because the time represented by that interval hasn't happened yet */
  intervals: Array<Maybe<Scalars['Float']>>;
  /** The maximum interval value */
  maximum: Scalars['Float'];
  /** The minimum interval value */
  minimum: Scalars['Float'];
  showAverage: Scalars['Boolean'];
};

export enum PetHealthTrendPeriod {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export type PetHealthTrendSegmentedTimeline = {
  __typename?: 'PetHealthTrendSegmentedTimeline';
  /** Indicates the end of data. The timeline may include future time that should be displayed different from time that has passed but has no events */
  dataEnd?: Maybe<Scalars['Int']>;
  intervals: Array<PetHealthTrendSegmentedTimelineInterval>;
  length: Scalars['Int'];
};

export type PetHealthTrendSegmentedTimelineInterval = {
  __typename?: 'PetHealthTrendSegmentedTimelineInterval';
  color: Scalars['HexColorCode'];
  intervalType: PetBehaviorDetailIntervalType;
  length: Scalars['Int'];
  offset: Scalars['Int'];
};

export type PetHealthTrendSummary = {
  __typename?: 'PetHealthTrendSummary';
  durationChange?: Maybe<PetHealthTrendSummaryChange>;
  /**
   * Summary of any trend in the duration metric
   * @deprecated Use napSummary or sleepSummary for rest trends
   */
  durationSummary?: Maybe<Scalars['String']>;
  eventsChange?: Maybe<PetHealthTrendSummaryChange>;
  /**
   * Summary of any trend in the events metric
   * @deprecated Use napSummary or sleepSummary for rest trends
   */
  eventsSummary?: Maybe<Scalars['String']>;
  /** Summary of nap duration for rest trends */
  napSummary?: Maybe<Scalars['String']>;
  /** Populated when there is no data to display e.g. "Collecting data" */
  placeholder?: Maybe<Scalars['String']>;
  /** Summary of sleep duration for rest trends */
  sleepSummary?: Maybe<Scalars['String']>;
};

export type PetHealthTrendSummaryChange = {
  __typename?: 'PetHealthTrendSummaryChange';
  change: Scalars['String'];
  direction: PetBehaviorChangeDirection;
};

export type PetHealthTrendUpgradeBanner = {
  __typename?: 'PetHealthTrendUpgradeBanner';
  body: Scalars['String'];
  buttonText: Scalars['String'];
  deeplink: Scalars['String'];
  image: Image;
};

export type PetHealthTrends = {
  __typename?: 'PetHealthTrends';
  /** Behavior trends are only available to users with compatible modules providing this data. These are trends like barking, licking, eating, etc. */
  behaviorTrends: Array<PetHealthTrend>;
  /** Generic trends are available to all users based on activity data collected for every module */
  genericTrends: Array<PetHealthTrend>;
  period: PetHealthTrendPeriod;
  /** Banner to show when the user needs to upgrade to unlock behavior data. */
  upgradeBanner?: Maybe<PetHealthTrendUpgradeBanner>;
};

export type PetHomeLocation = {
  __typename?: 'PetHomeLocation';
  city?: Maybe<Scalars['String']>;
  cityState?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type PetInsight = {
  __typename?: 'PetInsight';
  buttonText: Scalars['String'];
  buttonUrl: Scalars['String'];
  description: Scalars['String'];
  graph: PetInsightGraph;
  id: Scalars['ID'];
  leadingImage: InsightLeadingImage;
  title: Scalars['String'];
};

export type PetInsightGraph = {
  __typename?: 'PetInsightGraph';
  currentPeriodLineHexColor: Scalars['HexColorCode'];
  currentPeriodValues: Array<Scalars['Float']>;
  previousPeriodLineHexColor: Scalars['HexColorCode'];
  previousPeriodValues: Array<Scalars['Float']>;
  showDividingLine: Scalars['Boolean'];
};

export type PetInsightWithoutGraph = {
  __typename?: 'PetInsightWithoutGraph';
  buttonText: Scalars['String'];
  buttonUrl: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  leadingImage: InsightLeadingImage;
  title: Scalars['String'];
};

export enum PetNotificationMode {
  SENSITIVE = 'SENSITIVE',
  SMART = 'SMART'
}

export type PetNotificationSetting = {
  __typename?: 'PetNotificationSetting';
  description?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  id: Scalars['ID'];
  pushEligible: Scalars['Boolean'];
  pushEnabled: Scalars['Boolean'];
  settingType: PetNotificationSettingType;
  smsEligible: Scalars['Boolean'];
  smsEnabled: Scalars['Boolean'];
  title: Scalars['String'];
};

export enum PetNotificationSettingCategory {
  COLLAR_ALERTS = 'COLLAR_ALERTS',
  MEMBERSHIP = 'MEMBERSHIP',
  SOCIAL = 'SOCIAL'
}

export type PetNotificationSettingInput = {
  pushEnabled?: InputMaybe<Scalars['Boolean']>;
  settingType: PetNotificationSettingType;
  smsEnabled?: InputMaybe<Scalars['Boolean']>;
};

export enum PetNotificationSettingType {
  BATTERY = 'BATTERY',
  BIRTHDAY_CARD = 'BIRTHDAY_CARD',
  END_OF_OUTSIDE_TIME = 'END_OF_OUTSIDE_TIME',
  END_OF_WALK = 'END_OF_WALK',
  ESCAPE = 'ESCAPE',
  FOLLOWED = 'FOLLOWED',
  FOLLOWED_PET_PHOTO_ADDED = 'FOLLOWED_PET_PHOTO_ADDED',
  FOLLOWED_PET_TEXT_ADDED = 'FOLLOWED_PET_TEXT_ADDED',
  FOLLOWED_PET_VIDEO_ADDED = 'FOLLOWED_PET_VIDEO_ADDED',
  LIVE_SHARING_REMINDER = 'LIVE_SHARING_REMINDER',
  MODULE_OFFLINE = 'MODULE_OFFLINE',
  NEARBY_PET_JOINED_FI = 'NEARBY_PET_JOINED_FI',
  NEW_PETS_JOINED_PACK = 'NEW_PETS_JOINED_PACK',
  OUTSIDE_TIME_LIKE = 'OUTSIDE_TIME_LIKE',
  PET_DOCUMENTS_UPLOADED = 'PET_DOCUMENTS_UPLOADED',
  PHOTO_COMMENT = 'PHOTO_COMMENT',
  PHOTO_LIKE = 'PHOTO_LIKE',
  PLAN_RESUMED = 'PLAN_RESUMED',
  PLAN_WILL_PAUSE = 'PLAN_WILL_PAUSE',
  RANKING = 'RANKING',
  REALTIME_BEHAVIOR_FEEDBACK = 'REALTIME_BEHAVIOR_FEEDBACK',
  SAFE_ZONE = 'SAFE_ZONE',
  SEARCH_PARTY_NEARBY = 'SEARCH_PARTY_NEARBY',
  SEARCH_PARTY_RECOVERY = 'SEARCH_PARTY_RECOVERY',
  STREAK = 'STREAK',
  TEXT_POST_COMMENT = 'TEXT_POST_COMMENT',
  TEXT_POST_LIKE = 'TEXT_POST_LIKE',
  VIDEO_POST_COMMENT = 'VIDEO_POST_COMMENT',
  VIDEO_POST_LIKE = 'VIDEO_POST_LIKE',
  WALK_LIKE = 'WALK_LIKE',
  WALK_WITH_OWNER = 'WALK_WITH_OWNER',
  WEAR_TIME = 'WEAR_TIME'
}

export enum PetRankFilter {
  AGE = 'AGE',
  BREED = 'BREED'
}

export type PetRanking = {
  __typename?: 'PetRanking';
  breedRankNumber?: Maybe<Scalars['Int']>;
  breedRankPercentile?: Maybe<Scalars['Int']>;
  overallRankNumber?: Maybe<Scalars['Int']>;
  overallRankPercentile?: Maybe<Scalars['Int']>;
  /** @deprecated Might need to be totalStepsInRankedPeriod instead? */
  stepCount?: Maybe<Scalars['Int']>;
};

export type PetSnoozeStatus = {
  __typename?: 'PetSnoozeStatus';
  expiresAt?: Maybe<Scalars['DateTime']>;
  status: PetSnoozeStatusType;
};

/**
 * State flow:
 *
 *   DISABLED -> ENABLING -> ENABLED -> DISABLING -> DISABLED
 *                  |                       |
 *                  v                       v
 *            ENABLING_FAILED         DISABLING_FAILED
 *
 * Non-Ultra devices skip ENABLING/DISABLING and go directly to ENABLED/DISABLED.
 */
export enum PetSnoozeStatusType {
  DISABLED = 'DISABLED',
  DISABLING = 'DISABLING',
  DISABLING_FAILED = 'DISABLING_FAILED',
  ENABLED = 'ENABLED',
  ENABLING = 'ENABLING',
  ENABLING_FAILED = 'ENABLING_FAILED'
}

export type PetState = {
  __typename?: 'PetState';
  activityType?: Maybe<ActivityType>;
  atPOI?: Maybe<DogPark>;
  atPlace?: Maybe<Place>;
  connectedUser?: Maybe<User>;
};

export type PetStreakBonusSummary = {
  __typename?: 'PetStreakBonusSummary';
  bonuses: Array<PetDailyGoalStreakBonus>;
  daysUntilNextBonus: Scalars['Int'];
};

export type PetUpdate = {
  __typename?: 'PetUpdate';
  changeType: PetChangeType;
};

export type PhoneConfig = {
  __typename?: 'PhoneConfig';
  /** Countries allowed for phone number entry and display in the picker. */
  allowedCountries: Array<PhoneCountry>;
  /**
   * The country preselected in the phone number picker.
   *
   * Resolution order:
   * 1) Explicit locale setting in user preferences
   * 2) Header-derived country (X-Locale-Region or Accept-Language)
   * 3) Fallback to US
   *
   * Must always be one of `allowedCountries`.
   */
  defaultCountry: PhoneCountry;
};

export type PhoneCountry = {
  __typename?: 'PhoneCountry';
  callingCode: Scalars['String'];
  country: FiCountry;
  countryName: Scalars['String'];
  flagEmoji: Scalars['String'];
};

export type PhoneSupport = {
  __typename?: 'PhoneSupport';
  /** The name of the digital support line in ZenDesk. */
  digitalSupportLineName?: Maybe<Scalars['String']>;
  /** Indicates that user is eligible for phone support. Note that they may still require upgrade. */
  eligibleForSupport: Scalars['Boolean'];
  /**
   * Phone support number.
   *
   * If null, indicates the user has no phone support option.
   */
  phoneSupportNumber?: Maybe<Scalars['String']>;
  /** If true, the client should display the upgrade flow, rather than directly calling. */
  shouldPromptUpgrade: Scalars['Boolean'];
  /** URL to open in webview for upgrade flow if applicable. */
  upgradeWebviewUrl?: Maybe<Scalars['String']>;
};

export type Photo = {
  __typename?: 'Photo';
  aspectRatio: AspectRatio;
  caption?: Maybe<Scalars['String']>;
  comments: CommentFeed;
  date: Scalars['DateTime'];
  /** Admin-only */
  dbId: Scalars['Int'];
  deleted: Scalars['Boolean'];
  externalLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image: Image;
  isCommunityPhoto?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  /** Whether the current user has liked this photo. */
  liked: Scalars['Boolean'];
  likedByPets: Array<StrangerPet>;
  /** Pet associated with this photo, if any. */
  pet?: Maybe<StrangerPet>;
  poster: PhotoPoster;
  publicShareLink?: Maybe<Scalars['String']>;
  source?: Maybe<PhotoSource>;
};

export type PhotoFeed = {
  __typename?: 'PhotoFeed';
  feed: PaginatedPhotoFeed;
  first?: Maybe<Photo>;
  /**
   * items returns an unbounded list. Instead, please use `feed` which implements our standard paginated feed interface
   * @deprecated Use `feed` instead
   */
  items: Array<Photo>;
};


export type PhotoFeedfeedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type PhotoModerationFeed = ModerationFeed & {
  __typename?: 'PhotoModerationFeed';
  items: Array<ModerationPhotoItem>;
  totalCount: Scalars['Int'];
};

export type PhotoPoster = ExternalUser | StrangerUser;

export enum PhotoSource {
  APP = 'APP',
  IG_HASHTAG = 'IG_HASHTAG',
  IG_PROFILE_TAG = 'IG_PROFILE_TAG'
}

export type PhotoUpdatesInput = {
  caption?: InputMaybe<Scalars['String']>;
  /** Deprecated */
  isCommunityPhoto?: InputMaybe<Scalars['Boolean']>;
};

export type Place = {
  __typename?: 'Place';
  address?: Maybe<Scalars['String']>;
  /** Should only be populated for polygon safe-zones. */
  boundary?: Maybe<Scalars['JSON']>;
  cityState?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Array<Position>>;
  /**
   * If null, then this was created via the first-party Fi App.
   * If set, indicates which third party created the Place (e.g. 'verizon').
   */
  createdByThirdParty?: Maybe<Scalars['String']>;
  dbId: Scalars['Int'];
  geocodeAddress?: Maybe<Scalars['String']>;
  householdId: Scalars['ID'];
  id: Scalars['ID'];
  mapUrl: Scalars['String'];
  name: Scalars['String'];
  neighborhood?: Maybe<Scalars['String']>;
  position: Position;
  /**
   * Circle safe-zones have a real value here.
   * Polygon safe-zones have a hardcoded fake value (clients should ignore).
   */
  radius: Scalars['Float'];
  /** Containment zone for sound feedback. Null if no sound zone is configured. */
  soundZone?: Maybe<ContainmentZone>;
  /** Allows clients to differentiate between circle and polygon safe-zones. */
  type: PlaceType;
  /** Containment zone for vibration feedback. Null if no vibration zone is configured. */
  vibrationZone?: Maybe<ContainmentZone>;
};


export type PlacemapUrlArgs = {
  height: Scalars['Int'];
  minimumPadding?: InputMaybe<PaddingInput>;
  scale?: InputMaybe<Scalars['Int']>;
  style?: InputMaybe<MapStyle>;
  width: Scalars['Int'];
};

export enum PlaceType {
  CIRCLE = 'CIRCLE',
  POLYGON = 'POLYGON'
}

export type PlanMini = {
  __typename?: 'PlanMini';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
};

export type Platform = {
  __typename?: 'Platform';
  archived: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  updateChannels: Array<FirmwareUpdateChannel>;
};

export type Play = Activity & {
  __typename?: 'Play';
  address?: Maybe<Scalars['String']>;
  allPositionsForDebug?: Maybe<Array<Position>>;
  areaName?: Maybe<Scalars['String']>;
  cityState?: Maybe<Scalars['String']>;
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int'];
  dbId: Scalars['Int'];
  debugMetadata: Scalars['JSON'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  /** @deprecated Use isLikable */
  isClappable: Scalars['Boolean'];
  isLikable: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  mapUrl: Scalars['String'];
  neighborhood?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  obfuscated: Scalars['Boolean'];
  overallStepsPerMinuteForDebug: Scalars['Float'];
  place?: Maybe<Place>;
  position: Position;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']>;
  start: Scalars['DateTime'];
  totalSteps: Scalars['Int'];
};


export type PlaymapUrlArgs = {
  height: Scalars['Int'];
  scale?: InputMaybe<Scalars['Int']>;
  style?: InputMaybe<MapStyle>;
  width: Scalars['Int'];
};

export type PointInTimeEvent = {
  time: Scalars['DateTime'];
};

export type PoorLTEConnectivityDeviceInfo = LowLTESignalDeviceInfo | NoLTEConnectivityDeviceInfo;

export type Position = {
  __typename?: 'Position';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

/**
 * Preview of position-based discount for a subscription cart item.
 * Shows the user what discount they'll receive based on their subscription position.
 */
export type PositionDiscountPreview = {
  __typename?: 'PositionDiscountPreview';
  /** Cart item ID this preview applies to */
  cartItemId: Scalars['String'];
  /** Discount percentage (0 for position 1, 10 for position 2, 15 for position 3+) */
  discountPercent: Scalars['Int'];
  /** Whether the user is enrolled in the position discount experiment */
  isEnrolled: Scalars['Boolean'];
  /** 1-indexed position of this subscription (1st collar, 2nd collar, etc.) */
  position: Scalars['Int'];
};

export type PositionInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type PowerStateChangeDeviceEvent = DeviceEventBase & {
  __typename?: 'PowerStateChangeDeviceEvent';
  date: Scalars['DateTime'];
  firmwareVersion?: Maybe<Scalars['String']>;
  moduleId: Scalars['String'];
  new: DevicePowerState;
  old: DevicePowerState;
  platform: Scalars['String'];
};

export enum PreSignedUploadPurpose {
  COMMUNITY_VIDEO_POST = 'COMMUNITY_VIDEO_POST',
  PET_DOCUMENT = 'PET_DOCUMENT'
}

export type PreSignedUploadUrl = {
  __typename?: 'PreSignedUploadUrl';
  expiration: Scalars['DateTime'];
  key: Scalars['String'];
  url: Scalars['String'];
};

export type PreSignedUploadUrlInput = {
  contentType: Scalars['String'];
  purpose: PreSignedUploadPurpose;
};

/** Line item from invoice preview */
export type PreviewLineItem = {
  __typename?: 'PreviewLineItem';
  /** Final amount in dollars (after discounts) */
  amountInDollars: Scalars['Float'];
  /** Description of the line item */
  description: Scalars['String'];
  /** Discount applied in dollars */
  discountInDollars: Scalars['Float'];
  /** Quantity */
  quantity: Scalars['Int'];
  /** Line item SKU/product code */
  sku: Scalars['String'];
  /** Subtotal in dollars (before discounts) */
  subtotalInDollars: Scalars['Float'];
  /** Unit amount in dollars */
  unitAmountInDollars: Scalars['Float'];
};

export type PreviewMembershipUpgradeResult = {
  __typename?: 'PreviewMembershipUpgradeResult';
  appliedAccountBalanceInCents: Scalars['Int'];
  appliedDiscountInCents: Scalars['Int'];
  proratedCreditAmountInCents: Scalars['Int'];
  subtotalInCents: Scalars['Int'];
  taxInCents: Scalars['Int'];
  totalInCents: Scalars['Int'];
};

export type PreviewPurchaseResult = {
  __typename?: 'PreviewPurchaseResult';
  activationFeesInCents: Scalars['Int'];
  appliedDiscountInCents: Scalars['Int'];
  shippingInCents: Scalars['Int'];
  subtotalInCents: Scalars['Int'];
  taxInCents: Scalars['Int'];
  totalInCents: Scalars['Int'];
};

export type PreviewRenewAndSaveResult = {
  __typename?: 'PreviewRenewAndSaveResult';
  subtotalInCents: Scalars['Int'];
  taxInCents: Scalars['Int'];
  totalInCents: Scalars['Int'];
};

export type PreviewSubscriptionResult = {
  __typename?: 'PreviewSubscriptionResult';
  activationFeeInCents?: Maybe<Scalars['Int']>;
  couponAmountInCents?: Maybe<Scalars['Int']>;
  /** Positive integer indicating the value of the gift card, if one was applied. */
  giftCardAmountInCents?: Maybe<Scalars['Int']>;
  taxInCents: Scalars['Int'];
  totalInCents: Scalars['Int'];
};

export type PreviewUpgradeToSeriesThreePlusModuleResult = {
  __typename?: 'PreviewUpgradeToSeriesThreePlusModuleResult';
  shippingInCents: Scalars['Int'];
  subtotalInCents: Scalars['Int'];
  taxInCents: Scalars['Int'];
  totalInCents: Scalars['Int'];
};

export type PricingByCurrency = {
  __typename?: 'PricingByCurrency';
  CAD?: Maybe<Scalars['Int']>;
  USD: Scalars['Int'];
};

export type Principal = {
  __typename?: 'Principal';
  capabilities: Array<PrincipalCapability>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kind: Scalars['String'];
};

export enum PrincipalCapability {
  ADMIN = 'ADMIN',
  CHARGEBACK_DISPUTE_RESOLUTION = 'CHARGEBACK_DISPUTE_RESOLUTION',
  CREATE_ORDERS = 'CREATE_ORDERS',
  CREATE_TEST_DATA = 'CREATE_TEST_DATA',
  CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT',
  FICOMMERCE = 'FICOMMERCE',
  FIRMWARE_PROD = 'FIRMWARE_PROD',
  FIRMWARE_TEST = 'FIRMWARE_TEST',
  FI_MOBILE_SDK_PROD = 'FI_MOBILE_SDK_PROD',
  FI_MOBILE_SDK_TEST = 'FI_MOBILE_SDK_TEST',
  IMPORT_ORDERS = 'IMPORT_ORDERS',
  IN_APP_CONTENT_AUTHORING = 'IN_APP_CONTENT_AUTHORING',
  IN_APP_CONTENT_VIEWER = 'IN_APP_CONTENT_VIEWER',
  NEWS_NOTIFICATION = 'NEWS_NOTIFICATION',
  PUBLIC_PET_PROFILE = 'PUBLIC_PET_PROFILE',
  RMA = 'RMA',
  VERIZON_PROD = 'VERIZON_PROD',
  VERIZON_REPORTING_PROD = 'VERIZON_REPORTING_PROD',
  VERIZON_REPORTING_TEST = 'VERIZON_REPORTING_TEST',
  VERIZON_TEST = 'VERIZON_TEST'
}

export type Product = {
  __typename?: 'Product';
  /** Decompose into component pieces given the input sub item codes. */
  decompose: Array<Product>;
  description: Scalars['String'];
  eligibleForRma: Scalars['Boolean'];
  flagExchangeForProductReturn: Scalars['Boolean'];
  id: Scalars['ID'];
  /** When this is shipped as a kit, the sku to ship will be the sku of the kit. Otherwise null. */
  kitSkuToShip?: Maybe<Scalars['String']>;
  optionsForRequiredBundledSubscription: Array<SubscriptionOption>;
  priceInCents: Scalars['Int'];
  /**
   * When this is a physical product subscription, product to ship will be the product
   * that is shipped to the customer.
   */
  productToShip?: Maybe<Product>;
  rmaProductCategory?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
  subItems: Array<ReturnsTrackerSubItem>;
};


export type ProductdecomposeArgs = {
  rmaInput?: InputMaybe<ProductDecomposeRMAInput>;
  subItemCodes: Array<Scalars['String']>;
};


export type ProductoptionsForRequiredBundledSubscriptionArgs = {
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  onlyAvailable?: InputMaybe<Scalars['Boolean']>;
};

/** These are product features that are available for the given parent entity */
export enum ProductAvailability {
  ACTIVE_TIME = 'ACTIVE_TIME',
  APPLE_WATCH = 'APPLE_WATCH',
  BEHAVIOR_DETECTION = 'BEHAVIOR_DETECTION',
  BEHAVIOR_DETECTION_UPGRADE = 'BEHAVIOR_DETECTION_UPGRADE',
  DOG_PARKS = 'DOG_PARKS',
  HEALTH_AI = 'HEALTH_AI',
  HEALTH_OVERVIEW = 'HEALTH_OVERVIEW',
  OUTSIDE_TIME = 'OUTSIDE_TIME',
  RANK = 'RANK',
  STEPS = 'STEPS',
  STRAIN = 'STRAIN',
  SUPPLEMENTS = 'SUPPLEMENTS',
  /**
   * Walk Tracking vs Outside Time Tracking differentiates between a cosmetic treatment applied to "walk" segments where cats
   * will consider such a segment as "outside time" and dogs will consider as "walk".
   */
  WALKS = 'WALKS'
}

export type ProductDecomposeRMAInput = {
  drilldownCode: Scalars['String'];
  processType: RMAProcessType;
  reasonCode: Scalars['String'];
};

export type ProductInventoryLevel = {
  __typename?: 'ProductInventoryLevel';
  /** @deprecated Will no longer be used */
  allowAutoMarkOutOfStock: Scalars['Boolean'];
  /** @deprecated Query inventoryConfigurations instead */
  eligibleForJustInTimeKitting: Scalars['Boolean'];
  id: Scalars['ID'];
  /** @deprecated Will no longer be used */
  inStock: Scalars['Boolean'];
  inStockAtAnyWarehouse: Scalars['Boolean'];
  /** @deprecated Query inventoryConfigurations instead */
  justInTimeKittingEnabled: Scalars['Boolean'];
  /** @deprecated Will no longer be used */
  manualInventoryAdjustment: Scalars['Int'];
  /** @deprecated Will no longer be used */
  outOfStockThreshold: Scalars['Int'];
  productDescription?: Maybe<Scalars['String']>;
  /** @deprecated Use sources instead */
  quantityAvailable: Scalars['Int'];
  /** @deprecated Use sources instead */
  quantityInStock: Scalars['Int'];
  /** @deprecated Use sources instead */
  quantityPending: Scalars['Int'];
  /** @deprecated Use sources instead */
  quantityReserved: Scalars['Int'];
  sku: Scalars['String'];
  sources: Array<WarehouseInventoryLevel>;
};

export type ProductInventoryLevels = {
  __typename?: 'ProductInventoryLevels';
  activeWarehouses: Array<FulfillmentWarehouse>;
  configurations: Array<InventoryConfiguration>;
  dateLastUpdated: Scalars['DateTime'];
  levels: Array<ProductInventoryLevel>;
};

export type ProductTransferPreview = {
  __typename?: 'ProductTransferPreview';
  accountCode: Scalars['String'];
  /** Before waiver */
  hardwareFeeInCents: Scalars['Int'];
  hardwareFeeWaived: Scalars['Boolean'];
  /** totalCharge - totalCredit */
  netChargeInCents: Scalars['Int'];
  totalChargeInCents: Scalars['Int'];
  totalCreditInCents: Scalars['Int'];
  transfers: Array<TransferPreviewItem>;
};

export type ProductTransferPreviewInput = {
  accountCode: Scalars['String'];
  /** Overrides default hardware fee */
  hardwareFeeAmountInCents?: InputMaybe<Scalars['Int']>;
  transfers: Array<DeviceTransferInput>;
  waiveHardwareFee?: InputMaybe<Scalars['Boolean']>;
};

/** Result of executing a product transfer. */
export type ProductTransferResult = {
  __typename?: 'ProductTransferResult';
  /** Invoice number (hardware fee for SKU-only, membership for prorated upgrades) */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Order ID for hardware fulfillment (only present when new hardware needs to ship) */
  orderId?: Maybe<Scalars['Int']>;
  /** True if all transfers succeeded */
  success: Scalars['Boolean'];
  /** Total amount charged in cents */
  totalChargedInCents: Scalars['Int'];
  /** Results for each device transfer */
  transfers: Array<TransferResultItem>;
};

/**
 * Type of product transfer flow.
 * PRORATED_UPGRADE: For S1/S2 → S3+/Mini. Old subscription is terminated with prorated credit.
 * SKU_ONLY: For S3 → S3+ and Mini ↔ S3+. Only the subscription plan code changes.
 */
export enum ProductTransferType {
  PRORATED_UPGRADE = 'PRORATED_UPGRADE',
  SKU_ONLY = 'SKU_ONLY'
}

export type Promotion = {
  __typename?: 'Promotion';
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  internalName: Scalars['String'];
  isActive: Scalars['Boolean'];
  start?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
  variants: Scalars['JSON'];
};

/**
 * Pet that exists in the boarding facility's third-party platform but is not yet tied to a Fi pet because they have not
 * been checked into a boarding facility on the Fi app.
 */
export type ProspectiveBoardingPet = {
  __typename?: 'ProspectiveBoardingPet';
  name: Scalars['String'];
  owner: BoardingFacilityContact;
  profilePicture?: Maybe<Image>;
  thirdPartyAgeFormatted: Scalars['String'];
  /**
   * This breed comes from the third-party platform and may not map to our own breeds so we use a string
   * instead of the Breed type.
   */
  thirdPartyBreedName: Scalars['String'];
  /** The ID of the pet in the boarding facility's third-party platform. */
  thirdPartyPetId: Scalars['ID'];
  /** The next upcoming reservation time for the pet. */
  upcomingReservationTime?: Maybe<Scalars['DateTime']>;
};

export type PublicProfileSharing = {
  __typename?: 'PublicProfileSharing';
  url?: Maybe<Scalars['String']>;
};

export type PurchaseResultInvoice = {
  __typename?: 'PurchaseResultInvoice';
  number: Scalars['String'];
};

export type PurchaseSubscriptionInput = {
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  couponCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currency>;
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']>;
  moduleId: Scalars['ID'];
  redeemGiftCard?: InputMaybe<RedeemGiftCardInput>;
  sku: Scalars['ID'];
  threeDSecureActionResultToken?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  admin: Admin;
  adminBoardingFacilities: Array<BoardingFacility>;
  adminBoardingFacility: BoardingFacility;
  adminConsignmentAccount?: Maybe<ConsignmentAccount>;
  adminConsignmentAccounts: Array<ConsignmentAccount>;
  adminConsignmentAvailableSkus: Array<Scalars['String']>;
  adminConsignmentLocation?: Maybe<ConsignmentLocation>;
  adminDeviceActuations: AdminDeviceActuationsResult;
  adminDeviceHealthStatistics: AdminDeviceHealthStatisticsResult;
  adminEvalClassificationTaxonomy: Array<EvalClassification>;
  adminEvalGuidelineHistory: Array<EvalGuideline>;
  adminEvalGuidelines: Array<EvalGuideline>;
  /** Targeted Feature Flags */
  adminGetAllTargetedFeatureFlags: Array<AdminTargetedFeatureFlag>;
  /** Change Logs across products */
  adminGetChangeLog: ChangeLog;
  adminGetChangeLogs: ChangeLogs;
  /** Presigned URL to download the consignment account's resale certificate. Admin-only. */
  adminGetConsignmentResaleCertificateUrl?: Maybe<Scalars['String']>;
  adminGetDismissedMobileAppContent: Array<DismissedMobileAppContent>;
  adminGetDogParkCheckinExclusionsByDogPark: Array<AdminDogParkCheckinExclusion>;
  /** Dog park checkin exclusions */
  adminGetDogParkCheckinExclusionsByPet: Array<AdminDogParkCheckinExclusion>;
  adminGetHealthGptConfig: AdminHealthGptConfig;
  adminGetHealthGptThreadMessages: Array<AdminHealthGptMessage>;
  adminGetHealthGptThreadsForUser: Array<AdminHealthGptThread>;
  adminGetPetDocumentsUploadedByUserId: Array<AdminPetDocument>;
  /**
   * Admin Get a Pre-Signed URL for File Upload
   * This is a global mutation that can be used to get a pre-signed URL for any supported purpose
   */
  adminGetPreSignedUploadUrl: PreSignedUploadUrl;
  adminGetTargetedFeatureFlag?: Maybe<AdminTargetedFeatureFlag>;
  adminGetTargetedFeatureFlagAuditTrail: Array<AdminTargetedFeatureFlag>;
  adminGetVipUserLookupCriteria: Array<VipUserLookupCriteria>;
  adminGetZoomVideoSdkToken?: Maybe<ZoomVideoSdkToken>;
  adminHealthGptGetDocument: AdminHealthGptDocument;
  adminHealthGptGetDocuments: Array<AdminHealthGptDocument>;
  adminIsShelterluvIntegrationValid: Scalars['Boolean'];
  adminListAppIntegrationsForUser: Array<AppIntegration>;
  adminPreviewOrder: PreviewPurchaseResult;
  adminRenderTestDataTemplate: RenderTestDataTemplateResult;
  adminSearchDogParks: DogParkFeed;
  adminSearchResellerModules: Array<ResellerModule>;
  /**
   * Returns all breeds for a given species.
   * If no species is provided, returns all DOG breeds (for backwards compatibility).
   */
  allBreeds: Array<Breed>;
  allDogParks: DogParkFeed;
  allNanoBatches: Array<NanoWebIdBatchInfo>;
  article?: Maybe<Article>;
  articles: Array<Article>;
  assignedChargingBase?: Maybe<ChargingBase>;
  /**
   * Get list of all non-subscription products available for charging
   * Returns products like bands, charging bases, modules, supplements, etc.
   * Excludes subscriptions (use subscription creation flow for those)
   * Requires: Admin or Customer Support role
   */
  availableChargeableProducts: Array<ChargeableProduct>;
  /** @deprecated Used for legacy in-app subscription purchasing. Use Device.purchasableSubscriptionOptions instead. */
  availableSubscriptionOptions: Array<SubscriptionOption>;
  /**
   * Get available subscription plans for a transfer. S1/S2 upgrades limited to 6m/12m/24m plans.
   * Requires: Admin or Customer Support role
   */
  availableTransferPlans: Array<AvailableTransferPlan>;
  birthdayCardForPet: BirthdayCard;
  /**
   * The pets that exist in the boarding facility third-party platform but may not have been checked into the
   * facility on the Fi app.
   */
  boardingFacilityProspectivePets: BoardingFacilityProspectivePetFeed;
  /** Get a boarding pet by its Fi pet ID */
  boardingPet?: Maybe<BoardingPet>;
  /** Paginates through Packs alphabetically. */
  browsePacks: BrowsePacksResponse;
  browsePopularPacks: BrowsePacksResponse;
  chargingBase?: Maybe<ChargingBase>;
  chargingBaseOfflineDateRanges: Array<DateRange>;
  /** @deprecated Charging bases can always be re-assigned */
  checkChargingBaseAssignable: ChargingBaseAssignable;
  checkDeviceAssignable: DeviceAssignable;
  checkFiHandleValidAndAvailable?: Maybe<CheckFiHandleValidAndAvailableResponse>;
  checkForAppUpdatePrompt?: Maybe<AppUpdatePrompt>;
  /**
   * Check how many nearby users could be notified about an active search party.
   *
   * This query filters by mute preferences - only returns users who have not muted all search parties.
   * The count reflects the actual number of users who would receive notifications.
   *
   * Use this query before showing the "Notify Nearby Users" button to the pet owner.
   * If hasUsers is false, the button should be hidden or disabled.
   */
  checkNearbyUsersForSearchParty: NearbyUsersResult;
  /**
   * Check if a device can be transferred to a target platform type.
   * Returns eligibility status, transfer type, and reason if not eligible.
   * Requires: Admin or Customer Support role
   */
  checkTransferEligibility: TransferEligibility;
  chip?: Maybe<BaseChip>;
  chipContactInfoForVerifiedRescue?: Maybe<ChipContactInfoForVerifiedRescue>;
  chipReseller?: Maybe<ChipReseller>;
  clientUrls: ClientUrls;
  commentEventHistory: Array<AuditLogEvent>;
  contactsForUser: ContactsForUserResponse;
  currentPrincipal: Principal;
  currentUser: User;
  /** Lookup a device by moduleId or dbId. Exactly one of the arguments should be provided. */
  device?: Maybe<Device>;
  /** Device actuation */
  deviceActuationStatus: DeviceActuation;
  /**
   * Fetches a FW update URL for specified module (if update is available). Does
   * not do any household authorization checks, to allow for fetching FW updates
   * for unassigned devices during onboarding.
   */
  deviceFirmwareUpdate?: Maybe<FirmwareUpdate>;
  dogPark?: Maybe<DogPark>;
  dogParkCheckInsForPet: DogParkCheckinFeed;
  dogParkLeaderboard: DogParkVisitorFeed;
  /** @deprecated Dog park notifications were removed. */
  dogParkNotificationSettings?: Maybe<DogParkNotificationSettings>;
  /** @deprecated Dog park SMS notifications were never implemented. */
  dogParkShareableSubscriptionText?: Maybe<DogParkShareableSubscriptionText>;
  dynamicEnum: DynamicEnum;
  fiNewsNotification: FiNewsNotification;
  fiNewsNotificationFeed: FiNewsNotificationFeed;
  findAdministrativeAreas: Array<AdministrativeArea>;
  forwardGeocode: Array<ForwardGeocodeResult>;
  forwardGeocodeCity: Array<ForwardGeocodeCityResult>;
  getAllInsightsForPet: Array<Insight>;
  getAllMobileAppContent: Array<AdminMobileAppContent>;
  getAvailableS3DowngradeableSubscriptionOptions: AvailableS3DowngradeSubscriptionOptionsResult;
  getHealthGptChatThread: HealthGptChatThread;
  getHealthGptSuggestedQuestions: Array<HealthGptSuggestedQuestion>;
  getHealthInsightsForPet: Array<PetHealthInsight>;
  /** Decagon In App Chat */
  getInAppDecagonChat?: Maybe<DecagonChatConfiguration>;
  /** @deprecated Use getAllInsightsForPet instead */
  getInsightsForPet: Array<Maybe<PetInsight>>;
  getMobileAppContent: MobileAppContent;
  getMobileAppContentById?: Maybe<AdminMobileAppContent>;
  getMobileAppContentSplashScreen?: Maybe<MobileAppSplashScreen>;
  getMobileAppContentTargetingFacts: Array<MobileAppContentTargetingFact>;
  getMultipleSupplementSubscriptionsPricing?: Maybe<GetMultipleSupplementSubscriptionsPricingResult>;
  getOAuthSetupDetails: OAuthSetupDetails;
  getPermissionMobileAppContent: Array<PermissionMobileAppContent>;
  getPetBehaviorDetail: PetBehaviorDetail;
  getPetDocument: PetDocument;
  getPetDocumentFeed: PetDocumentFeed;
  getPetDocumentLabels: Array<Scalars['String']>;
  getPetHealthTrendsForPet: PetHealthTrends;
  /** Get a Pre-Signed URL for File Upload */
  getPreSignedUploadUrl: PreSignedUploadUrl;
  /**
   * Finds a sharing session for a pet.
   * If sessionType is not specified, defaults to Search Party.
   */
  getSharingSession: SharingSession;
  getUserOAuthStatus: Scalars['Boolean'];
  /**
   * In-app screen sharing.
   *
   * Regular users should call getZoomVideoSdkToken and start a session
   * with the returned result.
   * For Admins, call adminGetZoomVideoSdkToken with the userId of the user whose session you want to join.
   */
  getZoomVideoSdkToken?: Maybe<ZoomVideoSdkToken>;
  gnssFixFailures: Array<GnssFixFailure>;
  handsetLogs: Array<HandsetLogDocument>;
  household?: Maybe<Household>;
  households: Array<Household>;
  inAppPromotionBanner?: Maybe<InAppPromotionBanner>;
  instagramUser: InstagramUser;
  listAppIntegrations: Array<AppIntegration>;
  /**
   * Returns localized asset URLs based on Accept-Language header.
   * Keys are dynamically discovered from S3.
   *
   * TODO: Use the authenticated user's language preference instead of the header.
   *
   * Returns a JSON object where each key is an asset name, and the value is an array
   * of available image variants with their scale (1 or 2) and URL.
   *
   * Example:
   * {
   *   "bluetooth_01": [
   *     { "scale": 1, "url": "https://media.tryfi.com/app-assets/bluetooth_01_en.png" },
   *     { "scale": 2, "url": "https://media.tryfi.com/app-assets/bluetooth_01_en@2x.png" }
   *   ]
   * }
   */
  localizedAssets: Scalars['JSON'];
  /** Lookup a location report by its ID. Admin only. */
  locationReport?: Maybe<LocationReport>;
  missedLocationReports: Array<MissedLocationReport>;
  moderationPhotoFromCommentItem: ModerationPhotoFromCommentItem;
  moderationTextPostFromCommentItem: ModerationTextPostFromCommentItem;
  multidogHouseholdPromotionBanner?: Maybe<MultidogHouseholdPromotionBanner>;
  multipleModerationFeeds: MultipleModerationFeed;
  nanoBatch: Array<NanoWebId>;
  nearbyDogParks: NearbyDogParkFeed;
  nearbyPets: NearbyPetsFeed;
  /** @deprecated Use notificationLogsForUser instead */
  notificationLogs: Array<NotificationLogDocument>;
  notificationLogsForUser: NotificationLogsForUserResult;
  notificationTypeExampleMessages: Array<Scalars['String']>;
  onboardingSessionLogs: Array<HandsetLogDocument>;
  onboardingSessions: Array<OnboardingSession>;
  order: Order;
  orderAuditLogs: Array<AuditLogEvent>;
  orders: Array<Order>;
  pack?: Maybe<Pack>;
  packMemberFeed: PackMemberFeed;
  pet?: Maybe<Pet>;
  /** Returns all pets with active (Recurly) subscriptions for the current user. */
  petsWithActiveSubscription: Array<Pet>;
  phoneConfig: PhoneConfig;
  photo?: Maybe<Photo>;
  place?: Maybe<Place>;
  poorLTEConnectivityDeviceInfo: Array<PoorLTEConnectivityDeviceInfo>;
  previewAddOrderLineItems: PreviewPurchaseResult;
  /**
   * Preview pricing for charging any product to an account (admin/CS only)
   * Works for all product types - subscriptions, bands, charging bases, etc.
   * Uses Recurly invoice preview API
   * Requires: Admin or Customer Support role
   */
  previewChargeAccount: ChargePreview;
  previewMembershipUpgrade: PreviewMembershipUpgradeResult;
  /**
   * Preview a product transfer showing all billing actions.
   * Requires: Admin or Customer Support role
   */
  previewProductTransfer: ProductTransferPreview;
  previewRenewAndSave: PreviewRenewAndSaveResult;
  previewSubscription: PreviewSubscriptionResult;
  /**
   * Preview pricing for a subscription purchase (uses Recurly invoice preview API)
   * Requires: Admin or Customer Support role
   */
  previewSubscriptionPurchase: SubscriptionPurchasePreview;
  /**
   * Preview refund amounts for subscription cancellation options
   * Requires: Admin or Customer Support role
   */
  previewSubscriptionRefund: SubscriptionRefundPreview;
  previewUpgradeToSeriesThreePlusModule: PreviewUpgradeToSeriesThreePlusModuleResult;
  prioritizedBackorders: Array<Order>;
  product: Product;
  products: Array<Product>;
  publicPetProfile?: Maybe<StrangerPet>;
  publicPetProfileHandles?: Maybe<Array<Scalars['String']>>;
  publicPetProfiles: StrangerPetFeed;
  recentCommunityPhotos: PhotoFeed;
  recentDogParkVisitors: DogParkVisitorFeed;
  recentNotificationCountsByType: Array<NotificationCountByType>;
  /** One of `serialNumber` or `invoiceNumber` must be specified */
  recurlyInvoice: RecurlyInvoice;
  /**
   * Get referral copy for a specific context. Returns copy with variables
   * injected based on the user's device type.
   */
  referralCopy: ReferralCopy;
  renewSubscriptionBanner?: Maybe<RenewSubscriptionBanner>;
  /** Get a rescue pet by pet ID - returns pet + rescue transfer */
  rescuePet?: Maybe<RescuePet>;
  resellerChip?: Maybe<ResellerChip>;
  returnsTrackerSubItems: Array<ReturnsTrackerSubItem>;
  reverseGeocode?: Maybe<ReverseGeocodeResult>;
  rma: RMA;
  rmas: RMAFeed;
  searchFiHandle: SearchFiHandleResult;
  searchPacks: SearchPacksResponse;
  searchPets: Array<Pet>;
  /** Search and filter pets with offset pagination + facet counts for filter pills. */
  searchPetsWithFilters: SearchPetsWithFiltersResult;
  searchVets: Array<Veterinary>;
  series3UpgradeOffer?: Maybe<Series3UpgradeOffer>;
  /**
   * Either both `breedId` and `ageRange` should be provided to return the step count
   * distribution for that breed and age range, or both should be null in which case
   * the step count distribution for all Fi pets is returned.
   */
  stepCountDistribution?: Maybe<StepCountDistribution>;
  strangerPet?: Maybe<StrangerPet>;
  subscription: BillingSubscription;
  /**
   * Suggest equivalent plan by renewal months. Returns null if no subscription or match.
   * Requires: Admin or Customer Support role
   */
  suggestEquivalentPlan?: Maybe<AvailableTransferPlan>;
  suggestedPacks: SuggestedPacksResult;
  /** Pets to display in Discover tab Search. */
  suggestedPets: SuggestedPetResult;
  /** Pets to display in Discover tab carousel. */
  suggestedPetsToFollow: SuggestedPetResult;
  /** Pets in user's contacts ordered by creation date. */
  suggestedPetsToFollowFromContacts: SuggestedPetResult;
  /**
   * Returns the list of supported FiLanguage values for the current user.
   * Gated by feature flag — unlaunched languages are only visible to internal testers.
   */
  supportedLanguages: Array<FiLanguage>;
  textPost?: Maybe<TextPost>;
  textPostStyles: Array<TextPostStyle>;
  /** Returns all orders the current user has placed that contains collars that have not yet been assigned to a pet. */
  unactivatedOrders: Array<OrderHistoryResult>;
  user?: Maybe<AdminBaseUserProfile>;
  userPetsAtDogPark: DogParkVisitorFeed;
  validateAddress: ValidateAddressResponse;
  videoPost?: Maybe<VideoPost>;
  wifiNetwork?: Maybe<WifiNetwork>;
};


export type QueryadminBoardingFacilityArgs = {
  id: Scalars['ID'];
};


export type QueryadminConsignmentAccountArgs = {
  id: Scalars['ID'];
};


export type QueryadminConsignmentLocationArgs = {
  id: Scalars['ID'];
};


export type QueryadminDeviceActuationsArgs = {
  input: AdminDeviceActuationsInput;
};


export type QueryadminDeviceHealthStatisticsArgs = {
  input: AdminDeviceHealthStatisticsInput;
};


export type QueryadminEvalGuidelineHistoryArgs = {
  key: Scalars['String'];
};


export type QueryadminEvalGuidelinesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryadminGetChangeLogArgs = {
  id: Scalars['ID'];
};


export type QueryadminGetChangeLogsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryadminGetConsignmentResaleCertificateUrlArgs = {
  consignmentAccountId: Scalars['ID'];
};


export type QueryadminGetDismissedMobileAppContentArgs = {
  userId: Scalars['ID'];
};


export type QueryadminGetDogParkCheckinExclusionsByDogParkArgs = {
  dogParkId: Scalars['ID'];
};


export type QueryadminGetDogParkCheckinExclusionsByPetArgs = {
  petId: Scalars['ID'];
};


export type QueryadminGetHealthGptThreadMessagesArgs = {
  threadId: Scalars['ID'];
};


export type QueryadminGetHealthGptThreadsForUserArgs = {
  userId: Scalars['ID'];
};


export type QueryadminGetPetDocumentsUploadedByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryadminGetPreSignedUploadUrlArgs = {
  input: AdminPreSignedUploadUrlInput;
};


export type QueryadminGetTargetedFeatureFlagArgs = {
  id: Scalars['ID'];
};


export type QueryadminGetTargetedFeatureFlagAuditTrailArgs = {
  id: Scalars['ID'];
};


export type QueryadminGetZoomVideoSdkTokenArgs = {
  input: AdminGetZoomVideoSdkTokenInput;
};


export type QueryadminHealthGptGetDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryadminIsShelterluvIntegrationValidArgs = {
  chipResellerId: Scalars['String'];
};


export type QueryadminListAppIntegrationsForUserArgs = {
  userId: Scalars['ID'];
};


export type QueryadminPreviewOrderArgs = {
  input: AdminPreviewOrderInput;
};


export type QueryadminRenderTestDataTemplateArgs = {
  input: RenderTestDataTemplateInput;
};


export type QueryadminSearchDogParksArgs = {
  input: AdminSearchDogParksInput;
};


export type QueryadminSearchResellerModulesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<ResellerModuleQueryInput>;
};


export type QueryallBreedsArgs = {
  species?: InputMaybe<Species>;
};


export type QueryarticleArgs = {
  id: Scalars['ID'];
};


export type QueryarticlesArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryassignedChargingBaseArgs = {
  baseId: Scalars['String'];
};


export type QueryavailableChargeableProductsArgs = {
  currency?: Scalars['String'];
};


export type QueryavailableSubscriptionOptionsArgs = {
  currency?: InputMaybe<Currency>;
  moduleId?: InputMaybe<Scalars['String']>;
  platformId?: InputMaybe<Scalars['String']>;
  showAllSkus?: InputMaybe<Scalars['Boolean']>;
};


export type QueryavailableTransferPlansArgs = {
  sourceModuleId: Scalars['String'];
  targetPlatformType: Scalars['String'];
};


export type QuerybirthdayCardForPetArgs = {
  petId: Scalars['ID'];
};


export type QueryboardingFacilityProspectivePetsArgs = {
  input: BoardingFacilityProspectivePetsInput;
};


export type QueryboardingPetArgs = {
  fiPetId: Scalars['ID'];
};


export type QuerybrowsePacksArgs = {
  limit: Scalars['Int'];
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type QuerybrowsePopularPacksArgs = {
  category?: InputMaybe<PackCategory>;
  limit: Scalars['Int'];
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type QuerychargingBaseArgs = {
  baseId: Scalars['String'];
};


export type QuerychargingBaseOfflineDateRangesArgs = {
  chargingBaseId: Scalars['ID'];
  dateRange: DateRangeInput;
};


export type QuerycheckChargingBaseAssignableArgs = {
  baseId: Scalars['String'];
};


export type QuerycheckDeviceAssignableArgs = {
  imei?: InputMaybe<Scalars['String']>;
  moduleId?: InputMaybe<Scalars['String']>;
};


export type QuerycheckFiHandleValidAndAvailableArgs = {
  proposedHandle: Scalars['String'];
};


export type QuerycheckNearbyUsersForSearchPartyArgs = {
  petId: Scalars['ID'];
};


export type QuerycheckTransferEligibilityArgs = {
  sourceModuleId: Scalars['String'];
  targetPlatformType: Scalars['String'];
};


export type QuerychipArgs = {
  id: Scalars['ID'];
};


export type QuerychipContactInfoForVerifiedRescueArgs = {
  dbId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QuerychipResellerArgs = {
  id: Scalars['ID'];
};


export type QuerycommentEventHistoryArgs = {
  commentId: Scalars['ID'];
};


export type QuerycontactsForUserArgs = {
  input: ContactsForUserInput;
};


export type QuerydeviceArgs = {
  dbId?: InputMaybe<Scalars['Int']>;
  imei?: InputMaybe<Scalars['String']>;
  moduleId?: InputMaybe<Scalars['String']>;
};


export type QuerydeviceActuationStatusArgs = {
  id: Scalars['ID'];
};


export type QuerydeviceFirmwareUpdateArgs = {
  currentVersion: Scalars['String'];
  moduleId: Scalars['String'];
};


export type QuerydogParkArgs = {
  id: Scalars['ID'];
};


export type QuerydogParkCheckInsForPetArgs = {
  input: DogParkCheckinsForPetInput;
};


export type QuerydogParkLeaderboardArgs = {
  dogParkId: Scalars['ID'];
};


export type QuerydogParkNotificationSettingsArgs = {
  dogParkId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerydogParkShareableSubscriptionTextArgs = {
  dogParkId: Scalars['ID'];
};


export type QuerydynamicEnumArgs = {
  kind: DynamicEnumKind;
};


export type QueryfiNewsNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryfindAdministrativeAreasArgs = {
  level: AdminLevel;
  position: PositionInput;
};


export type QueryforwardGeocodeArgs = {
  partialAddress: Scalars['String'];
  proximity?: InputMaybe<PositionInput>;
};


export type QueryforwardGeocodeCityArgs = {
  proximity?: InputMaybe<PositionInput>;
  query: Scalars['String'];
};


export type QuerygetAllInsightsForPetArgs = {
  petId: Scalars['ID'];
};


export type QuerygetAvailableS3DowngradeableSubscriptionOptionsArgs = {
  input: AvailableS3DowngradeSubscriptionOptionsInput;
};


export type QuerygetHealthGptChatThreadArgs = {
  input: GetHealthGptChatThreadInput;
};


export type QuerygetHealthGptSuggestedQuestionsArgs = {
  petId: Scalars['ID'];
};


export type QuerygetHealthInsightsForPetArgs = {
  petId: Scalars['ID'];
};


export type QuerygetInsightsForPetArgs = {
  petId: Scalars['ID'];
};


export type QuerygetMobileAppContentArgs = {
  clientTargetingFacts?: InputMaybe<MobileAppContentClientTargetingFactsInput>;
  petId: Scalars['ID'];
};


export type QuerygetMobileAppContentByIdArgs = {
  id: Scalars['ID'];
};


export type QuerygetMobileAppContentSplashScreenArgs = {
  clientTargetingFacts?: InputMaybe<MobileAppContentClientTargetingFactsInput>;
  petId: Scalars['ID'];
  splashScreenId: Scalars['ID'];
};


export type QuerygetMultipleSupplementSubscriptionsPricingArgs = {
  input: GetMultipleSupplementSubscriptionsPricingInput;
};


export type QuerygetOAuthSetupDetailsArgs = {
  app: Scalars['String'];
};


export type QuerygetPermissionMobileAppContentArgs = {
  input: GetPermissionMobileAppContentInput;
};


export type QuerygetPetBehaviorDetailArgs = {
  input: GetPetBehaviorDetailInput;
};


export type QuerygetPetDocumentArgs = {
  id: Scalars['ID'];
};


export type QuerygetPetDocumentFeedArgs = {
  input: GetPetDocumentsInput;
};


export type QuerygetPetHealthTrendsForPetArgs = {
  period: PetHealthTrendPeriod;
  petId: Scalars['ID'];
};


export type QuerygetPreSignedUploadUrlArgs = {
  input: PreSignedUploadUrlInput;
};


export type QuerygetSharingSessionArgs = {
  petId: Scalars['ID'];
  sessionType?: InputMaybe<SharingSessionType>;
};


export type QuerygetUserOAuthStatusArgs = {
  app: Scalars['String'];
  userId: Scalars['ID'];
};


export type QuerygnssFixFailuresArgs = {
  dateRange: DateRangeInput;
  moduleId: Scalars['ID'];
};


export type QueryhandsetLogsArgs = {
  dateRange: DateRangeInput;
  logTypes?: InputMaybe<Array<HandsetLogType>>;
  userId: Scalars['ID'];
};


export type QueryhouseholdArgs = {
  id: Scalars['ID'];
};


export type QueryhouseholdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryinAppPromotionBannerArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryinstagramUserArgs = {
  token: Scalars['String'];
};


export type QuerylocationReportArgs = {
  id: Scalars['ID'];
};


export type QuerymissedLocationReportsArgs = {
  dateRange: DateRangeInput;
  moduleId: Scalars['ID'];
};


export type QuerymoderationPhotoFromCommentItemArgs = {
  photoId: Scalars['ID'];
};


export type QuerymoderationTextPostFromCommentItemArgs = {
  textPostId: Scalars['ID'];
};


export type QuerymultipleModerationFeedsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query: ModerationFeedQueryInput;
};


export type QuerynanoBatchArgs = {
  input: AdminQueryNanoBatchInput;
};


export type QuerynearbyDogParksArgs = {
  position: PositionInput;
};


export type QuerynearbyPetsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  radiusInMeters?: InputMaybe<Scalars['Int']>;
};


export type QuerynotificationLogsArgs = {
  dateRange: DateRangeInput;
  userId: Scalars['ID'];
};


export type QuerynotificationLogsForUserArgs = {
  input: NotificationLogsForUserInput;
};


export type QuerynotificationTypeExampleMessagesArgs = {
  notificationType: Scalars['String'];
};


export type QueryonboardingSessionLogsArgs = {
  dateRange: DateRangeInput;
  userId: Scalars['ID'];
};


export type QueryonboardingSessionsArgs = {
  userId: Scalars['ID'];
};


export type QueryorderArgs = {
  id: Scalars['ID'];
};


export type QueryorderAuditLogsArgs = {
  id: Scalars['ID'];
};


export type QueryordersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<OrdersQueryInput>;
};


export type QuerypackArgs = {
  id: Scalars['ID'];
};


export type QuerypackMemberFeedArgs = {
  adjacentPetId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  packAgeFilter?: InputMaybe<PackAgeFilter>;
  packId: Scalars['ID'];
  pagingInstruction?: InputMaybe<PagingInstruction>;
  validityToken?: InputMaybe<Scalars['String']>;
};


export type QuerypetArgs = {
  id: Scalars['ID'];
};


export type QueryphotoArgs = {
  id: Scalars['ID'];
};


export type QueryplaceArgs = {
  id: Scalars['ID'];
};


export type QuerypoorLTEConnectivityDeviceInfoArgs = {
  dateRange: DateRangeInput;
  moduleId: Scalars['ID'];
};


export type QuerypreviewAddOrderLineItemsArgs = {
  input: AddOrderLineItemsInput;
};


export type QuerypreviewChargeAccountArgs = {
  accountCode: Scalars['String'];
  couponCode?: InputMaybe<Scalars['String']>;
  currency?: Scalars['String'];
  quantity: Scalars['Int'];
  sku: Scalars['String'];
  unitAmountInCents?: InputMaybe<Scalars['Int']>;
};


export type QuerypreviewMembershipUpgradeArgs = {
  input: UpgradeMembershipInput;
};


export type QuerypreviewProductTransferArgs = {
  input: ProductTransferPreviewInput;
};


export type QuerypreviewRenewAndSaveArgs = {
  input: RenewAndSaveInput;
};


export type QuerypreviewSubscriptionArgs = {
  input: PurchaseSubscriptionInput;
};


export type QuerypreviewSubscriptionPurchaseArgs = {
  accountCode: Scalars['String'];
  couponCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currency>;
  overridePriceInCents?: InputMaybe<Scalars['Int']>;
  sku: Scalars['String'];
  waiveActivationFee?: InputMaybe<Scalars['Boolean']>;
  waiveTrial?: InputMaybe<Scalars['Boolean']>;
};


export type QuerypreviewSubscriptionRefundArgs = {
  subscriptionId: Scalars['String'];
};


export type QuerypreviewUpgradeToSeriesThreePlusModuleArgs = {
  input: UpgradeToSeriesThreePlusModuleInput;
};


export type QueryproductArgs = {
  sku: Scalars['String'];
};


export type QueryproductsArgs = {
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  noDiscontinued?: InputMaybe<Scalars['Boolean']>;
  noNoLongerManufactured?: InputMaybe<Scalars['Boolean']>;
  onlyAvailable?: InputMaybe<Scalars['Boolean']>;
  onlyPhysical?: InputMaybe<Scalars['Boolean']>;
};


export type QuerypublicPetProfileArgs = {
  handle: Scalars['String'];
};


export type QuerypublicPetProfilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type QueryrecentCommunityPhotosArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryrecentDogParkVisitorsArgs = {
  dogParkId: Scalars['ID'];
};


export type QueryrecurlyInvoiceArgs = {
  ecomConfigType?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};


export type QueryreferralCopyArgs = {
  context: ReferralCopyContext;
};


export type QueryrescuePetArgs = {
  petId: Scalars['ID'];
};


export type QueryresellerChipArgs = {
  dbId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryreverseGeocodeArgs = {
  position: PositionInput;
};


export type QueryrmaArgs = {
  id: Scalars['ID'];
};


export type QueryrmasArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<RMAQueryInput>;
};


export type QuerysearchFiHandleArgs = {
  position?: InputMaybe<PositionInput>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerysearchPacksArgs = {
  category?: InputMaybe<PackCategory>;
  query: Scalars['String'];
};


export type QuerysearchPetsArgs = {
  position?: InputMaybe<PositionInput>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerysearchPetsWithFiltersArgs = {
  input: SearchPetsWithFiltersInput;
};


export type QuerysearchVetsArgs = {
  proximity?: InputMaybe<PositionInput>;
  query: Scalars['String'];
};


export type Queryseries3UpgradeOfferArgs = {
  petId?: InputMaybe<Scalars['ID']>;
};


export type QuerystepCountDistributionArgs = {
  ageRange?: InputMaybe<AgeRange>;
  breedId?: InputMaybe<Scalars['ID']>;
};


export type QuerystrangerPetArgs = {
  householdId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type QuerysubscriptionArgs = {
  id: Scalars['String'];
};


export type QuerysuggestEquivalentPlanArgs = {
  sourceModuleId: Scalars['String'];
  targetPlatformType: Scalars['String'];
};


export type QuerysuggestedPetsArgs = {
  categoryTypes?: InputMaybe<Array<SuggestedPetCategoryType>>;
};


export type QuerytextPostArgs = {
  id: Scalars['ID'];
};


export type QueryuserArgs = {
  id: Scalars['ID'];
};


export type QueryuserPetsAtDogParkArgs = {
  dogParkId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryvalidateAddressArgs = {
  address: AddressInput;
};


export type QueryvideoPostArgs = {
  id: Scalars['ID'];
};


export type QuerywifiNetworkArgs = {
  householdId: Scalars['ID'];
  ssid: Scalars['String'];
};

export enum QuickReportModeState {
  NO_CHANGE = 'NO_CHANGE',
  TURN_OFF = 'TURN_OFF',
  TURN_ON = 'TURN_ON'
}

export type RMA = {
  __typename?: 'RMA';
  amazonLpn?: Maybe<Scalars['String']>;
  checkedInAt?: Maybe<Scalars['DateTime']>;
  checkedInBy?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  customerEmail: Scalars['String'];
  customerName: Scalars['String'];
  drilldown?: Maybe<DynamicEnumMember>;
  exchangeOrder?: Maybe<Order>;
  exchangeRecurlyInvoiceNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceSource?: Maybe<InvoiceSource>;
  items: Array<RMAItem>;
  notes: Array<RMANote>;
  processType: RMAProcessType;
  purchaseProvenance?: Maybe<DynamicEnumMember>;
  reason: DynamicEnumMember;
  refundStatus?: Maybe<RefundStatus>;
  shippingLabelUrl?: Maybe<Scalars['String']>;
  status: RMAStatus;
  tags: Array<RMATag>;
  trackingNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  /**
   * Note: this is a StrangerUser not a User since RMAs can be accessed by
   * less privileged users. Don't want to introduce a privilege escalation.
   */
  user?: Maybe<StrangerUser>;
  wasUpgrade: Scalars['Boolean'];
  zendeskNumber?: Maybe<Scalars['String']>;
};

export type RMAFeed = {
  __typename?: 'RMAFeed';
  items: Array<RMA>;
  /** Total count of all RMAs, doesn't take into account your query. */
  totalCount: Scalars['Int'];
};

export type RMAItem = {
  __typename?: 'RMAItem';
  checkInCondition?: Maybe<RMAItemCondition>;
  hardwareDefects: Array<HardwareDefect>;
  id: Scalars['ID'];
  lineItemId?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  serialNumber?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  stockpileAssignmentDescription?: Maybe<Scalars['String']>;
  stockpileAssignmentName?: Maybe<Scalars['String']>;
  subItem?: Maybe<ReturnsTrackerSubItem>;
};

export enum RMAItemCondition {
  HEAVILY_USED = 'HEAVILY_USED',
  LIGHTLY_USED = 'LIGHTLY_USED',
  MISSING = 'MISSING',
  NEW = 'NEW',
  UNACCEPTABLE = 'UNACCEPTABLE'
}

export type RMAItemInput = {
  hardwareDefectCodes: Array<Scalars['String']>;
  lineItemId?: InputMaybe<Scalars['String']>;
  ordinal?: InputMaybe<Scalars['Int']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  subItemCode?: InputMaybe<Scalars['String']>;
};

export type RMANote = {
  __typename?: 'RMANote';
  attributes: Scalars['JSON'];
  body: Scalars['String'];
  date: Scalars['DateTime'];
  initiatedBy?: Maybe<Scalars['String']>;
  noteType: Scalars['String'];
};

export type RMAPolicyResult = {
  __typename?: 'RMAPolicyResult';
  message: Scalars['String'];
  requiresException: Scalars['Boolean'];
  triggersNotification: Scalars['Boolean'];
  type: RMAPolicyResultType;
};

export enum RMAPolicyResultType {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN'
}

export enum RMAProcessType {
  RETURN = 'RETURN',
  SHIPPING_ERROR = 'SHIPPING_ERROR',
  UNKNOWN_RETURN = 'UNKNOWN_RETURN',
  WARRANTY_EXCHANGE = 'WARRANTY_EXCHANGE'
}

export type RMAQueryInput = {
  query?: InputMaybe<Scalars['String']>;
};

export enum RMAStatus {
  AWAITING_RETURN = 'AWAITING_RETURN',
  CANCELLED = 'CANCELLED',
  COMPLETE = 'COMPLETE',
  LOST_PACKAGE = 'LOST_PACKAGE'
}

export enum RMATag {
  CUSTOMER_DISCARD = 'CUSTOMER_DISCARD',
  INSPECT_ON_ARRIVAL = 'INSPECT_ON_ARRIVAL'
}

export type RandomPercentageBooleanSetting = BooleanSetting & {
  __typename?: 'RandomPercentageBooleanSetting';
  floatPercentage: Scalars['Float'];
  platformOverrides: Array<BooleanSettingPlatformOverride>;
};

export type RankChange = {
  __typename?: 'RankChange';
  /** e.g. 4, -5, 0 */
  amount: Scalars['Int'];
};

export type RankedPetsResponse = {
  __typename?: 'RankedPetsResponse';
  pageInfo: PageInfo;
  pets: Array<BasePet>;
  tokenValidity: TokenValidity;
};

export type ReactivateSubscriptionInput = {
  subscriptionId: Scalars['String'];
};

export enum RealtimeBehaviorFeedback {
  ALTERNATIVE_BEHAVIOR = 'ALTERNATIVE_BEHAVIOR',
  CORRECT_BEHAVIOR = 'CORRECT_BEHAVIOR',
  NOTHING = 'NOTHING',
  OTHER = 'OTHER',
  UNSURE = 'UNSURE'
}

export enum ReasonForPackInsertFailure {
  ALREADY_IN_PACK = 'ALREADY_IN_PACK',
  DELETED_PET = 'DELETED_PET',
  DEVICE_NOT_FOUND = 'DEVICE_NOT_FOUND',
  NO_ACTIVE_SUBSCRIPTION = 'NO_ACTIVE_SUBSCRIPTION',
  PET_NOT_FOUND = 'PET_NOT_FOUND'
}

export type ReassignChipToResellerInput = {
  /**
   * If true, clears the pet and latest contact history entry from the chip.
   * Defaults to false (keeps existing owner info).
   */
  clearOwnerInfo?: InputMaybe<Scalars['Boolean']>;
  serialNumber: Scalars['String'];
};

export type RebootDeviceEvent = DeviceEventBase & {
  __typename?: 'RebootDeviceEvent';
  date: Scalars['DateTime'];
  firmwareVersion?: Maybe<Scalars['String']>;
  moduleId: Scalars['String'];
  oldUptime: Scalars['Float'];
  platform: Scalars['String'];
};

export type RecallChipInput = {
  chipId: Scalars['ID'];
};

export type RecentlyPurchasedItemsResponse = {
  __typename?: 'RecentlyPurchasedItemsResponse';
  lineItems: Array<LineItem>;
};

export type RecentlySeenBaseInput = {
  baseId: Scalars['String'];
  rssi?: InputMaybe<Scalars['Int']>;
};

export type RecordAppInstallForUserInput = {
  app: AppIntegrationId;
  isInstalled: Scalars['Boolean'];
  /** For admin/CX use */
  userId?: InputMaybe<Scalars['ID']>;
};

export type RecordAppInstallForUserResult = {
  __typename?: 'RecordAppInstallForUserResult';
  /** Populated when success is false */
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type RecurlyInvoice = {
  __typename?: 'RecurlyInvoice';
  account: BillingAccount;
  /** Amount of account credits applied to this invoice (from creditPayments) */
  appliedCreditAmount: Scalars['Float'];
  /** Outstanding balance remaining (0 if fully paid) */
  balance: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  /**
   * The date that the package associated with the shipment associated with this invoice
   * was delivered. If null, it means that either the package hasn't been delivered yet,
   * or we could not find/determine the shipment.
   */
  deliveryDate?: Maybe<Scalars['DateTime']>;
  /** Total discounts/coupons applied to this invoice */
  discount: Scalars['Float'];
  id: Scalars['ID'];
  lineItems: Array<LineItem>;
  number: Scalars['String'];
  /** Amount actually paid/charged (after account credits applied) */
  paid: Scalars['Float'];
  /** Are the items in this invoice within the 14-day return window? */
  returnEligibility: RMAPolicyResult;
  subtotal: Scalars['Float'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
  /** Are the items in this invoice under warranty? */
  warrantyStatus: RMAPolicyResult;
};


export type RecurlyInvoicereturnEligibilityArgs = {
  drilldownCode: Scalars['String'];
  reasonCode: Scalars['String'];
};


export type RecurlyInvoicewarrantyStatusArgs = {
  drilldownCode: Scalars['String'];
  reasonCode: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
};

export type RedeemGiftCardInput = {
  redemptionCode: Scalars['String'];
};

export type ReferralCopy = {
  __typename?: 'ReferralCopy';
  /** The context this copy is for */
  context: ReferralCopyContext;
  /** Variables that were injected into the copy (for debugging/analytics) */
  injectedVariables: Array<ReferralCopyVariable>;
  /** The copy text with variables already injected */
  text: Scalars['String'];
};

export enum ReferralCopyContext {
  ONBOARDING = 'ONBOARDING',
  SHARE_SHEET = 'SHARE_SHEET'
}

export type ReferralCopyVariable = {
  __typename?: 'ReferralCopyVariable';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ReferralInput = {
  referralCode: Scalars['String'];
};

export type ReferralMenuBannerSettings = {
  __typename?: 'ReferralMenuBannerSettings';
  isEnabled: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum ReferralProgramName {
  Give1MonthGet1DollarPerMonthNoLimit = 'Give1MonthGet1DollarPerMonthNoLimit',
  Give1MonthGet1DollarPerMonthWithLimit = 'Give1MonthGet1DollarPerMonthWithLimit',
  Give1MonthGet1Month = 'Give1MonthGet1Month'
}

export enum ReferralRewardType {
  DOLLAR_CREDIT = 'DOLLAR_CREDIT',
  FIRST_FREE_BAND = 'FIRST_FREE_BAND',
  ONE_MONTH_EXTENSION = 'ONE_MONTH_EXTENSION',
  ONE_YEAR_EXTENSION = 'ONE_YEAR_EXTENSION',
  SECOND_FREE_BAND = 'SECOND_FREE_BAND',
  THREE_YEAR_EXTENSION = 'THREE_YEAR_EXTENSION',
  TWO_YEAR_EXTENSION = 'TWO_YEAR_EXTENSION'
}

export enum ReferralSource {
  DirectLink = 'DirectLink',
  Onboarding = 'Onboarding',
  ReferralsTab = 'ReferralsTab'
}

export type Referrals = {
  __typename?: 'Referrals';
  codeFraudulent: Scalars['Boolean'];
  codeSuspended: Scalars['Boolean'];
  give1MonthGet1DollarPerMonthDetails?: Maybe<Give1MonthGet1DollarPerMonthDetails>;
  invitedReferees: Array<StrangerUser>;
  numConfirmedReferrals: Scalars['Int'];
  numPendingReferrals: Scalars['Int'];
  /**
   * Number of users that have been referred so far.
   * DEPRECATED: This is associated with the V1 legacy referrals system; we're
   * keeping the resolver so that admin can use it.
   */
  numReferred: Scalars['Int'];
  pendingReferrees: Array<AdminBaseUserProfile>;
  pendingReferrerToReward?: Maybe<AdminBaseUserProfile>;
  referralCode: Scalars['String'];
  /** Message that the client should pre-populate the SMS message with. */
  referralMessage: Scalars['String'];
  referralProgramName: Scalars['String'];
  referralProgramTitle: Scalars['String'];
  unlockedRewardTypes: Array<ReferralRewardType>;
};

export enum RefundStatus {
  NOT_REFUNDED = 'NOT_REFUNDED',
  NO_REFUND_NECESSARY = 'NO_REFUND_NECESSARY',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  REFUNDED = 'REFUNDED'
}

export enum RefundType {
  custom = 'custom',
  full = 'full',
  prorate = 'prorate'
}

export type RegisterChipResellerInput = {
  contactInfo: ChipContactInfoInput;
  name: Scalars['String'];
  petInterest: ResellerPetInterest;
  type: ResellerType;
};

export type RegisterChipResellerInputV2 = {
  contactInfo: ChipContactInfoInput;
  isRescue?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  petInterestTypes: Array<InputMaybe<ResellerPetInterest>>;
  programInterest?: InputMaybe<Array<ResellerProgramInterest>>;
  shippingAddress: AddressInput;
  taxExemptType?: InputMaybe<ResellerTaxExemptType>;
  types: Array<InputMaybe<ResellerType>>;
};

export type RegisterConsignmentResaleCertificateInput = {
  consignmentAccountId: Scalars['ID'];
  uploadedFileKey: Scalars['String'];
};

export type RegisterHandsetInput = {
  deviceToken: Scalars['String'];
};

export type RegisterHandsetLiveActivityTokenInput = {
  deviceToken: Scalars['String'];
  liveActivityToken: Scalars['String'];
};

export enum RemoteLogLevel {
  CRITICAL = 'CRITICAL',
  DEBUG = 'DEBUG',
  ERROR = 'ERROR',
  INFO = 'INFO',
  OFF = 'OFF',
  WARNING = 'WARNING'
}

export type RemoveCouponFromAccountInput = {
  /** The account code (user external ID) */
  accountCode: Scalars['ID'];
  /** The coupon code to remove */
  couponCode: Scalars['String'];
};

export type RemoveUserEmailInput = {
  email: Scalars['String'];
  userId: Scalars['ID'];
};

export type RemoveUserFromHouseholdInput = {
  householdId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RemoveUserFromHouseholdResult = {
  __typename?: 'RemoveUserFromHouseholdResult';
  household: Household;
  petRecalled?: Maybe<Scalars['Boolean']>;
};

export type RemoveWifiCredentialInput = {
  householdId: Scalars['ID'];
  ssid: Scalars['String'];
};

export type RenderTestDataTemplateInput = {
  text: Scalars['String'];
};

export type RenderTestDataTemplateResult = {
  __typename?: 'RenderTestDataTemplateResult';
  renderedText: Scalars['String'];
};

export type RenderedDebugActivitySegments = {
  __typename?: 'RenderedDebugActivitySegments';
  activities: Array<SimpleDebugActivity>;
};

export type RenewAndSaveInput = {
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']>;
  moduleId: Scalars['ID'];
};

export type RenewSubscriptionBanner = InAppPromotionBanner & {
  __typename?: 'RenewSubscriptionBanner';
  ctaUrl: Scalars['String'];
  id: Scalars['ID'];
  line1Text: FormatString;
  line2Text: FormatString;
};

export type RenewSubscriptionInput = {
  moduleId?: InputMaybe<Scalars['String']>;
};

export type RenewSubscriptionResult = {
  __typename?: 'RenewSubscriptionResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type ReplacementProductAudit = {
  previousQuantity?: InputMaybe<Scalars['Int']>;
  quantity: Scalars['Int'];
  sku: Scalars['String'];
  type: ReplacementProductAuditType;
};

export enum ReplacementProductAuditType {
  ITEM_ADDED = 'ITEM_ADDED',
  ITEM_REMOVED = 'ITEM_REMOVED',
  QUANTITY_CHANGED = 'QUANTITY_CHANGED'
}

export type ReplacementProductInput = {
  id: Scalars['ID'];
  priceOverrideInCents?: InputMaybe<Scalars['Int']>;
  quantity: Scalars['Int'];
};

export type ReportSubmissionInput = {
  activityInput?: InputMaybe<Array<ActivityReportInput>>;
  binaryResponse?: InputMaybe<Scalars['Boolean']>;
  locationInput?: InputMaybe<Array<LocationReportInput>>;
  mobilityInput?: InputMaybe<Array<MobilityReportInput>>;
  moduleRequest?: InputMaybe<Scalars['String']>;
};

export enum ReportType {
  ACTIVITY = 'ACTIVITY',
  LOCATION = 'LOCATION',
  MOBILITY = 'MOBILITY'
}

export type ReportTypeFilterParams = {
  reportType: ReportType;
  sourceBlacklist?: InputMaybe<Array<Scalars['String']>>;
  sourceWhitelist?: InputMaybe<Array<Scalars['String']>>;
};

export type RequestEmailVerificationInput = {
  email: Scalars['String'];
  userId: Scalars['ID'];
};

export type RequestVerificationCodeInput = {
  phoneNumber: Scalars['String'];
};

export type RerouteShipmentsInput = {
  shipmentIds: Array<Scalars['Int']>;
  warehouseId: Scalars['Int'];
};

export type RescueAdoptionTransfersFilter = {
  status?: InputMaybe<PetAdoptionTransferStatus>;
};

export type RescueCancelPetAdoptionTransferInput = {
  petId: Scalars['ID'];
};

export type RescueCancelPetAdoptionTransferResult = {
  __typename?: 'RescueCancelPetAdoptionTransferResult';
  transfer: RescueTransfer;
};

export type RescueCreatePetAdoptionTransferInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  petId: Scalars['ID'];
  phoneNumber: Scalars['String'];
};

export type RescueCreatePetAdoptionTransferResult = {
  __typename?: 'RescueCreatePetAdoptionTransferResult';
  household: Household;
  inviteMessage?: Maybe<Scalars['String']>;
  inviteUrl?: Maybe<Scalars['String']>;
  transfer: RescueTransfer;
};

export type RescueCreatePetFosterTransferInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  petId: Scalars['ID'];
  phoneNumber: Scalars['String'];
};

export type RescueCreatePetFosterTransferResult = {
  __typename?: 'RescueCreatePetFosterTransferResult';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RescuePet = {
  __typename?: 'RescuePet';
  pet: Pet;
  transfer?: Maybe<RescueTransfer>;
};

export type RescueRecallPetFosterTransferInput = {
  petId: Scalars['ID'];
  unassignBaseIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type RescueRecallPetFosterTransferResult = {
  __typename?: 'RescueRecallPetFosterTransferResult';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RescueRecallPetInput = {
  petId: Scalars['ID'];
  unassignBaseIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type RescueRecallPetResult = {
  __typename?: 'RescueRecallPetResult';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RescueTransfer = {
  __typename?: 'RescueTransfer';
  createdAt: Scalars['DateTime'];
  fromHousehold?: Maybe<Household>;
  id: Scalars['ID'];
  status: RescueTransferStatus;
  toHousehold?: Maybe<Household>;
  toName?: Maybe<Scalars['String']>;
  type: RescueTransferType;
  updatedAt: Scalars['DateTime'];
};

export type RescueTransferPetPermanentlyInput = {
  billingAccountInput?: InputMaybe<BillingAccountInput>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  giftCardRedemptionCode: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  petId: Scalars['ID'];
};

export type RescueTransferPetPermanentlyResult = {
  __typename?: 'RescueTransferPetPermanentlyResult';
  accountCreated: Scalars['Boolean'];
  billingAccount?: Maybe<BillingAccount>;
  newAccountTemporaryPassword?: Maybe<Scalars['String']>;
};

export type RescueTransferPetTemporarilyInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  petId: Scalars['ID'];
};

export type RescueTransferPetTemporarilyResult = {
  __typename?: 'RescueTransferPetTemporarilyResult';
  accountCreated: Scalars['Boolean'];
  newAccountTemporaryPassword?: Maybe<Scalars['String']>;
};

export enum RescueTransferStatus {
  ACCEPTED = 'ACCEPTED',
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
  RECALLED = 'RECALLED',
  REJECTED = 'REJECTED',
  RESCUE_RESOLVED = 'RESCUE_RESOLVED'
}

export enum RescueTransferType {
  ADOPTION = 'ADOPTION',
  FOSTER = 'FOSTER'
}

/** A chip with information relevant to a ChipReseller. */
export type ResellerChip = {
  __typename?: 'ResellerChip';
  boxId?: Maybe<Scalars['String']>;
  cartonId?: Maybe<Scalars['String']>;
  chipCondition: ChipCondition;
  /** Admin only */
  contactHistory: Array<ChipContactHistoryEntry>;
  createdAt: Scalars['DateTime'];
  dbId: Scalars['Int'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isFiChip: Scalars['Boolean'];
  latestContactHistoryEntry?: Maybe<ChipContactHistoryEntry>;
  /** @deprecated Use `latestContactHistoryEntry.contactInfo` instead */
  latestContactInfo?: Maybe<ChipContactInfo>;
  manufacturedAt?: Maybe<Scalars['DateTime']>;
  pet?: Maybe<StrangerPet>;
  primaryPetOwner?: Maybe<StrangerUser>;
  reseller?: Maybe<ChipReseller>;
  serialNumber: Scalars['String'];
  /** Admin only */
  shipmentData?: Maybe<DeviceShipment>;
  shippedAt?: Maybe<Scalars['DateTime']>;
  shortId: Scalars['String'];
  sku?: Maybe<Scalars['String']>;
  status: ChipStatusType;
  transfer?: Maybe<ChipTransfer>;
  /** Admin only */
  transfers: Array<ChipTransfer>;
  updatedAt: Scalars['DateTime'];
};

export type ResellerChipFeed = {
  __typename?: 'ResellerChipFeed';
  chips: Array<ResellerChip>;
  metadata?: Maybe<ResellerChipFeedMetadata>;
};

export type ResellerChipFeedMetadata = {
  __typename?: 'ResellerChipFeedMetadata';
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  totalChipCount: Scalars['Int'];
};

export type ResellerModule = {
  __typename?: 'ResellerModule';
  activatedSubscriptionId?: Maybe<Scalars['String']>;
  consignmentLocation?: Maybe<ConsignmentLocation>;
  moduleId: Scalars['String'];
  orderSource: OrderSource;
  renewalMonths: Scalars['Int'];
  shipDate: Scalars['DateTime'];
  shipmentId?: Maybe<Scalars['String']>;
};

export type ResellerModuleQueryInput = {
  moduleId?: InputMaybe<Scalars['String']>;
  orderSource?: InputMaybe<OrderSource>;
};

export enum ResellerPetInterest {
  CATS = 'CATS',
  DOGS = 'DOGS',
  DOGS_AND_CATS = 'DOGS_AND_CATS',
  OTHER = 'OTHER'
}

export enum ResellerProgramInterest {
  FREE_MICROCHIPS = 'FREE_MICROCHIPS',
  RESCUE_COLLAR_PROGRAM = 'RESCUE_COLLAR_PROGRAM'
}

export enum ResellerStatus {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export enum ResellerTaxExemptType {
  GOVERNMENT_ENTITY = 'GOVERNMENT_ENTITY',
  REGISTERED_501C3 = 'REGISTERED_501C3'
}

export enum ResellerType {
  BREEDER = 'BREEDER',
  RESCUE = 'RESCUE',
  VET = 'VET'
}

export type ResolveChipTransferInput = {
  chipTransferId: Scalars['ID'];
  /**
   * If status == ACCEPTED and this is set, the transfer will be accepted
   * and also the chip will be associated with the specified pet.
   */
  petId?: InputMaybe<Scalars['ID']>;
  status: ChipTransferStatus;
};

export type ResolvePetAdoptionTransferInput = {
  billingAccountInput?: InputMaybe<BillingAccountInput>;
  giftCardRedemptionCode?: InputMaybe<Scalars['String']>;
  petId: Scalars['ID'];
  resolution: AdoptionTransferResolution;
};

export type ResolvePetAdoptionTransferResult = {
  __typename?: 'ResolvePetAdoptionTransferResult';
  redirectUrl: Scalars['String'];
  transfer: PetAdoptionTransfer;
};

export type Rest = Activity & {
  __typename?: 'Rest';
  address?: Maybe<Scalars['String']>;
  allPositionsForDebug?: Maybe<Array<Position>>;
  areaName?: Maybe<Scalars['String']>;
  cityState?: Maybe<Scalars['String']>;
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int'];
  dbId: Scalars['Int'];
  debugMetadata: Scalars['JSON'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  /** @deprecated Use isLikable */
  isClappable: Scalars['Boolean'];
  isLikable: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  mapUrl: Scalars['String'];
  neighborhood?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  obfuscated: Scalars['Boolean'];
  overallStepsPerMinuteForDebug: Scalars['Float'];
  place?: Maybe<Place>;
  position: Position;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']>;
  start: Scalars['DateTime'];
  totalSteps: Scalars['Int'];
};


export type RestmapUrlArgs = {
  height: Scalars['Int'];
  scale?: InputMaybe<Scalars['Int']>;
  style?: InputMaybe<MapStyle>;
  width: Scalars['Int'];
};

export type RestFeed = {
  __typename?: 'RestFeed';
  cursor: Scalars['String'];
  nextCursor?: Maybe<Scalars['String']>;
  period: ActivityRestStrainPeriod;
  prevCursor?: Maybe<Scalars['String']>;
  restSummary: RestFeedSummary;
};

/**
 * Describes rests (naps + sleep) and associated metadata (total time, etc.)
 * across the specified Period.
 */
export type RestFeedSummary = {
  __typename?: 'RestFeedSummary';
  /** Maximum rest (sleep + nap) seconds over the period (e.g. maximum rest/month for YEAR). */
  maxRestSeconds: Scalars['Int'];
  /**
   * Average per day over the period (only counting days we have data for).
   *
   * For the DAY period this will be the same as the Total field above.
   * For WEEK/MONTH/YEAR this will be the average per day that we have data for.
   */
  napSecondsAverage?: Maybe<Scalars['Int']>;
  /** Summed over the entire period */
  napSecondsTotal: Scalars['Int'];
  /** Only populated for DAY period */
  overnightRestSummary?: Maybe<OvernightRestSummary>;
  period: ActivityRestStrainPeriod;
  /**
   * One value for each sub-period:
   * * Day: 24 values, one per hour
   * * Week: 7 values, one per day
   * * Month: 28-31 values, one per day
   * * Year: 12 values, one per month
   */
  restData: Array<RestFeedSummaryData>;
  /**
   * Graph visualization for rest data (available for month/year periods only)
   * Returns null for day/week periods where aggregated charting is not meaningful
   */
  restGraph?: Maybe<PetBehaviorDetailGraph>;
  restSecondsAverage?: Maybe<Scalars['Int']>;
  restSecondsTotal: Scalars['Int'];
  /** Rest time comparison between current and previous period */
  restTimeComparison: PetBehaviorDetailComparison;
  /**
   * Segmented timeline for rests showing hourly sleep time blocks
   * Always available as an array, providing detailed time-based data for all periods
   */
  restTimelines: Array<PetBehaviorDetailSegmentedTimeline>;
  sleepSecondsAverage?: Maybe<Scalars['Int']>;
  sleepSecondsTotal: Scalars['Int'];
  /** Midnight at the beginning of the period */
  start: Scalars['DateTime'];
  title: Scalars['String'];
  /** Labels to display on the x-axis of graphs in the app. */
  xAxisLabels: Array<Scalars['String']>;
};

export type RestFeedSummaryData = {
  __typename?: 'RestFeedSummaryData';
  availability: ActivityRestStrainPeriodDataAvailability;
  isCurrent?: Maybe<Scalars['Boolean']>;
  napSeconds?: Maybe<Scalars['Int']>;
  /** Sum of nap and sleep seconds. */
  restSeconds?: Maybe<Scalars['Int']>;
  sleepSeconds?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
};

/** Not exposed outside of admin. */
export type RestSegment = {
  __typename?: 'RestSegment';
  end?: Maybe<Scalars['DateTime']>;
  start: Scalars['DateTime'];
  type: RestSegmentType;
};

export enum RestSegmentType {
  ACTIVE = 'ACTIVE',
  OFFLINE = 'OFFLINE',
  OFF_DOG = 'OFF_DOG',
  RESTING = 'RESTING'
}

export type RestSummary = {
  __typename?: 'RestSummary';
  dailyRests: Array<DailyRestSummary>;
  data: RestSummaryData;
  end: Scalars['DateTime'];
  period: ActivitySummaryPeriod;
  start: Scalars['DateTime'];
};

export type RestSummaryData = ConcreteRestSummaryData | UnavailableRestSummaryData;

export type RestSummaryFeed = {
  __typename?: 'RestSummaryFeed';
  nextCursor?: Maybe<Scalars['String']>;
  restSummaries: Array<RestSummary>;
};

export type ResumeMembershipInput = {
  moduleId?: InputMaybe<Scalars['String']>;
  recurlySubscriptionId: Scalars['String'];
};

export type ResumeMembershipResult = {
  __typename?: 'ResumeMembershipResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ReturnsTrackerSubItem = {
  __typename?: 'ReturnsTrackerSubItem';
  code: Scalars['String'];
  friendlyName: Scalars['String'];
  hasSerialNumber: Scalars['Boolean'];
  miniFriendlyName?: Maybe<Scalars['String']>;
  miniName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  requiredForRefund: Scalars['Boolean'];
};

export type ReverseGeocodeResult = {
  __typename?: 'ReverseGeocodeResult';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cityState?: Maybe<Scalars['String']>;
  neighborhood?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type RevokeUserInviteInput = {
  inviteCode: Scalars['String'];
};

export type RevokeUserInviteResult = {
  __typename?: 'RevokeUserInviteResult';
  household?: Maybe<Household>;
  petRecalled?: Maybe<Scalars['Boolean']>;
};

export type S3UpgradePromotionBanner = InAppPromotionBanner & {
  __typename?: 'S3UpgradePromotionBanner';
  backgroundColorHex: Scalars['String'];
  ctaUrl: Scalars['String'];
  id: Scalars['ID'];
  line1Text: FormatString;
  line1TextColorHex: Scalars['String'];
  line2Text: FormatString;
  line2TextColorHex: Scalars['String'];
};

export type SearchFiHandleResult = {
  __typename?: 'SearchFiHandleResult';
  /** @deprecated Always empty */
  packs: Array<Pack>;
  pets: Array<StrangerPet>;
};

export type SearchPacksResponse = {
  __typename?: 'SearchPacksResponse';
  packFeed: PackFeed;
};

/**
 * The set of filter chips the UI supports.
 * Multiple can be active at once (OR semantics).
 */
export enum SearchPetsFilter {
  IN_FOSTER = 'IN_FOSTER',
  IN_RESCUE = 'IN_RESCUE',
  MY_PETS = 'MY_PETS',
  PENDING_ADOPTIONS = 'PENDING_ADOPTIONS'
}

/** Facet count for a single filter. */
export type SearchPetsWithFiltersFacet = {
  __typename?: 'SearchPetsWithFiltersFacet';
  filter: SearchPetsFilter;
  totalCount: Scalars['Int'];
};

/** Input for pet search with filters and pagination. */
export type SearchPetsWithFiltersInput = {
  /**
   * Multi-select filters (OR semantics).
   * If omitted or empty, no filter constraint is applied.
   */
  filters?: InputMaybe<Array<SearchPetsFilter>>;
  /** Max results to return in this page. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Pagination info */
  pagingInstruction?: InputMaybe<PagingInstruction>;
  /** Simple text query applied to pet name. */
  query?: InputMaybe<Scalars['String']>;
};

/** Pagination and request metadata for pet search with filters. */
export type SearchPetsWithFiltersMetadata = {
  __typename?: 'SearchPetsWithFiltersMetadata';
  /** Echo back the filters actually applied (empty means none). */
  filtersApplied: Array<SearchPetsFilter>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  /** Echo back normalized query string if provided. */
  query?: Maybe<Scalars['String']>;
  /**
   * Total number of pets matching the current query + selected filters.
   * Used for pagination / "All (X)".
   */
  totalCount: Scalars['Int'];
};

/** Result of pet search with filters. */
export type SearchPetsWithFiltersResult = {
  __typename?: 'SearchPetsWithFiltersResult';
  /** Counts per filter option (for pills/tabs). */
  facets: Array<SearchPetsWithFiltersFacet>;
  /** Pagination info */
  pageInfo: PageInfo;
  /** Flat list in display order (single list UI). */
  pets: Array<Pet>;
  totalCount: Scalars['Int'];
};

export type SeekParameters = {
  before: Scalars['DateTime'];
};

export type SendBackgroundNotificationInput = {
  userId: Scalars['ID'];
};

export type SendHealthGptChatMessageInput = {
  message: Scalars['String'];
  petId: Scalars['ID'];
};

export type SendNotificationInput = {
  channelId: PetNotificationSettingCategory;
  deepLink?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  userId: Scalars['ID'];
};

export type SendSMSInput = {
  message: Scalars['String'];
  /** One of `userId` or `phoneNumber` must be set. */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** One of `userId` or `phoneNumber` must be set. */
  userId?: InputMaybe<Scalars['ID']>;
};

export type SentPushNotificationLog = {
  __typename?: 'SentPushNotificationLog';
  notificationCategory?: Maybe<Scalars['String']>;
  notificationMessage: Scalars['String'];
  notificationType: Scalars['String'];
  pet?: Maybe<Pet>;
  shouldShowBadge?: Maybe<Scalars['Boolean']>;
  timestamp: Scalars['DateTime'];
  user: User;
};

export type SentSMSNotificationLog = {
  __typename?: 'SentSMSNotificationLog';
  notificationMessage: Scalars['String'];
  notificationType: Scalars['String'];
  pet?: Maybe<Pet>;
  phoneNumber?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  twilio?: Maybe<Scalars['Boolean']>;
  user: User;
};

export type Series3UpgradeCartInput = {
  cartItems: Array<ForModuleBundleCartItemInput>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  couponCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currency>;
  isUpgradeV2?: InputMaybe<Scalars['Boolean']>;
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']>;
  shippingCode?: InputMaybe<Scalars['String']>;
  threeDSecureActionResultToken?: InputMaybe<Scalars['String']>;
};

export type Series3UpgradeDeviceOffer = {
  __typename?: 'Series3UpgradeDeviceOffer';
  amountDueTodayInCents: Scalars['Int'];
  currentCollarModel: Scalars['String'];
  device: Device;
  pet: Pet;
  promoDiscounts: Array<Series3UpgradePromoDiscount>;
  proratedCreditAmountInCents: Scalars['Int'];
};

export type Series3UpgradeOffer = {
  __typename?: 'Series3UpgradeOffer';
  deviceOffers: Array<Series3UpgradeDeviceOffer>;
  nextBillDate: Scalars['DateTime'];
  planCode: Scalars['String'];
};

export type Series3UpgradePromoDiscount = {
  __typename?: 'Series3UpgradePromoDiscount';
  discountAmountInCents: Scalars['Int'];
  planCode: Scalars['String'];
};

export enum SetFeatureFlagType {
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER',
  STRING = 'STRING'
}

/**
 * GraphQL doesn't support union types for inputs, so this takes a lassez-faire
 * approach to type safety with all optional fields.
 */
export type SetFeatureFlagValue = {
  booleanFloatPercentage?: InputMaybe<Scalars['Float']>;
  booleanGroups?: InputMaybe<Array<Scalars['String']>>;
  booleanPercentage?: InputMaybe<Scalars['Int']>;
  booleanPlatformOverrides?: InputMaybe<Array<BooleanSettingPlatformOverrideInput>>;
  booleanType?: InputMaybe<BooleanSettingType>;
  booleanUserIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['Float']>;
  setDynamicSettingName?: InputMaybe<Scalars['String']>;
  string?: InputMaybe<Scalars['String']>;
  unsetDynamicSettingName?: InputMaybe<Scalars['Boolean']>;
};

export type SetFirmwareRolloutResult = {
  __typename?: 'SetFirmwareRolloutResult';
  /** The number of records that were updated. */
  numUpdated: Scalars['Int'];
};

export type SetNextShipmentDateInput = {
  nextShipDate: Scalars['DateTime'];
  recurlySubscriptionId: Scalars['ID'];
};

export type SetNextShipmentDateResult = {
  __typename?: 'SetNextShipmentDateResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SetPetPrimaryPhotoInput = {
  petId: Scalars['ID'];
  photoId: Scalars['ID'];
};

/**
 * Input for setting containment zones on a safe zone (Place).
 * Each zone field is optional - omit to not create that zone type, or set to null to remove an existing zone.
 */
export type SetPlaceContainmentInput = {
  /** Containment zone for sound feedback. */
  soundZone?: InputMaybe<CreateContainmentZoneInput>;
  /** Containment zone for vibration feedback. */
  vibrationZone?: InputMaybe<CreateContainmentZoneInput>;
};

export type SetPrimaryUserEmailInput = {
  email: Scalars['String'];
  userId: Scalars['ID'];
};

export type SetRemoteLoggingForFirmwareChannelInput = {
  channelName: Scalars['String'];
  enabled: Scalars['Boolean'];
  platform: Scalars['String'];
};

export type SetShippingAddressInput = {
  applyToAll: Scalars['Boolean'];
  recurlySubscriptionId: Scalars['ID'];
  shippingAddress: AddressInput;
};

export type SetShippingAddressResult = {
  __typename?: 'SetShippingAddressResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SetStepGoalForPetInput = {
  dailyStepGoal: Scalars['Int'];
  petId: Scalars['ID'];
};

export type SetStepGoalForPetResult = {
  __typename?: 'SetStepGoalForPetResult';
  pet: Pet;
};

export type SetTermsOfServiceAcceptedInput = {
  /** The user that is accepting the terms of service. */
  userId: Scalars['ID'];
};

export type SetTermsOfServiceAcceptedResult = {
  __typename?: 'SetTermsOfServiceAcceptedResult';
  success: Scalars['Boolean'];
};

export type SetUserPasswordToRandomStringResult = {
  __typename?: 'SetUserPasswordToRandomStringResult';
  newPassword: Scalars['String'];
};

export type SetUserRoleInHouseholdInput = {
  householdId: Scalars['ID'];
  role: UserHouseholdRole;
  userId: Scalars['ID'];
};

export type SetUserRoleInHouseholdResult = {
  __typename?: 'SetUserRoleInHouseholdResult';
  userHousehold: UserHousehold;
};

export type SharingSession = {
  __typename?: 'SharingSession';
  session?: Maybe<SharingSessionDetails>;
};

export type SharingSessionDetails = {
  __typename?: 'SharingSessionDetails';
  /**
   * Whether nearby user detection is enabled for this search party session.
   * When enabled, the system will periodically check for new nearby users and notify them.
   */
  enableNearbyUserDetection: Scalars['Boolean'];
  sharingUrl: Scalars['String'];
  /** Total number of visitors to the sharing session */
  visitorCount: Scalars['Int'];
};

export enum SharingSessionType {
  LOCATION_SHARING = 'LOCATION_SHARING',
  SEARCH_PARTY = 'SEARCH_PARTY'
}

export type ShelterluvConfiguration = {
  __typename?: 'ShelterluvConfiguration';
  apiKeyEndsWith: Scalars['String'];
  enabled: Scalars['Boolean'];
  fiNanoBackfillCompletedAt?: Maybe<Scalars['DateTime']>;
  lastImportAt?: Maybe<Scalars['DateTime']>;
  thirdPartyChipBackfillCompletedAt?: Maybe<Scalars['DateTime']>;
  thirdPartyChipBackfillEnabled: Scalars['Boolean'];
  thirdPartyChipIncrementalEnabled: Scalars['Boolean'];
};

export type ShelterluvConfigurationInput = {
  apiKey: Scalars['String'];
  thirdPartyChipBackfillEnabled: Scalars['Boolean'];
  thirdPartyChipIncrementalEnabled: Scalars['Boolean'];
};

export type ShipOrderLineItemsInput = {
  id: Scalars['ID'];
  lineItemIds: Array<Scalars['ID']>;
};

export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  residential?: Maybe<Scalars['Boolean']>;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export enum ShippingOption {
  DHL_PARCEL_EXPEDITED_MAX = 'DHL_PARCEL_EXPEDITED_MAX',
  /** The shipping options below are only available for internal orders. */
  DHL_PARCEL_GROUND = 'DHL_PARCEL_GROUND',
  FREE_TRIAL = 'FREE_TRIAL',
  GROUND = 'GROUND',
  IN_PERSON = 'IN_PERSON',
  OVERNIGHT = 'OVERNIGHT',
  PRIORITY_MAIL = 'PRIORITY_MAIL',
  TWO_DAY = 'TWO_DAY',
  UPS_2ND_DAY_AIR = 'UPS_2ND_DAY_AIR',
  UPS_GROUND = 'UPS_GROUND',
  UPS_NEXT_DAY_AIR = 'UPS_NEXT_DAY_AIR',
  UPS_NEXT_DAY_AIR_SATURDAY = 'UPS_NEXT_DAY_AIR_SATURDAY'
}

export type ShippingOptionInput = {
  code: Scalars['String'];
};

export type SimpleCard = Card & {
  __typename?: 'SimpleCard';
  date: Scalars['DateTime'];
  icon?: Maybe<Image>;
  id: Scalars['ID'];
  message: FormatString;
  title?: Maybe<Scalars['String']>;
};

export type SimpleDebugActivity = {
  __typename?: 'SimpleDebugActivity';
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  positions: Array<Position>;
  start: Scalars['DateTime'];
  typeString?: Maybe<Scalars['String']>;
};

export type SimpleHealthMetric = {
  __typename?: 'SimpleHealthMetric';
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
  values: HealthRollupValues;
};

export enum SizeOption {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
  XLARGE = 'XLARGE',
  XSMALL = 'XSMALL'
}

export type SkipSupplementShipmentInput = {
  recurlySubscriptionId: Scalars['ID'];
};

export type SkipSupplementShipmentResult = {
  __typename?: 'SkipSupplementShipmentResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SleepAmount = {
  __typename?: 'SleepAmount';
  /** Total duration in seconds */
  duration: Scalars['Int'];
  type: SleepType;
};

export type SleepInterruptionSpan = {
  __typename?: 'SleepInterruptionSpan';
  end: Scalars['DateTime'];
  /** Between 0-1: where to place end this bar between `sleepStart` and `sleepEnd`. */
  endCoordinate: Scalars['Float'];
  start: Scalars['DateTime'];
  /** Between 0-1: where to place end this bar between `sleepStart` and `sleepEnd`. */
  startCoordinate: Scalars['Float'];
};

export enum SleepType {
  NAP = 'NAP',
  SLEEP = 'SLEEP'
}

/** One of inputs should be specified */
export type SocialContentInput = {
  commentId?: InputMaybe<Scalars['ID']>;
  photoId?: InputMaybe<Scalars['ID']>;
  textPostId?: InputMaybe<Scalars['ID']>;
};

export type Span = {
  __typename?: 'Span';
  color?: Maybe<Scalars['HexColorCode']>;
  length: Scalars['Int'];
  start: Scalars['Int'];
  style: FontStyle;
};

export enum Species {
  CAT = 'CAT',
  DOG = 'DOG',
  OTHER = 'OTHER'
}

export type StatChanged = {
  __typename?: 'StatChanged';
  newValue: Scalars['Int'];
  oldValue: Scalars['Int'];
  stat: DeviceStat;
};

export type StatDeltaDeviceEvent = DeviceEventBase & {
  __typename?: 'StatDeltaDeviceEvent';
  date: Scalars['DateTime'];
  deltaValue: Scalars['Float'];
  duration: Scalars['Float'];
  firmwareVersion?: Maybe<Scalars['String']>;
  moduleId: Scalars['String'];
  platform: Scalars['String'];
  statName: Scalars['String'];
};

export type Statistics = {
  __typename?: 'Statistics';
  last24HrsTotalActivityReports: Scalars['Int'];
  last24HrsTotalLocationReports: Scalars['Int'];
  totalActivatedDevices: Scalars['Int'];
  totalActivatedUsers: Scalars['Int'];
  totalDevices: Scalars['Int'];
  totalUsers: Scalars['Int'];
  uptime: Scalars['Float'];
};

export type StepActivity = {
  __typename?: 'StepActivity';
  date: Scalars['DateTime'];
  stepCount: Scalars['Int'];
};

export type StepActivityInfo = {
  __typename?: 'StepActivityInfo';
  currentStepGoalStreak: Scalars['Int'];
  currentStreakText: Scalars['String'];
  longestStepGoalStreak: Scalars['Int'];
  streakBonusSummary: PetStreakBonusSummary;
};

export type StepCountDistribution = {
  __typename?: 'StepCountDistribution';
  averageStepCount: Scalars['Int'];
  /** The size (in steps) of an individual bucket */
  bucketSize: Scalars['Int'];
  buckets: Array<StepCountDistributionBucket>;
};

export type StepCountDistributionBucket = {
  __typename?: 'StepCountDistributionBucket';
  /** A single value (in steps) somewhere in the middle of this bucket. */
  midpointSteps: Scalars['Int'];
  /** The percentage of dogs in this bucket (0-1). */
  percentage: Scalars['Float'];
  /** The percentile as an integer between 1-100 (e.g. 95 = top 95th percentile). */
  percentile: Scalars['Int'];
  /** The lower bound of steps contained in this bucket. */
  steps: Scalars['Int'];
};

export type StepFeed = {
  __typename?: 'StepFeed';
  /** Cursors are base64 encoded ISO date strings. */
  cursor: Scalars['String'];
  nextCursor?: Maybe<Scalars['String']>;
  period: ActivityRestStrainPeriod;
  prevCursor?: Maybe<Scalars['String']>;
  stepSummary: StepSummary;
};

/**
 * Describes steps and associated metadata (streak counts, walks, etc.) across
 * the specified ActivityRestStrainPeriod.
 */
export type StepSummary = {
  __typename?: 'StepSummary';
  /** Active time comparison between current and previous period */
  activeTimeComparison: PetBehaviorDetailComparison;
  /**
   * Graph visualization for active time data (available for month/year periods only)
   * Returns null for day/week periods where aggregated charting is not meaningful
   */
  activeTimeGraph?: Maybe<PetBehaviorDetailGraph>;
  /**
   * Average active minutes per day for this period. For DAY period, this equals totalActiveMinutes.
   * For WEEK/MONTH/YEAR periods, this is totalActiveMinutes divided by the number of days with data.
   */
  activeTimePerDay: Scalars['Int'];
  /** Segmented timeline for walks showing hourly active time blocks */
  activityTimelines: Array<PetBehaviorDetailSegmentedTimeline>;
  comparisonActiveTimeLegend?: Maybe<Scalars['String']>;
  comparisonStepsLegend?: Maybe<Scalars['String']>;
  /** Comparison graph labels. */
  comparisonTitleCurrent?: Maybe<Scalars['String']>;
  comparisonTitlePrevious?: Maybe<Scalars['String']>;
  /** Maximum steps over the period (e.g. maximum steps/month for YEAR). */
  maxSteps: Scalars['Int'];
  metStepGoal?: Maybe<Scalars['Boolean']>;
  period: ActivityRestStrainPeriod;
  /** Midnight at the beginning of the period */
  start: Scalars['DateTime'];
  /**
   * One value for each sub-period:
   * * Day: 24 values, one per hour
   * * Week: 7 values, one per day
   * * Month: 28-31 values, one per day
   * * Year: 12 values, one per month
   */
  stepData: Array<StepSummaryData>;
  /** Only applicable (and only populated) for DAY period. */
  stepGoal?: Maybe<Scalars['Int']>;
  /** Steps comparison between current and previous period */
  stepsComparison: PetBehaviorDetailComparison;
  /**
   * Graph visualization for step data (available for month/year periods only)
   * Returns null for day/week periods where aggregated charting is not meaningful
   */
  stepsGraph?: Maybe<PetBehaviorDetailGraph>;
  /**
   * Average steps per day for this period. For DAY period, this equals totalSteps.
   * For WEEK/MONTH/YEAR periods, this is totalSteps divided by the number of days with data.
   */
  stepsPerDay: Scalars['Int'];
  strainLevel?: Maybe<StrainLevel>;
  /** Strain score for the specified period. */
  strainScore?: Maybe<Scalars['Float']>;
  streakDays?: Maybe<Scalars['Int']>;
  streakExtended?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  totalActiveMinutes: Scalars['Int'];
  totalNumberOfWalks: Scalars['Int'];
  /** Summed over the entire period */
  totalSteps: Scalars['Int'];
  totalWalkDistanceMeters: Scalars['Float'];
  /** Labels to display on the x-axis of graphs in the app. */
  xAxisLabels: Array<Scalars['String']>;
};

export type StepSummaryData = {
  __typename?: 'StepSummaryData';
  activeMinutes?: Maybe<Scalars['Int']>;
  availability: ActivityRestStrainPeriodDataAvailability;
  isCurrent?: Maybe<Scalars['Boolean']>;
  metStepGoal?: Maybe<Scalars['Boolean']>;
  previousActiveMinutes?: Maybe<Scalars['Int']>;
  /**
   * Comparison graph data.
   * Previous refers to the data from the corresponding sub-period in the previous period.
   * For example, if this StepSummaryData refers to Wednesday in the WEEK view,
   * then previous will refer to the Wednesday in the previous week.
   */
  previousSteps?: Maybe<Scalars['Int']>;
  steps?: Maybe<Scalars['Int']>;
  strainLevel?: Maybe<StrainLevel>;
  strainScore?: Maybe<Scalars['Float']>;
  tooltip?: Maybe<Scalars['String']>;
};

export type StoreCartItemInput = {
  addonLineItems?: InputMaybe<Array<CartLineItemInput>>;
  cartItemId: Scalars['String'];
  giftCardDelivery?: InputMaybe<GiftCardDeliveryInput>;
  /**
   * Whether this cart item is a gift. It will be used to determine if we should gift wrap the item and treat the
   * bundled subscription so it will not be created under the purchaser's account.
   */
  isGift?: InputMaybe<Scalars['Boolean']>;
  lineItem: CartLineItemInput;
  quantity: Scalars['Int'];
  subscriptionLineItem?: InputMaybe<CartLineItemInput>;
};

/**
 * Strain scores are a range from 0 to 30.
 * Descriptive levels are defined as:
 * LOW       [0 - 7.5)    (0-25%)
 * MODERATE  [7.5 - 22.5) (25-75%)
 * HIGH      [22.5 - 30]  (75-100%)
 */
export enum StrainLevel {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MODERATE = 'MODERATE',
  /** If the score cannot be calculated for given period (e.g. due to lack of data). */
  UNAVAILABLE = 'UNAVAILABLE'
}

export type StrainScore = {
  __typename?: 'StrainScore';
  date?: Maybe<Scalars['DateTime']>;
  level?: Maybe<StrainScoreLevel>;
  score?: Maybe<Scalars['Float']>;
};

export type StrainScoreAverage = {
  __typename?: 'StrainScoreAverage';
  level?: Maybe<StrainScoreLevel>;
  score?: Maybe<Scalars['Float']>;
};

/**
 * Strain scores: https://docs.google.com/document/d/16RiGCt9MSLb6lrpeBMFORZP4qsj5pQeEDswpZ-QHcNY/edit
 * Bucket values:
 * Light       1-10
 * Moderate   11-16
 * Strenuous  17-22
 * All Out    23-30+
 *
 * *** DEPRECATED: Use StrainLevel instead ***
 */
export enum StrainScoreLevel {
  ALL_OUT = 'ALL_OUT',
  LIGHT = 'LIGHT',
  MODERATE = 'MODERATE',
  STRENUOUS = 'STRENUOUS',
  /** If the score cannot be calculated for given period (e.g. due to lack of data). */
  UNAVAILABLE = 'UNAVAILABLE'
}

export enum StrainScorePeriod {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export type StrainScoreResult = {
  __typename?: 'StrainScoreResult';
  nextCursor?: Maybe<Scalars['String']>;
  scores: Array<StrainScore>;
};

/**
 * A chip that may be unassigned or may be assigned to someone else.
 * The user is able to request a transfer.
 */
export type StrangerChip = BaseChip & {
  __typename?: 'StrangerChip';
  /**
   * Whether this chip has owner contact information (latestContactHistoryEntry).
   * This allows us to determine if we should show the clear/keep owner info option
   * when reassigning a chip without exposing the actual owner data.
   */
  hasOwner: Scalars['Boolean'];
  id: Scalars['ID'];
  isFiChip: Scalars['Boolean'];
  serialNumber: Scalars['String'];
  shortId: Scalars['String'];
  /**
   * An outstanding transfer related to the chip. This will only be returned if either
   * 1) The transfer is to the current user (canResolve will be true)
   * 2) The transfer was requested by the current user (canResolve will be false)
   */
  transfer?: Maybe<ChipTransfer>;
};

export type StrangerPet = BasePet & {
  __typename?: 'StrangerPet';
  additionalInfo?: Maybe<Scalars['String']>;
  ageRange: AgeRange;
  breed?: Maybe<Breed>;
  color?: Maybe<Scalars['String']>;
  dayOfBirth?: Maybe<Scalars['Int']>;
  discoverPostFeed: PetDiscoverFeed;
  /** Sum of comments and likes made by this pet. */
  engagementScore: Scalars['Int'];
  fiHandle?: Maybe<Scalars['String']>;
  followStatus: FollowStatus;
  followers: StrangerPetFeed;
  following: StrangerPetFeed;
  gender: Gender;
  /** @deprecated Use homeLocation instead */
  homeCityState?: Maybe<Scalars['String']>;
  homeLocation?: Maybe<PetHomeLocation>;
  id: Scalars['ID'];
  instagramHandle?: Maybe<Scalars['String']>;
  isIncludedInRanking: Scalars['Boolean'];
  isPurebred: Scalars['Boolean'];
  monthOfBirth?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** True if the pet joined Fi within the last two weeks. */
  newToFi?: Maybe<Scalars['Boolean']>;
  /** Whether outside time feature is available for this pet in their product availability */
  outsideTimeAvailable: Scalars['Boolean'];
  packFeed: PackFeed;
  petRanking?: Maybe<PackRanking>;
  photos: PhotoFeed;
  /** Whether ranking feature is available for this pet in their product availability */
  rankAvailable: Scalars['Boolean'];
  /** @deprecated Use pet.restFeed */
  restSummaryFeed: RestSummaryFeed;
  species?: Maybe<Species>;
  stepActivityInfo: StepActivityInfo;
  /** Total number of likes for this pet, across walks, photos, etc. */
  totalLikes: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  weight: Scalars['Float'];
  yearOfBirth: Scalars['Int'];
};


export type StrangerPetdiscoverPostFeedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type StrangerPetfollowersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type StrangerPetfollowingArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type StrangerPetpetRankingArgs = {
  limitBy: Array<PetRankFilter>;
};


export type StrangerPetrestSummaryFeedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  period: ActivitySummaryPeriod;
};

export type StrangerPetFeed = {
  __typename?: 'StrangerPetFeed';
  pageInfo: PageInfo;
  strangerPets: Array<StrangerPet>;
  totalCount: Scalars['Int'];
};

export type StrangerUser = {
  __typename?: 'StrangerUser';
  firstName: Scalars['String'];
  id: Scalars['ID'];
  /** Currently just the profile picture from their first pet. */
  profilePicture?: Maybe<Image>;
};

export type StrangerWalk = {
  __typename?: 'StrangerWalk';
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int'];
  /** @deprecated Use liked */
  clapped: Scalars['Boolean'];
  distance: Scalars['Float'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  likeCount: Scalars['Int'];
  liked: Scalars['Boolean'];
  start: Scalars['DateTime'];
  stepCount: Scalars['Int'];
};

export type StreakDetail = {
  __typename?: 'StreakDetail';
  availability: ActivityRestStrainPeriodDataAvailability;
  date: Scalars['DateTime'];
  metStepGoal?: Maybe<Scalars['Boolean']>;
  /**
   * Cursor that can be passed into pet.stepFeed to get get step data for this
   * day, i.e. "jump to date" functionality
   */
  stepFeedCursor: Scalars['String'];
  stepGoal?: Maybe<Scalars['Int']>;
  steps?: Maybe<Scalars['Int']>;
  streakExtended?: Maybe<Scalars['Boolean']>;
  /** Server-generated day label (e.g., "16") */
  title: Scalars['String'];
};

export type StreakHistoryFeed = {
  __typename?: 'StreakHistoryFeed';
  /** cursor is a base64 encoded ISO date string for symmetry with prevCursor */
  cursor: Scalars['String'];
  endDate: Scalars['DateTime'];
  /**
   * prevCursor is a base64 encoded ISO date string.
   *
   * There is no nextCursor as this feed will always start 'now'
   * and only supports swiping back through time.
   */
  prevCursor?: Maybe<Scalars['String']>;
  /** The first and last (inclusive) days that are available in streakDetails. */
  startDate: Scalars['DateTime'];
  /**
   * Index (0-6) indicating where day 1 should appear in the calendar grid.
   * Monday=0, Tuesday=1, ..., Sunday=6
   */
  startPosition: Scalars['Int'];
  /** Streak history for each day of the month. */
  streakDetails: Array<StreakDetail>;
  /** Server-generated month header (e.g., "May 2025") */
  title: Scalars['String'];
};

export type StringFeatureFlag = FeatureFlag & {
  __typename?: 'StringFeatureFlag';
  accessedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  dynamicSettingName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  stringValue: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SubmitHealthGptChatMessageFeedbackInput = {
  feedback?: InputMaybe<Scalars['String']>;
  messageId: Scalars['ID'];
  wasHelpful: Scalars['Boolean'];
};

export type SubmitObservedBehaviorInput = {
  behavior: Scalars['String'];
  eventTs: Scalars['DateTime'];
  petId: Scalars['ID'];
};

export type SubmitObservedBehaviorResponse = {
  __typename?: 'SubmitObservedBehaviorResponse';
  /** Placeholder for future expansion */
  success?: Maybe<Scalars['Boolean']>;
};

export type SubmitRealtimeBehaviorFeedbackInput = {
  eventId: Scalars['ID'];
  feedback: RealtimeBehaviorFeedback;
  feedbackTs: Scalars['DateTime'];
};

export type SubmitRealtimeBehaviorFeedbackResponse = {
  __typename?: 'SubmitRealtimeBehaviorFeedbackResponse';
  /** Placeholder for future expansion */
  success?: Maybe<Scalars['Boolean']>;
};

export type SubmitReportsResult = {
  __typename?: 'SubmitReportsResult';
  /** @deprecated Always HIGH */
  desiredLocationAccuracy: ClientLocationAccuracy;
  moduleResponse?: Maybe<Scalars['String']>;
  quickReportMode: QuickReportModeState;
  /** @deprecated Use `quickReportMode` instead */
  quickReportModeEnabled: Scalars['Boolean'];
  shouldDisconnectFromModule: Scalars['Boolean'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Subscribe to changes in actuation state for a specific device.
   * Returns updates when actuation status changes or when a new actuation is created.
   */
  deviceActuationUpdates: DeviceActuation;
  /** Subscribe to all new location reports */
  newLocationReport?: Maybe<LocationReport>;
  /** Subscribe to snooze status changes for a specific pet. */
  petSnoozeStatusUpdates: PetSnoozeStatus;
  petUpdates: Array<PetUpdate>;
};


export type SubscriptiondeviceActuationUpdatesArgs = {
  moduleId: Scalars['String'];
};


export type SubscriptionnewLocationReportArgs = {
  imei?: InputMaybe<Scalars['String']>;
  moduleId?: InputMaybe<Scalars['String']>;
};


export type SubscriptionpetSnoozeStatusUpdatesArgs = {
  petId: Scalars['ID'];
};


export type SubscriptionpetUpdatesArgs = {
  changeTypes: Array<PetChangeType>;
  petId: Scalars['ID'];
};

export enum SubscriptionAccessType {
  /** Payment has failed to renew the subscription beyond the grace period, payment update is required */
  FAILED_PAYMENT = 'FAILED_PAYMENT',
  /** Indicates that a device has an active subscription and should have access to everything */
  FULL_ACCESS = 'FULL_ACCESS',
  /** An S3 module that has no active subscription and should not have access to any features */
  NO_ACCESS = 'NO_ACCESS',
  /** An S1 or S2 module that has no active subscription and should not have access to GPS or historical data */
  NO_GPS_ACCESS = 'NO_GPS_ACCESS'
}

export type SubscriptionChange = {
  __typename?: 'SubscriptionChange';
  activateAt?: Maybe<Scalars['DateTime']>;
  activated?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  plan?: Maybe<PlanMini>;
  subscriptionId?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionOption = {
  __typename?: 'SubscriptionOption';
  /** @deprecated Use activationFeePricingInCents instead */
  activationFeeInCents?: Maybe<Scalars['Int']>;
  activationFeePricingInCents?: Maybe<PricingByCurrency>;
  attemptUpsellToPlanCode?: Maybe<Scalars['String']>;
  /** @deprecated Use renewalMonths instead */
  billingCadence: BillingCadence;
  billingPeriodsPerTerm: Scalars['Int'];
  buyItMembership: Scalars['Boolean'];
  couponExtensionMonths?: Maybe<Scalars['Int']>;
  daysBetweenShipments?: Maybe<Scalars['Int']>;
  displayedRate: Scalars['String'];
  displayedRateUnit: Scalars['String'];
  featured: Scalars['Boolean'];
  freeTrialDays?: Maybe<Scalars['Int']>;
  /**
   * Deprecated fields
   * @deprecated Use pricingDescription instead
   */
  fullRate?: Maybe<Scalars['String']>;
  /** @deprecated Use pricingDescription instead */
  fullRateUnit?: Maybe<Scalars['String']>;
  inAppManagementName: Scalars['String'];
  isPlusPlan: Scalars['Boolean'];
  monthlyUpgradeSavings?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Used by clients in subscription management e.g., "Monthly membership", "6 month membership" */
  planDescription: Scalars['String'];
  planSwitchAmountChargedInCents?: Maybe<Scalars['Int']>;
  planSwitchCreditAppliedInCents?: Maybe<Scalars['Int']>;
  /** @deprecated Use pricingInCents instead */
  priceInCents: Scalars['Int'];
  /** Used by clients in subscription management e.g., "$19 / month", "$99 / 6 months" */
  pricingDescription: Scalars['String'];
  pricingInCents: PricingByCurrency;
  recommendedForDogSize?: Maybe<SizeOption>;
  recommendedForDogWeightRangePounds?: Maybe<WeightRange>;
  renewalMonths: Scalars['Int'];
  /** @deprecated Use renewalMonths instead */
  renewalYears?: Maybe<Scalars['Int']>;
  savings?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
  supportPlus: Scalars['Boolean'];
  unavailableForTenders: Array<TenderType>;
  upsellOnly: Scalars['Boolean'];
  valueLabel?: Maybe<Scalars['String']>;
  weeksBetweenShipments?: Maybe<Scalars['Int']>;
};

export type SubscriptionPendingChange = {
  __typename?: 'SubscriptionPendingChange';
  subscriptionChange?: Maybe<SubscriptionChange>;
  subscriptionOption?: Maybe<SubscriptionOption>;
};

/** Preview of subscription purchase pricing (from Recurly invoice preview API) */
export type SubscriptionPurchasePreview = {
  __typename?: 'SubscriptionPurchasePreview';
  /** Account balance credit applied in cents (reduces total) */
  appliedAccountBalanceInCents: Scalars['Int'];
  /** Base price in cents */
  basePriceInCents: Scalars['Int'];
  /** Line items from Recurly invoice preview */
  lineItems: Array<PreviewLineItem>;
  /** Override price in cents (if set) */
  overridePriceInCents?: Maybe<Scalars['Int']>;
  /** SKU being previewed */
  sku: Scalars['String'];
  /** Tax amount in cents */
  taxInCents: Scalars['Int'];
  /** Total amount to charge in cents (after account balance applied) */
  totalInCents: Scalars['Int'];
};

/** Preview of subscription refund amounts for different refund options */
export type SubscriptionRefundPreview = {
  __typename?: 'SubscriptionRefundPreview';
  /** Currency of the subscription (USD or CAD) */
  currency: Scalars['String'];
  /** Amount refunded for full refund in cents */
  fullRefundAmount: Scalars['Int'];
  /** Most recent invoice number for this subscription */
  mostRecentInvoiceNumber?: Maybe<Scalars['String']>;
  /** Amount refunded for no refund option (always 0) */
  noRefundAmount: Scalars['Int'];
  /** Amount refunded for prorated refund in cents */
  proratedRefundAmount: Scalars['Int'];
  /** Subscription ID */
  subscriptionId: Scalars['String'];
};

/** Refund type options for subscription cancellation */
export enum SubscriptionRefundType {
  /** Immediate cancellation with full refund */
  FULL_REFUND = 'FULL_REFUND',
  /** Cancel at end of current term, no refund */
  NO_REFUND = 'NO_REFUND',
  /** Immediate cancellation with prorated refund */
  PRORATED_REFUND = 'PRORATED_REFUND'
}

export type SubscriptionRenewalPreview = {
  __typename?: 'SubscriptionRenewalPreview';
  appliedDiscountInCents: Scalars['Int'];
  subtotalInCents: Scalars['Int'];
  taxInCents: Scalars['Int'];
  totalInCents: Scalars['Int'];
};

export type SubscriptionRenewalStatus = {
  __typename?: 'SubscriptionRenewalStatus';
  reason?: Maybe<Scalars['String']>;
  shouldOfferSubscriptionRenewal: Scalars['Boolean'];
};

export type SuggestedPacksResult = {
  __typename?: 'SuggestedPacksResult';
  packs: Array<Pack>;
};

export type SuggestedPet = {
  __typename?: 'SuggestedPet';
  strangerPet: StrangerPet;
  suggestionContextString?: Maybe<Scalars['String']>;
  /** Used in Carousel suggestions. */
  suggestionFormatString?: Maybe<FormatString>;
};

export enum SuggestedPetCategoryType {
  CONTACTS = 'CONTACTS',
  ENGAGED_WITH = 'ENGAGED_WITH',
  FOLLOWS_YOU = 'FOLLOWS_YOU',
  NEARBY_HOME = 'NEARBY_HOME',
  NEARBY_PET = 'NEARBY_PET',
  SAME_AGE = 'SAME_AGE'
}

export type SuggestedPetFeed = {
  __typename?: 'SuggestedPetFeed';
  suggestedPets: Array<SuggestedPet>;
  type: SuggestedPetCategoryType;
};

export type SuggestedPetResult = {
  __typename?: 'SuggestedPetResult';
  suggestionCategories: Array<SuggestedPetFeed>;
};

export type SupplementShipmentDates = {
  __typename?: 'SupplementShipmentDates';
  displayDate: Scalars['DateTime'];
  latestSkipDate: Scalars['DateTime'];
  nextShipmentDate: Scalars['DateTime'];
  previewResumingShipmentDate: Scalars['DateTime'];
  previewSkippingShipmentDate: Scalars['DateTime'];
  previewUpdate: Array<SupplementUpdatePreview>;
};

export type SupplementUpdatePreview = {
  __typename?: 'SupplementUpdatePreview';
  nextShipDate: Scalars['DateTime'];
  sku: Scalars['String'];
};

export type SuppressedNotificationLog = {
  __typename?: 'SuppressedNotificationLog';
  debugMetadata: Scalars['JSON'];
  notificationMessage: Scalars['String'];
  notificationType: Scalars['String'];
  pet?: Maybe<Pet>;
  suppressionType: Scalars['String'];
  timestamp: Scalars['DateTime'];
  user: User;
};

export type SyncOrdersInput = {
  externalOrderIds: Array<Scalars['ID']>;
  orderSource: OrderSource;
};

export type SyncOrdersResults = {
  __typename?: 'SyncOrdersResults';
  created: Scalars['Int'];
  errors: Scalars['Int'];
  filtered: Scalars['Int'];
  new: Scalars['Int'];
};

export type TActivityReportEvent = TEvent & {
  __typename?: 'TActivityReportEvent';
  activityReport: ActivityReport;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type TAppLaunchEvent = TEvent & {
  __typename?: 'TAppLaunchEvent';
  applicationState?: Maybe<ApplicationState>;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  user: User;
};

export type TCollapsedEvents = TEvent & {
  __typename?: 'TCollapsedEvents';
  allEvents: Array<TEvent>;
  count: Scalars['Int'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  /** Expose first/last event separately so you don't need to select all of `allEvents`. */
  firstEvent: TEvent;
  id: Scalars['ID'];
  /** Expose first/last event separately so you don't need to select all of `allEvents`. */
  lastEvent: TEvent;
};

export type TConnectionHistoryEvent = TEvent & {
  __typename?: 'TConnectionHistoryEvent';
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  state: ConnectionState;
};

export type TDeviceInfoEvent = TEvent & {
  __typename?: 'TDeviceInfoEvent';
  date: Scalars['DateTime'];
  description: Scalars['String'];
  deviceInfo: Scalars['JSON'];
  id: Scalars['ID'];
};

export type TDeviceRestartEvent = TEvent & {
  __typename?: 'TDeviceRestartEvent';
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  newUptime: Scalars['Int'];
  oldDate: Scalars['DateTime'];
  oldUptime: Scalars['Int'];
};

export type TEvent = {
  date: Scalars['DateTime'];
  /** A simple string description of the event, useful for ad-hoc querying. */
  description: Scalars['String'];
  id: Scalars['ID'];
};

export enum TEventType {
  ACTIVITY_REPORT = 'ACTIVITY_REPORT',
  APP_LAUNCH = 'APP_LAUNCH',
  CONNECTION_HISTORY = 'CONNECTION_HISTORY',
  /**
   * Includes some handy events derived from device-info, like device restarts
   * based on uptime.
   */
  DEVICE_EVENTS = 'DEVICE_EVENTS',
  DEVICE_INFO = 'DEVICE_INFO',
  FIRMWARE_UPDATE = 'FIRMWARE_UPDATE',
  LED_EVENT = 'LED_EVENT',
  LOCATION_REPORT = 'LOCATION_REPORT',
  LOST_DOG_MODE_TOGGLE = 'LOST_DOG_MODE_TOGGLE',
  MOBILITY_REPORT = 'MOBILITY_REPORT',
  MODULE_LOG = 'MODULE_LOG',
  NOTIFICATION_SEND = 'NOTIFICATION_SEND',
  OPERATION_PARAMS_CHANGE = 'OPERATION_PARAMS_CHANGE',
  PET_STATE = 'PET_STATE',
  STATS_CHANGED = 'STATS_CHANGED',
  SUPPRESSED_ESCAPE = 'SUPPRESSED_ESCAPE',
  SUPPRESSED_NOTIFICATION = 'SUPPRESSED_NOTIFICATION',
  WARNING = 'WARNING',
  WEBSOCKET_EVENTS = 'WEBSOCKET_EVENTS'
}

export type TFirmwareUpdateEvent = TEvent & {
  __typename?: 'TFirmwareUpdateEvent';
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  newVersion: Scalars['String'];
  oldVersion?: Maybe<Scalars['String']>;
};

export type TGenericLogEvent = TEvent & {
  __typename?: 'TGenericLogEvent';
  attributes?: Maybe<Scalars['JSON']>;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  level: LogLevel;
  message: Scalars['String'];
};

export type TLedEvent = TEvent & {
  __typename?: 'TLedEvent';
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  ledOn: Scalars['Boolean'];
};

export type TLocationReportEvent = TEvent & {
  __typename?: 'TLocationReportEvent';
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  locationReport: LocationReport;
};

export type TLostDogModeToggleEvent = TEvent & {
  __typename?: 'TLostDogModeToggleEvent';
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  ldmOn: Scalars['Boolean'];
  userEmail?: Maybe<Scalars['String']>;
};

export type TMobilityReportEvent = TEvent & {
  __typename?: 'TMobilityReportEvent';
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  mobilityReport: MobilityReport;
};

export type TModemRegistrationFailuresEvent = TEvent & {
  __typename?: 'TModemRegistrationFailuresEvent';
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  numFailures: Scalars['Int'];
};

export type TModuleLogEvent = TEvent & {
  __typename?: 'TModuleLogEvent';
  attributes: Scalars['JSON'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  hsmTransitionDetails?: Maybe<ModuleHSMTransitionDetails>;
  id: Scalars['ID'];
  logType: Scalars['String'];
  message: Scalars['String'];
};

export type TNotificationSendEvent = TEvent & {
  __typename?: 'TNotificationSendEvent';
  channel: NotificationChannel;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
  user: User;
};

export type TOperationParamsChangeEvent = TEvent & {
  __typename?: 'TOperationParamsChangeEvent';
  /** @deprecated Use reason */
  controlEntry?: Maybe<Array<Maybe<Scalars['String']>>>;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  newMode?: Maybe<Scalars['String']>;
  newParams: Scalars['JSON'];
  oldMode?: Maybe<Scalars['String']>;
  oldParams: Scalars['JSON'];
  reason?: Maybe<Scalars['String']>;
};

export type TPetStateChangeEvent = TEvent & {
  __typename?: 'TPetStateChangeEvent';
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  newState: PetState;
  oldState: PetState;
};

export type TStatsChangedEvent = TEvent & {
  __typename?: 'TStatsChangedEvent';
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  newDeviceInfo: Scalars['JSON'];
  oldDeviceInfo: Scalars['JSON'];
  statsChanged: Array<StatChanged>;
};

export type TSuppressedEscapeEvent = TEvent & {
  __typename?: 'TSuppressedEscapeEvent';
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  pet: Pet;
  statePlaceId?: Maybe<Scalars['Int']>;
  suppressionReason: Scalars['String'];
  totalReportsOutsidePlace: Scalars['Int'];
  weightedAverageSteps: Scalars['Float'];
  weightedStepThreshold: Scalars['Float'];
};

export type TSuppressedNotificationEvent = TEvent & {
  __typename?: 'TSuppressedNotificationEvent';
  date: Scalars['DateTime'];
  debugMetadata: Scalars['JSON'];
  description: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
  suppressionType: Scalars['String'];
  user: User;
};

export type TWebsocketEvent = TEvent & {
  __typename?: 'TWebsocketEvent';
  backhaul?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
  protocol?: Maybe<Scalars['String']>;
  session: Scalars['JSON'];
  sessionId: Scalars['String'];
};

export type TargetedFeatureFlag = {
  __typename?: 'TargetedFeatureFlag';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value: Scalars['Boolean'];
};

export enum TenderType {
  CREDIT_CARD = 'CREDIT_CARD',
  PAYPAL = 'PAYPAL'
}

export type TextPost = {
  __typename?: 'TextPost';
  comments: CommentFeed;
  date: Scalars['DateTime'];
  /** Admin-only */
  dbId: Scalars['Int'];
  deleted: Scalars['Boolean'];
  id: Scalars['ID'];
  likeCount: Scalars['Int'];
  /** If the current user has liked this post. */
  liked: Scalars['Boolean'];
  likedByPets: Array<StrangerPet>;
  /** Pet associated with this post, if any. */
  pet: StrangerPet;
  poster: StrangerUser;
  publicShareLink?: Maybe<Scalars['String']>;
  style: TextPostStyle;
  text: Scalars['String'];
};

export type TextPostModerationFeed = ModerationFeed & {
  __typename?: 'TextPostModerationFeed';
  items: Array<ModerationTextPostItem>;
  totalCount: Scalars['Int'];
};

export type TextPostStyle = {
  __typename?: 'TextPostStyle';
  backgroundColorHex: Scalars['String'];
  backgroundEndColorHex: Scalars['String'];
  /** @deprecated Android is querying this field, but it is not used. */
  backgroundPhoto?: Maybe<Photo>;
  id: Scalars['ID'];
  textColorHex: Scalars['String'];
};

export type ThirdPartyChipInput = {
  serialNumber: Scalars['String'];
};

export type ThirdPartyData = {
  __typename?: 'ThirdPartyData';
  data: AirvetDataItem;
  thirdPartyId: ThirdPartyId;
};

export enum ThirdPartyId {
  AIRVET = 'AIRVET',
  COSTCO_COM = 'COSTCO_COM',
  VERIZON = 'VERIZON'
}

export type TimeBoundStepCount = {
  __typename?: 'TimeBoundStepCount';
  end: Scalars['DateTime'];
  /** Activity level in percent (0-1). */
  percentActive: Scalars['Float'];
  start: Scalars['DateTime'];
  steps: Scalars['Int'];
};

export type TimeRangeEvent = {
  end?: Maybe<Scalars['DateTime']>;
  start?: Maybe<Scalars['DateTime']>;
};

export enum TimelineAggregation {
  COLLAPSE_SIMILAR = 'COLLAPSE_SIMILAR'
}

/**
 * Rudimentary filters that will be applied where applicable.
 * These are purposely not very generic -- we're not implementing a full-fledged
 * query language.
 */
export type TimelineFieldFilter = {
  reportBackhaulsIn?: InputMaybe<Array<Scalars['String']>>;
  reportSourcesIn?: InputMaybe<Array<Scalars['String']>>;
};

export type TimelineIntervalPagination = {
  end?: InputMaybe<Scalars['DateTime']>;
  start: Scalars['DateTime'];
};

export type TimelineLimitBeforePagination = {
  /**
   * This before date is used with a LessThan comparison so that the last element of the previous page can be passed directly here
   * and not return duplicate records
   */
  before?: InputMaybe<Scalars['DateTime']>;
  limit: Scalars['Int'];
};

/** Exactly one of the members must be set. */
export type TimelinePagination = {
  interval?: InputMaybe<TimelineIntervalPagination>;
  limitBefore?: InputMaybe<TimelineLimitBeforePagination>;
};

export type TimelineQueryClause = {
  /** BETA! Still trying to figure out the best level to apply aggregation on. */
  aggregation?: InputMaybe<TimelineAggregation>;
  fieldFilter?: InputMaybe<TimelineFieldFilter>;
  /** Event types we are interested in */
  types: Array<TEventType>;
};

export type TimelineQueryInput = {
  /** Return results matching ANY of these clauses. */
  clauses: Array<TimelineQueryClause>;
  /** Causes some data nodes to emit example events */
  debugEvents?: InputMaybe<Scalars['Boolean']>;
  pagination: TimelinePagination;
};

export type TimelineQueryResult = {
  __typename?: 'TimelineQueryResult';
  events: Array<TEvent>;
};

export type TokenValidity = InvalidToken | ValidToken;

/** Result of checking transfer eligibility for a device. */
export type TransferEligibility = {
  __typename?: 'TransferEligibility';
  /** Whether the transfer is allowed */
  eligible: Scalars['Boolean'];
  /** Human-readable reason if transfer is not eligible */
  reason?: Maybe<Scalars['String']>;
  /** Whether the transfer requires shipping new hardware */
  requiresNewHardware: Scalars['Boolean'];
  /** Whether the transfer involves prorated credit from old subscription */
  requiresProration: Scalars['Boolean'];
  /** Module ID of the source device */
  sourceModuleId: Scalars['String'];
  /** Target platform type (e.g., FC3B, M1) */
  targetPlatformType: Scalars['String'];
  /** Type of transfer flow to use (null if not eligible) */
  transferType?: Maybe<ProductTransferType>;
};

export type TransferPreviewItem = {
  __typename?: 'TransferPreviewItem';
  /** Only for PRORATED_UPGRADE */
  membershipChargeInCents: Scalars['Int'];
  /** Only for PRORATED_UPGRADE */
  proratedCreditInCents: Scalars['Int'];
  /** 'unchanged' for SKU_ONLY, 'reset' for PRORATED_UPGRADE */
  renewalDateChange: Scalars['String'];
  sourceModuleId: Scalars['String'];
  sourcePlanCode?: Maybe<Scalars['String']>;
  targetModuleId?: Maybe<Scalars['String']>;
  targetPlanCode: Scalars['String'];
  transferType: ProductTransferType;
};

/** Result of a single device transfer. */
export type TransferResultItem = {
  __typename?: 'TransferResultItem';
  /** Error message if success is false */
  error?: Maybe<Scalars['String']>;
  sourceModuleId: Scalars['String'];
  /** Subscription ID (same as source for SKU_ONLY, new for PRORATED_UPGRADE) */
  subscriptionId: Scalars['String'];
  success: Scalars['Boolean'];
  targetModuleId: Scalars['String'];
  transferType: ProductTransferType;
};

export type Travel = Activity & {
  __typename?: 'Travel';
  address?: Maybe<Scalars['String']>;
  areaName?: Maybe<Scalars['String']>;
  cityState?: Maybe<Scalars['String']>;
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int'];
  dbId: Scalars['Int'];
  debugMetadata: Scalars['JSON'];
  /** Distance in meters traveled */
  distance: Scalars['Float'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  /** @deprecated Use isLikable */
  isClappable: Scalars['Boolean'];
  isLikable: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  mapUrl: Scalars['String'];
  neighborhood?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  obfuscated: Scalars['Boolean'];
  positions: Array<Position>;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']>;
  start: Scalars['DateTime'];
  totalSteps: Scalars['Int'];
};


export type TravelmapUrlArgs = {
  height: Scalars['Int'];
  minimumPadding?: InputMaybe<PaddingInput>;
  scale?: InputMaybe<Scalars['Int']>;
  style?: InputMaybe<MapStyle>;
  width: Scalars['Int'];
};

export type TrueBooleanSetting = BooleanSetting & {
  __typename?: 'TrueBooleanSetting';
  /**
   * DO NOT USE: This is required since GraphQL doesn't support empty types.
   * Use the __typename to determine the flag's boolean value.
   */
  emptyType?: Maybe<Scalars['Boolean']>;
  platformOverrides: Array<BooleanSettingPlatformOverride>;
};

export type TwoLinePromotionBanner = InAppPromotionBanner & {
  __typename?: 'TwoLinePromotionBanner';
  backgroundColorHex: Scalars['String'];
  ctaUrl: Scalars['String'];
  id: Scalars['ID'];
  line1Text: FormatString;
  line1TextColorHex: Scalars['String'];
  line2Text: FormatString;
  line2TextColorHex: Scalars['String'];
};

export type UnavailableDailyRestSummary = DailyRestSummary & {
  __typename?: 'UnavailableDailyRestSummary';
  date: Scalars['DateTime'];
};

export type UnavailableOvernightRestSummary = OvernightRestSummary & {
  __typename?: 'UnavailableOvernightRestSummary';
  date: Scalars['DateTime'];
  inProgress: Scalars['Boolean'];
};

export type UnavailableRestSummaryData = {
  __typename?: 'UnavailableRestSummaryData';
  /** This field is always null, it's added because GraphQL doesn't support empty types. */
  unavailable?: Maybe<Scalars['Boolean']>;
};

export type UncertaintyInfo = {
  __typename?: 'UncertaintyInfo';
  areaName?: Maybe<Scalars['String']>;
  circle: Circle;
  updatedAt: Scalars['DateTime'];
};

export type UnknownConnectivity = ConnectionState & {
  __typename?: 'UnknownConnectivity';
  date: Scalars['DateTime'];
  /** Always null, added so that fragments can have something to select. */
  unknownConnectivity?: Maybe<Scalars['Boolean']>;
};

export type UnmatchedPath = {
  __typename?: 'UnmatchedPath';
  locations: Array<Location>;
};

export type UnregisterHandsetLiveActivityTokenInput = {
  deviceToken: Scalars['String'];
};

export type UpdateChangeLogInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  type?: InputMaybe<ChangeLogType>;
  version?: InputMaybe<Scalars['String']>;
};

export type UpdateChargingBaseInput = {
  bleTxPowerLevel?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<PositionInput>;
  tenancy?: InputMaybe<Scalars['String']>;
};

export type UpdateChipConditionInput = {
  chipCondition: ChipCondition;
  chipId: Scalars['ID'];
};

export type UpdateChipContactInfoInput = {
  chipId: Scalars['ID'];
  contactInfo: ChipContactInfoInput;
  petId?: InputMaybe<Scalars['ID']>;
};

export type UpdateChipContactInfoResult = {
  __typename?: 'UpdateChipContactInfoResult';
  contactInfoResponse: ChipContactInfoResponse;
  /**
   * True if the pet ownership was transferred as part of this operation. The current
   * user may no longer own the pet associated with the chip.
   */
  petOwnershipWasTransferred: Scalars['Boolean'];
};

export type UpdateChipResellerInfoInput = {
  contactInfo?: InputMaybe<ChipResellerContactInfoInput>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<ChipResellerShippingAddressInput>;
  taxExemptType?: InputMaybe<ResellerTaxExemptType>;
};

export type UpdateConsignmentAccountInput = {
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  fiSalesRepEmail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateConsignmentLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  recipientName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type UpdateDeviceOperationParamsInput = {
  ledEnabled?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<OperationParamsMode>;
  moduleId?: InputMaybe<Scalars['ID']>;
  reboot?: InputMaybe<Scalars['Boolean']>;
  remoteLogLevel?: InputMaybe<RemoteLogLevel>;
  requestLppp?: InputMaybe<Scalars['Boolean']>;
  wifiDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDogParkNotificationSettingsInput = {
  dogParkId: Scalars['ID'];
  /**
   * Update preferences for the specified user instead of the currently logged-in
   * user (admin only).
   */
  forUserId?: InputMaybe<Scalars['ID']>;
  settingInput: DogParkNotificationSettingsInput;
};

export type UpdateDynamicEnumMemberInput = {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
};

export type UpdateFiNewsNotificationInput = {
  featureImageUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateFirmwareChannelInput = {
  channelName: Scalars['String'];
  platform: Scalars['String'];
  releaseClass?: InputMaybe<FirmwareReleaseClass>;
  type?: InputMaybe<FirmwareUpdateType>;
  version?: InputMaybe<Scalars['String']>;
};

export type UpdateFirmwareInput = {
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  releaseClass?: InputMaybe<FirmwareReleaseClass>;
};

export type UpdateFrequencyOption = {
  __typename?: 'UpdateFrequencyOption';
  batteryDescription: Scalars['String'];
  updateInterval: Scalars['Int'];
};

export type UpdateGingrBoardingFacilityInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  apiSubdomain?: InputMaybe<Scalars['String']>;
  boardingFacilityId: Scalars['ID'];
  locationId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  /** The timezone for the boarding facility (e.g., "America/New_York"). */
  timezone?: InputMaybe<Scalars['String']>;
};

export type UpdateInPersonEventInput = {
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['String'];
  id: Scalars['ID'];
  location: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['String'];
};

export type UpdateInPersonEventInventoryInput = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  sku: Scalars['String'];
};

export type UpdateMobileAppBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['HexColorCode']>;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  description?: InputMaybe<Scalars['String']>;
  destinationUrl?: InputMaybe<Scalars['String']>;
  foregroundColorHex?: InputMaybe<Scalars['HexColorCode']>;
  id: Scalars['ID'];
  internalName?: InputMaybe<Scalars['String']>;
  leadingImage?: InputMaybe<MobileAppBannerImageInput>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateMobileAppBlockerScreenInput = {
  bottomSheet?: InputMaybe<CreateMobileAppBottomSheetInput>;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  id: Scalars['ID'];
  internalName?: InputMaybe<Scalars['String']>;
  /** If pages are being updated, all pages must be provided, updating individual pages is not supported */
  pages?: InputMaybe<Array<CreateMobileAppBlockerScreenPageInput>>;
};

export type UpdateMobileAppBottomSheetInput = {
  /** If buttons are being updated, all buttons must be provided, updating individual buttons is not supported */
  buttons: Array<CreateMobileAppBottomSheetButtonInput>;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  description: Scalars['String'];
  id: Scalars['ID'];
  image?: InputMaybe<CreateMobileAppBottomSheetImageInput>;
  internalName?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdateMobileAppDiscoverItemInput = {
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  description?: InputMaybe<Scalars['String']>;
  destinationUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  internalName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateMobileAppPermissionBlockerScreenInput = {
  bottomSheet?: InputMaybe<CreateMobileAppBottomSheetInput>;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  dismissable?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  internalName?: InputMaybe<Scalars['String']>;
  /** If pages are being updated, all pages must be provided, updating individual pages is not supported */
  pages?: InputMaybe<Array<CreateMobileAppBlockerScreenPageInput>>;
  permissionType?: InputMaybe<Scalars['String']>;
};

export type UpdateMobileAppSplashScreenInput = {
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  id: Scalars['ID'];
  internalName?: InputMaybe<Scalars['String']>;
  /** If pages are being updated, all pages must be provided, updating individual pages is not supported */
  pages?: InputMaybe<Array<CreateMobileAppSplashScreenPageInput>>;
};

export type UpdateOrderShippingAddressInput = {
  id: Scalars['ID'];
  shippingAddress: OrderShippingAddressInput;
};

export type UpdateOrderShippingOptionInput = {
  id: Scalars['ID'];
  shippingOption: ShippingOption;
};

export type UpdatePetAlertPreferencesInput = {
  alertsEnabled?: InputMaybe<Scalars['Boolean']>;
  changeSettings?: InputMaybe<Array<PetNotificationSettingInput>>;
  /**
   * Update preferences for the specified user instead of the currently logged-in
   * user (admin only).
   */
  forUserId?: InputMaybe<Scalars['ID']>;
  notificationMode?: InputMaybe<PetNotificationMode>;
  /** A value of 0 means these notifications should be turned off. */
  numMinutesForOfflineNotification?: InputMaybe<Scalars['Int']>;
  petId: Scalars['ID'];
};

export type UpdatePetCityStateInput = {
  city: Scalars['String'];
  id: Scalars['ID'];
  state: Scalars['String'];
};

export type UpdatePetDocumentInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  labels?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  totalCostCents?: InputMaybe<Scalars['Int']>;
};

export type UpdatePetInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  breedId?: InputMaybe<Scalars['ID']>;
  color?: InputMaybe<Scalars['String']>;
  dayOfBirth?: InputMaybe<Scalars['Int']>;
  fiHandle?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['ID'];
  isIncludedInRanking?: InputMaybe<Scalars['Boolean']>;
  isPurebred?: InputMaybe<Scalars['Boolean']>;
  monthOfBirth?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  species?: InputMaybe<Species>;
  tenancy?: InputMaybe<Scalars['String']>;
  thirdPartyAccess?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
  yearOfBirth?: InputMaybe<Scalars['Int']>;
};

export type UpdatePhoneNumberAndAutoAcceptInvitesResult = {
  __typename?: 'UpdatePhoneNumberAndAutoAcceptInvitesResult';
  acceptedUserHouseholds: Array<UserHousehold>;
  acceptedUserInvites: Array<UserInvite>;
  user: User;
};

export type UpdatePhoneNumberInput = {
  phoneNumber: Scalars['String'];
  verificationCode: Scalars['String'];
};

export type UpdatePlaceInput = {
  address?: InputMaybe<Scalars['String']>;
  /** Should only be set for polygon safe zones. */
  boundary?: InputMaybe<Scalars['JSON']>;
  coordinates?: InputMaybe<Array<PositionInput>>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<PositionInput>;
  /** Should only be set for circle safe zones. */
  radius?: InputMaybe<Scalars['Float']>;
  /**
   * Optional containment zone for sound feedback. Set to create/update, omit to leave unchanged.
   * To remove an existing sound zone, use removeContainmentZonesForSafeZone mutation.
   */
  soundZone?: InputMaybe<CreateContainmentZoneInput>;
  subjectId: Scalars['ID'];
  /** Circle or polygon safe zone. */
  type?: InputMaybe<PlaceType>;
  /**
   * Optional containment zone for vibration feedback. Set to create/update, omit to leave unchanged.
   * To remove an existing vibration zone, use removeContainmentZonesForSafeZone mutation.
   */
  vibrationZone?: InputMaybe<CreateContainmentZoneInput>;
};

export type UpdatePromotionInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  internalName?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  variants?: InputMaybe<Scalars['JSON']>;
};

export type UpdateResellerContactInfoInput = {
  contactInfo: ChipContactInfoInput;
  resellerId: Scalars['ID'];
  shippingAddress?: InputMaybe<AddressInput>;
};

export type UpdateResellerRescueVerified = {
  subjectId: Scalars['ID'];
  verified: Scalars['Boolean'];
};

export type UpdateShelterluvConfigInput = {
  chipResellerId: Scalars['ID'];
  shelterluvConfiguration: ShelterluvConfigurationInput;
};

export type UpdateSupplementSubscriptionInput = {
  newSku: Scalars['String'];
  recurlySubscriptionId: Scalars['ID'];
};

export type UpdateSupplementSubscriptionResult = {
  __typename?: 'UpdateSupplementSubscriptionResult';
  reasonForFailure?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateUserCommunicationPreferencesInput = {
  pushEnabled: Scalars['Boolean'];
  smsEnabled: Scalars['Boolean'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  subjectId: Scalars['ID'];
  tenancy?: InputMaybe<Scalars['String']>;
  thirdPartyAccess?: InputMaybe<Scalars['String']>;
};

export type UpdateUserLocalePreferencesInput = {
  distanceUnit?: InputMaybe<DistanceUnit>;
  language?: InputMaybe<FiLanguage>;
  region?: InputMaybe<FiCountry>;
  weightUnit?: InputMaybe<WeightUnit>;
};

export type UpdateWifiNetworkInput = {
  householdId: Scalars['ID'];
  isHidden?: InputMaybe<Scalars['Boolean']>;
  newPsk?: InputMaybe<Scalars['String']>;
  newSsid?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<PositionInput>;
  ssid: Scalars['String'];
};

export type UpgradeMembershipInput = {
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  couponCodes?: InputMaybe<Array<Scalars['String']>>;
  currency?: InputMaybe<Currency>;
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']>;
  moduleId: Scalars['ID'];
  sku: Scalars['ID'];
  threeDSecureActionResultToken?: InputMaybe<Scalars['String']>;
};

export type UpgradeToSeriesThreePlusModuleInput = {
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']>;
  moduleId: Scalars['ID'];
};

export type UploadContactInput = {
  contacts: Array<ContactInfo>;
};

export type User = {
  __typename?: 'User';
  automaticallyActivateDevices: Scalars['Boolean'];
  billingAccount?: Maybe<BillingAccount>;
  /**
   * In-app subscription management (aka in-app cancellation)
   * @deprecated No longer needed
   */
  canManageSupplementSubscriptions?: Maybe<Scalars['Boolean']>;
  /** Chip reseller associated with this user, if any. */
  chipReseller?: Maybe<ChipReseller>;
  /** @deprecated Use chips instead */
  chipTransfersToUser: Array<ChipTransfer>;
  chips: Array<BaseChip>;
  dbId: Scalars['Int'];
  deactivated: Scalars['Boolean'];
  discoverFeed: DiscoverFeed;
  /**
   * A URL that users can use to update their payment information. This calls the
   * recurly API so only request when needed.
   */
  editBillingInfoUrl?: Maybe<Scalars['String']>;
  /** Refers to user's primary email */
  email: Scalars['String'];
  emails: Array<UserEmail>;
  fiFeed: FiFeed;
  fiNewsNotificationsEnabled: Scalars['Boolean'];
  firstName: Scalars['String'];
  /**
   * Access is restricted to admins. To alter client behavior based on
   * a user's groups, create a new feature flag.
   */
  groups: Array<UserGroup>;
  handsets: Array<Handset>;
  /** Returns true if the user has the multidog discount coupon applied in Recurly. */
  hasMultidogDiscount: Scalars['Boolean'];
  hasPurchasedSupplementSubscription?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use userHouseholds instead */
  households: Array<Household>;
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  isRescuePartner: Scalars['Boolean'];
  isVerizonCustomer: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  latestLocation?: Maybe<Location>;
  /**
   * Whether the user has opted in to marketing emails (Product Updates & Promotions topic in CIO).
   * Read from Customer.io subscription preferences. Defaults to true for users who haven't been asked.
   */
  marketingEmailsOptedIn: Scalars['Boolean'];
  muteAllSearchParties: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  notificationFeed: NotificationFeed;
  phoneNumber?: Maybe<Scalars['String']>;
  /** Returns phone support details for this user. */
  phoneSupport: PhoneSupport;
  /**
   * Returns all collar kit product IDs that the user has previously purchased (excluding canceled orders).
   * Used by the frontend to prevent showing free trial options for products the user already owns.
   */
  previouslyPurchasedCollarProductIds: Array<Scalars['String']>;
  /** Returns all pets that can be recalled by this user. */
  recallableTransferredPets: Array<Pet>;
  referrals: Referrals;
  settings: UserSettings;
  socialBanned: Scalars['Boolean'];
  /** Returns all feature flag values by default, but can optionally provide an array of feature flag names to return */
  targetedFeatureFlags: Array<TargetedFeatureFlag>;
  tenancy?: Maybe<Scalars['String']>;
  thirdPartyAccess?: Maybe<Scalars['String']>;
  thirdPartyData: Array<Maybe<ThirdPartyData>>;
  /** @deprecated All subscription data will be in thirdPartyData */
  thirdPartySubscriptions?: Maybe<Array<Maybe<BillingSubscription>>>;
  timezone: Scalars['String'];
  /** Returns all pets that can be temporarily transferred by this user. */
  transferablePets: Array<Pet>;
  userHouseholds: Array<UserHousehold>;
};


export type UserchipTransfersToUserArgs = {
  query?: InputMaybe<ChipTransferQueryInput>;
};


export type UserdiscoverFeedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  pulledToRefresh?: InputMaybe<Scalars['Boolean']>;
};


export type UserfiFeedArgs = {
  filter?: InputMaybe<FiFeedFilter>;
  includeTravel?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  seekParameters?: InputMaybe<SeekParameters>;
};


export type UsergroupsArgs = {
  excludePseudo?: InputMaybe<Scalars['Boolean']>;
};


export type UserhandsetsArgs = {
  status?: InputMaybe<Array<HandsetStatus>>;
};


export type UsernotificationFeedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};


export type UsertargetedFeatureFlagsArgs = {
  names?: InputMaybe<Array<Scalars['String']>>;
};


export type UserthirdPartyDataArgs = {
  id?: InputMaybe<ThirdPartyId>;
};


export type UseruserHouseholdsArgs = {
  householdIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UserAccountDeletionInput = {
  userId: Scalars['ID'];
};

/** Info for a user's contacts uploaded from their phone. */
export type UserContactInfo = {
  __typename?: 'UserContactInfo';
  emails?: Maybe<Array<Scalars['String']>>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Scalars['String']>>;
};

export enum UserDevice {
  PHONE = 'PHONE',
  WEARABLE = 'WEARABLE'
}

export type UserEmail = {
  __typename?: 'UserEmail';
  email: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
};

export type UserFeedbackActivityPlayFeedbackSubmitInput = {
  feedback: Scalars['String'];
  playEventId: Scalars['ID'];
};

export type UserFeedbackActivityRestFeedbackSubmitInput = {
  feedback: Scalars['String'];
  restEventId: Scalars['ID'];
};

export type UserFeedbackActivityTravelFeedbackSubmitInput = {
  feedback: Scalars['String'];
  travelEventId: Scalars['ID'];
};

export type UserFeedbackActivityWalkFeedbackSubmitInput = {
  feedback: Scalars['String'];
  walkEventId: Scalars['ID'];
};

export type UserFeedbackEscapeAlertFeedbackSubmitInput = {
  escapeAlertNotificationId: Scalars['ID'];
  feedback: Scalars['String'];
  isNotificationAccurate?: InputMaybe<Scalars['Boolean']>;
  petId?: InputMaybe<Scalars['ID']>;
};

export type UserFeedbackLostDogFeedbackSubmitInput = {
  feedback: Scalars['String'];
  petId?: InputMaybe<Scalars['ID']>;
};

export type UserFeedbackLostDogModeDidHelpInput = {
  didHelp: Scalars['Boolean'];
  petId?: InputMaybe<Scalars['ID']>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Similar to household but augmented with user specific data */
export type UserHousehold = {
  __typename?: 'UserHousehold';
  /** Whether this is the first user household that was created for this user. */
  firstCreated: Scalars['Boolean'];
  household: Household;
  householdRole: UserHouseholdRole;
};

export enum UserHouseholdRole {
  CARETAKER = 'CARETAKER',
  OWNER = 'OWNER',
  PROVISIONAL_CARETAKER = 'PROVISIONAL_CARETAKER'
}

export type UserIdsBooleanSetting = BooleanSetting & {
  __typename?: 'UserIdsBooleanSetting';
  platformOverrides: Array<BooleanSettingPlatformOverride>;
  userIds: Array<Scalars['Int']>;
};

export type UserInvite = {
  __typename?: 'UserInvite';
  acceptedDate?: Maybe<Scalars['DateTime']>;
  /**
   * This is admin-only for now because we don't expose the User type for other users,
   * and invites can be accessed at a household level where you may receive another user's
   * invite.
   */
  adminInviter: User;
  createdAt: Scalars['DateTime'];
  dbId: Scalars['Int'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  householdInvite?: Maybe<HouseholdInvite>;
  /** The invite code. */
  id: Scalars['String'];
  inviteCode: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  revokedDate?: Maybe<Scalars['DateTime']>;
  state: InviteState;
};

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  maxNumMinutesForOfflineNotification: Scalars['Int'];
  minNumMinutesForOfflineNotification: Scalars['Int'];
  showPetAlertSettings: Scalars['Boolean'];
};

export type UserSearchPartySettings = {
  __typename?: 'UserSearchPartySettings';
  muteAllSearchParties: Scalars['Boolean'];
};

export type UserSettings = {
  __typename?: 'UserSettings';
  activityRankingsEnabled: Scalars['Boolean'];
  appUpdateRequired: Scalars['Boolean'];
  autoSetBaseLocationEnabled: Scalars['Boolean'];
  diagnosticModeEnabled: Scalars['Boolean'];
  distanceUnit?: Maybe<DistanceUnit>;
  dynamicSettings: Scalars['JSON'];
  helpCenterEnabled: Scalars['Boolean'];
  householdInvitesEnabled: Scalars['Boolean'];
  language?: Maybe<FiLanguage>;
  locationReportThrottleDuration: Scalars['Float'];
  lostDogPhoneLineEnabled: Scalars['Boolean'];
  minimumLogLevel: LogLevel;
  minimumTimeIntervalBetweenLocationReports: Scalars['Float'];
  moduleActivationRequiresModuleBePowered: Scalars['Boolean'];
  notificationSettings: UserNotificationSettings;
  pushEnabled: Scalars['Boolean'];
  referralMenuBannerSettings: ReferralMenuBannerSettings;
  referralsEnabled: Scalars['Boolean'];
  region?: Maybe<FiCountry>;
  rescueOrganizationAccess: Scalars['Boolean'];
  searchPartySettings: UserSearchPartySettings;
  series2UpsellString: FormatString;
  shouldAlwaysScanForBases: Scalars['Boolean'];
  shouldBatchLocationReports: Scalars['Boolean'];
  shouldPromptAppReview: Scalars['Boolean'];
  showDebugMenu: Scalars['Boolean'];
  showSeries2Upsell: Scalars['Boolean'];
  smsEnabled: Scalars['Boolean'];
  systemMetricLoggingEnabled: Scalars['Boolean'];
  useFiBleProxy: Scalars['Boolean'];
  userImpersonationEnabled: Scalars['Boolean'];
  walkSharingEnabled: Scalars['Boolean'];
  weightUnit?: Maybe<WeightUnit>;
  whenInUseLocationPermissionAllowed: Scalars['Boolean'];
};

export type ValidToken = {
  __typename?: 'ValidToken';
  token: Scalars['String'];
};

export type ValidateAddressResponse = {
  __typename?: 'ValidateAddressResponse';
  matchedAddress?: Maybe<Address>;
  status?: Maybe<ValidateAddressResponseStatus>;
};

export enum ValidateAddressResponseStatus {
  CORRECTED = 'CORRECTED',
  NOT_VERIFIED = 'NOT_VERIFIED',
  VERIFIED = 'VERIFIED'
}

export type Veterinary = {
  __typename?: 'Veterinary';
  address?: Maybe<VeterinaryAddress>;
  dbId: Scalars['Int'];
  formattedAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type VeterinaryAddress = {
  __typename?: 'VeterinaryAddress';
  city: Scalars['String'];
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type VideoLink = {
  __typename?: 'VideoLink';
  aspectRatio: AspectRatio;
  type: VideoType;
  url: Scalars['String'];
};

export enum VideoOrientation {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT'
}

export type VideoPost = {
  __typename?: 'VideoPost';
  aspectRatio: AspectRatio;
  caption?: Maybe<Scalars['String']>;
  comments: CommentFeed;
  date: Scalars['DateTime'];
  deleted: Scalars['Boolean'];
  id: Scalars['ID'];
  includesAudio: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  /** If the current user has liked this post. */
  liked: Scalars['Boolean'];
  likedByPets: Array<StrangerPet>;
  /** Pet associated with this post */
  pet: StrangerPet;
  poster: StrangerUser;
  /** Returns the requested playback format, may return null if the format is not available due to video processing not being complete. */
  preferredPlaybackLink?: Maybe<VideoLink>;
  /** A link to a web page containing this post that can be shared publicly if item is publicly shareable */
  publicShareLink?: Maybe<Scalars['String']>;
  status: VideoPostStatus;
  thumbnailImage?: Maybe<Image>;
};


export type VideoPostpreferredPlaybackLinkArgs = {
  format: VideoType;
};

export enum VideoPostStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  READY = 'READY'
}

export enum VideoType {
  DASH = 'DASH',
  HLS = 'HLS',
  MP4 = 'MP4'
}

export type VipUserLookupCriteria = {
  __typename?: 'VipUserLookupCriteria';
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  emailDomain?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<VipUserLookupCriteriaName>;
};

export type VipUserLookupCriteriaName = {
  __typename?: 'VipUserLookupCriteriaName';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type VirtualPack = BasePack & {
  __typename?: 'VirtualPack';
  actingPetCanJoin: Scalars['Boolean'];
  actingPetCanLeave: Scalars['Boolean'];
  actingPetCannotJoinReason?: Maybe<Scalars['String']>;
  actingPetDidManuallyJoin: Scalars['Boolean'];
  actingPetIsMember: Scalars['Boolean'];
  actingPetMembershipReason: Scalars['String'];
  ageFiltersWithEnoughRankedPets: Array<PackAgeFilter>;
  avatar: PackAvatar;
  category: PackCategory;
  description?: Maybe<Scalars['String']>;
  /**
   * A 6-digit hex color code, including # sign, and letters lowercase (eg.
   * `#ff00b1`) used to highlight this pack in the app.
   */
  highlightColorHex?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  joinPackUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petRanking: PackRanking;
  photo?: Maybe<Photo>;
  totalRankedPets: Scalars['Int'];
  /**
   * A 64-bit integer representing the total steps for all pets in this pack for
   * the latest ranking period returned as a String.
   */
  totalRankedSteps: Scalars['String'];
};


export type VirtualPackpetRankingArgs = {
  packAgeFilter?: InputMaybe<PackAgeFilter>;
  petId: Scalars['ID'];
};

export type Walk = Activity & {
  __typename?: 'Walk';
  address?: Maybe<Scalars['String']>;
  animatedShareableUrl: AnimatedShareableUrls;
  areaName?: Maybe<Scalars['String']>;
  cityState?: Maybe<Scalars['String']>;
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int'];
  dbId: Scalars['Int'];
  debugMetadata: Scalars['JSON'];
  /** Distance in meters traveled */
  distance: Scalars['Float'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  isAccurateWalk: Scalars['Boolean'];
  /** @deprecated Use isLikable */
  isClappable: Scalars['Boolean'];
  isLikable: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  mapPath: MapPath;
  mapUrl: Scalars['String'];
  neighborhood?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  obfuscated: Scalars['Boolean'];
  /** Stored path positions */
  path: Array<Position>;
  pathProcessingDataForDebug: PathProcessingDataForDebug;
  /** raw positions */
  positions: Array<Location>;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']>;
  routeMatcherName?: Maybe<Scalars['String']>;
  sharedToExternalApps: Array<Maybe<AppIntegrationId>>;
  start: Scalars['DateTime'];
  totalSteps: Scalars['Int'];
};


export type WalkanimatedShareableUrlArgs = {
  format: AnimationFormat;
};


export type WalkmapUrlArgs = {
  height: Scalars['Int'];
  minimumPadding?: InputMaybe<PaddingInput>;
  scale?: InputMaybe<Scalars['Int']>;
  style?: InputMaybe<MapStyle>;
  width: Scalars['Int'];
};

export type WalkCard = Card & {
  __typename?: 'WalkCard';
  date: Scalars['DateTime'];
  icon?: Maybe<Image>;
  id: Scalars['ID'];
  message: FormatString;
  title?: Maybe<Scalars['String']>;
  walk: Walk;
};

export type WalkSegmentsGeoJSONZipInput = {
  /** Must be a walk activity. */
  activityId: Scalars['ID'];
  /** To be included in downloaded file. */
  description?: InputMaybe<Scalars['String']>;
};

export type WarehouseInventoryLevel = {
  __typename?: 'WarehouseInventoryLevel';
  allowFulfillment: Scalars['Boolean'];
  fulfillmentWarehouse: FulfillmentWarehouse;
  manualAdjustment: Scalars['Int'];
  outOfStockThreshold: Scalars['Int'];
  quantityInStock: Scalars['Int'];
  quantityPending: Scalars['Int'];
  quantityReserved: Scalars['Int'];
};

export type WeightRange = {
  __typename?: 'WeightRange';
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
};

export enum WeightUnit {
  KG = 'KG',
  LB = 'LB'
}

export type WifiCredentialInput = {
  isHidden: Scalars['Boolean'];
  psk?: InputMaybe<Scalars['String']>;
  ssid: Scalars['String'];
};

export type WifiNetwork = {
  __typename?: 'WifiNetwork';
  addressLabel?: Maybe<Scalars['String']>;
  isHidden: Scalars['Boolean'];
  isInSafeZone: Scalars['Boolean'];
  position: Position;
  ssid: Scalars['String'];
  state?: Maybe<WifiNetworkStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum WifiNetworkStatus {
  ACTIVE = 'ACTIVE',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
  PENDING = 'PENDING'
}

export type WifiNetworks = {
  __typename?: 'WifiNetworks';
  credentialPackHash?: Maybe<Scalars['String']>;
  maximumNetworkCount: Scalars['Int'];
  networks: Array<WifiNetwork>;
};

export type WifiScanResult = {
  __typename?: 'WifiScanResult';
  authMode?: Maybe<Scalars['String']>;
  rssi?: Maybe<Scalars['Int']>;
  ssid?: Maybe<Scalars['String']>;
};

export type ZoomVideoSdkToken = {
  __typename?: 'ZoomVideoSdkToken';
  jwt: Scalars['String'];
  sessionName: Scalars['String'];
  userIdentity: Scalars['String'];
};

export enum supplementCancellationReason {
  DOG_DOES_NOT_LIKE_IT = 'DOG_DOES_NOT_LIKE_IT',
  OTHER = 'OTHER',
  SUBSCRIBED_BY_ACCIDENT = 'SUBSCRIBED_BY_ACCIDENT',
  TOO_EXPENSIVE = 'TOO_EXPENSIVE'
}

export enum zendeskCancellationReason {
  BATTERY_DRAINS_TOO_QUICKLY = 'BATTERY_DRAINS_TOO_QUICKLY',
  BILLING_ERROR = 'BILLING_ERROR',
  CAT_PASSED_AWAY = 'CAT_PASSED_AWAY',
  CAT_WILL_NOT_WEAR_COLLAR = 'CAT_WILL_NOT_WEAR_COLLAR',
  COLLAR_DOES_NOT_WORK_PROPERLY = 'COLLAR_DOES_NOT_WORK_PROPERLY',
  COLLAR_IS_LOST = 'COLLAR_IS_LOST',
  COLLAR_IS_PHYSICALLY_BROKEN = 'COLLAR_IS_PHYSICALLY_BROKEN',
  DOG_DOES_NOT_RUN_AWAY = 'DOG_DOES_NOT_RUN_AWAY',
  DOG_PASSED_AWAY = 'DOG_PASSED_AWAY',
  DOG_WILL_NOT_WEAR_COLLAR = 'DOG_WILL_NOT_WEAR_COLLAR',
  LOCATION_REPORTS_INCORRECT = 'LOCATION_REPORTS_INCORRECT',
  OTHER = 'OTHER',
  PLAN_TO_REACTIVATE = 'PLAN_TO_REACTIVATE',
  REPLACING_DEVICE = 'REPLACING_DEVICE',
  TOOK_TOO_LONG_TO_NOTIFY = 'TOOK_TOO_LONG_TO_NOTIFY',
  TOO_EXPENSIVE = 'TOO_EXPENSIVE'
}

export type billingAccountVariables = Exact<{ [key: string]: never; }>;


export type billingAccount = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, isRescuePartner: boolean, isVerizonCustomer: boolean, billingAccount?: { __typename?: 'BillingAccount', firstName?: string | null, lastName?: string | null, billingInfo?: { __typename?: 'BillingInfo', firstName: string, lastName: string, address: { __typename?: 'Address', line1: string, line2?: string | null, city: string, state: string, zip: string, country: string }, paymentInfo: { __typename: 'ObfuscatedCardInfo', lastFour: number, type: string, month: number, year: number } | { __typename: 'PayPalInfo' } } | null, address?: { __typename?: 'Address', line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, phone?: string | null } | null } | null } };

export type updateBillingInfoVariables = Exact<{
  input: BillingAccountInput;
  recaptchaToken?: InputMaybe<Scalars['String']>;
}>;


export type updateBillingInfo = { __typename?: 'Mutation', updateBillingAccount: { __typename?: 'BillingAccount', billingInfo?: { __typename?: 'BillingInfo', firstName: string, lastName: string, address: { __typename?: 'Address', line1: string, line2?: string | null, city: string, state: string, zip: string, country: string }, paymentInfo: { __typename: 'ObfuscatedCardInfo', lastFour: number, type: string, month: number, year: number } | { __typename: 'PayPalInfo' } } | null } };

export type ECOMMERCE_createUserBillingAccountVariables = Exact<{ [key: string]: never; }>;


export type ECOMMERCE_createUserBillingAccount = { __typename?: 'Mutation', createBillingAccount: { __typename?: 'BillingAccount', code: string } };

export type activeBillingSubscriptionsVariables = Exact<{ [key: string]: never; }>;


export type activeBillingSubscriptions = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, billingAccount?: { __typename?: 'BillingAccount', subscriptions: Array<{ __typename?: 'BillingSubscription', id: string }> } | null } };

export type ECOMMERCE_activeBillingSubscriptionsDetailsVariables = Exact<{ [key: string]: never; }>;


export type ECOMMERCE_activeBillingSubscriptionsDetails = { __typename?: 'Query', currentUser: { __typename?: 'User', billingAccount?: { __typename?: 'BillingAccount', subscriptions: Array<{ __typename?: 'BillingSubscription', id: string, currentTermEndsAt: any, lastPaymentFailed?: boolean | null, isCanceled?: boolean | null, expiresAt?: any | null, subscriptionOption?: { __typename?: 'SubscriptionOption', name: string, renewalMonths: number } | null }> } | null } };

export type ECOMMERCE_getSupplementSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ECOMMERCE_getSupplementSubscriptionsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, hasPurchasedSupplementSubscription?: boolean | null, billingAccount?: { __typename?: 'BillingAccount', billingInfo?: { __typename?: 'BillingInfo', paymentInfo: { __typename: 'ObfuscatedCardInfo', lastFour: number, type: string, month: number, year: number } | { __typename: 'PayPalInfo', billingAgreementId?: string | null } } | null, subscriptions: Array<{ __typename?: 'BillingSubscription', id: string, state: BillingSubscriptionState, currentTermEndsAt: any, address?: { __typename?: 'ShippingAddress', street1: string, street2?: string | null, city: string, state: string, country: string, zipcode: string } | null, supplementShipmentDates?: { __typename?: 'SupplementShipmentDates', latestSkipDate: any, nextShipmentDate: any, displayDate: any, previewResumingShipmentDate: any, previewSkippingShipmentDate: any, previewUpdate: Array<{ __typename?: 'SupplementUpdatePreview', sku: string, nextShipDate: any }> } | null, nextSupplementShipmentDetails?: { __typename?: 'NextSupplementShipmentDetails', status: string, deliveryExpected?: any | null, trackingLink?: string | null, discount?: number | null } | null, pendingChanges?: { __typename?: 'SubscriptionPendingChange', subscriptionOption?: { __typename?: 'SubscriptionOption', weeksBetweenShipments?: number | null, sku: string } | null } | null, subscriptionOption?: { __typename?: 'SubscriptionOption', sku: string, priceInCents: number, displayedRateUnit: string, billingPeriodsPerTerm: number, inAppManagementName: string, freeTrialDays?: number | null, weeksBetweenShipments?: number | null, recommendedForDogWeightRangePounds?: { __typename?: 'WeightRange', min?: number | null, max?: number | null } | null } | null }> } | null } };

export type ECOMMERCE_billingInfoFromBillingAccountVariables = Exact<{ [key: string]: never; }>;


export type ECOMMERCE_billingInfoFromBillingAccount = { __typename?: 'Query', currentUser: { __typename?: 'User', editBillingInfoUrl?: string | null, billingAccount?: { __typename?: 'BillingAccount', address?: { __typename?: 'Address', line1: string, line2?: string | null, city: string, state: string, zip: string } | null, billingInfo?: { __typename?: 'BillingInfo', address: { __typename?: 'Address', line1: string, line2?: string | null, city: string, state: string, zip: string }, paymentInfo: { __typename: 'ObfuscatedCardInfo', lastFour: number, type: string, month: number, year: number } | { __typename: 'PayPalInfo' } } | null } | null } };

export type marketingEmailsOptedInVariables = Exact<{ [key: string]: never; }>;


export type marketingEmailsOptedIn = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, marketingEmailsOptedIn: boolean } };

export type ECOMMERCE_setMarketingEmailsOptedInVariables = Exact<{
  marketingEmailsOptedIn: Scalars['Boolean'];
}>;


export type ECOMMERCE_setMarketingEmailsOptedIn = { __typename?: 'Mutation', setMarketingEmailsOptedIn: { __typename?: 'User', id: string, marketingEmailsOptedIn: boolean } };

export type ECOMMERCE_previewMembershipUpgradeVariables = Exact<{
  input: UpgradeMembershipInput;
}>;


export type ECOMMERCE_previewMembershipUpgrade = { __typename?: 'Query', previewMembershipUpgrade: { __typename?: 'PreviewMembershipUpgradeResult', appliedAccountBalanceInCents: number, appliedDiscountInCents: number, proratedCreditAmountInCents: number, subtotalInCents: number, taxInCents: number, totalInCents: number } };

export type ECOMMERCE_purchaseMembershipUpgradeVariables = Exact<{
  input: UpgradeMembershipInput;
}>;


export type ECOMMERCE_purchaseMembershipUpgrade = { __typename?: 'Mutation', purchaseMembershipUpgrade: { __typename?: 'CartPurchaseResult', isGWP: boolean, isReturningCustomer: boolean, chargeInvoice?: { __typename?: 'PurchaseResultInvoice', number: string } | null, giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice', number: string }> } };

export type ECOMMERCE_purchaseMonthlyUpgradeVariables = Exact<{
  input: UpgradeMembershipInput;
}>;


export type ECOMMERCE_purchaseMonthlyUpgrade = { __typename?: 'Mutation', purchaseMonthlyUpgradePromotion: { __typename?: 'CartPurchaseResult', isGWP: boolean, isReturningCustomer: boolean, chargeInvoice?: { __typename?: 'PurchaseResultInvoice', number: string } | null, giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice', number: string }> } };

export type ECOMMERCE_packVariables = Exact<{
  packId: Scalars['ID'];
}>;


export type ECOMMERCE_pack = { __typename?: 'Query', pack?: { __typename?: 'Pack', id: string, name: string } | null };

export type ECOMMERCE_joinPackVariables = Exact<{
  petId: Scalars['ID'];
  packId: Scalars['ID'];
}>;


export type ECOMMERCE_joinPack = { __typename?: 'Mutation', joinPack?: { __typename?: 'Pack', id: string } | null };

export type ECOMMERCE_resolvePetAdoptionTransferVariables = Exact<{
  input: ResolvePetAdoptionTransferInput;
}>;


export type ECOMMERCE_resolvePetAdoptionTransfer = { __typename?: 'Mutation', resolvePetAdoptionTransfer: { __typename?: 'ResolvePetAdoptionTransferResult', redirectUrl: string, transfer: { __typename?: 'PetAdoptionTransfer', id: string, status: PetAdoptionTransferStatus } } };

export type ECOMMERCE_purchaseConsumerStoreCartVariables = Exact<{
  input: ConsumerStoreCartInput;
}>;


export type ECOMMERCE_purchaseConsumerStoreCart = { __typename?: 'Mutation', purchaseConsumerStoreCart: { __typename?: 'CartPurchaseResult', isGWP: boolean, isReturningCustomer: boolean, chargeInvoice?: { __typename?: 'PurchaseResultInvoice', number: string } | null, giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice', number: string }> } };

export type ECOMMERCE_purchaseSeries3UpgradeCartVariables = Exact<{
  input: Series3UpgradeCartInput;
}>;


export type ECOMMERCE_purchaseSeries3UpgradeCart = { __typename?: 'Mutation', purchaseSeries3UpgradeCart: { __typename?: 'CartPurchaseResult', isGWP: boolean, isReturningCustomer: boolean, chargeInvoice?: { __typename?: 'PurchaseResultInvoice', number: string } | null, giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice', number: string }> } };

export type ECOMMERCE_previewSubscriptionVariables = Exact<{
  input: PurchaseSubscriptionInput;
}>;


export type ECOMMERCE_previewSubscription = { __typename?: 'Query', previewSubscription: { __typename?: 'PreviewSubscriptionResult', activationFeeInCents?: number | null, taxInCents: number, totalInCents: number, giftCardAmountInCents?: number | null, couponAmountInCents?: number | null } };

export type ECOMMERCE_purchaseSubscriptionVariables = Exact<{
  input: PurchaseSubscriptionInput;
}>;


export type ECOMMERCE_purchaseSubscription = { __typename?: 'Mutation', purchaseSubscription: { __typename?: 'CartPurchaseResult', isGWP: boolean, isReturningCustomer: boolean, chargeInvoice?: { __typename?: 'PurchaseResultInvoice', number: string } | null, giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice', number: string }> } };

export type ECOMMERCE_deviceSubscriptionVariables = Exact<{
  moduleId: Scalars['String'];
}>;


export type ECOMMERCE_deviceSubscription = { __typename?: 'Query', device?: { __typename?: 'Device', subscription?: { __typename?: 'BillingSubscription', currentTermEndsAt: any } | null } | null };

export type ECOMMERCE_purchaseSubscriptionDeviceVariables = Exact<{
  moduleId: Scalars['String'];
  inAppFlow?: InputMaybe<Scalars['Boolean']>;
  monthlyUpgrade?: InputMaybe<Scalars['Boolean']>;
  couponCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currency>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
}>;


export type ECOMMERCE_purchaseSubscriptionDevice = { __typename?: 'Query', device?: { __typename?: 'Device', id: string, moduleId: string, currentCollarModel?: string | null, preselectedPlanCodeForNewSubscription?: string | null, subscriptionAccessType: SubscriptionAccessType, hasSubscriptionOverride: boolean, shouldOfferFreeMonthDuringCancellation?: boolean | null, shouldOfferPauseMonthDuringCancellation?: boolean | null, shouldOfferDowngradeDuringCancellation?: boolean | null, shouldOfferDiscountDuringClickToCancel?: boolean | null, canCancel: boolean, canCancelDate?: any | null, upgradeRedeemed?: DeviceUpgrade | null, purchasableSubscriptionOptions: Array<{ __typename?: 'SubscriptionOption', sku: string, name: string, priceInCents: number, billingCadence: BillingCadence, displayedRate: string, displayedRateUnit: string, fullRate?: string | null, fullRateUnit?: string | null, savings?: string | null, monthlyUpgradeSavings?: string | null, featured: boolean, renewalYears?: number | null, activationFeeInCents?: number | null, renewalMonths: number, billingPeriodsPerTerm: number, upsellOnly: boolean, buyItMembership: boolean, valueLabel?: string | null, supportPlus: boolean, couponExtensionMonths?: number | null, planSwitchCreditAppliedInCents?: number | null, planSwitchAmountChargedInCents?: number | null, isPlusPlan: boolean, pricingInCents: { __typename?: 'PricingByCurrency', USD: number, CAD?: number | null } }>, prepaidSubscription?: { __typename?: 'DevicePrepaidSubscription', planCode: string, orderSource: OrderSource, renewalPlanCode?: string | null, freeMonths?: number | null, resellerPriceInCents?: number | null } | null, pet?: { __typename?: 'Pet', id: string, name: string, gender: Gender, species?: Species | null, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null }, household: { __typename?: 'Household', pets: Array<{ __typename?: 'Pet', id: string, name: string, device?: { __typename?: 'Device', subscriptionAccessType: SubscriptionAccessType } | null, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null } }> } } | null, subscription?: { __typename?: 'BillingSubscription', id: string, code: string, billingEmail?: string | null, currentTermEndsAt: any, expiresAt?: any | null, pausedAt?: any | null, isPaused?: boolean | null, isCanceled?: boolean | null, hasFreeTrialPlan?: boolean | null, isInTrialPeriod?: boolean | null, subscriptionOption?: { __typename?: 'SubscriptionOption', name: string, priceInCents: number, activationFeeInCents?: number | null, billingCadence: BillingCadence, displayedRate: string, displayedRateUnit: string, renewalYears?: number | null, renewalMonths: number, billingPeriodsPerTerm: number, sku: string, buyItMembership: boolean, pricingInCents: { __typename?: 'PricingByCurrency', USD: number, CAD?: number | null }, activationFeePricingInCents?: { __typename?: 'PricingByCurrency', USD: number, CAD?: number | null } | null } | null, pendingChanges?: { __typename?: 'SubscriptionPendingChange', subscriptionOption?: { __typename?: 'SubscriptionOption', priceInCents: number, renewalMonths: number, pricingInCents: { __typename?: 'PricingByCurrency', USD: number, CAD?: number | null } } | null } | null } | null, subscriptionRenewalStatus?: { __typename?: 'SubscriptionRenewalStatus', shouldOfferSubscriptionRenewal: boolean } | null } | null };

export type purchaseSubscriptionDeviceDetails = { __typename?: 'Device', id: string, moduleId: string, currentCollarModel?: string | null, preselectedPlanCodeForNewSubscription?: string | null, subscriptionAccessType: SubscriptionAccessType, hasSubscriptionOverride: boolean, shouldOfferFreeMonthDuringCancellation?: boolean | null, shouldOfferPauseMonthDuringCancellation?: boolean | null, shouldOfferDowngradeDuringCancellation?: boolean | null, shouldOfferDiscountDuringClickToCancel?: boolean | null, canCancel: boolean, canCancelDate?: any | null, upgradeRedeemed?: DeviceUpgrade | null, purchasableSubscriptionOptions: Array<{ __typename?: 'SubscriptionOption', sku: string, name: string, priceInCents: number, billingCadence: BillingCadence, displayedRate: string, displayedRateUnit: string, fullRate?: string | null, fullRateUnit?: string | null, savings?: string | null, monthlyUpgradeSavings?: string | null, featured: boolean, renewalYears?: number | null, activationFeeInCents?: number | null, renewalMonths: number, billingPeriodsPerTerm: number, upsellOnly: boolean, buyItMembership: boolean, valueLabel?: string | null, supportPlus: boolean, couponExtensionMonths?: number | null, planSwitchCreditAppliedInCents?: number | null, planSwitchAmountChargedInCents?: number | null, isPlusPlan: boolean, pricingInCents: { __typename?: 'PricingByCurrency', USD: number, CAD?: number | null } }>, prepaidSubscription?: { __typename?: 'DevicePrepaidSubscription', planCode: string, orderSource: OrderSource, renewalPlanCode?: string | null, freeMonths?: number | null, resellerPriceInCents?: number | null } | null, pet?: { __typename?: 'Pet', id: string, name: string, gender: Gender, species?: Species | null, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null }, household: { __typename?: 'Household', pets: Array<{ __typename?: 'Pet', id: string, name: string, device?: { __typename?: 'Device', subscriptionAccessType: SubscriptionAccessType } | null, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null } }> } } | null, subscription?: { __typename?: 'BillingSubscription', id: string, code: string, billingEmail?: string | null, currentTermEndsAt: any, expiresAt?: any | null, pausedAt?: any | null, isPaused?: boolean | null, isCanceled?: boolean | null, hasFreeTrialPlan?: boolean | null, isInTrialPeriod?: boolean | null, subscriptionOption?: { __typename?: 'SubscriptionOption', name: string, priceInCents: number, activationFeeInCents?: number | null, billingCadence: BillingCadence, displayedRate: string, displayedRateUnit: string, renewalYears?: number | null, renewalMonths: number, billingPeriodsPerTerm: number, sku: string, buyItMembership: boolean, pricingInCents: { __typename?: 'PricingByCurrency', USD: number, CAD?: number | null }, activationFeePricingInCents?: { __typename?: 'PricingByCurrency', USD: number, CAD?: number | null } | null } | null, pendingChanges?: { __typename?: 'SubscriptionPendingChange', subscriptionOption?: { __typename?: 'SubscriptionOption', priceInCents: number, renewalMonths: number, pricingInCents: { __typename?: 'PricingByCurrency', USD: number, CAD?: number | null } } | null } | null } | null, subscriptionRenewalStatus?: { __typename?: 'SubscriptionRenewalStatus', shouldOfferSubscriptionRenewal: boolean } | null };

export type purchaseSubscriptionPetDetails = { __typename?: 'Pet', id: string, name: string, gender: Gender, species?: Species | null, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null }, household: { __typename?: 'Household', pets: Array<{ __typename?: 'Pet', id: string, name: string, device?: { __typename?: 'Device', subscriptionAccessType: SubscriptionAccessType } | null, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null } }> } };

export type subscriptionOption = { __typename?: 'SubscriptionOption', sku: string, name: string, priceInCents: number, billingCadence: BillingCadence, displayedRate: string, displayedRateUnit: string, fullRate?: string | null, fullRateUnit?: string | null, savings?: string | null, monthlyUpgradeSavings?: string | null, featured: boolean, renewalYears?: number | null, activationFeeInCents?: number | null, renewalMonths: number, billingPeriodsPerTerm: number, upsellOnly: boolean, buyItMembership: boolean, valueLabel?: string | null, supportPlus: boolean, couponExtensionMonths?: number | null, planSwitchCreditAppliedInCents?: number | null, planSwitchAmountChargedInCents?: number | null, isPlusPlan: boolean, pricingInCents: { __typename?: 'PricingByCurrency', USD: number, CAD?: number | null } };

export type ECOMMERCE_referralsVariables = Exact<{ [key: string]: never; }>;


export type ECOMMERCE_referrals = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, referrals: { __typename?: 'Referrals', referralProgramName: string, referralCode: string, numConfirmedReferrals: number, numPendingReferrals: number, unlockedRewardTypes: Array<ReferralRewardType>, codeSuspended: boolean, referralMessage: string, referralProgramTitle: string, invitedReferees: Array<{ __typename?: 'StrangerUser', firstName: string, profilePicture?: { __typename?: 'Image', nearestResized: string } | null }>, give1MonthGet1DollarPerMonthDetails?: { __typename?: 'Give1MonthGet1DollarPerMonthDetails', totalDollarsEarned: number, numActiveReferrals: number } | null } } };

export type referralsFragment = { __typename?: 'User', referrals: { __typename?: 'Referrals', referralProgramName: string, referralCode: string, numConfirmedReferrals: number, numPendingReferrals: number, unlockedRewardTypes: Array<ReferralRewardType>, codeSuspended: boolean, referralMessage: string, referralProgramTitle: string, invitedReferees: Array<{ __typename?: 'StrangerUser', firstName: string, profilePicture?: { __typename?: 'Image', nearestResized: string } | null }>, give1MonthGet1DollarPerMonthDetails?: { __typename?: 'Give1MonthGet1DollarPerMonthDetails', totalDollarsEarned: number, numActiveReferrals: number } | null } };

export type ECOMMERCE_previewRenewAndSaveVariables = Exact<{
  input: RenewAndSaveInput;
}>;


export type ECOMMERCE_previewRenewAndSave = { __typename?: 'Query', previewRenewAndSave: { __typename?: 'PreviewRenewAndSaveResult', subtotalInCents: number, taxInCents: number, totalInCents: number } };

export type ECOMMERCE_purchaseRenewAndSaveVariables = Exact<{
  input: RenewAndSaveInput;
}>;


export type ECOMMERCE_purchaseRenewAndSave = { __typename?: 'Mutation', purchaseRenewAndSave: { __typename?: 'CartPurchaseResult', isGWP: boolean, isReturningCustomer: boolean, chargeInvoice?: { __typename?: 'PurchaseResultInvoice', number: string } | null, giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice', number: string }> } };

export type ECOMMERCE_rescueRecallPetVariables = Exact<{
  input: RescueRecallPetInput;
}>;


export type ECOMMERCE_rescueRecallPet = { __typename?: 'Mutation', rescueRecallPet?: { __typename?: 'RescueRecallPetResult', ok?: boolean | null } | null };

export type fullAddress = { __typename?: 'Address', line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, phone?: string | null };

export type updateShippingAddressVariables = Exact<{
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  address: AddressInput;
  billingInfo?: InputMaybe<BillingInfoInput>;
  recaptchaToken?: InputMaybe<Scalars['String']>;
}>;


export type updateShippingAddress = { __typename?: 'Mutation', updateBillingAccount: { __typename?: 'BillingAccount', firstName?: string | null, lastName?: string | null, address?: { __typename?: 'Address', line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, phone?: string | null } | null } };

export type validateAddressVariables = Exact<{
  address: AddressInput;
}>;


export type validateAddress = { __typename?: 'Query', validateAddress: { __typename?: 'ValidateAddressResponse', status?: ValidateAddressResponseStatus | null, matchedAddress?: { __typename?: 'Address', line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, phone?: string | null } | null } };

export type ECOMMERCE_currentUserEditBillingInfoUrlVariables = Exact<{ [key: string]: never; }>;


export type ECOMMERCE_currentUserEditBillingInfoUrl = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, editBillingInfoUrl?: string | null } };

export type ECOMMERCE_createZendeskCancellationTicketVariables = Exact<{
  input: CreateZendeskCancellationTicketInput;
}>;


export type ECOMMERCE_createZendeskCancellationTicket = { __typename?: 'Mutation', createZendeskCancellationTicket?: { __typename?: 'CreateZendeskTicketResult', ticketCreated?: boolean | null } | null };

export type ECOMMERCE_createZendeskReplacementTicketVariables = Exact<{
  input: CreateZendeskReplacementTicketInput;
}>;


export type ECOMMERCE_createZendeskReplacementTicket = { __typename?: 'Mutation', createZendeskReplacementTicket?: { __typename?: 'CreateZendeskTicketResult', ticketCreated?: boolean | null } | null };

export type ECOMMERCE_createZendeskTroubleshootingTicketVariables = Exact<{
  input: CreateZendeskTroubleshootingTicketInput;
}>;


export type ECOMMERCE_createZendeskTroubleshootingTicket = { __typename?: 'Mutation', createZendeskTroubleshootingTicket?: { __typename?: 'CreateZendeskTicketResult', ticketCreated?: boolean | null } | null };

export type ECOMMERCE_petsWithActiveSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ECOMMERCE_petsWithActiveSubscription = { __typename?: 'Query', petsWithActiveSubscription: Array<{ __typename?: 'Pet', id: string, name: string, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null }, device?: { __typename?: 'Device', id: string, moduleId: string, currentCollarModel?: string | null, subscriptionAccessType: SubscriptionAccessType, hasSubscriptionOverride: boolean, subscription?: { __typename?: 'BillingSubscription', id: string, currentTermEndsAt: any, subscriptionOption?: { __typename?: 'SubscriptionOption', name: string, priceInCents: number, billingCadence: BillingCadence, displayedRate: string, displayedRateUnit: string, renewalYears?: number | null, renewalMonths: number, billingPeriodsPerTerm: number, sku: string } | null } | null } | null }> };

export type ECOMMERCE_applyMultidogDiscountVariables = Exact<{ [key: string]: never; }>;


export type ECOMMERCE_applyMultidogDiscount = { __typename?: 'Mutation', applyMultidogDiscount?: { __typename?: 'ApplyMultidogDiscountResult', success?: boolean | null } | null };

export type ECOMMERCE_hasMultidogDiscountVariables = Exact<{ [key: string]: never; }>;


export type ECOMMERCE_hasMultidogDiscount = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, hasMultidogDiscount: boolean } };

export type ECOMMERCE_claimFreeMonthVariables = Exact<{
  input: ClaimFreeMonthInput;
}>;


export type ECOMMERCE_claimFreeMonth = { __typename?: 'Mutation', claimFreeMonth?: { __typename?: 'ClaimFreeMonthResult', success?: boolean | null } | null };

export type ECOMMERCE_claimClickToCancelDiscountVariables = Exact<{
  input: ClaimClickToCancelDiscountInput;
}>;


export type ECOMMERCE_claimClickToCancelDiscount = { __typename?: 'Mutation', claimClickToCancelDiscount?: { __typename?: 'ClaimClickToCancelDiscountResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_downgradeS2Variables = Exact<{
  input: DowngradeSeries2Input;
}>;


export type ECOMMERCE_downgradeS2 = { __typename?: 'Mutation', downgradeSeries2?: { __typename?: 'DowngradeSeries2Result', success?: boolean | null } | null };

export type ECOMMERCE_getAvailableS3DowngradeableSubscriptionOptionsVariables = Exact<{
  input: AvailableS3DowngradeSubscriptionOptionsInput;
}>;


export type ECOMMERCE_getAvailableS3DowngradeableSubscriptionOptions = { __typename?: 'Query', getAvailableS3DowngradeableSubscriptionOptions: { __typename?: 'AvailableS3DowngradeSubscriptionOptionsResult', subscriptionOptions: Array<{ __typename?: 'SubscriptionOption', sku: string, name: string, priceInCents: number, displayedRate: string, displayedRateUnit: string, billingCadence: BillingCadence, renewalMonths: number, billingPeriodsPerTerm: number, supportPlus: boolean, valueLabel?: string | null, savings?: string | null, fullRate?: string | null, fullRateUnit?: string | null, featured: boolean, renewalYears?: number | null, activationFeeInCents?: number | null, upsellOnly: boolean, buyItMembership: boolean, pricingInCents: { __typename?: 'PricingByCurrency', USD: number, CAD?: number | null }, activationFeePricingInCents?: { __typename?: 'PricingByCurrency', USD: number, CAD?: number | null } | null }> } };

export type ECOMMERCE_downgradeS3Variables = Exact<{
  input: DowngradeSeries3Input;
}>;


export type ECOMMERCE_downgradeS3 = { __typename?: 'Mutation', downgradeSeries3?: { __typename?: 'DowngradeSeries3Result', success?: boolean | null } | null };

export type ECOMMERCE_renewSubscriptionVariables = Exact<{
  input: RenewSubscriptionInput;
}>;


export type ECOMMERCE_renewSubscription = { __typename?: 'Mutation', renewSubscription?: { __typename?: 'RenewSubscriptionResult', success?: boolean | null } | null };

export type ECOMMERCE_cancelSupplementSubscriptionVariables = Exact<{
  input: CancelSupplementSubscriptionInput;
}>;


export type ECOMMERCE_cancelSupplementSubscription = { __typename?: 'Mutation', cancelSupplementSubscription?: { __typename?: 'CancelSupplementSubscriptionResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_updateSupplementSubscriptionVariables = Exact<{
  input: UpdateSupplementSubscriptionInput;
}>;


export type ECOMMERCE_updateSupplementSubscription = { __typename?: 'Mutation', updateSupplementSubscription?: { __typename?: 'UpdateSupplementSubscriptionResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_getMultipleSupplementSubscriptionsPricingVariables = Exact<{
  input: GetMultipleSupplementSubscriptionsPricingInput;
}>;


export type ECOMMERCE_getMultipleSupplementSubscriptionsPricing = { __typename?: 'Query', getMultipleSupplementSubscriptionsPricing?: { __typename?: 'GetMultipleSupplementSubscriptionsPricingResult', subtotalInCents: number, taxInCents: number, totalInCents: number } | null };

export type ECOMMERCE_addMultipleSupplementSubscriptionsVariables = Exact<{
  input: AddMultipleSupplementSubscriptionsInput;
}>;


export type ECOMMERCE_addMultipleSupplementSubscriptions = { __typename?: 'Mutation', addMultipleSupplementSubscriptions?: { __typename?: 'AddMultipleSupplementSubscriptionsResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_setSupplementNextShipDateVariables = Exact<{
  input: SetNextShipmentDateInput;
}>;


export type ECOMMERCE_setSupplementNextShipDate = { __typename?: 'Mutation', setSupplementNextShipDate?: { __typename?: 'SetNextShipmentDateResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_setSupplementShippingAddressVariables = Exact<{
  input: SetShippingAddressInput;
}>;


export type ECOMMERCE_setSupplementShippingAddress = { __typename?: 'Mutation', setSupplementShippingAddress?: { __typename?: 'SetShippingAddressResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_claimSupplementDiscountVariables = Exact<{
  input: ClaimSupplementDiscountInput;
}>;


export type ECOMMERCE_claimSupplementDiscount = { __typename?: 'Mutation', claimSupplementDiscount?: { __typename?: 'ClaimSupplementDiscountResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_claimTwoMonthsHalfOffDiscountVariables = Exact<{
  input: ClaimTwoMonthsHalfOffInput;
}>;


export type ECOMMERCE_claimTwoMonthsHalfOffDiscount = { __typename?: 'Mutation', claimTwoMonthsHalfOff?: { __typename?: 'ClaimTwoMonthsHalfOffResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_pauseMembershipVariables = Exact<{
  input: PauseMembershipInput;
}>;


export type ECOMMERCE_pauseMembership = { __typename?: 'Mutation', pauseMembership?: { __typename?: 'PauseMembershipResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_resumeMembershipVariables = Exact<{
  input: ResumeMembershipInput;
}>;


export type ECOMMERCE_resumeMembership = { __typename?: 'Mutation', resumeMembership?: { __typename?: 'ResumeMembershipResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_cancelMembershipVariables = Exact<{
  input: CancelMembershipInput;
}>;


export type ECOMMERCE_cancelMembership = { __typename?: 'Mutation', cancelMembership?: { __typename?: 'CancelMembershipResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_cancelThirdPartyMembershipVariables = Exact<{
  input: CancelThirdPartySubscriptionInput;
}>;


export type ECOMMERCE_cancelThirdPartyMembership = { __typename?: 'Mutation', cancelThirdPartySubscription: { __typename?: 'CancelThirdPartySubscriptionResult', success: boolean, reasonForFailure?: string | null } };

export type ECOMMERCE_allSubscriptionsForCurrentUserVariables = Exact<{ [key: string]: never; }>;


export type ECOMMERCE_allSubscriptionsForCurrentUser = { __typename?: 'Query', currentUser: { __typename?: 'User', email: string, editBillingInfoUrl?: string | null, userHouseholds: Array<{ __typename?: 'UserHousehold', householdRole: UserHouseholdRole, household: { __typename?: 'Household', pets: Array<{ __typename?: 'Pet', id: string, name: string, species?: Species | null, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null }, device?: { __typename?: 'Device', moduleId: string, subscriptionId?: string | null, currentCollarModelLongName?: string | null, subscription?: { __typename?: 'BillingSubscription', name: string, code: string, billingEmail?: string | null, isCanceled?: boolean | null, isPaused?: boolean | null, hasFreeTrialPlan?: boolean | null, isInTrialPeriod?: boolean | null, currentTermEndsAt: any, expiresAt?: any | null, pausedAt?: any | null, lastPaymentFailed?: boolean | null, subscriptionOption?: { __typename?: 'SubscriptionOption', sku: string, priceInCents: number, renewalMonths: number, activationFeeInCents?: number | null } | null, nextRenewalPreview?: { __typename?: 'SubscriptionRenewalPreview', totalInCents: number } | null, pendingChanges?: { __typename?: 'SubscriptionPendingChange', subscriptionOption?: { __typename?: 'SubscriptionOption', priceInCents: number, renewalMonths: number } | null } | null } | null, cxPendingAction?: { __typename?: 'CxPendingAction', category: string } | null } | null }> } }> } };

export type ECOMMERCE_changeMembershipPlanEndOfTermVariables = Exact<{
  input: ChangeMembershipPlanEndOfTermInput;
}>;


export type ECOMMERCE_changeMembershipPlanEndOfTerm = { __typename?: 'Mutation', changeMembershipPlanEndOfTerm?: { __typename?: 'ChangeMembershipPlanEndOfTermResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_convertFreeTrialVariables = Exact<{
  input: ConvertFreeTrialInput;
}>;


export type ECOMMERCE_convertFreeTrial = { __typename?: 'Mutation', convertFreeTrial?: { __typename?: 'ConvertFreeTrialResult', success: boolean, reasonForFailure?: string | null } | null };

export type ECOMMERCE_series3UpgradeOfferVariables = Exact<{
  petId?: InputMaybe<Scalars['ID']>;
}>;


export type ECOMMERCE_series3UpgradeOffer = { __typename?: 'Query', series3UpgradeOffer?: { __typename?: 'Series3UpgradeOffer', planCode: string, deviceOffers: Array<{ __typename?: 'Series3UpgradeDeviceOffer', proratedCreditAmountInCents: number, promoDiscounts: Array<{ __typename?: 'Series3UpgradePromoDiscount', discountAmountInCents: number, planCode: string }>, device: { __typename?: 'Device', moduleId: string, series3UpgradeV2Eligible: boolean }, pet: { __typename?: 'Pet', id: string, name: string, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null } } }> } | null };

export type series3UpgradeDeviceOffer = { __typename?: 'Series3UpgradeDeviceOffer', proratedCreditAmountInCents: number, promoDiscounts: Array<{ __typename?: 'Series3UpgradePromoDiscount', discountAmountInCents: number, planCode: string }>, device: { __typename?: 'Device', moduleId: string, series3UpgradeV2Eligible: boolean }, pet: { __typename?: 'Pet', id: string, name: string, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null } } };

export type ECOMMERCE_previewUpgradeToSeriesThreePlusModuleVariables = Exact<{
  input: UpgradeToSeriesThreePlusModuleInput;
}>;


export type ECOMMERCE_previewUpgradeToSeriesThreePlusModule = { __typename?: 'Query', previewUpgradeToSeriesThreePlusModule: { __typename?: 'PreviewUpgradeToSeriesThreePlusModuleResult', subtotalInCents: number, shippingInCents: number, taxInCents: number, totalInCents: number } };

export type ECOMMERCE_purchaseUpgradeToSeriesThreePlusModuleVariables = Exact<{
  input: UpgradeToSeriesThreePlusModuleInput;
}>;


export type ECOMMERCE_purchaseUpgradeToSeriesThreePlusModule = { __typename?: 'Mutation', purchaseUpgradeToSeriesThreePlusModule: { __typename?: 'CartPurchaseResult', isGWP: boolean, isReturningCustomer: boolean, chargeInvoice?: { __typename?: 'PurchaseResultInvoice', number: string } | null, giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice', number: string }> } };

export type userIdentityVariables = Exact<{ [key: string]: never; }>;


export type userIdentity = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, email: string, isRescuePartner: boolean, isVerizonCustomer: boolean, hasPurchasedSupplementSubscription?: boolean | null, previouslyPurchasedCollarProductIds: Array<string>, billingAccount?: { __typename?: 'BillingAccount', billingInfo?: { __typename?: 'BillingInfo', firstName: string, lastName: string, address: { __typename?: 'Address', line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } | null, address?: { __typename?: 'Address', line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, phone?: string | null } | null } | null } };

export type userPetsVariables = Exact<{ [key: string]: never; }>;


export type userPets = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, userHouseholds: Array<{ __typename?: 'UserHousehold', household: { __typename?: 'Household', pets: Array<{ __typename?: 'Pet', id: string, name: string, weight: number, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null }, device?: { __typename?: 'Device', subscription?: { __typename?: 'BillingSubscription', id: string, unitAmountInCents: number } | null } | null }> } }> } };

export type userPetsIdVariables = Exact<{ [key: string]: never; }>;


export type userPetsId = { __typename?: 'Query', currentUser: { __typename?: 'User', userHouseholds: Array<{ __typename?: 'UserHousehold', household: { __typename?: 'Household', pets: Array<{ __typename?: 'Pet', id: string }> } }> } };

export type userPetsWeightVariables = Exact<{ [key: string]: never; }>;


export type userPetsWeight = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, userHouseholds: Array<{ __typename?: 'UserHousehold', household: { __typename?: 'Household', pets: Array<{ __typename?: 'Pet', weight: number }> } }> } };

export type userThirdPartiesVariables = Exact<{ [key: string]: never; }>;


export type userThirdParties = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, email: string, thirdPartyData: Array<{ __typename?: 'ThirdPartyData', thirdPartyId: ThirdPartyId, data: { __typename?: 'AirvetDataItem', nextBillDate?: any | null, subscriptionId?: string | null } } | null> } };

export type ECOMMERCE_rescueTransferPetPermanentlyVariables = Exact<{
  input: RescueTransferPetPermanentlyInput;
}>;


export type ECOMMERCE_rescueTransferPetPermanently = { __typename?: 'Mutation', rescueTransferPetPermanently?: { __typename?: 'RescueTransferPetPermanentlyResult', accountCreated: boolean, newAccountTemporaryPassword?: string | null, billingAccount?: { __typename?: 'BillingAccount', billingInfo?: { __typename?: 'BillingInfo', firstName: string, lastName: string, address: { __typename?: 'Address', line1: string, line2?: string | null, city: string, state: string, zip: string, country: string }, paymentInfo: { __typename: 'ObfuscatedCardInfo', lastFour: number, type: string, month: number, year: number } | { __typename: 'PayPalInfo' } } | null } | null } | null };

export type ECOMMERCE_rescueTransferPetTemporarilyVariables = Exact<{
  input: RescueTransferPetTemporarilyInput;
}>;


export type ECOMMERCE_rescueTransferPetTemporarily = { __typename?: 'Mutation', rescueTransferPetTemporarily?: { __typename?: 'RescueTransferPetTemporarilyResult', accountCreated: boolean, newAccountTemporaryPassword?: string | null } | null };

export type ECOMMERCE_rescuePlacementMainVariables = Exact<{ [key: string]: never; }>;


export type ECOMMERCE_rescuePlacementMain = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, transferablePets: Array<{ __typename?: 'Pet', id: string, name: string, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null }, household: { __typename?: 'Household', id: string, users: Array<{ __typename?: 'HouseholdUser', id: string, firstName: string, lastName?: string | null, email: string }> }, device?: { __typename?: 'Device', id: string, moduleId: string, currentCollarModel?: string | null } | null }>, recallableTransferredPets: Array<{ __typename?: 'Pet', id: string, name: string, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null }, household: { __typename?: 'Household', id: string, users: Array<{ __typename?: 'HouseholdUser', id: string, firstName: string, lastName?: string | null, email: string }> }, device?: { __typename?: 'Device', id: string, moduleId: string, currentCollarModel?: string | null } | null }>, userHouseholds: Array<{ __typename?: 'UserHousehold', firstCreated: boolean, household: { __typename?: 'Household', id: string, pets: Array<{ __typename?: 'Pet', id: string, name: string, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null }, household: { __typename?: 'Household', id: string, users: Array<{ __typename?: 'HouseholdUser', id: string, firstName: string, lastName?: string | null, email: string }> }, device?: { __typename?: 'Device', id: string, moduleId: string, currentCollarModel?: string | null } | null }>, bases: Array<{ __typename?: 'ChargingBase', id: string, baseId: string, name: string }> } }> } };

export type baseDetails = { __typename?: 'ChargingBase', id: string, baseId: string, name: string };

export type petDetails = { __typename?: 'Pet', id: string, name: string, photos: { __typename?: 'PhotoFeed', first?: { __typename?: 'Photo', image: { __typename?: 'Image', fullSize?: string | null } } | null }, household: { __typename?: 'Household', id: string, users: Array<{ __typename?: 'HouseholdUser', id: string, firstName: string, lastName?: string | null, email: string }> }, device?: { __typename?: 'Device', id: string, moduleId: string, currentCollarModel?: string | null } | null };
